// Door configurator frontend logic for Shopify theme
// This file is meant to be uploaded as an asset (door-config.js) in your theme.

(function () {
    var DOOR_SELECTION_LOG_ONLY = false;
    try { window.__doorSelectionLogOnly = DOOR_SELECTION_LOG_ONLY; } catch (eModeExpose) { }
    function silenceDoorConsoleLogs() {
        if (!DOOR_SELECTION_LOG_ONLY) return;
        try {
            if (window.__doorConsoleSilenced) return;
            window.__doorConsoleSilenced = true;
            var c = window.console;
            if (!c) return;
            if (!window.__doorConsoleOriginals) {
                window.__doorConsoleOriginals = {
                    log: c.log,
                    info: c.info,
                    warn: c.warn,
                    error: c.error,
                    debug: c.debug
                };
            }
            var noop = function () { };
            c.log = noop;
            c.info = noop;
            c.warn = noop;
            c.error = noop;
            c.debug = noop;
        } catch (eSilence) { }
    }
    silenceDoorConsoleLogs();

    function $(selector) {
        return document.querySelector(selector);
    }
    function all(selector, root) {
        return Array.from((root || document).querySelectorAll(selector));
    }

    /** Sidelight / transom / swing / SDL: user must pick explicitly (no first-visible auto-check)
     *  unless configurator_defaults supplies a value (SDL uses that path separately). */
    var OPTIONAL_DESIGN_RADIO_OPTION_IDS = {
        sidelight_location: true,
        sidelight_style: true,
        transom_style: true,
        transom_count: true,
        swing_direction: true,
        sdl_profile: true
    };
    function optionIdSkipsDefaultRadioAutoSelect(optId) {
        var n = String(optId || '').toLowerCase().replace(/-/g, '_');
        return !!OPTIONAL_DESIGN_RADIO_OPTION_IDS[n];
    }
    function syncSidelightTransomAccordionHeaderUi(container) {
        if (!container) return;
        [
            ['sidelight_design', ['sidelight_location', 'sidelight_style']],
            ['transom_design', ['transom_style', 'transom_count']]
        ].forEach(function (pair) {
            var section = container.querySelector('.door-option-wrap[data-option-id="' + pair[0] + '"]');
            if (!section) return;
            var body = section.querySelector('.door-accordion-body');
            if (!body) return;
            var removeBtn = section.querySelector('.door-accordion-remove-btn');
            var sign = section.querySelector('.door-accordion-sign');
            var anyChecked = false;
            pair[1].forEach(function (id) {
                if (body.querySelector('input[type="radio"][data-option-id="' + id + '"]:checked')) anyChecked = true;
            });
            if (removeBtn) removeBtn.style.setProperty('display', anyChecked ? '' : 'none', 'important');
            if (sign) sign.style.setProperty('display', anyChecked ? 'none' : '', 'important');
        });
    }

    // On saved-config restore: open the sidelight/transom design accordions that have
    // a selected child (so the picked style is visible) and refresh the "added" header UI.
    function openRestoredDesignAccordions(container) {
        if (!container) return;
        ['sidelight_design', 'transom_design'].forEach(function (designId) {
            var section = container.querySelector('.door-option-wrap[data-option-id="' + designId + '"]');
            if (!section) return;
            var body = section.querySelector('.door-accordion-body');
            if (!body) return;
            if (body.querySelector('input[type="radio"]:checked')) {
                body.classList.add('door-accordion-body--open');
                var sign = section.querySelector('.door-accordion-sign');
                if (sign) sign.style.setProperty('display', 'none', 'important');
            }
        });
        try { syncSidelightTransomAccordionHeaderUi(container); } catch (eOpenDesign) { }
    }

    function doorConf2HardwareCall(name) {
        var H = window.DoorConf2Hardware;
        var fn = H && H[name];
        if (typeof fn !== 'function') return undefined;
        return fn.apply(H, Array.prototype.slice.call(arguments, 1));
    }

    function readRecommendedHardwareProducts() {
        var out = doorConf2HardwareCall('readRecommendedHardwareProducts');
        return Array.isArray(out) ? out : [];
    }

    function hideLegacyRecommendedProductsBlock() {
        doorConf2HardwareCall('hideLegacyRecommendedProductsBlock');
    }

    function getHardwareSelectionsForConfig() {
        var out = doorConf2HardwareCall('getHardwareSelectionsForConfig');
        return Array.isArray(out) ? out : [];
    }

    // Casing lives in door-conf2-update.js (DoorConf2Update). Read the current pick so
    // it can be persisted into the saved config and admin payload.
    function getCasingSelectionsForConfig() {
        try {
            if (window.DoorConf2Update && typeof window.DoorConf2Update.getCasingSelectionsForConfig === 'function') {
                var out = window.DoorConf2Update.getCasingSelectionsForConfig();
                return Array.isArray(out) ? out : [];
            }
        } catch (eCasingCfg) { }
        return [];
    }

    function enhanceDoorSelectWithDivDropdown(selectEl) {
        if (!selectEl || selectEl.tagName !== 'SELECT') return null;
        // If marked enhanced but the custom UI is missing (select moved / enhance ran while
        // detached), clear the flag so we can recreate the dropdown.
        if (selectEl.getAttribute('data-door-div-select') === '1') {
            var next = selectEl.nextElementSibling;
            if (!(next && next.classList && next.classList.contains('door-div-select'))) {
                selectEl.removeAttribute('data-door-div-select');
                selectEl.classList.remove('door-native-select--enhanced');
            }
        }
        var out = doorConf2HardwareCall('enhanceDoorSelectWithDivDropdown', selectEl);
        if (out) return out;
        try {
            if (window.DoorConf2Update && typeof window.DoorConf2Update.enhanceDoorSelectWithDivDropdown === 'function') {
                return window.DoorConf2Update.enhanceDoorSelectWithDivDropdown(selectEl);
            }
        } catch (eUpdEnh) { }
        return null;
    }

    /** Move a select into a header row and keep its custom .door-div-select UI beside it. */
    function moveSelectWithDivDropdown(sel, headerRow) {
        if (!sel || !headerRow) return;
        var divUi = null;
        try {
            var next = sel.nextElementSibling;
            if (next && next.classList && next.classList.contains('door-div-select')) {
                divUi = next;
            } else if (sel.parentNode) {
                var sib = sel.parentNode.querySelector('.door-div-select');
                // Only adopt a sibling in the same parent that is adjacent-ish to this select.
                if (sib && (sib.previousElementSibling === sel || sel.nextElementSibling === sib)) {
                    divUi = sib;
                }
            }
        } catch (eFindDiv) { divUi = null; }
        if (sel.parentNode !== headerRow) {
            headerRow.appendChild(sel);
        }
        if (divUi) {
            try {
                if (divUi.parentNode !== headerRow || divUi.previousElementSibling !== sel) {
                    if (sel.nextSibling) headerRow.insertBefore(divUi, sel.nextSibling);
                    else headerRow.appendChild(divUi);
                }
            } catch (eMoveDiv) { }
        }
        try { enhanceDoorSelectWithDivDropdown(sel); } catch (eReEnh) { }
    }

    function renderHardwareOptionsGrid(parentEl, products) {
        return doorConf2HardwareCall('renderHardwareOptionsGrid', parentEl, products) || null;
    }

    function syncHardwareOptionsGridVisibility(hwAccordionEl, isOpen) {
        doorConf2HardwareCall('syncHardwareOptionsGridVisibility', hwAccordionEl, isOpen);
    }

    function getHwFieldDefsForLineItems() {
        var out = doorConf2HardwareCall('getHardwareFieldDefs');
        return Array.isArray(out) ? out : [];
    }

    var HARDWARE_SUMMARY_EXTRA_FIELDS = [
        { labelKeys: ['function_label'], valueKeys: ['function_value'], name: '', unlabeled: true },
        { labelKeys: ['closer_color_label'], valueKeys: ['closer_color_value'], name: 'Closer Color' },
        { labelKeys: ['thickness_label'], valueKeys: ['thickness_value'], name: 'Hardware Door Thickness' },
        { labelKeys: ['hardware_swing_direction_label', 'swing_direction_label'], valueKeys: ['hardware_swing_direction_value', 'swing_direction_value'], name: 'Hardware Swing Direction' },
        { labelKeys: ['backset_label'], valueKeys: ['backset_value'], name: 'Door Backset' },
        { labelKeys: ['track_length_label'], valueKeys: ['track_length_value'], name: 'Track Length' },
        { labelKeys: ['connected_doors_label'], valueKeys: ['connected_doors_value'], name: 'Number of Connected Doors' },
        { labelKeys: ['upper_track_length_label'], valueKeys: ['upper_track_length_value'], name: 'Upper Track Length' },
        { labelKeys: ['max_door_size_label'], valueKeys: ['max_door_size_value'], name: 'Max Door Size' },
        { labelKeys: ['carriage_pack_type_label'], valueKeys: ['carriage_pack_type_value'], name: 'Carriage Pack Type' },
        { labelKeys: ['strap_hinge_length_label'], valueKeys: ['strap_hinge_length_value'], name: 'Strap Hinge Length' }
    ];

    function readHardwareRowFieldValue(row, keys) {
        if (!row || !keys) return '';
        for (var i = 0; i < keys.length; i++) {
            var v = String(row[keys[i]] == null ? '' : row[keys[i]]).trim();
            if (v) return v;
        }
        return '';
    }

    function hardwareRowHasSwingField(row) {
        if (!row || typeof row !== 'object') return false;
        if (window.DoorConf2Hardware && typeof window.DoorConf2Hardware.hardwareRowHasSwingField === 'function') {
            return window.DoorConf2Hardware.hardwareRowHasSwingField(row);
        }
        var opts = row.hardware_swing_direction_options || row.swing_direction_options;
        return Array.isArray(opts) && opts.length > 0;
    }

    function formatHardwareSelectionSummaryLine(row) {
        if (!row || typeof row !== 'object') return '';
        var line = String(row.title || row.product_id || 'Hardware').trim();
        if (!line) line = 'Hardware';
        var seen = {};
        function appendPart(text) {
            text = String(text || '').trim();
            if (!text) return;
            var key = text.toLowerCase();
            if (seen[key]) return;
            seen[key] = true;
            line += ' — ' + text;
        }
        appendPart(row.finish_label || row.finish_value);

        var fieldDefs = getHwFieldDefsForLineItems();
        if (fieldDefs && fieldDefs.length) {
            fieldDefs.forEach(function (fieldDef) {
                if (!fieldDef) return;
                if (fieldDef.storeValue === 'swing_direction_value' && !hardwareRowHasSwingField(row)) return;
                var val = String(row[fieldDef.storeLabel] || row[fieldDef.storeValue] || '').trim();
                if (!val) return;
                if (/^(select|please select|not selected|none|n\/a)$/i.test(val)) return;
                if (seen[val.toLowerCase()]) return;
                var isFunction = fieldDef.storeLabel === 'function_label' || fieldDef.storeValue === 'function_value';
                if (isFunction) {
                    appendPart(val);
                    return;
                }
                var name = String(fieldDef.defaultLabel || '').trim();
                appendPart(name ? (name + ': ' + val) : val);
            });
        } else {
            HARDWARE_SUMMARY_EXTRA_FIELDS.forEach(function (field) {
                if (field.name === 'Hardware Swing Direction' && !hardwareRowHasSwingField(row)) return;
                var val = readHardwareRowFieldValue(row, (field.labelKeys || []).concat(field.valueKeys || []));
                if (!val) return;
                if (/^(select|please select|not selected|none|n\/a)$/i.test(val)) return;
                if (field.unlabeled) appendPart(val);
                else appendPart(field.name ? (field.name + ': ' + val) : val);
            });
        }
        if (row.qty && row.qty > 1) line += ' (×' + row.qty + ')';
        return line;
    }
    try { window.DoorConf2FormatHardwareSummaryLine = formatHardwareSelectionSummaryLine; } catch (eHwFmtExpose) { }

    var ADDITIONAL_OPTIONS_SELECT_IDS = ['door_sweep', 'door_seal_kit', 'pet_door'];
    var ADDITIONAL_OPTIONS_ACCORDION_ORDER = ['priming', 'door_sweep', 'door_seal_kit', 'pet_door'];

    function isAdditionalOptionsSelectOption(optId) {
        return ADDITIONAL_OPTIONS_SELECT_IDS.indexOf(normalizeOptionIdKey(optId)) !== -1;
    }

    /** Door Sweep / Door Stops with Seals: no empty "Select …" placeholder; default to "No …". */
    function optionWantsNoneAsDefaultSelect(optId) {
        var k = normalizeOptionIdKey(optId);
        return k === 'door_sweep' || k === 'door_seal_kit';
    }

    function resolveNoneChoiceValueForOption(optId, choices) {
        var oid = normalizeOptionIdKey(optId);
        var preferredList = oid === 'door_sweep'
            ? ['no_door_sweep']
            : (oid === 'door_seal_kit'
                ? ['no_door_stop', 'no_door_stops', 'no_door_seal_kit', 'no_door_stops_with_seals']
                : []);
        var list = Array.isArray(choices) ? choices : [];
        var i;
        for (var pi = 0; pi < preferredList.length; pi++) {
            var preferred = preferredList[pi];
            for (i = 0; i < list.length; i++) {
                var pv = list[i] && list[i].value != null ? String(list[i].value) : '';
                if (pv === preferred) return pv;
            }
        }
        for (i = 0; i < list.length; i++) {
            var v = list[i] && list[i].value != null ? String(list[i].value) : '';
            if (!v) continue;
            if (normalizeChoiceKey(v).indexOf('no_') === 0) return v;
        }
        for (i = 0; i < list.length; i++) {
            var lab = String((list[i] && (list[i].label || list[i].value)) || '').trim().toLowerCase();
            if (lab.indexOf('no ') === 0) {
                return list[i].value != null && list[i].value !== '' ? String(list[i].value) : '';
            }
        }
        return '';
    }

    function syncAdditionalOptionsSelectUi(sel) {
        if (!sel) return;
        // Custom dropdown needs the <select> in the DOM (insertAdjacentElement requires a parent).
        if (!sel.parentNode) return;
        try {
            enhanceDoorSelectWithDivDropdown(sel);
        } catch (eEnh) { }
        try {
            var dw = sel.nextElementSibling;
            if (!(dw && dw.classList && dw.classList.contains('door-div-select'))) return;
            if (window.DoorConf2Hardware && typeof window.DoorConf2Hardware.syncDoorDivSelectFromNative === 'function') {
                window.DoorConf2Hardware.syncDoorDivSelectFromNative(sel, dw);
            } else if (window.DoorConf2Update && typeof window.DoorConf2Update.syncDoorDivSelectFromNative === 'function') {
                window.DoorConf2Update.syncDoorDivSelectFromNative(sel, dw);
            }
        } catch (eSync) { }
    }

    function applyNoneDefaultToSelect(sel, optId, choices) {
        if (!sel || !optionWantsNoneAsDefaultSelect(optId)) return;
        var noneVal = resolveNoneChoiceValueForOption(optId, choices);
        if (!noneVal) {
            for (var i = 0; i < (sel.options || []).length; i++) {
                var op = sel.options[i];
                if (!op || !op.value) continue;
                var nk = normalizeChoiceKey(op.value);
                var lab = String(op.textContent || '').trim().toLowerCase();
                if (nk.indexOf('no_') === 0 || lab.indexOf('no ') === 0) {
                    noneVal = String(op.value);
                    break;
                }
            }
        }
        if (!noneVal) return;
        var has = false;
        for (var j = 0; j < (sel.options || []).length; j++) {
            if (String(sel.options[j].value) === noneVal) { has = true; break; }
        }
        if (!has) return;
        sel.value = noneVal;
        syncAdditionalOptionsSelectUi(sel);
    }

    function locksetPrepSectionVisible(wrap) {
        if (!wrap || wrap.classList.contains('door-hidden')) return false;
        if (wrap.style.display === 'none') return false;
        if (wrap.getAttribute('hidden') === 'true') return false;
        return true;
    }

    function locksetChoiceCardVisible(card) {
        if (!card) return false;
        if (card.style.display === 'none' || card.classList.contains('door-hidden')) return false;
        if (card.getAttribute('data-product-tag-hidden') === '1') return false;
        if (card.getAttribute('data-choice-condition-hidden') === '1') return false;
        return true;
    }

    function resolveLocksetPrepDefaultWantKey(wrap) {
        var def = null;
        try { def = getDefaultSelectionForOption('lockset_prep'); } catch (eDef) { }
        if (def != null && String(def).trim() !== '') {
            var cfg = normalizeChoiceKey(def);
            if (cfg && cfg !== 'no_lock_prep' && cfg !== 'no_lockset_prep') {
                var radios = wrap.querySelectorAll('input[type="radio"][data-option-id="lockset_prep"]');
                for (var i = 0; i < radios.length; i++) {
                    var card = radios[i].closest && radios[i].closest('.common-check-option');
                    if (!locksetChoiceCardVisible(card)) continue;
                    if (normalizeChoiceKey(radios[i].value) === cfg) return cfg;
                }
            }
        }
        return 'no_lock_prep';
    }

    /** Default Lockset Prep to no_lock_prep when visible and nothing is selected yet. */
    function applyLocksetPrepNoneDefault(root) {
        if (doorRestorePending()) return false;
        var scope = root || document.getElementById('door-configurator-options') || document;
        if (!scope || !scope.querySelector) return false;
        var wrap = scope.querySelector('.door-option-wrap[data-option-id="lockset_prep"]');
        if (!locksetPrepSectionVisible(wrap)) return false;

        var radios = wrap.querySelectorAll('input[type="radio"][data-option-id="lockset_prep"]');
        var already = wrap.querySelector('input[type="radio"][data-option-id="lockset_prep"]:checked');
        if (already) {
            var alreadyCard = already.closest && already.closest('.common-check-option');
            if (locksetChoiceCardVisible(alreadyCard)) return false;
        }

        var wantKey = resolveLocksetPrepDefaultWantKey(wrap);
        var target = null;
        Array.prototype.forEach.call(radios, function (r) {
            var card = r.closest && r.closest('.common-check-option');
            if (!locksetChoiceCardVisible(card)) return;
            if (normalizeChoiceKey(r.value) === wantKey) target = r;
        });
        if (!target && wantKey !== 'no_lock_prep') {
            Array.prototype.forEach.call(radios, function (r) {
                var card = r.closest && r.closest('.common-check-option');
                if (!locksetChoiceCardVisible(card)) return;
                if (normalizeChoiceKey(r.value) === 'no_lock_prep') target = r;
            });
        }
        if (!target) return false;

        Array.prototype.forEach.call(radios, function (r) {
            var on = r === target;
            r.checked = on;
            var card = r.closest && r.closest('.common-check-option');
            if (card) card.classList.toggle('common-check-option--selected', on);
        });
        try { target.dispatchEvent(new Event('change', { bubbles: true })); } catch (eChg) { }
        return true;
    }

    /** Re-apply "No …" defaults for Door Sweep / Door Stops (survives clearAllDefaultSelections). */
    function applyAdditionalOptionsNoneDefaults(root) {
        var scope = root || document.getElementById('door-configurator-options') || document;
        if (!scope || !scope.querySelectorAll) return;
        ['door_sweep', 'door_seal_kit'].forEach(function (oid) {
            var sel = scope.querySelector('select[data-option-id="' + oid + '"]');
            if (!sel) return;
            try {
                var emptyOps = [];
                for (var ei = 0; ei < (sel.options || []).length; ei++) {
                    var eop = sel.options[ei];
                    if (eop && String(eop.value || '') === '') emptyOps.push(eop);
                }
                for (var ej = 0; ej < emptyOps.length; ej++) {
                    try { sel.removeChild(emptyOps[ej]); } catch (eRmPh) { }
                }
            } catch (ePh) { }
            if (!sel.value) applyNoneDefaultToSelect(sel, oid, null);
            else syncAdditionalOptionsSelectUi(sel);
        });
    }

    function hasAdditionalOptionsCandidates(root) {
        var scope = root || document.getElementById('door-configurator') || document;
        for (var i = 0; i < ADDITIONAL_OPTIONS_ACCORDION_ORDER.length; i++) {
            var oid = ADDITIONAL_OPTIONS_ACCORDION_ORDER[i];
            if (scope.querySelector('.door-option-wrap[data-option-id="' + oid + '"], [data-option-id="' + oid + '"]')) {
                return true;
            }
        }
        return false;
    }

    /**
     * Products WITH lockset_prep (DOM) already build Additional Options + Hardware + Casing
     * in the existing render path — leave them 100% alone.
     *
     * Products WITHOUT lockset_prep: create Additional Options (if missing) and move priming /
     * sweep / seal / pet door into it with the same hydration as the lockset path.
     */
    function ensureAdditionalOptionsAccordion(container) {
        if (!container) container = document.getElementById('door-configurator-options');
        if (!container) return null;
        var root = document.getElementById('door-configurator') || container;

        // Only skip when lockset_prep is actually rendered — that path owns Additional Options /
        // Hardware / Casing and must not be raced (avoids Willowbrook style breakage).
        var hasLocksetDom = !!(container.querySelector('.door-option-wrap[data-option-id="lockset_prep"]')
            || root.querySelector('.door-option-wrap[data-option-id="lockset_prep"]'));
        if (hasLocksetDom) return null;

        function moveCommonChecksIntoHeaderRow(blockEl) {
            try {
                if (!blockEl || !blockEl.querySelector) return;
                var headerRowEl = blockEl.querySelector('.door-option-header-row');
                var checksEl = blockEl.querySelector('.common-check-options');
                if (!headerRowEl || !checksEl) return;
                if (checksEl.parentNode === headerRowEl) return;
                headerRowEl.appendChild(checksEl);
            } catch (eMoveChecks) { }
        }

        function hydrateBlock(block, oid) {
            if (!block || !oid) return;
            try {
                if (oid === 'pet_door' && shouldHidePetDoor()) {
                    block.classList.add('door-hidden');
                    block.setAttribute('data-empty-hidden', '1');
                    block.style.display = 'none';
                    return;
                }
            } catch (ePetHydrateHide) { }
            try {
                if (block.classList && !block.classList.contains('additional-options-card')) {
                    block.classList.add('additional-options-card');
                }
            } catch (eCard) { }
            moveCommonChecksIntoHeaderRow(block);
            try {
                var guardAttr =
                    (oid === 'door_seal_kit') ? 'data-seal-kit-img-hydrated'
                        : (oid === 'pet_door') ? 'data-pet-door-img-hydrated'
                            : 'data-sweep-img-hydrated';
                if (block.getAttribute(guardAttr)) {
                    enhanceAdditionalOptionsSelects(block);
                    return;
                }
                var descEls = block.querySelectorAll('.door-option-desc');
                var imgUrl = '';
                var srcDescEl = null;
                for (var di = 0; di < descEls.length; di++) {
                    var dEl = descEls[di];
                    var foundUrl = getDoorOptionDescMediaUrl(dEl);
                    if (!foundUrl) continue;
                    imgUrl = foundUrl;
                    srcDescEl = dEl;
                    break;
                }
                if (imgUrl && srcDescEl) {
                    // Keep description text free of the media URL; image is shown beside it.
                    srcDescEl.setAttribute('data-door-desc-media-url', imgUrl);
                    setDoorOptionDescriptionText(
                        srcDescEl,
                        (srcDescEl.getAttribute('data-door-original-desc') || '') + '\n' + imgUrl
                    );
                    var img = document.createElement('img');
                    img.src = imgUrl;
                    img.alt = '';
                    img.loading = 'lazy';
                    img.style.maxWidth = '100%';
                    img.style.height = 'auto';
                    img.style.display = 'block';
                    if (oid === 'door_sweep' || oid === 'door_seal_kit' || oid === 'pet_door') {
                        var headerRowSweep = block.querySelector('.door-option-header-row');
                        var selectSweep = block.querySelector('select[data-option-id="' + oid + '"]');
                        if (headerRowSweep && selectSweep) {
                            moveSelectWithDivDropdown(selectSweep, headerRowSweep);
                        }
                        if (headerRowSweep && headerRowSweep.parentNode === block) {
                            headerRowSweep.insertAdjacentElement('afterend', img);
                        } else {
                            block.appendChild(img);
                        }
                    } else {
                        srcDescEl.insertAdjacentElement('afterend', img);
                    }
                    block.setAttribute(guardAttr, '1');
                }
            } catch (eHydrate) { }
            enhanceAdditionalOptionsSelects(block);
        }

        function tryMoveOnce(addlInner) {
            if (!addlInner) return false;
            ADDITIONAL_OPTIONS_ACCORDION_ORDER.forEach(function (oid) {
                var wrap = root.querySelector('.door-option-wrap[data-option-id="' + oid + '"]')
                    || root.querySelector('[data-option-id="' + oid + '"]');
                if (!wrap) return;
                if (wrap.closest && wrap.closest('.door-post-lockset-additional-options')) {
                    hydrateBlock(wrap.closest('.door-option-wrap') || wrap, oid);
                    return;
                }
                var block = wrap.closest
                    ? (wrap.closest('.door-option-wrap') || wrap.closest('.door-section') || wrap.closest('section') || wrap)
                    : wrap;
                if (!block) return;
                if (block.classList && (
                    block.classList.contains('door-post-lockset-additional-options')
                    || block.classList.contains('door-post-lockset-hardware-options')
                    || block.classList.contains('door-post-lockset-casing-options')
                )) return;
                addlInner.appendChild(block);
                hydrateBlock(block, oid);
            });
            enhanceAdditionalOptionsSelects(addlInner);
            return true;
        }

        function revealAddlAccordion(addlAcc) {
            if (!addlAcc) return;
            addlAcc.style.display = '';
            addlAcc.removeAttribute('hidden');
            addlAcc.classList.remove('door-hidden');
        }

        function scheduleMoves(addlAcc, addlInner) {
            var maxTries = 24;
            var t = 0;
            function loop() {
                t++;
                tryMoveOnce(addlInner);
                revealAddlAccordion(addlAcc);
                var stillOutside = ADDITIONAL_OPTIONS_ACCORDION_ORDER.some(function (oid) {
                    var wrap = root.querySelector('.door-option-wrap[data-option-id="' + oid + '"]');
                    if (!wrap) return false;
                    return !(wrap.closest && wrap.closest('.door-post-lockset-additional-options'));
                });
                if ((!stillOutside && t > 2) || t >= maxTries) {
                    try { hideEmptyOptionSections(container); } catch (eHide) { }
                    revealAddlAccordion(addlAcc);
                    // Keep visible when we successfully moved priming / related options in.
                    if (addlInner && addlInner.querySelector('.door-option-wrap[data-option-id]')) {
                        revealAddlAccordion(addlAcc);
                    }
                    return;
                }
                setTimeout(loop, 200);
            }
            setTimeout(loop, 0);
        }

        var existing = container.querySelector('.door-post-lockset-additional-options')
            || root.querySelector('.door-post-lockset-additional-options');
        if (existing) {
            var existingInner = existing.querySelector('.door-accordion-body-inner');
            if (existingInner) scheduleMoves(existing, existingInner);
            return existing;
        }

        if (!hasAdditionalOptionsCandidates(root)) return null;

        var addlAcc = document.createElement('div');
        addlAcc.className = 'door-option-accordion door-post-lockset-additional-options common-icon-accordion';
        addlAcc.setAttribute('data-option-id', 'additional_options');

        var addlBtn = document.createElement('button');
        addlBtn.type = 'button';
        addlBtn.className = 'door-accordion-header';

        var addlHeaderRow = document.createElement('div');
        addlHeaderRow.className = 'door-option-header-row';
        var addlHeaderText = document.createElement('div');
        addlHeaderText.className = 'door-accordion-header-text door-option-title';
        addlHeaderText.textContent = 'Additional Options';
        addlHeaderRow.appendChild(addlHeaderText);
        addlBtn.appendChild(addlHeaderRow);

        var plusSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
            '<rect x="7" width="2" height="16" rx="1" fill="currentColor"></rect>' +
            '<rect x="16" y="7" width="2" height="16" rx="1" transform="rotate(90 16 7)" fill="currentColor"></rect>' +
            '</svg>';
        var minusSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
            '<rect x="0" y="7" width="16" height="2" rx="1" fill="currentColor"></rect>' +
            '</svg>';
        var sign = document.createElement('span');
        sign.className = 'door-accordion-sign';
        sign.innerHTML = plusSvg;
        addlBtn.appendChild(sign);

        var addlBody = document.createElement('div');
        addlBody.className = 'door-accordion-body';
        var addlInner = document.createElement('div');
        addlInner.className = 'door-accordion-body-inner';
        addlBody.appendChild(addlInner);

        addlBtn.addEventListener('click', function () {
            var opened = addlBody.classList.toggle('door-accordion-body--open');
            sign.innerHTML = opened ? minusSvg : plusSvg;
        });
        addlAcc.appendChild(addlBtn);
        addlAcc.appendChild(addlBody);

        // Place before Hardware if present; else after profile sections; else append.
        // Never mutate Hardware / Casing nodes — only insert sibling.
        var hwAcc = container.querySelector('.door-post-lockset-hardware-options');
        var afterAnchor = container.querySelector('.door-option-wrap[data-option-id="applied_molding"]')
            || container.querySelector('.door-option-wrap[data-option-id="panel_profile"]')
            || container.querySelector('.door-option-wrap[data-option-id="stile_and_rail_profile"]');
        if (hwAcc && hwAcc.parentNode === container) {
            container.insertBefore(addlAcc, hwAcc);
        } else if (afterAnchor && afterAnchor.parentNode === container) {
            container.insertBefore(addlAcc, afterAnchor.nextSibling);
        } else {
            container.appendChild(addlAcc);
        }

        scheduleMoves(addlAcc, addlInner);
        return addlAcc;
    }

    /** Catalog add-ons live in door-conf2-update.js (DoorConf2Update). */
    function applyCatalogMetaobjectAddonsFromUpdate(config) {
        try {
            if (window.DoorConf2Update && typeof window.DoorConf2Update.applyCatalogMetaobjectAddons === 'function') {
                return window.DoorConf2Update.applyCatalogMetaobjectAddons(config);
            }
        } catch (eCatUpd) { }
        window['__doorAddon_door_seal_kit_matching'] = 0;
        window['__doorAddon_door_sweeps_matching'] = 0;
        window['__doorAddon_priming_services'] = 0;
        window['__doorAddon_applied_molding_tier'] = 0;
        window['__doorAddon_pet_gates_measurements'] = 0;
        return { sealKit: 0, doorSweeps: 0, priming: 0, appliedMolding: 0, total: 0 };
    }

    function ensureDoorPriceBoxVisible() {
        try {
            if (window.DoorConf2Update && typeof window.DoorConf2Update.ensureDoorPriceBoxVisible === 'function') {
                window.DoorConf2Update.ensureDoorPriceBoxVisible();
            }
        } catch (ePriceBox) { }
    }

    function enhanceAdditionalOptionsSelects(root) {
        var scope = root || document.getElementById('door-configurator') || document;
        if (!scope || !scope.querySelectorAll) return;
        try { applyAdditionalOptionsNoneDefaults(scope); } catch (eNoneDef) { }
        ADDITIONAL_OPTIONS_SELECT_IDS.forEach(function (oid) {
            var wrap = scope.querySelector('.door-option-wrap[data-option-id="' + oid + '"]');
            if (wrap && wrap.getAttribute('data-empty-hidden') === '1') {
                wrap.removeAttribute('data-empty-hidden');
                wrap.style.display = '';
            }
            var sel = scope.querySelector('select[data-option-id="' + oid + '"]');
            if (sel) enhanceDoorSelectWithDivDropdown(sel);
        });
    }

    // Dp start 09-07 — re-enable Door Sweep / Door Stops options + rebuild custom dropdown UI
    function refreshAdditionalOptionsSelectDropdowns(root) {
        var scope = root || document.getElementById('door-configurator-options') || document.getElementById('door-configurator') || document;
        if (!scope || !scope.querySelector) return;
        ['door_sweep', 'door_seal_kit'].forEach(function (oid) {
            var sel = scope.querySelector('select[data-option-id="' + oid + '"]');
            if (!sel || !sel.options) return;
            var i;
            for (i = 0; i < sel.options.length; i++) {
                var op = sel.options[i];
                if (!op) continue;
                // Only undo product-tag hides (leave intentional showWhen/hideWhen alone).
                if (op.getAttribute('data-product-tag-hidden') === '1') {
                    op.hidden = false;
                    op.disabled = false;
                    try { op.removeAttribute('data-product-tag-hidden'); } catch (eOpAttr) { }
                }
            }
            try { applyNoneDefaultToSelect(sel, oid, null); } catch (eNone) { }
            var linked = sel.nextElementSibling;
            if (linked && linked.classList && linked.classList.contains('door-div-select')) {
                try {
                    if (window.DoorConf2Update && typeof window.DoorConf2Update.rebuildDoorDivSelectOptions === 'function') {
                        window.DoorConf2Update.rebuildDoorDivSelectOptions(sel, linked);
                    } else {
                        // Force Hardware/Update enhance to recreate list items.
                        sel.removeAttribute('data-door-div-select');
                        sel.classList.remove('door-native-select--enhanced');
                        try { linked.parentNode && linked.parentNode.removeChild(linked); } catch (eRmDiv) { }
                        enhanceDoorSelectWithDivDropdown(sel);
                    }
                } catch (eRebuild) {
                    try { enhanceDoorSelectWithDivDropdown(sel); } catch (eEnh) { }
                }
            } else {
                try { enhanceDoorSelectWithDivDropdown(sel); } catch (eEnh2) { }
            }
        });
    }
    // Dp end 09-07


    var doorConfigSchema = null;
    var autoSelectIdCounter = 0;

    function doorAutosaveRestorePending() {
        try {
            var search = String((window.location && window.location.search) || '');
            if (search.indexOf('autosave=1') === -1) return false;
            var raw = localStorage.getItem('door_autosave_payload');
            if (!raw) return false;
            var parsed = JSON.parse(raw);
            return !!(parsed && parsed.options && typeof parsed.options === 'object');
        } catch (eAutosavePending) {
            return false;
        }
    }

    function doorSavedConfigRestorePending() {
        try {
            var search = String((window.location && window.location.search) || '');
            if (/[?&]config_id=\d+/.test(search)) return true;
            var container = document.getElementById('door-configurator');
            if (container && container.getAttribute('data-edit-config-id')) return true;
        } catch (eSavedCfg) { }
        return false;
    }

    function doorRestorePending() {
        return doorAutosaveRestorePending() || doorSavedConfigRestorePending();
    }

    var DOOR_SAVED_RESTORE_BUILD = '20260604b';

    function doorSavedRestoreDebugEnabled() {
        try {
            if (window.__DOOR_SAVED_MEASUREMENT_RESTORE_DEBUG === true) return true;
            var search = String((window.location && window.location.search) || '');
            return /(?:\?|&)door_saved_restore_debug(?:=1|=true|(?=&|$))/i.test(search)
                || /(?:\?|&)door_saved_restore_debug\b/i.test(search);
        } catch (eDbgOn) { }
        return false;
    }

    function doorSavedRestoreDebugLog(phase, detail) {
        if (!doorSavedRestoreDebugEnabled()) return;
        window.__doorSavedRestoreDebugLog = window.__doorSavedRestoreDebugLog || [];
        var entry = {
            t: new Date().toISOString(),
            phase: String(phase || ''),
            detail: detail || null
        };
        window.__doorSavedRestoreDebugLog.push(entry);
        try {
            console.log('[door-saved-restore]', phase, detail || '');
        } catch (eCon) { }
        var panel = document.getElementById('door-saved-restore-debug');
        if (!panel) {
            panel = document.createElement('div');
            panel.id = 'door-saved-restore-debug';
            panel.setAttribute('aria-live', 'polite');
            panel.style.cssText = 'position:fixed;bottom:0;left:0;right:0;max-height:42vh;overflow:auto;background:rgba(0,0,0,0.92);color:#6f6;font:12px/1.45 monospace;padding:10px 12px;z-index:2147483646;border-top:2px solid #6f6;pointer-events:auto;';
            var title = document.createElement('div');
            title.style.cssText = 'color:#fff;font-weight:bold;margin-bottom:6px;';
            title.textContent = 'Door saved-restore debug (door_saved_restore_debug=1) — build ' + DOOR_SAVED_RESTORE_BUILD;
            panel.appendChild(title);
            document.body.appendChild(panel);
        }
        var line = document.createElement('div');
        line.textContent = entry.t.substr(11, 8) + ' ' + entry.phase + (detail ? ' ' + JSON.stringify(detail) : '');
        panel.appendChild(line);
    }

    try {
        window.__doorSavedRestoreDebug = doorSavedRestoreDebugLog;
        if (doorSavedRestoreDebugEnabled()) {
            doorSavedRestoreDebugLog('door-conf2.js boot', { build: DOOR_SAVED_RESTORE_BUILD });
        }
    } catch (eDbgExpose) { }

    function normalizeOptionIdKey(id) {
        return String(id || '').toLowerCase().replace(/-/g, '_');
    }

    function sanitizeForDomId(s) {
        return String(s == null ? '' : s)
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9_-]+/g, '_')
            .replace(/^_+|_+$/g, '');
    }

    function ensureSelectHasId(selectEl, prefix) {
        if (!selectEl) return '';
        if (selectEl.id) return selectEl.id;
        autoSelectIdCounter += 1;
        selectEl.id = (prefix ? String(prefix) : 'door-select') + '-' + autoSelectIdCounter;
        return selectEl.id;
    }

    function buildOptionDomId(selectId, valueOrLabel, index) {
        var base = sanitizeForDomId(selectId) || 'select';
        var v = sanitizeForDomId(valueOrLabel);
        if (!v) v = String(index != null ? index : 0);
        // Keep it compact + readable (no "__opt__" marker): <selectId>__<value>
        return base + '__' + v;
    }

    function doorConf2MeasurementsCall(name) {
        var M = window.DoorConf2Measurements;
        var fn = M && M[name];
        if (typeof fn !== 'function') return undefined;
        return fn.apply(M, Array.prototype.slice.call(arguments, 1));
    }

    function runMeasurementUiSync() { doorConf2MeasurementsCall('runMeasurementUiSync'); }
    function applyMeasurementTypeTabSelection(radioEl, measureOptionId, optionsContainer, schema) {
        doorConf2MeasurementsCall('applyMeasurementTypeTabSelection', radioEl, measureOptionId, optionsContainer, schema);
    }
    function syncMeasurementTypeDetailsVisibility(optionsContainer, schema) {
        doorConf2MeasurementsCall('syncMeasurementTypeDetailsVisibility', optionsContainer, schema);
    }
    function syncSlabSidelightMeasurementUI(optionsContainer, schema) {
        doorConf2MeasurementsCall('syncSlabSidelightMeasurementUI', optionsContainer, schema);
    }
    function syncMeasurementTabCardVisibility(optionsContainer, schema) {
        doorConf2MeasurementsCall('syncMeasurementTabCardVisibility', optionsContainer, schema);
    }
    function syncMeasurementTypeSectionPreHungGate(schema, optionsContainer) {
        doorConf2MeasurementsCall('syncMeasurementTypeSectionPreHungGate', schema, optionsContainer);
    }
    function syncHingeFinishVisibility(schema, optionsContainer) {
        doorConf2MeasurementsCall('syncHingeFinishVisibility', schema, optionsContainer);
    }
    function syncLocksetPrepVisibility(schema, optionsContainer) {
        doorConf2MeasurementsCall('syncLocksetPrepVisibility', schema, optionsContainer);
    }
    function linkStaticMeasurementRowsToSchema(schema, rootEl) {
        doorConf2MeasurementsCall('linkStaticMeasurementRowsToSchema', schema, rootEl);
    }
    function assignStaticMeasurementRowSelectIds(rootEl) {
        doorConf2MeasurementsCall('assignStaticMeasurementRowSelectIds', rootEl);
    }
    function fixPanelDoorWidthAndTransomHeightOptionRanges(rootEl) {
        doorConf2MeasurementsCall('fixPanelDoorWidthAndTransomHeightOptionRanges', rootEl);
    }
    function applyStaticMeasurementDimensionDefaults(rootEl) {
        var M = window.DoorConf2Measurements;
        if (M && typeof M.applyStaticMeasurementDimensionDefaults === 'function') {
            M.applyStaticMeasurementDimensionDefaults(rootEl);
            return;
        }
        if (!rootEl) rootEl = document.getElementById('door-configurator-options') || document;
        try {
            rootEl.querySelectorAll(
                'select#exact-door-width-int, select[id^="exact-door-width-int"],' +
                'select#finished-width-int, select[id^="finished-width-int"],' +
                'select#rough-width-int, select[id^="rough-width-int"],' +
                'select#panel-width-int, select[id^="panel-width-int"]'
            ).forEach(function (sel) {
                if (sel.getAttribute('data-door-user-changed') === '1') return;
                var cur = String(sel.value != null ? sel.value : '').trim();
                if (cur === '36') return;
                for (var oi = 0; oi < (sel.options || []).length; oi++) {
                    if (String(sel.options[oi].value) === '36') {
                        sel.value = '36';
                        break;
                    }
                }
            });
        } catch (eFb) { }
    }
    function assignUniqueOptionIds(rootEl, selectIdPrefix) {
        doorConf2MeasurementsCall('assignUniqueOptionIds', rootEl, selectIdPrefix);
    }
    function recordDoorSelectMeta(selectEl, fallbackSelectIdPrefix) {
        return doorConf2MeasurementsCall('recordDoorSelectMeta', selectEl, fallbackSelectIdPrefix) || null;
    }
    function getDoorSelectionMetaBySelectId() {
        var out = doorConf2MeasurementsCall('getDoorSelectionMetaBySelectId');
        return out && typeof out === 'object' ? out : {};
    }
    function getDoorLastSelectionMeta() {
        return doorConf2MeasurementsCall('getDoorLastSelectionMeta') || null;
    }
    function buildMeasurementTypeTabOptionList(measureOpt, schema, optionsContainer) {
        var out = doorConf2MeasurementsCall('buildMeasurementTypeTabOptionList', measureOpt, schema, optionsContainer);
        if (Array.isArray(out) && out.length) {
            if (isSidelightOrTransomCollectionActive()) {
                out = out.filter(function (o) {
                    return normalizeOptionIdKey(o && o.value) !== 'exact_door_size';
                });
            }
            return out;
        }
        var opts = (measureOpt && measureOpt.options) ? measureOpt.options : [];
        if (opts.length >= 2) {
            var outOpts = opts.slice().map(function (o) {
                if (!o) return o;
                var t = String((o.label || o.title || o.value) || '').toLowerCase();
                var v = normalizeOptionIdKey(o.value);
                // Finished Opening Size must never submit rough_opening_size.
                if ((t.indexOf('finished') !== -1 || (t.indexOf('opening') !== -1 && t.indexOf('rough') === -1))
                    && t.indexOf('rough') === -1
                    && (v === 'rough_opening_size' || v.indexOf('rough') !== -1 || !v)) {
                    return {
                        value: 'finished_opening',
                        label: o.label || 'Finished Opening Size',
                        title: o.title,
                        measureVis: o.measureVis || 'slab'
                    };
                }
                if (t.indexOf('rough') !== -1 || v === 'rough_opening_size') {
                    return {
                        value: 'rough_opening_size',
                        label: o.label || 'Rough Opening Size',
                        title: o.title,
                        measureVis: o.measureVis || 'jamb'
                    };
                }
                return o;
            });
            if (isSidelightOrTransomCollectionActive()) {
                outOpts = outOpts.filter(function (o) {
                    return normalizeOptionIdKey(o && o.value) !== 'exact_door_size';
                });
            }
            return outOpts;
        }
        return [
            { value: 'exact_door_size', label: 'Exact Door Size', measureVis: 'always' },
            { value: 'finished_opening', label: 'Finished Opening Size', measureVis: 'slab' },
            { value: 'rough_opening_size', label: 'Rough Opening Size', measureVis: 'jamb' },
            { value: 'jamb_unit_size', label: 'Jamb Unit Size', measureVis: 'jamb' }
        ].filter(function (o) {
            return !(isSidelightOrTransomCollectionActive() && normalizeOptionIdKey(o && o.value) === 'exact_door_size');
        });
    }
    function findPreHungStyleOption(schema) {
        return doorConf2MeasurementsCall('findPreHungStyleOption', schema) || null;
    }
    function getPreHungDoorSetupChoices(schema) {
        var out = doorConf2MeasurementsCall('getPreHungDoorSetupChoices', schema);
        return Array.isArray(out) ? out : [];
    }
    function initializePanelUnitDesignSections(container, schema) {
        doorConf2MeasurementsCall('initializePanelUnitDesignSections', container, schema);
    }
    function appendStaticPanelUnitDesignSection(container) {
        return doorConf2MeasurementsCall('appendStaticPanelUnitDesignSection', container) || null;
    }
    function schemaIncludesPanelUnitDesignOption(schema) {
        return !!doorConf2MeasurementsCall('schemaIncludesPanelUnitDesignOption', schema);
    }
    function productIsPorchPanelProduct() {
        return !!doorConf2MeasurementsCall('productIsPorchPanelProduct');
    }
    function panelUnitDesignSectionExists(root) {
        return !!doorConf2MeasurementsCall('panelUnitDesignSectionExists', root);
    }
    function optionIsPanelUnitDesign(opt) {
        return !!doorConf2MeasurementsCall('optionIsPanelUnitDesign', opt);
    }
    function measurementSchemaUsesJsonVisibility(schema) {
        return !!doorConf2MeasurementsCall('measurementSchemaUsesJsonVisibility', schema);
    }
    function isMeasurementTypeOptionId(id) {
        return normalizeOptionIdKey(id) === 'measurement_type';
    }
    function measurementModeFromCheckedTab(chk, optionsContainer, schema) {
        return doorConf2MeasurementsCall('measurementModeFromCheckedTab', chk, optionsContainer, schema) || '';
    }
    function syncMeasurementSelectedPriceLabels(opts) {
        doorConf2MeasurementsCall('syncMeasurementSelectedPriceLabels', opts);
    }

    function displayLabelForMeasurementTabChoice(o) {
        var out = doorConf2MeasurementsCall('displayLabelForMeasurementTabChoice', o);
        if (out) return out;
        if (!o) return '';
        return String(o.label || o.value || '');
    }

    function isMeasurementSidelightTransomTabValue(valueKey) {
        if (doorConf2MeasurementsCall('isMeasurementSidelightTransomTabValue', valueKey)) return true;
        var v = normalizeOptionIdKey(valueKey);
        return v === 'exact_sidelight_size' || v === 'exact_transom_size';
    }

    function resolveMeasurementTabProductTagShouldHide(schema, tabValueKey) {
        return !!doorConf2MeasurementsCall('resolveMeasurementTabProductTagShouldHide', schema, tabValueKey);
    }

    function isPanelUnitDesignSectionEl(el) {
        return !!doorConf2MeasurementsCall('isPanelUnitDesignSectionEl', el);
    }


    /** Schema option for swing direction (metaobject key e.g. swing_direction). Used to mirror choices under pre_hung. */
    function findSwingDirectionOption(schema) {
        if (!Array.isArray(schema)) return null;
        for (var si = 0; si < schema.length; si++) {
            var sopt = schema[si];
            if (!sopt || !sopt.id) continue;
            var st = (sopt.type || '').toLowerCase();
            if (st !== 'radio' && st !== 'select') continue;
            var sid = normalizeOptionIdKey(sopt.id);
            if (sid === 'swing_direction' || sid === 'swingdirection') return sopt;
            var slab = String(sopt.label || '').toLowerCase();
            if (slab.indexOf('swing') !== -1 && slab.indexOf('direction') !== -1) return sopt;
        }
        return null;
    }

    /** True when this schema option is the Pre Hung / pre-hung style control (radio or select). */
    function optionIsPreHungStyle(opt) {
        if (!opt || !opt.id) return false;
        var t = (opt.type || '').toLowerCase();
        if (t !== 'radio' && t !== 'select') return false;
        var id = normalizeOptionIdKey(opt.id);
        var lab = String(opt.label || '').toLowerCase();
        if (id.indexOf('pre_hung') !== -1 || id.indexOf('prehung') !== -1) return true;
        if (lab.indexOf('pre-hung') !== -1) return true;
        if (lab.indexOf('pre') !== -1 && lab.indexOf('hung') !== -1) return true;
        return false;
    }

    /** True when this schema option is Select Wood (wood species radio or select). */
    function optionIsSelectWood(opt) {
        if (!opt || !opt.id) return false;
        var t = (opt.type || '').toLowerCase();
        if (t !== 'radio' && t !== 'select') return false;
        var id = String(opt.id || '').toLowerCase().replace(/-/g, '_');
        var lab = String(opt.label || '').toLowerCase();
        if (id.indexOf('wood') !== -1) return true;
        if (lab.indexOf('wood') !== -1) return true;
        return false;
    }

    function optionIsWoodType(opt) {
        if (!opt) return false;
        return String(opt.id || '').toLowerCase().replace(/-/g, '_') === 'wood_type';
    }

    function optionIsScreenAndStormInserts(opt) {
        if (!opt) return false;
        var id = String(opt.id || '').toLowerCase().replace(/-/g, '_');
        var lab = String(opt.label || '').toLowerCase();
        if (id === 'screen_and_storm_inserts') return true;
        return lab.indexOf('screen') !== -1 && lab.indexOf('storm') !== -1 && lab.indexOf('insert') !== -1;
    }

    function findScreenAndStormInsertsAdditionalOptionsOpt(schema) {
        if (!Array.isArray(schema)) return null;
        for (var iai = 0; iai < schema.length; iai++) {
            var iaOpt = schema[iai];
            if (!iaOpt || !iaOpt.id) continue;
            if (normalizeOptionIdKey(iaOpt.id) === 'screen_and_storm_inserts_additional_options') return iaOpt;
        }
        return null;
    }

    function insertsAddlWhenToRefs(when) {
        if (when == null) return [];
        if (typeof when === 'string' && when.trim()) {
            try { when = JSON.parse(when); } catch (eWhenParse) { return []; }
        }
        var refs = [];
        function pushRef(refId, refValue) {
            if (!refId || refValue == null || refValue === '') return;
            refs.push({ refId: String(refId), refValue: refValue });
        }
        if (Array.isArray(when)) {
            when.forEach(function (cond) {
                if (!cond || typeof cond !== 'object') return;
                if (cond.key != null && cond.value != null) {
                    pushRef(cond.key, cond.value);
                    return;
                }
                Object.keys(cond).forEach(function (k) {
                    var v = cond[k];
                    if (Array.isArray(v)) v.forEach(function (vv) { pushRef(k, vv); });
                    else pushRef(k, v);
                });
            });
            return refs;
        }
        if (when && typeof when === 'object') {
            Object.keys(when).forEach(function (k) {
                var v = when[k];
                if (Array.isArray(v)) v.forEach(function (vv) { pushRef(k, vv); });
                else pushRef(k, v);
            });
        }
        return refs;
    }

    function getInsertsAddlChoiceShowWhenRefs(choice) {
        if (!choice) return [];
        if (choice.showWhenListRaw != null && String(choice.showWhenListRaw) !== '') {
            return insertsAddlWhenToRefs(choice.showWhenListRaw);
        }
        if (choice.showWhen) return insertsAddlWhenToRefs(choice.showWhen);
        return [];
    }

    /** True when the config_choice has at least one show_when key + value in the metaobject. */
    function insertsAddlChoiceHasConfiguredShowWhen(choice) {
        return getInsertsAddlChoiceShowWhenRefs(choice).length > 0;
    }

    function insertsAdditionalOptionsSchemaHasConfiguredChoices(schema) {
        var addlOpt = findScreenAndStormInsertsAdditionalOptionsOpt(schema);
        if (!addlOpt || !Array.isArray(addlOpt.options) || !addlOpt.options.length) return false;
        return addlOpt.options.some(insertsAddlChoiceHasConfiguredShowWhen);
    }

    function getInsertsAdditionalOptionsChoicesForMode(schema, insertsMode) {
        var addlOpt = findScreenAndStormInsertsAdditionalOptionsOpt(schema);
        if (!addlOpt || !Array.isArray(addlOpt.options) || !addlOpt.options.length) return [];
        if (!insertsAdditionalOptionsSchemaHasConfiguredChoices(schema)) return [];
        var modeKey = normalizeChoiceKey(insertsMode);
        var out = [];
        addlOpt.options.forEach(function (choice) {
            if (!insertsAddlChoiceHasConfiguredShowWhen(choice)) return;
            var refs = getInsertsAddlChoiceShowWhenRefs(choice);
            var matches = refs.some(function (r) {
                // --- Dp start 16-07 ---
                var refNorm = normalizeChoiceKey(r.refValue);
                return refNorm === modeKey
                    || (refNorm === 'screen_and_storm_inserts' && modeKey === 'screen_and_storm_inserts_choice')
                    || (refNorm === 'screen_and_storm_inserts_choice' && modeKey === 'screen_and_storm_inserts');
                // --- Dp end 16-07 ---
            });
            if (!matches) return;
            var val = choice.value != null && choice.value !== '' ? String(choice.value) : '';
            if (!val) return;
            // dp start 21-07
            // Dp start 22-07 — hide Top & Bottom Inserts choices only when metafield is false (unset/true = show)
            // Hide top & bottom inserts choices if metafield says so (true = show, false/unset = hide)
            if (val === 'top_bottom_inserts' || val === 'top_bottom_inserts_screen' || val === 'top_bottom_inserts_glass') {
                try {
                    if (shouldHideTopBottomInserts()) return;
                } catch (e) { }
            }
            if (val === 'fixed_screen') {
                try {
                    if (shouldHideFixedScreen()) return;
                } catch (e) { }
            }
            if (val === 'fixed_glass') {
                try {
                    if (shouldHideFixedGlass()) return;
                } catch (e) { }
            }
            // Dp end 22-07
            // dp end 21-07
            out.push({
                value: val,
                label: choice.label || choice.title || val,
                desc: normalizeChoiceDescriptionText(choice.description)
            });
        });
        return out;
    }

    function insertsAdditionalOptionDisplayLabel(value, container) {
        var val = String(value || '').trim();
        if (!val) return '';
        var root = container || document.getElementById('door-configurator-options') || document;
        var escaped = val.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        var inp = root.querySelector('input[data-option-id="screen_and_storm_inserts_additional_options"][value="' + escaped + '"]');
        if (inp) {
            var card = inp.closest ? inp.closest('.common-check-option') : null;
            var lblEl = card ? card.querySelector('.common-check-option-label') : null;
            var lbl = lblEl ? String(lblEl.textContent || '').trim() : '';
            if (lbl) return lbl.replace(/\s*\(optional\)\s*$/i, '').trim() || lbl;
        }
        var addlOpt = findScreenAndStormInsertsAdditionalOptionsOpt(doorConfigSchema);
        if (addlOpt && Array.isArray(addlOpt.options)) {
            for (var i = 0; i < addlOpt.options.length; i++) {
                var c = addlOpt.options[i];
                if (c && String(c.value || '') === val) {
                    var schemaLbl = String(c.label || c.title || '').trim();
                    if (schemaLbl) return schemaLbl.replace(/\s*\(optional\)\s*$/i, '').trim() || schemaLbl;
                    break;
                }
            }
        }
        var fallback = {
            top_bottom_inserts_glass: 'Top & Bottom Inserts',
            top_bottom_inserts_screen: 'Top & Bottom Inserts',
            top_bottom_inserts: 'Top & Bottom Inserts',
            fixed_glass: 'Fixed Glass',
            fixed_screen: 'Fixed Screen'
        };
        if (fallback[val]) return fallback[val];
        return val.replace(/_/g, ' ');
    }

    function getSelectedInsertsAdditionalOptionLabels(config, container) {
        var seen = {};
        var values = [];
        function pushVal(v) {
            var s = String(v == null ? '' : v).trim();
            if (!s || seen[s]) return;
            seen[s] = true;
            values.push(s);
        }
        if (config) {
            var raw = config.screen_and_storm_inserts_additional_options;
            if (Array.isArray(raw)) raw.forEach(pushVal);
            else if (raw != null && raw !== '') pushVal(raw);
        }
        var root = container || document.getElementById('door-configurator-options');
        if (root) {
            all('input[type="checkbox"][data-option-id="screen_and_storm_inserts_additional_options"]:checked', root).forEach(function (inp) {
                pushVal(inp.value);
            });
        }
        return values.map(function (v) {
            return insertsAdditionalOptionDisplayLabel(v, root);
        }).filter(Boolean);
    }

    function optionIsScreenType(opt) {
        if (!opt) return false;
        return String(opt.id || '').toLowerCase().replace(/-/g, '_') === 'screen_type';
    }

    function optionIsScreenStormInsertFrameColor(opt) {
        if (!opt) return false;
        return String(opt.id || '').toLowerCase().replace(/-/g, '_') === 'screen_storm_insert_frame_color';
    }

    function optionIsGlassType(opt) {
        if (!opt) return false;
        return String(opt.id || '').toLowerCase().replace(/-/g, '_') === 'glass_type';
    }

    function getSelectedScreenStormInsertsMode(container) {
        if (!container) {
            container = document.getElementById('door-configurator-options')
                || document.getElementById('door-configurator');
        }
        if (!container) return '';
        var checked = container.querySelector('input[type="radio"][data-option-id="screen_and_storm_inserts"]:checked');
        var v = checked ? String(checked.value || '') : '';
        if (!v) {
            var sel = container.querySelector('select[data-option-id="screen_and_storm_inserts"]');
            if (sel) v = String(sel.value || '');
        }
        try { return normalizeChoiceKey(v); } catch (eNorm) {
            return String(v || '').toLowerCase().replace(/-/g, '_');
        }
    }

    function insertsModeShowsScreenType(mode) {
        var m = String(mode || '');
        return m === 'screen_insert_only'
            || m === 'screen_and_storm_inserts_choice'
            || m === 'screen_and_storm_inserts';
    }

    function insertsModeShowsStormGlassType(mode) {
        var m = String(mode || '');
        return m === 'storm_glass_only'
            || m === 'screen_and_storm_inserts_choice'
            || m === 'screen_and_storm_inserts';
    }

    function isScreenTypeOptionId(optId) {
        var id = String(optId || '').toLowerCase().replace(/-/g, '_');
        return id === 'screen_type' || id === 'select_screen';
    }

    function isStormGlassTypeOptionId(optId) {
        var id = String(optId || '').toLowerCase().replace(/-/g, '_');
        return id === 'storm_glass_type'
            || id === 'storm_glass'
            || id === 'select_storm_glass'
            || id === 'glass_type';
    }

    function isInactiveScreenStormTypeOption(optId, container) {
        var mode = getSelectedScreenStormInsertsMode(container);
        if (!mode) return false;
        if (isScreenTypeOptionId(optId)) return !insertsModeShowsScreenType(mode);
        if (isStormGlassTypeOptionId(optId)) return !insertsModeShowsStormGlassType(mode);
        return false;
    }

    function pruneInactiveScreenStormSelections(config, container) {
        if (!config || typeof config !== 'object') return config;
        var mode = getSelectedScreenStormInsertsMode(container);
        if (!mode) return config;
        if (!insertsModeShowsScreenType(mode)) {
            ['screen_type', 'select_screen'].forEach(function (id) {
                if (Object.prototype.hasOwnProperty.call(config, id)) config[id] = null;
            });
        }
        if (!insertsModeShowsStormGlassType(mode)) {
            ['storm_glass_type', 'storm_glass', 'select_storm_glass', 'glass_type'].forEach(function (id) {
                if (Object.prototype.hasOwnProperty.call(config, id)) config[id] = null;
            });
            if (Object.prototype.hasOwnProperty.call(config, 'glass_bevel')) config.glass_bevel = [];
        }
        return config;
    }

    function isInactiveScreenStormSummaryLabel(label, container) {
        var key = String(label || '').toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
        if (!key) return false;
        var mode = getSelectedScreenStormInsertsMode(container);
        if (!mode) return false;
        var looksScreenType = (key.indexOf('screen') !== -1 && key.indexOf('type') !== -1)
            || key === 'select screen';
        var looksStormType = (key.indexOf('storm') !== -1 && (key.indexOf('glass') !== -1 || key.indexOf('type') !== -1))
            || key.indexOf('select storm') !== -1
            || (key.indexOf('glass type') !== -1 && key.indexOf('screen') === -1);
        if (looksScreenType && !insertsModeShowsScreenType(mode)) return true;
        if (looksStormType && !insertsModeShowsStormGlassType(mode)) return true;
        return false;
    }

    function clearOptionRadioSelections(optionsContainer, optionIds) {
        if (!optionsContainer || !optionIds || !optionIds.length) return;
        optionIds.forEach(function (oid) {
            optionsContainer.querySelectorAll('input[type="radio"][data-option-id="' + oid + '"]').forEach(function (inp) {
                if (!inp.checked) return;
                inp.checked = false;
                var card = inp.closest && inp.closest('.common-check-option');
                if (card) card.classList.remove('common-check-option--selected');
            });
            optionsContainer.querySelectorAll('select[data-option-id="' + oid + '"]').forEach(function (sel) {
                if (!sel || !sel.value) return;
                sel.value = '';
                try { sel.dispatchEvent(new Event('change', { bubbles: true })); } catch (eSel) { }
            });
        });
    }

    function clearScreenTypeSelections(optionsContainer) {
        if (!optionsContainer) {
            optionsContainer = document.getElementById('door-configurator-options')
                || document.getElementById('door-configurator');
        }
        if (!optionsContainer) return;
        clearOptionRadioSelections(optionsContainer, ['screen_type', 'select_screen']);
    }

    /** Clear storm/glass type + bevel when leaving Fixed Glass (e.g. switch to Screen Only). */
    function clearStormGlassTypeSelections(optionsContainer) {
        if (!optionsContainer) {
            optionsContainer = document.getElementById('door-configurator-options')
                || document.getElementById('door-configurator');
        }
        if (!optionsContainer) return;
        clearOptionRadioSelections(optionsContainer, [
            'glass_type',
            'storm_glass_type',
            'storm_glass',
            'select_storm_glass'
        ]);
        optionsContainer.querySelectorAll('input[type="checkbox"][data-option-id="glass_bevel"]').forEach(function (bevel) {
            if (!bevel.checked) return;
            bevel.checked = false;
            try { bevel.dispatchEvent(new Event('change', { bubbles: true })); } catch (eBevel) { }
        });
    }

    function findGlassBevelOption(schema) {
        if (!Array.isArray(schema)) return null;
        for (var gi = 0; gi < schema.length; gi++) {
            var gopt = schema[gi];
            if (!gopt || !gopt.id) continue;
            var gid = String(gopt.id || '').toLowerCase().replace(/-/g, '_');
            if (gid === 'glass_bevel') return gopt;
        }
        return null;
    }

    function appendGlassBevelSwitchToSection(section, schema) {
        if (!section || !schema) return;
        if (section.querySelector('.door-bevel-glass-switch-wrap')) {
            try { ensureStainedGlassDisclaimerAfterBevel(section); } catch (eStainedExist) { }
            return;
        }
        var glassBevelOpt = findGlassBevelOption(schema);
        var bevelChoice = (glassBevelOpt && Array.isArray(glassBevelOpt.options) && glassBevelOpt.options.length)
            ? (glassBevelOpt.options[0] || {})
            : {};

        var bevelWrap = document.createElement('div');
        bevelWrap.className = 'door-bevel-glass-switch-wrap';

        var bevelText = document.createElement('span');
        bevelText.className = 'door-bevel-glass-switch-label';
        bevelText.textContent = (glassBevelOpt && glassBevelOpt.label && !/^bevel glass$/i.test(String(glassBevelOpt.label).trim()))
            ? glassBevelOpt.label
            : 'Beveled Glass';
        bevelWrap.appendChild(bevelText);

        var bevelLabel = document.createElement('label');
        bevelLabel.className = 'common-switch';

        var bevelInput = document.createElement('input');
        bevelInput.type = 'checkbox';
        bevelInput.setAttribute('data-option-id', glassBevelOpt && glassBevelOpt.id ? glassBevelOpt.id : 'glass_bevel');
        bevelInput.name = 'attributes[' + ((glassBevelOpt && (glassBevelOpt.label || glassBevelOpt.id)) || 'Beveled Glass') + '][]';
        bevelInput.value = bevelChoice.value != null ? String(bevelChoice.value) : 'true';
        bevelLabel.appendChild(bevelInput);

        var bevelKnob = document.createElement('span');
        bevelKnob.className = 'common-switch-slider';
        bevelLabel.appendChild(bevelKnob);

        bevelWrap.appendChild(bevelLabel);
        section.appendChild(bevelWrap);

        bevelInput.addEventListener('change', function () {
            updateEstimatedPrice();
            try { updateDoorPreview(); } catch (eBevelPreview) { }
        });
        try { syncBevelGlassSwitchVisibility(section); } catch (eBevelVisAppend) { }
        try { ensureStainedGlassDisclaimerAfterBevel(section); } catch (eStainedNote) { }
    }

    var STAINED_GLASS_DISCLAIMER_TEXT =
        '*Stained Glass shown is an example only. We’ll work with you to select or create the right stained glass design for your door and your home.';

    function glassTypeSectionHasStainedGlassOption(section) {
        if (!section || !section.querySelector) return false;
        return !!section.querySelector(
            'input[type="radio"][data-option-id="glass_type"][value="stained_glass"],' +
            'input[type="radio"][data-option-id="storm_glass_type"][value="stained_glass"],' +
            'input[type="radio"][name="attributes[Select Glass]"][value="stained_glass"]'
        );
    }

    /** Show static stained-glass note after .door-bevel-glass-switch-wrap when stained_glass choice exists. */
    function ensureStainedGlassDisclaimerAfterBevel(section) {
        if (!section) {
            var root = document.getElementById('door-configurator-options')
                || document.getElementById('door-configurator');
            if (!root) return;
            var sections = root.querySelectorAll(
                '.door-option-wrap[data-option-id="glass_type"],' +
                '.door-option-wrap[data-option-id="storm_glass_type"],' +
                '.door-section[data-option-id="glass_type"],' +
                '.door-section[data-option-id="storm_glass_type"]'
            );
            Array.prototype.forEach.call(sections, function (sec) {
                try { ensureStainedGlassDisclaimerAfterBevel(sec); } catch (eSec) { }
            });
            return;
        }
        var bevelWrap = section.querySelector('.door-bevel-glass-switch-wrap');
        var existing = section.querySelector('.door-stained-glass-disclaimer');
        if (!glassTypeSectionHasStainedGlassOption(section)) {
            if (existing) existing.remove();
            return;
        }
        if (!bevelWrap) return;
        if (existing) {
            if (existing.previousElementSibling !== bevelWrap) {
                bevelWrap.insertAdjacentElement('afterend', existing);
            }
            existing.classList.remove('door-hidden');
            existing.style.display = '';
            return;
        }
        var note = document.createElement('p');
        note.className = 'door-stained-glass-disclaimer';
        note.textContent = STAINED_GLASS_DISCLAIMER_TEXT;
        bevelWrap.insertAdjacentElement('afterend', note);
    }

    /* MERGE: product_wise_edge_profile_sdl — start */
    function isDividedLightSdlOnly() {
        var main = document.getElementById('door-configurator')
            || document.getElementById('landing-product-configurator');
        if (!main) return false;
        var raw = String(main.getAttribute('data-divided-light') || '')
            .trim()
            .toLowerCase()
            .replace(/[_-]+/g, ' ')
            .replace(/\s+/g, ' ');
        return raw === 'sdl only';
    }

    /** AG = SDL Only → no Simulated Divided Light toggle; SDL cards show directly. */
    function shouldHideSdlToggleForSdlOnly() {
        try { return isDividedLightSdlOnly(); } catch (eSdlOnlyToggle) { return false; }
    }

    /** AG (data-divided-light) is empty/blank → hide all SDL (section, toggle, switch). */
    function isDividedLightEmpty() {
        var main = document.getElementById('door-configurator')
            || document.getElementById('landing-product-configurator');
        if (!main) return false;
        var raw = String(main.getAttribute('data-divided-light') || '').trim();
        return raw === '';
    }

    function syncBevelGlassSwitchVisibility(optionsContainer) {
        var root = optionsContainer
            || document.getElementById('door-configurator-options')
            || document.getElementById('door-configurator');
        if (!root) return;
        var wraps = root.querySelectorAll('.door-bevel-glass-switch-wrap');
        if (!wraps || !wraps.length) return;
        // Only hide Bevel glass when custom.divided_light = "SDL Only".
        // Do not hide based on product_wise sdl_profile:true (or other SDL metafields).
        var hideBevel = isDividedLightSdlOnly();
        Array.prototype.forEach.call(wraps, function (bevelWrap) {
            bevelWrap.classList.toggle('door-hidden', hideBevel);
            bevelWrap.style.display = hideBevel ? 'none' : '';
            if (hideBevel) {
                var inp = bevelWrap.querySelector('input[type="checkbox"][data-option-id="glass_bevel"]');
                if (inp && inp.checked) {
                    inp.checked = false;
                    try { updateEstimatedPrice(); } catch (eBevelPrice) { }
                    try { updateDoorPreview(); } catch (eBevelPrev) { }
                }
            }
        });
        try { ensureStainedGlassDisclaimerAfterBevel(root); } catch (eStainedAfterBevel) { }
    }
    /* MERGE: product_wise_edge_profile_sdl — end */

    function optionIsStileAndRailProfile(opt) {
        if (!opt) return false;
        return String(opt.id || '').toLowerCase().replace(/-/g, '_') === 'stile_and_rail_profile';
    }

    function optionIsAppliedMolding(opt) {
        if (!opt) return false;
        var id = String(opt.id || '').toLowerCase().replace(/-/g, '_');
        return id === 'applied_molding' || id === 'applied_molding_choice';
    }

    function normalizeChoiceKey(v) {
        var k = String(v == null ? '' : v).trim().toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
        if (k === 'carftsman') k = 'craftsman';
        // --- Dp start 16-07  ---
        if (k === 'screen_&_storm_inserts' || k === 'screen_storm_inserts') k = 'screen_and_storm_inserts';
        if (k === 'screen_&_storm_inserts_choice' || k === 'screen_storm_inserts_choice') k = 'screen_and_storm_inserts_choice';
        // --- Dp end 16-07  ---
        return k;
    }

    // --- Dp start 16-07 ---
    // SDL Profile section only for these stile selections (hide for roman_ogee, bead_and_cove, etc.).
    var SDL_STILE_PROFILE_KEYS = ['quarter_bead', 'craftsman'];
    /** SDL profiles shown per stile_and_rail_profile selection. */
    var SDL_PROFILE_STATIC_BY_STILE = {
        quarter_bead: ['bell_ogee', 'half_round'],
        craftsman: ['flat'],
        roman_ogee: ['bell_ogee', 'half_round', 'roman_ogee'],
        bead_and_cove: ['cove', 'half_round', 'bell_ogee', 'bead_and_cove']
    };
    // --- Dp end 16-07 ---
    /** SDL profiles shown when Applied Molding stile + RM5 molding are selected. */
    var SDL_PROFILE_BY_APPLIED_MOLDING_RM5 = ['bell_ogee', 'flat', 'cove', 'half_round'];
    var _sdlProfileSyncTimer = null;

    function canonicalSdlProfileKey(key) {
        var k = normalizeChoiceKey(key);
        if (!k) return '';
        if (k === 'halfround' || k === 'half_round' || k.indexOf('half_round') === 0) return 'half_round';
        if (k === 'bellogee' || k === 'bell_ogee' || k.indexOf('bell_ogee') === 0) return 'bell_ogee';
        if (k === 'flat' || k.indexOf('flat') === 0) return 'flat';
        if (k === 'cove' || k.indexOf('cove') === 0) return 'cove';
        // --- Dp start 16-07 ---
        if (
            k === 'romanogee' || k === 'roman_ogee' || k.indexOf('roman_ogee') === 0
            || (k.indexOf('roman') !== -1 && k.indexOf('ogee') !== -1)
        ) return 'roman_ogee';
        if (
            k === 'bead_and_cove' || k === 'bead_cove' || k === 'beadandcove'
            || k === 'bead_love' || k === 'bead_and_love'
            || (k.indexOf('bead') !== -1 && k.indexOf('cove') !== -1)
        ) return 'bead_and_cove';
        // --- Dp end 16-07 ---
        return k;
    }

    function sdlProfileKeyInAllowedList(choiceKey, allowedList) {
        var canon = canonicalSdlProfileKey(choiceKey);
        if (!canon) return false;
        for (var ai = 0; ai < allowedList.length; ai++) {
            if (canonicalSdlProfileKey(allowedList[ai]) === canon) return true;
        }
        return false;
    }

    function canonicalStileProfileKey(key) {
        var k = normalizeChoiceKey(key);
        if (!k) return '';
        if (k === 'quarter_bead' || k === 'quarterbead' || k.indexOf('quarter_bead') === 0) return 'quarter_bead';
        if (k === 'craftsman' || k === 'carftsman') return 'craftsman';
        // Individual stile option from product-wise stile_and_rail_profile (not the Applied Molding accordion gate).
        if (k === 'rm5' || k === 'rm_5' || k === 'rm5_applied_molding') return 'rm5_applied_molding';
        if (k === 'applied_molding' || k === 'applied_moldings' || k === 'applied_molding_choice' || k.indexOf('applied_molding') === 0) {
            return 'applied_molding';
        }
        // --- Dp start 16-07 ---
        if (k === 'romanogee' || k === 'roman_ogee' || (k.indexOf('roman') !== -1 && k.indexOf('ogee') !== -1)) return 'roman_ogee';
        if (
            k === 'bead_and_cove' || k === 'bead_cove' || k === 'beadandcove'
            || k === 'bead_love' || k === 'bead_and_love'
            || (k.indexOf('bead') !== -1 && (k.indexOf('cove') !== -1 || k.indexOf('love') !== -1))
        ) return 'bead_and_cove';
        // --- Dp end 16-07 ---
        return k;
    }

    function stileProfileKeyInList(stileKey, list) {
        var canon = canonicalStileProfileKey(stileKey);
        for (var i = 0; i < list.length; i++) {
            if (canonicalStileProfileKey(list[i]) === canon) return true;
        }
        return false;
    }

    function scheduleSdlProfileVisibilitySync(optionsContainer) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer) return;
        if (_sdlProfileSyncTimer) clearTimeout(_sdlProfileSyncTimer);
        _sdlProfileSyncTimer = setTimeout(function () {
            _sdlProfileSyncTimer = null;
            // --- Dp start 16-07 ---
            try { syncAppliedMoldingSectionVisibility(optionsContainer); } catch (eAmVisSched) { }
            // --- Dp end 16-07 ---
            try { syncSdlProfileVisibility(optionsContainer); } catch (eSdlSched) { }
        }, 0);
    }

    // --- Dp start 16-07 ---
    /**
     * Applied Molding is merged into stile_and_rail_profile (e.g. rm5_applied_molding).
     * Always hide the standalone Applied Molding accordion section.
     */
    function syncAppliedMoldingSectionVisibility(optionsContainer) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer) return;
        var wraps = optionsContainer.querySelectorAll(
            '.door-option-wrap[data-option-id="applied_molding"], .door-option-wrap[data-option-id="applied_molding_choice"]'
        );
        if (!wraps || !wraps.length) return;

        Array.prototype.forEach.call(wraps, function (wrap) {
            if (!wrap) return;
            wrap.classList.add('door-hidden');
            wrap.style.display = 'none';
            wrap.setAttribute('data-empty-hidden', '1');
            wrap.setAttribute('hidden', 'true');
            wrap.querySelectorAll(
                'input[type="radio"][data-option-id="applied_molding"], input[type="radio"][data-option-id="applied_molding_choice"]'
            ).forEach(function (inp) {
                inp.checked = false;
                var card = inp.closest && inp.closest('.common-check-option');
                if (card) card.classList.remove('common-check-option--selected');
            });
            var addlWraps = wrap.querySelectorAll('.door-inserts-additional-options.screen-and-storm-inserts');
            Array.prototype.forEach.call(addlWraps, function (aw) {
                if (!aw) return;
                aw.style.display = 'none';
                aw.classList.add('door-hidden');
            });
        });
    }

    /* MERGE: product_wise_applied_molding_accordion — start */
    /** @deprecated Applied Molding accordion is always hidden (merged into stile). */
    function applyProductWiseRm5AppliedMoldingOnly(optionsContainer) {
        // no-op — molding choices live under stile_and_rail_profile now
    }
    /* MERGE: product_wise_applied_molding_accordion — end */
    // --- Dp end 16-07 ---

    function pushUniqueChoiceKey(keys, raw) {
        var key = normalizeChoiceKey(raw);
        if (key && keys.indexOf(key) === -1) keys.push(key);
    }

    function collectStileProfileKeysFromCard(card, keys) {
        if (!card) return;
        pushUniqueChoiceKey(keys, card.getAttribute('data-choice-value') || '');
        var inp = card.querySelector('input[data-option-id="stile_and_rail_profile"]');
        if (inp) pushUniqueChoiceKey(keys, inp.value);
        var lbl = card.querySelector('.common-check-option-label');
        if (lbl) pushUniqueChoiceKey(keys, lbl.textContent);
    }

    function getSelectedStileProfileKeys(optionsContainer) {
        var keys = [];
        if (!optionsContainer) return keys;
        var checked = optionsContainer.querySelector('input[type="radio"][data-option-id="stile_and_rail_profile"]:checked');
        if (checked) {
            collectStileProfileKeysFromCard(checked.closest && checked.closest('.common-check-option'), keys);
            pushUniqueChoiceKey(keys, checked.value);
            return keys;
        }
        // Hero card is the visible default when no radio is checked yet (e.g. Quarter Bead on load).
        var heroCard = optionsContainer.querySelector('.door-stile-rail-primary-option .common-check-option');
        collectStileProfileKeysFromCard(heroCard, keys);
        return keys;
    }

    function getAppliedMoldingChoiceKeys(optionsContainer) {
        var keys = [];
        if (!optionsContainer) return keys;
        var optionIds = ['applied_molding_choice', 'applied_molding'];
        for (var oi = 0; oi < optionIds.length; oi++) {
            var oid = optionIds[oi];
            var checked = optionsContainer.querySelector('input[type="radio"][data-option-id="' + oid + '"]:checked');
            if (checked) {
                var valKey = normalizeChoiceKey(checked.value);
                if (valKey) keys.push(valKey);
                var card = checked.closest && checked.closest('.common-check-option');
                if (card) {
                    var lbl = card.querySelector('.common-check-option-label');
                    if (lbl) {
                        var lblKey = normalizeChoiceKey(lbl.textContent);
                        if (lblKey && keys.indexOf(lblKey) === -1) keys.push(lblKey);
                    }
                }
                if (keys.length) return keys;
            }
            var sel = optionsContainer.querySelector('select[data-option-id="' + oid + '"]');
            if (sel && sel.value) {
                keys.push(normalizeChoiceKey(sel.value));
                return keys;
            }
        }
        return keys;
    }

    function isRm5AppliedMoldingChoiceKey(key) {
        var k = normalizeChoiceKey(key);
        // --- Dp start 31-07 — Applied Molding renaming logic support ---
        return k === 'rm5' || k === 'rm_5' || k === 'rm5_applied_molding';
        // --- Dp end 31-07 — Applied Molding renaming logic support ---
    }

    function isRm5AppliedMoldingSelected(optionsContainer) {
        var keys = getAppliedMoldingChoiceKeys(optionsContainer);
        for (var i = 0; i < keys.length; i++) {
            if (isRm5AppliedMoldingChoiceKey(keys[i])) return true;
        }
        return false;
    }

    function isAppliedMoldingStileSelected(optionsContainer) {
        var keys = getSelectedStileProfileKeys(optionsContainer);
        for (var ai = 0; ai < keys.length; ai++) {
            var stileCanon = canonicalStileProfileKey(keys[ai]);
            // rm5_applied_molding is its own stile card — not the Applied Molding accordion trigger.
            if (stileCanon === 'rm5_applied_molding') continue;
            if (stileCanon === 'applied_molding') return true;
        }
        // --- Dp start 16-07 ---
        try {
            if (!optionsContainer) return false;
            var checked = optionsContainer.querySelector('input[type="radio"][data-option-id="stile_and_rail_profile"]:checked');
            if (!checked) return false;
            var checkedCanon = canonicalStileProfileKey(checked.value);
            if (checkedCanon === 'rm5_applied_molding') return false;
            if (checkedCanon === 'applied_molding') return true;
            var card = checked.closest && checked.closest('.common-check-option');
            var lbl = card && card.querySelector('.common-check-option-label');
            var lab = lbl ? String(lbl.textContent || '').toLowerCase() : '';
            // Ignore RM5 Applied Molding label — that maps to individual stile option.
            if (lab.indexOf('rm5') !== -1 || lab.indexOf('rm 5') !== -1) return false;
            if (lab.indexOf('applied') !== -1 && lab.indexOf('mold') !== -1) return true;
            var valLab = String(checked.value || '').toLowerCase();
            if (valLab.indexOf('rm5') !== -1) return false;
            if (valLab.indexOf('applied') !== -1 && valLab.indexOf('mold') !== -1) return true;
        } catch (eAmLab) { }
        // --- Dp end 16-07 ---
        return false;
    }

    function isRm5AppliedMoldingStileSelected(optionsContainer) {
        var keys = getSelectedStileProfileKeys(optionsContainer);
        for (var ri = 0; ri < keys.length; ri++) {
            if (canonicalStileProfileKey(keys[ri]) === 'rm5_applied_molding') return true;
        }
        return false;
    }

    function isAppliedMoldingSdlContext(optionsContainer) {
        // Figma: RM5 Applied Molding is the only applied-molding stile that opens SDL.
        return isRm5AppliedMoldingStileSelected(optionsContainer);
    }

    function isStileProfileSdlTrigger(optionsContainer) {
        var stileKeys = getSelectedStileProfileKeys(optionsContainer);
        for (var si = 0; si < stileKeys.length; si++) {
            if (stileProfileKeyInList(stileKeys[si], SDL_STILE_PROFILE_KEYS)) return true;
        }
        return false;
    }

    /** True when selected stile allows the SDL Profile section. */
    function stileAllowsSdlProfileSection(optionsContainer) {
        return isStileProfileSdlTrigger(optionsContainer)
            || isRm5AppliedMoldingStileSelected(optionsContainer);
    }

    /** SDL block visible when stile is quarter_bead / craftsman / rm5_applied_molding. */
    function shouldShowSdlProfile(optionsContainer) {
        // AG empty → no SDL at all.
        try { if (isDividedLightEmpty()) return false; } catch (eAgEmpty) { }
        return stileAllowsSdlProfileSection(optionsContainer);
    }

    function getAllowedSdlProfileKeys(optionsContainer) {
        if (isAppliedMoldingSdlContext(optionsContainer)) {
            return SDL_PROFILE_BY_APPLIED_MOLDING_RM5.slice();
        }
        var allowed = [];
        var stileKeys = getSelectedStileProfileKeys(optionsContainer);
        for (var si = 0; si < stileKeys.length; si++) {
            var stileCanon = canonicalStileProfileKey(stileKeys[si]);
            var list = SDL_PROFILE_STATIC_BY_STILE[stileCanon];
            if (!list) continue;
            list.forEach(function (k) {
                if (allowed.indexOf(k) === -1) allowed.push(k);
            });
        }
        return allowed;
    }

    function ensureDefaultStileProfileChecked(optionsContainer) {
        if (!optionsContainer) return;
        try {
            // Auto-select + keep the selected/default card in the top primary slot.
            promoteSelectedProfileToHero(optionsContainer, { collapseAccordion: false });
        } catch (ePromoteStile) {
            var heroInp = optionsContainer.querySelector(
                '.door-stile-rail-primary-option .common-check-option input[type="radio"][data-option-id="stile_and_rail_profile"]'
            );
            if (!heroInp) return;
            var checked = optionsContainer.querySelector('input[type="radio"][data-option-id="stile_and_rail_profile"]:checked');
            if (!checked) {
                heroInp.checked = true;
                var heroCardOnly = heroInp.closest && heroInp.closest('.common-check-option');
                if (heroCardOnly) heroCardOnly.classList.add('common-check-option--selected');
                return;
            }
            if (checked === heroInp) return;
            var checkedCard = checked.closest && checked.closest('.common-check-option');
            var checkedHidden = checkedCard && (
                checkedCard.style.display === 'none' ||
                checkedCard.classList.contains('door-hidden') ||
                checkedCard.getAttribute('data-product-tag-hidden') === '1'
            );
            if (checkedHidden) {
                checked.checked = false;
                checkedCard.classList.remove('common-check-option--selected');
                heroInp.checked = true;
                var heroCard = heroInp.closest && heroInp.closest('.common-check-option');
                if (heroCard) heroCard.classList.add('common-check-option--selected');
            }
        }
    }

    function sdlProfileChoiceKeyFromCard(card) {
        if (!card) return '';
        var inp = card.querySelector('input[data-option-id="sdl_profile"]');
        if (inp && inp.value) return normalizeChoiceKey(inp.value);
        var dv = card.getAttribute('data-choice-value');
        if (dv) return normalizeChoiceKey(dv);
        var lbl = card.querySelector('.common-check-option-label');
        if (lbl) return normalizeChoiceKey(lbl.textContent);
        return '';
    }

    function isSdlProfileCardVisible(card) {
        if (!card) return false;
        if (card.style.display === 'none') return false;
        if (card.classList.contains('door-hidden')) return false;
        if (card.getAttribute('data-wood-exposure-hidden') === '1') return false;
        return true;
    }

    /**
     * SDL profile selection:
     * - Keep a visible customer (or restored) pick.
     * - Else configurator_defaults.sdl_profile when visible.
     * - Else Figma chart default: Quarter Bead → Bell Ogee, Craftsman → Flat, RM5 → Cove.
     * Clears a checked choice only when it becomes hidden.
     */
    function getChartSdlProfileDefault(optionsContainer) {
        if (!optionsContainer) return null;
        try {
            if (isRm5AppliedMoldingStileSelected(optionsContainer)) return 'cove';
        } catch (eRm5Def) { }
        var stileKeys = [];
        try { stileKeys = getSelectedStileProfileKeys(optionsContainer) || []; } catch (eStileDef) { stileKeys = []; }
        for (var i = 0; i < stileKeys.length; i++) {
            var canon = canonicalStileProfileKey(stileKeys[i]);
            if (canon === 'quarter_bead') return 'bell_ogee';
            if (canon === 'craftsman') return 'flat';
            if (canon === 'rm5_applied_molding') return 'cove';
        }
        return null;
    }

    function getSdlProfileDefaultToSelect(optionsContainer) {
        var configured = null;
        try { configured = getConfiguredSdlProfileDefaultValue(); } catch (eCfg) { configured = null; }
        if (configured) return configured;
        // AG = SDL Only + CN Default SDL column empty → no auto-selection.
        try { if (isDividedLightSdlOnly()) return null; } catch (eSdlOnlyDef) { }
        try { return getChartSdlProfileDefault(optionsContainer); } catch (eChart) { return null; }
    }

    function autoSelectFirstVisibleSdlProfile(optionsContainer) {
        if (!optionsContainer) return false;
        var sdlWrap = optionsContainer.querySelector('.door-option-wrap[data-option-id="sdl_profile"]');
        if (!sdlWrap) return false;
        var changed = false;
        var checked = sdlWrap.querySelector('input[type="radio"][data-option-id="sdl_profile"]:checked');
        if (checked) {
            var checkedCard = checked.closest && checked.closest('.common-check-option');
            if (isSdlProfileCardVisible(checkedCard)) return false;
            checked.checked = false;
            if (checkedCard) checkedCard.classList.remove('common-check-option--selected');
            changed = true;
        }
        var defVal = null;
        try { defVal = getSdlProfileDefaultToSelect(optionsContainer); } catch (eSdlDefAuto) { defVal = null; }
        if (!defVal) {
            var selClear = sdlWrap.querySelector('select[data-option-id="sdl_profile"]');
            if (selClear && selClear.value) {
                var curOpt = selClear.options && selClear.selectedIndex >= 0
                    ? selClear.options[selClear.selectedIndex]
                    : null;
                if (curOpt && (curOpt.hidden || curOpt.disabled)) {
                    selClear.value = '';
                    changed = true;
                }
            }
            return changed;
        }

        var wantCandidates = [];
        try { wantCandidates = getDefaultSelectionValueCandidates('sdl_profile', defVal); } catch (eCand) {
            wantCandidates = [String(defVal)];
        }
        var cards = sdlWrap.querySelectorAll('.common-check-option');
        for (var ci = 0; ci < cards.length; ci++) {
            var card = cards[ci];
            if (!isSdlProfileCardVisible(card)) continue;
            var inp = card.querySelector('input[type="radio"][data-option-id="sdl_profile"]');
            if (!inp) continue;
            var match = false;
            try {
                match = defaultSelectionValuesMatch('sdl_profile', defVal, inp.value);
            } catch (eMatch) {
                var key = normalizeChoiceKey(inp.value);
                for (var wi = 0; wi < wantCandidates.length; wi++) {
                    if (normalizeChoiceKey(wantCandidates[wi]) === key) { match = true; break; }
                }
            }
            if (!match) {
                try {
                    match = canonicalSdlProfileKey(inp.value) === canonicalSdlProfileKey(defVal);
                } catch (eCanonMatch) { }
            }
            if (!match) continue;
            inp.checked = true;
            card.classList.add('common-check-option--selected');
            return true;
        }
        var sel = sdlWrap.querySelector('select[data-option-id="sdl_profile"]');
        if (sel) {
            for (var si = 0; si < wantCandidates.length; si++) {
                var cand = String(wantCandidates[si] || '');
                var hasOpt = Array.prototype.some.call(sel.options || [], function (o) {
                    return o && !o.hidden && !o.disabled && String(o.value || '') === cand;
                });
                if (hasOpt) {
                    sel.value = cand;
                    return true;
                }
            }
            if (sel.value) {
                sel.value = '';
                return true;
            }
        }
        return changed;
    }

    function applySdlProfileChoiceVisibility(optionsContainer, allowed) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer) return;
        var sdlWrap = optionsContainer.querySelector('.door-option-wrap[data-option-id="sdl_profile"]');
        if (!sdlWrap) return;
        var allowedList = Array.isArray(allowed) ? allowed : [];
        var radioWrap = sdlWrap.querySelector('.common-check-options');
        if (radioWrap) {
            radioWrap.style.display = '';
            radioWrap.classList.remove('door-hidden');
        }
        var selectionChanged = false;
        sdlWrap.querySelectorAll('.common-check-option').forEach(function (card) {
            var key = sdlProfileChoiceKeyFromCard(card);
            var shouldHide = !key || !sdlProfileKeyInAllowedList(key, allowedList);
            var woodHid = card.getAttribute && card.getAttribute('data-wood-exposure-hidden') === '1';
            card.style.display = (shouldHide || woodHid) ? 'none' : '';
            card.classList.toggle('door-hidden', !!(shouldHide || woodHid));
            card.removeAttribute('data-product-tag-hidden');
            card.removeAttribute('data-choice-condition-hidden');
            var inp = card.querySelector('input[type="radio"][data-option-id="sdl_profile"]');
            if (inp) inp.disabled = !!(shouldHide || woodHid);
            if (shouldHide && inp && inp.checked) {
                inp.checked = false;
                card.classList.remove('common-check-option--selected');
                selectionChanged = true;
            }
        });
        var sel = sdlWrap.querySelector('select[data-option-id="sdl_profile"]');
        if (sel) {
            var cleared = false;
            Array.prototype.forEach.call(sel.options, function (op) {
                if (!op || !op.value) return;
                var key = normalizeChoiceKey(op.value);
                var shouldHide = !sdlProfileKeyInAllowedList(key, allowedList);
                op.hidden = shouldHide;
                op.disabled = shouldHide;
                op.removeAttribute('data-product-tag-hidden');
                if (shouldHide && normalizeChoiceKey(sel.value) === key) cleared = true;
            });
            if (cleared) {
                var defSel = null;
                try { defSel = getSdlProfileDefaultToSelect(optionsContainer); } catch (eSdlSelDef) { defSel = null; }
                var matchedSel = '';
                if (defSel) {
                    var selCands = [];
                    try { selCands = getDefaultSelectionValueCandidates('sdl_profile', defSel); } catch (eSdlSelCand) {
                        selCands = [String(defSel)];
                    }
                    for (var sdi = 0; sdi < selCands.length; sdi++) {
                        var sc = String(selCands[sdi] || '');
                        var okOpt = Array.prototype.some.call(sel.options || [], function (o) {
                            return o && !o.hidden && !o.disabled && String(o.value || '') === sc;
                        });
                        if (okOpt) { matchedSel = sc; break; }
                    }
                    if (!matchedSel) {
                        var chartCanon = canonicalSdlProfileKey(defSel);
                        Array.prototype.some.call(sel.options || [], function (o) {
                            if (!o || o.hidden || o.disabled || !o.value) return false;
                            if (canonicalSdlProfileKey(o.value) === chartCanon) {
                                matchedSel = String(o.value);
                                return true;
                            }
                            return false;
                        });
                    }
                }
                sel.value = matchedSel;
                selectionChanged = true;
            }
        }
        if (autoSelectFirstVisibleSdlProfile(optionsContainer)) selectionChanged = true;
        if (selectionChanged) {
            try { updateEstimatedPrice(); } catch (ePrice) { }
            try { updateDoorPreview(); } catch (ePrev) { }
        }
    }

    /** Filter SDL choices by stile profile (quarter_bead / craftsman / applied_molding). */
    function applyStaticSdlProfileVisibility(optionsContainer) {
        // --- Dp start 16-07 ---
        // Show only SDL choices related to the selected stile / applied-molding context.
        var allowed = getAllowedSdlProfileKeys(optionsContainer);
        /* MERGE: product_wise_edge_profile_sdl — start */
        try {
            var pweConfig = (window.DoorConf2Update && typeof window.DoorConf2Update.getProductWiseEdgeProfileSdlFromMain === 'function')
                ? window.DoorConf2Update.getProductWiseEdgeProfileSdlFromMain()
                : null;
            if (pweConfig && window.DoorConf2Update
                && typeof window.DoorConf2Update.getProductWiseSdlProfileAllowedValues === 'function') {
                // Pass selected stile so compound sdl_profile values (e.g. "flat_cove")
                // resolve: craftsman → flat, rm5_applied_molding → cove.
                var pweStileKey = '';
                try {
                    var pweStileKeys = getSelectedStileProfileKeys(optionsContainer);
                    if (pweStileKeys && pweStileKeys.length) pweStileKey = pweStileKeys[0];
                } catch (ePweStile) { pweStileKey = ''; }
                var pweSdlAllowed = window.DoorConf2Update.getProductWiseSdlProfileAllowedValues(pweConfig, pweStileKey);
                // Specific sdl_profile value(s) like "cove" / "flat_cove" → show only those options.
                if (pweSdlAllowed && pweSdlAllowed.length) {
                    allowed = pweSdlAllowed.slice();
                }
            }
        } catch (ePweSdlFilter) { }
        /* MERGE: product_wise_edge_profile_sdl — end */
        applySdlProfileChoiceVisibility(optionsContainer, allowed);
        // --- Dp end 16-07 ---
    }

    // --- Dp start 16-07 ---
    function revealAllSdlProfileChoices(optionsContainer) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer) return;
        var sdlWrap = optionsContainer.querySelector('.door-option-wrap[data-option-id="sdl_profile"]');
        if (!sdlWrap) return;
        var radioWrap = sdlWrap.querySelector('.common-check-options');
        if (radioWrap) {
            radioWrap.style.display = '';
            radioWrap.classList.remove('door-hidden');
        }
        sdlWrap.querySelectorAll('.common-check-option').forEach(function (card) {
            card.style.display = '';
            card.classList.remove('door-hidden');
            card.removeAttribute('data-product-tag-hidden');
            card.removeAttribute('data-choice-condition-hidden');
            card.removeAttribute('data-wood-exposure-hidden');
            var inp = card.querySelector('input[type="radio"][data-option-id="sdl_profile"]');
            if (inp) inp.disabled = false;
        });
        var sel = sdlWrap.querySelector('select[data-option-id="sdl_profile"]');
        if (sel) {
            Array.prototype.forEach.call(sel.options, function (op) {
                if (!op || !op.value) return;
                op.hidden = false;
                op.disabled = false;
                op.removeAttribute('data-product-tag-hidden');
            });
        }
        try { autoSelectFirstVisibleSdlProfile(optionsContainer); } catch (eSdlAuto) { }
    }

    function revealAllAppliedMoldingChoices(optionsContainer) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer) return;
        var wraps = optionsContainer.querySelectorAll(
            '.door-option-wrap[data-option-id="applied_molding"], .door-option-wrap[data-option-id="applied_molding_choice"]'
        );
        Array.prototype.forEach.call(wraps, function (wrap) {
            if (!wrap) return;
            wrap.querySelectorAll('.common-check-option').forEach(function (card) {
                card.style.display = '';
                card.classList.remove('door-hidden');
                card.removeAttribute('data-product-tag-hidden');
                card.removeAttribute('data-choice-condition-hidden');
                card.removeAttribute('data-wood-exposure-hidden');
                var inp = card.querySelector(
                    'input[type="radio"][data-option-id="applied_molding"],' +
                    'input[type="radio"][data-option-id="applied_molding_choice"]'
                );
                if (inp) inp.disabled = false;
            });
            wrap.querySelectorAll('.door-inserts-additional-options.screen-and-storm-inserts').forEach(function (aw) {
                aw.style.display = '';
                aw.classList.remove('door-hidden');
            });
        });
    }
    // --- Dp end 16-07 ---

    var SDL_PROFILE_DESC_DEFAULT = 'Choose a Simulated Divided Lites (SDL) Edge Profile';
    var SDL_PROFILE_DESC_CRAFTSMAN = 'This door features a Simulated Divided Lites (SDL) Edge Profile';

    function isCraftsmanStileSelected(optionsContainer) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer) return false;
        function looksCraftsman(raw) {
            var k = normalizeChoiceKey(raw);
            if (!k) return false;
            if (canonicalStileProfileKey(k) === 'craftsman') return true;
            return k.indexOf('craftsman') !== -1 || k.indexOf('carftsman') !== -1;
        }
        try {
            var keys = getSelectedStileProfileKeys(optionsContainer) || [];
            for (var i = 0; i < keys.length; i++) {
                if (looksCraftsman(keys[i])) return true;
            }
        } catch (eKeys) { }
        try {
            var checked = optionsContainer.querySelector(
                'input[type="radio"][data-option-id="stile_and_rail_profile"]:checked'
            );
            if (checked && looksCraftsman(checked.value)) return true;
            var card = (checked && checked.closest)
                ? checked.closest('.common-check-option')
                : optionsContainer.querySelector('.door-stile-rail-primary-option .common-check-option');
            if (!card) return false;
            if (looksCraftsman(card.getAttribute('data-choice-value'))) return true;
            var lbl = card.querySelector('.common-check-option-label');
            if (lbl && looksCraftsman(lbl.textContent)) return true;
        } catch (eDom) { }
        return false;
    }

    function getSdlProfileSectionCopy(optionsContainer) {
        return isCraftsmanStileSelected(optionsContainer)
            ? SDL_PROFILE_DESC_CRAFTSMAN
            : SDL_PROFILE_DESC_DEFAULT;
    }

    function applySdlProfileDescText(descEl, copy) {
        if (!descEl) return;
        var raw = String(copy || '');
        var mapped = raw;
        try { mapped = mapCollectionDoorWording(raw) || raw; } catch (eSdlMap) { mapped = raw; }
        descEl.setAttribute('data-door-original-desc', raw);
        descEl.setAttribute('data-skip-door-wording', '1');
        descEl.textContent = mapped;
    }

    function syncSdlProfileSectionCopy(optionsContainer, sdlWrap) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        var sdlCopy = getSdlProfileSectionCopy(optionsContainer);
        var root = document.getElementById('door-configurator') || optionsContainer || document;
        var seen = [];
        function applyTo(descEl) {
            if (!descEl || seen.indexOf(descEl) !== -1) return;
            seen.push(descEl);
            applySdlProfileDescText(descEl, sdlCopy);
        }
        if (root && root.querySelectorAll) {
            Array.prototype.forEach.call(root.querySelectorAll('.door-sdl-profile-desc'), applyTo);
        }
        if (optionsContainer && optionsContainer !== root && optionsContainer.querySelectorAll) {
            Array.prototype.forEach.call(optionsContainer.querySelectorAll('.door-sdl-profile-desc'), applyTo);
        }
        if (sdlWrap) applyTo(sdlWrap.querySelector('.door-sdl-profile-desc'));
    }

    function customizeSdlProfileSection(sdlWrap) {
        if (!sdlWrap || sdlWrap.getAttribute('data-sdl-customized') === '1') return;
        sdlWrap.setAttribute('data-sdl-customized', '1');
        sdlWrap.classList.add('door-sdl-profile-nested-wrap');
        var titleRow = sdlWrap.querySelector('.door-option-header-row');
        if (!titleRow) return;
        var titleEl = titleRow.querySelector('.door-section-title, .door-option-title');
        if (titleEl) titleEl.style.display = 'none';
        var titleWrap = titleRow.querySelector('.door-option-title-wrap') || titleRow;
        var descEl = titleRow.querySelector('.door-sdl-profile-desc');
        if (!descEl) {
            descEl = document.createElement('p');
            descEl.className = 'door-option-desc door-sdl-profile-desc';
            titleWrap.appendChild(descEl);
        }
        var optionsContainer = sdlWrap.closest('#door-configurator-options')
            || document.getElementById('door-configurator-options');
        applySdlProfileDescText(descEl, getSdlProfileSectionCopy(optionsContainer));
    }

    /* MERGE: sdl_enable_toggle — start */
    function getSdlEnableSwitchWrap(optionsContainer) {
        if (!optionsContainer) return null;
        return optionsContainer.querySelector('.door-sdl-enable-switch-wrap');
    }

    function isSdlEnableToggleOn(optionsContainer) {
        var wrap = getSdlEnableSwitchWrap(optionsContainer);
        var inp = wrap && wrap.querySelector('input[type="checkbox"][data-option-id="sdl_enable"]');
        return !!(inp && inp.checked);
    }

    function setSdlEnableToggleOn(optionsContainer, on) {
        var wrap = getSdlEnableSwitchWrap(optionsContainer);
        var inp = wrap && wrap.querySelector('input[type="checkbox"][data-option-id="sdl_enable"]');
        if (inp) inp.checked = !!on;
    }

    function setSdlEnableToggleLocked(optionsContainer, locked) {
        var wrap = getSdlEnableSwitchWrap(optionsContainer);
        var inp = wrap && wrap.querySelector('input[type="checkbox"][data-option-id="sdl_enable"]');
        if (!wrap || !inp) return;
        if (locked) {
            inp.checked = true;
            inp.disabled = true;
            wrap.setAttribute('data-sdl-toggle-locked', '1');
            wrap.classList.add('door-sdl-enable-switch-wrap--locked');
        } else {
            inp.disabled = false;
            wrap.removeAttribute('data-sdl-toggle-locked');
            wrap.classList.remove('door-sdl-enable-switch-wrap--locked');
        }
    }

    function clearSdlProfileSelections(sdlWrap) {
        if (!sdlWrap) return;
        sdlWrap.querySelectorAll('input[type="radio"][data-option-id="sdl_profile"]').forEach(function (inp) {
            inp.checked = false;
            var c = inp.closest && inp.closest('.common-check-option');
            if (c) c.classList.remove('common-check-option--selected');
        });
        try {
            var note = sdlWrap.querySelector('.door-sdl-profile-required-note');
            if (note) {
                note.style.display = 'none';
                note.textContent = '';
                note.classList.remove('is-error');
            }
        } catch (eSdlNoteClr) { }
    }

    function hideSdlEnableSwitch(optionsContainer) {
        var switchWrap = getSdlEnableSwitchWrap(optionsContainer);
        if (!switchWrap) return;
        try { setSdlEnableToggleLocked(optionsContainer, false); } catch (eUnlockHide) { }
        switchWrap.classList.add('door-hidden');
        switchWrap.style.display = 'none';
        setSdlEnableToggleOn(optionsContainer, false);
    }

    /**
     * configurator_defaults.sdl_profile with a real value (e.g. "cove") →
     * skip the Simulated Divided Light toggle and show the SDL section directly.
     */
    function getConfiguredSdlProfileDefaultValue() {
        var v = null;
        try { v = getDefaultSelectionForOption('sdl_profile'); } catch (eSdlDef) { v = null; }
        if (v == null) return null;
        var s = String(v).trim();
        if (!s) return null;
        var lower = s.toLowerCase();
        if (lower === 'null' || lower === 'undefined' || lower === 'false' || lower === 'none') return null;
        return s;
    }

    function hasForcedSdlProfileDefault() {
        return !!getConfiguredSdlProfileDefaultValue();
    }

    function hideSdlEnableSwitchKeepForcedOpen(optionsContainer) {
        var switchWrap = getSdlEnableSwitchWrap(optionsContainer);
        if (!switchWrap) return;
        try { setSdlEnableToggleLocked(optionsContainer, false); } catch (eUnlockForced) { }
        switchWrap.classList.add('door-hidden');
        switchWrap.style.display = 'none';
        // Keep logical "on" so any toggle checks still treat SDL as enabled.
        setSdlEnableToggleOn(optionsContainer, true);
    }

    /** Create "Simulated Divided Light" switch (off by default): [toggle] [label], before sdl_profile. */
    function ensureSdlEnableSwitch(optionsContainer, sdlWrap) {
        if (!optionsContainer || !sdlWrap) return null;
        var rm5LocksToggle = false;
        try { rm5LocksToggle = isRm5AppliedMoldingStileSelected(optionsContainer); } catch (eRm5LockEnsure) { rm5LocksToggle = false; }
        // SDL Only (Col AG) or a forced default profile → hide the opt-in toggle.
        // RM5 still shows a locked toggle unless the product is SDL Only.
        if (shouldHideSdlToggleForSdlOnly() || (hasForcedSdlProfileDefault() && !rm5LocksToggle)) {
            var existingForced = getSdlEnableSwitchWrap(optionsContainer);
            if (existingForced) hideSdlEnableSwitchKeepForcedOpen(optionsContainer);
            return existingForced;
        }
        var existing = getSdlEnableSwitchWrap(optionsContainer);
        if (existing) {
            if (existing.parentNode !== sdlWrap.parentNode || existing.nextSibling !== sdlWrap) {
                if (sdlWrap.parentNode) sdlWrap.parentNode.insertBefore(existing, sdlWrap);
            }
            // Keep switch left of label if an older build inserted label first.
            var existingLabel = existing.querySelector('label.common-switch');
            var existingText = existing.querySelector('.door-sdl-enable-switch-label');
            if (existingLabel && existingText && existingLabel.previousSibling !== null) {
                existing.insertBefore(existingLabel, existingText);
            }
            return existing;
        }

        var wrap = document.createElement('div');
        wrap.className = 'door-sdl-enable-switch-wrap';
        wrap.setAttribute('data-sdl-enable-wrap', '1');

        var label = document.createElement('label');
        label.className = 'common-switch';

        var input = document.createElement('input');
        input.type = 'checkbox';
        input.setAttribute('data-option-id', 'sdl_enable');
        // UI gate only — cart attribute remains attributes[SDL Profile] radios.
        input.checked = false;
        label.appendChild(input);

        var knob = document.createElement('span');
        knob.className = 'common-switch-slider';
        label.appendChild(knob);
        wrap.appendChild(label);

        var text = document.createElement('span');
        text.className = 'door-sdl-enable-switch-label';
        text.textContent = 'Simulated Divided Light';
        wrap.appendChild(text);

        if (sdlWrap.parentNode) {
            sdlWrap.parentNode.insertBefore(wrap, sdlWrap);
        }

        input.addEventListener('change', function () {
            if (wrap.getAttribute('data-sdl-toggle-locked') === '1') {
                input.checked = true;
                return;
            }
            // Clear profile picks immediately when turning off so sync does not re-enable the toggle.
            if (!input.checked) {
                try { clearSdlProfileSelections(sdlWrap); } catch (eSdlClearOff) { }
            }
            try { scheduleSdlProfileVisibilitySync(optionsContainer); } catch (eSdlToggleSync) { }
            try { updateEstimatedPrice(); } catch (eSdlTogglePrice) { }
            try { updateDoorPreview(); } catch (eSdlTogglePrev) { }
        });

        return wrap;
    }

    function syncSdlEnableSwitchVisibility(optionsContainer, sdlAvailable) {
        var switchWrap = getSdlEnableSwitchWrap(optionsContainer);
        if (!switchWrap) return;
        var rm5LocksToggle = false;
        try { rm5LocksToggle = isRm5AppliedMoldingStileSelected(optionsContainer); } catch (eRm5LockVis) { rm5LocksToggle = false; }
        // SDL Only (Col AG) or a forced default profile → never show the toggle.
        // RM5 locked toggle still shows unless the product is SDL Only.
        if (shouldHideSdlToggleForSdlOnly() || (hasForcedSdlProfileDefault() && !rm5LocksToggle)) {
            hideSdlEnableSwitchKeepForcedOpen(optionsContainer);
            return;
        }
        var showSwitch = !!sdlAvailable;
        switchWrap.classList.toggle('door-hidden', !showSwitch);
        switchWrap.style.display = showSwitch ? '' : 'none';
        if (!showSwitch) {
            setSdlEnableToggleOn(optionsContainer, false);
        }
    }
    /* MERGE: sdl_enable_toggle — end */

    function syncSdlProfileVisibility(optionsContainer) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer) return;
        try { ensureDefaultStileProfileChecked(optionsContainer); } catch (eStileDef) { }
        var sdlWrap = optionsContainer.querySelector('.door-option-wrap[data-option-id="sdl_profile"]');
        if (!sdlWrap) {
            /* MERGE: sdl_enable_toggle — start */
            // No SDL option in schema/DOM — never show the toggle row.
            try { hideSdlEnableSwitch(optionsContainer); } catch (eSdlNoWrap) { }
            /* MERGE: sdl_enable_toggle — end */
            try { syncBevelGlassSwitchVisibility(optionsContainer); } catch (eBevelVisNoSdl) { }
            return;
        }
        // AG empty → hide SDL section and toggle completely.
        try {
            if (isDividedLightEmpty()) {
                hideSdlEnableSwitch(optionsContainer);
                sdlWrap.classList.add('door-hidden');
                sdlWrap.style.display = 'none';
                clearSdlProfileSelections(sdlWrap);
                try { syncBevelGlassSwitchVisibility(optionsContainer); } catch (eBevelAgEmpty) { }
                return;
            }
        } catch (eAgEmptySdl) { }
        // --- Dp start 16-07 ---
        try { syncAppliedMoldingSectionVisibility(optionsContainer); } catch (eAmBeforeSdl) { }
        // --- Dp end 16-07 ---
        var available = shouldShowSdlProfile(optionsContainer);
        /* MERGE: product_wise_edge_profile_sdl — start */
        // Product metafield sdl_profile:
        //   false → never show toggle or choices
        //   true / "cove" → allow toggle when stile is quarter_bead / craftsman / applied_molding_choice
        //   absent → stile-driven
        // rm5_applied_molding + sdl_profile:true → show toggle and force it ON (SDL must be selected).
        var pweSdlHideExplicit = false;
        var stileAllowsSdl = stileAllowsSdlProfileSection(optionsContainer);
        var pweConfig = null;
        var forceSdlToggleOnForRm5 = false;
        try {
            pweConfig = (window.DoorConf2Update && typeof window.DoorConf2Update.getProductWiseEdgeProfileSdlFromMain === 'function')
                ? window.DoorConf2Update.getProductWiseEdgeProfileSdlFromMain()
                : null;
            if (pweConfig && window.DoorConf2Update) {
                if (typeof window.DoorConf2Update.shouldForceShowSdlProfileByProductWise === 'function'
                    && window.DoorConf2Update.shouldForceShowSdlProfileByProductWise(pweConfig)
                    && stileAllowsSdl) {
                    available = true;
                }
                if (typeof window.DoorConf2Update.shouldHideSdlProfileByProductWise === 'function') {
                    var pweSdlHide = window.DoorConf2Update.shouldHideSdlProfileByProductWise(pweConfig);
                    if (pweSdlHide === true) {
                        available = false;
                        pweSdlHideExplicit = true;
                    }
                }
            }
        } catch (ePweSdlVis) { }
        /* MERGE: product_wise_edge_profile_sdl — end */
        // --- Dp start 16-07 ---
        // Hide SDL for any stile other than quarter_bead / craftsman / applied_molding_choice.
        if (!pweSdlHideExplicit) {
            available = !!stileAllowsSdl && !!available;
        }
        if (!stileAllowsSdl) {
            available = false;
        }
        // --- Dp end 16-07 ---
        try {
            // Figma: RM5 always shows the SDL toggle locked On (SDL required).
            if (isRm5AppliedMoldingStileSelected(optionsContainer) && stileAllowsSdl) {
                available = true;
                forceSdlToggleOnForRm5 = true;
            }
        } catch (eRm5SdlForce) { }
        /* MERGE: sdl_force_hide_solid_wood_doors — start */
        // When browsing from solid-wood-doors collection, never show SDL — even if stile
        // (quarter_bead / craftsman / etc.) would otherwise force it on. Other collections unchanged.
        try {
            var sdlHideCol = '';
            try { sdlHideCol = getCollectionHandleFromUrl(); } catch (eSdlColUrl) { }
            if (!sdlHideCol) {
                var sdlMain = document.getElementById('door-configurator');
                if (sdlMain) {
                    sdlHideCol = normProductTagSlug(sdlMain.getAttribute('data-route-collection') || '');
                }
            }
            if (sdlHideCol === 'solid-wood-exterior-doors' || sdlHideCol === 'solid-wood-interior-doors' || sdlHideCol === 'solid-wood-doors') {
                available = false;
                forceSdlToggleOnForRm5 = false;
            }
        } catch (eSdlForceHideSwd) { }
        /* MERGE: sdl_force_hide_solid_wood_doors — end */

        /* MERGE: sdl_enable_toggle — start */
        // RM5 forces SDL On. Leaving RM5 for Quarter Bead / Craftsman must turn SDL Off
        // so the customer makes a proactive choice (do not keep RM5's forced On state).
        try {
            var wasRm5SdlForced = optionsContainer.getAttribute('data-sdl-rm5-forced') === '1';
            if (forceSdlToggleOnForRm5 && available) {
                optionsContainer.setAttribute('data-sdl-rm5-forced', '1');
            } else if (wasRm5SdlForced && !forceSdlToggleOnForRm5) {
                optionsContainer.removeAttribute('data-sdl-rm5-forced');
                try { setSdlEnableToggleLocked(optionsContainer, false); } catch (eLeaveRm5Unlock) { }
                setSdlEnableToggleOn(optionsContainer, false);
                clearSdlProfileSelections(sdlWrap);
            }
        } catch (eLeaveRm5Sdl) { }

        // Toggle when SDL is available. RM5 keeps the toggle visible and locked On,
        // except when Col AG is SDL Only (no toggle; SDL cards show directly).
        var sdlOnlyNoToggle = shouldHideSdlToggleForSdlOnly();
        var forceSdlOpenFromDefaults = hasForcedSdlProfileDefault() || sdlOnlyNoToggle;
        if (available && !sdlOnlyNoToggle && (!hasForcedSdlProfileDefault() || forceSdlToggleOnForRm5)) {
            try { ensureSdlEnableSwitch(optionsContainer, sdlWrap); } catch (eSdlEnsureToggle) { }
        }
        var hasSdlSelection = !!sdlWrap.querySelector('input[type="radio"][data-option-id="sdl_profile"]:checked');
        // Saved-config restore only: if a profile is selected and toggle is still default-off, turn ON once.
        // Do not re-force ON after the user turns the toggle off (selections are cleared on off).
        if (available && hasSdlSelection && !forceSdlOpenFromDefaults && !isSdlEnableToggleOn(optionsContainer) && !forceSdlToggleOnForRm5) {
            setSdlEnableToggleOn(optionsContainer, true);
        }
        if (forceSdlToggleOnForRm5 && available && !sdlOnlyNoToggle) {
            setSdlEnableToggleOn(optionsContainer, true);
            try { setSdlEnableToggleLocked(optionsContainer, true); } catch (eRm5LockOn) { }
        } else {
            try { setSdlEnableToggleLocked(optionsContainer, false); } catch (eRm5Unlock) { }
        }
        if (sdlOnlyNoToggle || (hasForcedSdlProfileDefault() && !forceSdlToggleOnForRm5)) {
            try { hideSdlEnableSwitchKeepForcedOpen(optionsContainer); } catch (eSdlHideForced) { }
        } else {
            try { syncSdlEnableSwitchVisibility(optionsContainer, available); } catch (eSdlToggleVis) { }
            if (forceSdlToggleOnForRm5 && available) {
                setSdlEnableToggleOn(optionsContainer, true);
                try { setSdlEnableToggleLocked(optionsContainer, true); } catch (eRm5LockOn2) { }
            }
        }
        var show = available && (forceSdlOpenFromDefaults || forceSdlToggleOnForRm5 || isSdlEnableToggleOn(optionsContainer));
        /* MERGE: sdl_enable_toggle — end */

        sdlWrap.classList.toggle('door-hidden', !show);
        sdlWrap.style.display = show ? '' : 'none';
        if (show) {
            sdlWrap.removeAttribute('data-empty-hidden');
            applyStaticSdlProfileVisibility(optionsContainer);
        }
        if (!show) {
            clearSdlProfileSelections(sdlWrap);
            try { updateEstimatedPrice(); } catch (eSdlPrice) { }
            try { updateDoorPreview(); } catch (eSdlPrev) { }
        }
        try { syncSdlProfileSectionCopy(optionsContainer, sdlWrap); } catch (eSdlCopy) { }
        try { syncBevelGlassSwitchVisibility(optionsContainer); } catch (eBevelVisSdl) { }
    }

    /**
     * When SDL Profile choices are visible (e.g. Applied Molding selected + SDL toggle ON),
     * the customer must pick one of Bell Ogee / Flat / Cove / Half-Round before
     * Add to Quote or Save to Project.
     * @returns {string} Error message, or '' if valid.
     */
    function getSdlProfileRequiredError(optionsContainer) {
        if (!optionsContainer) {
            optionsContainer = document.getElementById('door-configurator-options')
                || document.getElementById('door-configurator');
        }
        if (!optionsContainer) return '';
        var sdlWrap = optionsContainer.querySelector('.door-option-wrap[data-option-id="sdl_profile"]');
        if (!sdlWrap) return '';
        if (sdlWrap.classList.contains('door-hidden') || sdlWrap.style.display === 'none') return '';
        if (sdlWrap.getAttribute('hidden') != null) return '';

        var visibleChoices = 0;
        var hasSelected = false;
        sdlWrap.querySelectorAll('.common-check-option').forEach(function (card) {
            if (!isSdlProfileCardVisible(card)) return;
            visibleChoices += 1;
            var inp = card.querySelector('input[type="radio"][data-option-id="sdl_profile"]');
            if (inp && inp.checked) hasSelected = true;
        });
        if (!visibleChoices) {
            var sel = sdlWrap.querySelector('select[data-option-id="sdl_profile"]');
            if (sel) {
                Array.prototype.forEach.call(sel.options || [], function (op) {
                    if (!op || !op.value || op.disabled || op.hidden) return;
                    visibleChoices += 1;
                });
                if (sel.value) hasSelected = true;
            }
        }
        if (!visibleChoices) return '';
        if (hasSelected) return '';
        return 'Please select an SDL profile before continuing.';
    }

    /** Inline required note next to SDL (visible after scroll — bottom banners alone are off-screen). */
    function getOrCreateSdlProfileRequiredNote(sdlWrap) {
        if (!sdlWrap) return null;
        var note = sdlWrap.querySelector('.door-sdl-profile-required-note');
        if (note) return note;
        note = document.createElement('p');
        note.className = 'door-sdl-profile-required-note door-inline-msg is-error';
        note.setAttribute('role', 'alert');
        note.style.display = 'none';
        var titleRow = sdlWrap.querySelector('.door-option-header-row, .door-option-title, .door-sdl-profile-desc');
        if (titleRow && titleRow.parentNode) {
            if (titleRow.nextSibling) titleRow.parentNode.insertBefore(note, titleRow.nextSibling);
            else titleRow.parentNode.appendChild(note);
        } else {
            var body = sdlWrap.querySelector('.door-accordion-body, .common-check-options');
            if (body && body.parentNode) body.parentNode.insertBefore(note, body);
            else sdlWrap.insertBefore(note, sdlWrap.firstChild);
        }
        return note;
    }

    function showSdlProfileRequiredNote(optionsContainer, errMsg) {
        if (!optionsContainer) {
            optionsContainer = document.getElementById('door-configurator-options')
                || document.getElementById('door-configurator');
        }
        if (!optionsContainer) return null;
        var sdlWrap = optionsContainer.querySelector('.door-option-wrap[data-option-id="sdl_profile"]');
        if (!sdlWrap) return null;
        var note = getOrCreateSdlProfileRequiredNote(sdlWrap);
        if (!note) return null;
        note.classList.add('is-error');
        note.classList.remove('is-success');
        note.textContent = errMsg || 'Please select an SDL profile before continuing.';
        note.style.display = 'block';
        note.style.color = '#b91c1c';
        return note;
    }

    function clearSdlProfileRequiredNote(optionsContainer) {
        if (!optionsContainer) {
            optionsContainer = document.getElementById('door-configurator-options')
                || document.getElementById('door-configurator');
        }
        var roots = [];
        if (optionsContainer) roots.push(optionsContainer);
        var main = document.getElementById('door-configurator');
        if (main && roots.indexOf(main) === -1) roots.push(main);
        roots.forEach(function (root) {
            root.querySelectorAll('.door-sdl-profile-required-note').forEach(function (note) {
                note.style.display = 'none';
                note.textContent = '';
                note.classList.remove('is-error');
            });
            root.querySelectorAll('.door-validation-highlight').forEach(function (el) {
                el.classList.remove('door-validation-highlight');
            });
        });
    }

    function focusSdlProfileSection(optionsContainer, errMsg) {
        if (!optionsContainer) {
            optionsContainer = document.getElementById('door-configurator-options')
                || document.getElementById('door-configurator');
        }
        if (!optionsContainer) return;
        var sdlWrap = optionsContainer.querySelector('.door-option-wrap[data-option-id="sdl_profile"]');
        if (!sdlWrap) return;
        var note = showSdlProfileRequiredNote(optionsContainer, errMsg);
        try {
            var scrollTarget = note || sdlWrap;
            scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (eScroll) {
            try { sdlWrap.scrollIntoView(true); } catch (eScroll2) { }
        }
        try {
            var firstVisible = null;
            sdlWrap.querySelectorAll('.common-check-option').forEach(function (card) {
                if (firstVisible || !isSdlProfileCardVisible(card)) return;
                firstVisible = card;
            });
            if (firstVisible) {
                firstVisible.classList.add('door-validation-highlight');
                setTimeout(function () {
                    try { firstVisible.classList.remove('door-validation-highlight'); } catch (eHl) { }
                }, 2200);
            }
            sdlWrap.classList.add('door-validation-highlight-wrap');
            setTimeout(function () {
                try { sdlWrap.classList.remove('door-validation-highlight-wrap'); } catch (eWrap) { }
            }, 2200);
        } catch (eHl2) { }
    }

    function validateSdlProfileBeforeSubmit(messageEl) {
        var err = getSdlProfileRequiredError();
        if (!err) {
            clearSdlProfileRequiredNote();
            return true;
        }
        // Only show once — inline under SDL (scroll target). Do not mirror into
        // door-save-config-message / door-hubspot-message / door-guest-quote-message.
        focusSdlProfileSection(null, err);
        return false;
    }

    try {
        window.DoorConf2Validate = window.DoorConf2Validate || {};
        window.DoorConf2Validate.getSdlProfileRequiredError = getSdlProfileRequiredError;
        window.DoorConf2Validate.focusSdlProfileSection = focusSdlProfileSection;
        window.DoorConf2Validate.validateSdlProfileBeforeSubmit = validateSdlProfileBeforeSubmit;
        window.DoorConf2Validate.clearSdlProfileRequiredNote = clearSdlProfileRequiredNote;
    } catch (eExportSdlVal) { }

    // Clear the required note as soon as an SDL profile is chosen.
    try {
        if (!window.__doorSdlRequiredNoteBound) {
            window.__doorSdlRequiredNoteBound = true;
            document.addEventListener('change', function (ev) {
                var t = ev && ev.target;
                if (!t) return;
                var oid = String(t.getAttribute && t.getAttribute('data-option-id') || '');
                if (oid !== 'sdl_profile') return;
                if (t.type === 'radio' && !t.checked) return;
                if (t.tagName === 'SELECT' && !t.value) return;
                try { clearSdlProfileRequiredNote(); } catch (eClear) { }
            }, true);
        }
    } catch (eBindSdlNote) { }

    function collapseProfileAdditionalAccordion(accordion) {
        if (!accordion) return;
        var body = accordion.querySelector('.door-accordion-body');
        if (body) body.classList.remove('door-accordion-body--open');
        var sign = accordion.querySelector('.door-accordion-sign');
        if (sign) {
            sign.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
                '<rect x="7" width="2" height="16" rx="1" fill="currentColor"></rect>' +
                '<rect x="16" y="7" width="2" height="16" rx="1" transform="rotate(90 16 7)" fill="currentColor"></rect>' +
                '</svg>';
        }
    }

    // Dp start 31-08
    function isProfileChoiceCardHidden(card) {
        if (!card) return true;
        if (card.style.display === 'none') return true;
        if (card.classList.contains('door-hidden')) return true;
        if (card.getAttribute('data-product-tag-hidden') === '1') return true;
        if (card.getAttribute('data-fixed-glass-stile-hidden') === '1') return true;
        if (card.getAttribute('data-inserts-mode-stile-hidden') === '1') return true;
        if (card.getAttribute('data-choice-condition-hidden') === '1') return true;
        return false;
    }
    // Dp end 31-08

    /**
     * Screen/Storm or porch-panel + Fixed Glass eligible: when Fixed Glass is selected,
     * Soft Ogee is the only stile_and_rail_profile option shown.
     */
    function keyLooksSoftOgee(raw) {
        var k = normalizeChoiceKey(raw);
        if (!k) return false;
        if (k.indexOf('roman') !== -1 || k.indexOf('bell') !== -1) return false;
        if (k === 'soft_ogee' || k === 'softogee') return true;
        return k.indexOf('soft') !== -1 && k.indexOf('ogee') !== -1;
    }

    function isSoftOgeeStileChoice(valueOrCard) {
        if (!valueOrCard) return false;
        if (typeof valueOrCard === 'string' || typeof valueOrCard === 'number') {
            return keyLooksSoftOgee(valueOrCard);
        }
        var card = valueOrCard;
        var fromAttr = card.getAttribute && card.getAttribute('data-choice-value');
        if (keyLooksSoftOgee(fromAttr)) return true;
        var inp = card.querySelector && card.querySelector('input[type="radio"][data-option-id="stile_and_rail_profile"]');
        if (inp && keyLooksSoftOgee(inp.value)) return true;
        var lbl = card.querySelector && card.querySelector('.common-check-option-label');
        if (lbl && keyLooksSoftOgee(lbl.textContent)) return true;
        return false;
    }

    function isScreenAndStormProductType() {
        try {
            if (isScreenStormProduct()) return true;
        } catch (eSsType) { }
        try {
            var configEl = document.getElementById('door-configurator')
                || document.getElementById('landing-product-configurator');
            if (!configEl) return false;
            var t = String(configEl.getAttribute('data-product-type') || '')
                .toLowerCase()
                .replace(/[\s-]+/g, '_');
            return t === 'screen_and_storm_doors' || t.indexOf('screen_and_storm') !== -1;
        } catch (eType) { }
        return false;
    }

    /** True when product has porch-panel / porch-panels tag (or porch product type). */
    function isPorchPanelProductTag() {
        try {
            var configEl = document.getElementById('door-configurator')
                || document.getElementById('landing-product-configurator');
            if (!configEl) return false;
            if (configEl.getAttribute('data-porch-panel-product') === 'true') return true;
            var typeNorm = String(configEl.getAttribute('data-product-type') || '')
                .toLowerCase()
                .replace(/[\s_-]+/g, ' ');
            if (typeNorm.indexOf('porch') !== -1) return true;
            var tagsAttr = configEl.getAttribute('data-product-tags') || '';
            var tags = [];
            try {
                var parsed = typeof tagsAttr === 'string' && tagsAttr.trim() ? JSON.parse(tagsAttr) : [];
                tags = Array.isArray(parsed)
                    ? parsed.map(function (t) { return normProductTagSlug(t); }).filter(Boolean)
                    : [];
            } catch (eTags) {
                tags = String(tagsAttr || '').split(/[|,]/).map(function (t) {
                    return normProductTagSlug(t);
                }).filter(Boolean);
            }
            for (var i = 0; i < tags.length; i++) {
                if (tags[i] === 'porch-panel' || tags[i] === 'porch-panels') return true;
            }
        } catch (ePorch) { }
        return false;
    }

    // Dp start VDN-598 27-10
    /** True when product belongs to a porch-panel collection (URL, route collection or product collection handles) or porch-panel tag/type. */
    function isPorchPanelCollectionProduct() {
        try {
            var isPorchPanelHandle = function (h) {
                var s = normProductTagSlug(h || '');
                return !!s && s.indexOf('porch-panel') !== -1;
            };
            if (isPorchPanelHandle(getCollectionHandleFromUrl())) return true;
            var root = document.getElementById('door-configurator')
                || document.getElementById('landing-product-configurator');
            if (root) {
                if (isPorchPanelHandle(root.getAttribute('data-route-collection'))) return true;
                var handles = [];
                try { handles = JSON.parse(root.getAttribute('data-product-collection-handles') || '[]'); } catch (eHandles) { handles = []; }
                if (Array.isArray(handles)) {
                    for (var i = 0; i < handles.length; i++) {
                        if (isPorchPanelHandle(handles[i])) return true;
                    }
                }
            }
        } catch (ePorchCol) { }
        return isPorchPanelProductTag() || productIsPorchPanelProduct();
    }
    // Dp end VDN-598 27-10

    // Dp start VDN-598 28-10 — live Files CDN for Recommended / Premium flags
    var DP_LIVE_RECOMMENDED_FLAG = 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/recommended-flag.svg?v=1793178505';
    var DP_LIVE_PREMIUM_FLAG = 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/premium-flag.svg?v=1793178534';
    function dpLiveWoodFlagSrc(u) {
        var s = String(u || '');
        var lower = s.toLowerCase();
        if (!s) return s;
        if (lower.indexOf('recommended-flag') !== -1 || (lower.indexOf('recommend') !== -1 && lower.indexOf('premium') === -1)) {
            return DP_LIVE_RECOMMENDED_FLAG;
        }
        if (lower.indexOf('premium-flag') !== -1 || lower.indexOf('premium') !== -1) {
            return DP_LIVE_PREMIUM_FLAG;
        }
        return s;
    }
    // Dp end VDN-598 28-10

    /**
     * Soft Ogee + Fixed Glass force rules apply to Screen & Storm and porch-panel.
     * Still requires fixed_glass_eligible metafield + Fixed Glass selection.
     */
    function isSoftOgeeForceProductContext() {
        return isScreenAndStormProductType() || isPorchPanelProductTag();
    }

    function isFixedGlassEligibleProduct() {
        try {
            return !!checkMetafieldTrue('fixed-glass-eligible', false);
        } catch (eEl) {
            return false;
        }
    }

    function getFixedGlassInsertCheckbox(container) {
        if (!container) return null;
        return container.querySelector(
            'input[type="checkbox"][data-option-id="screen_and_storm_inserts_additional_options"][value="fixed_glass"]'
        );
    }

    function isFixedGlassInsertSelected(container) {
        var inp = getFixedGlassInsertCheckbox(container);
        return !!(inp && inp.checked);
    }

    // Dp start 31-08
    /** Soft Ogee is only for the Fixed Glass additional option while in screen/storm or porch-panel context. */
    function isSoftOgeeRequiresFixedGlassSelection(container) {
        return isSoftOgeeForceProductContext();
    }

    function isSoftOgeeHiddenByInsertsMode(container) {
        if (!isSoftOgeeForceProductContext()) return false;
        var mode = '';
        try { mode = getSelectedScreenStormInsertsMode(container); } catch (eMode) { mode = ''; }
        var normMode = normalizeChoiceKey(mode);
        return normMode === 'screen_insert_only'
            || normMode === 'screen_only'
            || normMode === 'screen_inserts_only'
            || normMode === 'screen_and_storm_inserts_choice'
            || normMode === 'screen_and_storm_inserts'
            || (normMode.indexOf('screen') !== -1 && normMode.indexOf('storm') === -1);
    }
    // Dp end 31-08

    function isFixedGlassForceSoftOgeeActive(container) {
        if (isSoftOgeeHiddenByInsertsMode(container)) return false;
        if (!isSoftOgeeForceProductContext()) return false;
        if (!isFixedGlassEligibleProduct()) return false;
        return isFixedGlassInsertSelected(container);
    }

    function syncStileSoftOgeeForFixedGlass(container) {
        if (!container) container = document.getElementById('door-configurator-options');
        if (!container) return;

        var stileWrap = container.querySelector('.door-option-wrap[data-option-id="stile_and_rail_profile"]');
        if (!stileWrap) return;

        var fixedGlassOn = isFixedGlassForceSoftOgeeActive(container);
        // Dp start 17-08 — Storm Glass Only + Fixed Glass must not hide Stile and Rail Profile
        // when Soft Ogee is not a product option (e.g. Welcome Round Top). Default Soft Ogee-only
        // filter still runs when Soft Ogee exists.
        try {
            var hasSoftOgeeChoice = false;
            all('.common-check-option', stileWrap).forEach(function (card) {
                if (!isSoftOgeeStileChoice(card)) return;
                if (card.getAttribute('data-product-tag-hidden') === '1') return;
                hasSoftOgeeChoice = true;
            });
            if (fixedGlassOn && !hasSoftOgeeChoice) {
                fixedGlassOn = false;
            }
        } catch (eKeepStileFg) { }
        // Dp end 17-08
        var hideSoftByInserts = isSoftOgeeHiddenByInsertsMode(container);
        var softInp = null;
        var softCard = null;
        var clearedOther = false;
        var restoredAny = false;

        all('.common-check-option', stileWrap).forEach(function (card) {
            var inp = card.querySelector('input[type="radio"][data-option-id="stile_and_rail_profile"]');
            if (!inp) return;
            var isSoft = isSoftOgeeStileChoice(card);
            if (isSoft) {
                softInp = inp;
                softCard = card;
                // Dp start 31-08
                if (fixedGlassOn) {
                    card.removeAttribute('data-fixed-glass-stile-hidden');
                    card.removeAttribute('data-inserts-mode-stile-hidden');
                    card.removeAttribute('data-choice-condition-hidden');
                    card.removeAttribute('data-product-tag-hidden');
                    card.removeAttribute('data-wood-exposure-hidden');
                    card.style.display = '';
                    card.classList.remove('door-hidden');
                    inp.disabled = false;
                } else if (isSoftOgeeRequiresFixedGlassSelection(container) || hideSoftByInserts) {
                    card.setAttribute('data-fixed-glass-stile-hidden', '1');
                    card.setAttribute('data-inserts-mode-stile-hidden', '1');
                    card.setAttribute('data-choice-condition-hidden', '1');
                    card.style.display = 'none';
                    card.classList.add('door-hidden');
                    if (inp.checked) {
                        inp.checked = false;
                        card.classList.remove('common-check-option--selected');
                        clearedOther = true;
                    }
                    inp.disabled = true;
                } else {
                    var conditionHiddenSoft = card.getAttribute('data-choice-condition-hidden') === '1';
                    var tagHiddenSoft = card.getAttribute('data-product-tag-hidden') === '1';
                    var woodHidSoft = card.getAttribute('data-wood-exposure-hidden') === '1';
                    if (!conditionHiddenSoft && !tagHiddenSoft && !woodHidSoft) {
                        card.style.display = '';
                        card.classList.remove('door-hidden');
                        restoredAny = true;
                    }
                }
                return;
                // Dp end 31-08
            }
            if (fixedGlassOn) {
                card.setAttribute('data-fixed-glass-stile-hidden', '1');
                card.style.display = 'none';
                card.classList.add('door-hidden');
                if (inp.checked) {
                    inp.checked = false;
                    card.classList.remove('common-check-option--selected');
                    clearedOther = true;
                }
                inp.disabled = true;
            } else {
                var wasForcedHidden = card.getAttribute('data-fixed-glass-stile-hidden') === '1';
                card.removeAttribute('data-fixed-glass-stile-hidden');
                inp.disabled = false;
                var conditionHidden = card.getAttribute('data-choice-condition-hidden') === '1';
                var tagHidden = card.getAttribute('data-product-tag-hidden') === '1';
                var woodHid = card.getAttribute('data-wood-exposure-hidden') === '1';
                if (wasForcedHidden || (!conditionHidden && !tagHidden && !woodHid)) {
                    if (!conditionHidden && !tagHidden && !woodHid) {
                        card.style.display = '';
                        card.classList.remove('door-hidden');
                        restoredAny = true;
                    }
                }
            }
        });

        if (fixedGlassOn && softInp) {
            if (clearedOther || !softInp.checked) {
                softInp.disabled = false;
                softInp.checked = true;
                if (softCard) softCard.classList.add('common-check-option--selected');
                try { softInp.dispatchEvent(new Event('change', { bubbles: true })); } catch (eSoftCh) { }
                try { updateEstimatedPrice(); } catch (eSoftPrice) { }
            }
            try {
                var acc = stileWrap.querySelector('.door-stile-rail-accordion');
                if (acc) {
                    collapseProfileAdditionalAccordion(acc);
                    acc.style.display = 'none';
                }
            } catch (eSoftAcc) { }
            try {
                promoteSelectedProfileToHero(container, { collapseAccordion: true });
            } catch (eSoftHero) { }
            return;
        }

        if (!fixedGlassOn) {
            try {
                stileWrap.classList.remove('door-hidden');
                stileWrap.removeAttribute('data-empty-hidden');
                stileWrap.removeAttribute('hidden');
                stileWrap.style.display = '';
                var accRestore = stileWrap.querySelector('.door-stile-rail-accordion');
                if (accRestore) accRestore.style.display = '';
                var outerRestore = stileWrap.querySelector('.door-inserts-additional-options.screen-and-storm-inserts');
                if (outerRestore) {
                    outerRestore.style.display = '';
                    outerRestore.classList.remove('door-hidden');
                }
            } catch (eShowStile) { }

            var checked = stileWrap.querySelector('input[type="radio"][data-option-id="stile_and_rail_profile"]:checked');
            var checkedCard = checked && checked.closest ? checked.closest('.common-check-option') : null;
            if (!checked || isProfileChoiceCardHidden(checkedCard)) {
                var radios = all('input[type="radio"][data-option-id="stile_and_rail_profile"]', stileWrap);
                for (var ri = 0; ri < radios.length; ri++) {
                    var pick = radios[ri];
                    if (pick.disabled) continue;
                    var pickCard = pick.closest ? pick.closest('.common-check-option') : null;
                    if (isProfileChoiceCardHidden(pickCard)) continue;
                    pick.checked = true;
                    if (pickCard) pickCard.classList.add('common-check-option--selected');
                    try { pick.dispatchEvent(new Event('change', { bubbles: true })); } catch (ePickCh) { }
                    try { updateEstimatedPrice(); } catch (ePickPrice) { }
                    break;
                }
            }
            try {
                promoteSelectedProfileToHero(container, { collapseAccordion: false });
            } catch (eRestoreHero) { }
        }

        // Dp start 17-08 — keep the Stile and Rail Profile section visible after Fixed Glass sync
        try {
            var anyStileChoice = !!stileWrap.querySelector('input[type="radio"][data-option-id="stile_and_rail_profile"]');
            if (anyStileChoice) {
                stileWrap.classList.remove('door-hidden');
                stileWrap.removeAttribute('data-empty-hidden');
                stileWrap.removeAttribute('hidden');
                stileWrap.style.display = '';
            }
        } catch (eShowStileFg) { }
        // Dp end 17-08
    }

    /**
     * Stile/Panel profile hero swap (mockup behavior):
     * - Selected choice always lives in the top primary slot.
     * - Previous primary card moves into Additional Options.
     * - Optionally collapses the Additional Options accordion after a pick.
     * - On load with no selection: auto-selects the primary (default) card.
     */
    function promoteSelectedProfileToHero(optionsContainer, opts) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer) return;
        opts = opts || {};
        var collapseAccordion = !!opts.collapseAccordion;
        var configs = [
            {
                heroSel: '.door-panel-profile-hero',
                primarySel: '.door-panel-profile-primary-option',
                accSel: '.door-panel-profile-accordion',
                descSel: '.door-panel-profile-choice-desc',
                optionId: 'panel_profile'
            },
            {
                heroSel: '.door-stile-rail-hero',
                primarySel: '.door-stile-rail-primary-option',
                accSel: '.door-stile-rail-accordion',
                descSel: '.door-stile-rail-choice-desc',
                optionId: 'stile_and_rail_profile'
            }
        ];

        configs.forEach(function (cfg) {
            if (cfg.optionId === 'panel_profile' && shouldHidePanelProfile()) return;
            var hero = optionsContainer.querySelector(cfg.heroSel);
            if (!hero) return;
            var primaryWrap = hero.querySelector(cfg.primarySel);
            if (!primaryWrap) return;
            var section = hero.closest('.door-option-wrap') || optionsContainer;
            var accordion = section.querySelector(cfg.accSel) || optionsContainer.querySelector(cfg.accSel);
            var accBody = accordion
                ? (accordion.querySelector('.door-accordion-body .common-check-options')
                    || accordion.querySelector('.common-check-options'))
                : null;

            var checkedInp = section.querySelector(
                'input[type="radio"][data-option-id="' + cfg.optionId + '"]:checked'
            );
            var selectedCard = checkedInp && checkedInp.closest
                ? checkedInp.closest('.common-check-option')
                : null;

            // Page load / cleared state: auto-select the current primary card (or first visible additional).
            if (!selectedCard || isProfileChoiceCardHidden(selectedCard)) {
                if (checkedInp) {
                    checkedInp.checked = false;
                    if (selectedCard) selectedCard.classList.remove('common-check-option--selected');
                }
                selectedCard = null;
                var heroCandidate = primaryWrap.querySelector('.common-check-option');
                if (heroCandidate && !isProfileChoiceCardHidden(heroCandidate)) {
                    selectedCard = heroCandidate;
                } else if (accBody) {
                    var accCards = accBody.querySelectorAll('.common-check-option');
                    for (var ai = 0; ai < accCards.length; ai++) {
                        if (!isProfileChoiceCardHidden(accCards[ai])) {
                            selectedCard = accCards[ai];
                            break;
                        }
                    }
                }
                if (selectedCard) {
                    var autoInp = selectedCard.querySelector(
                        'input[type="radio"][data-option-id="' + cfg.optionId + '"]'
                    );
                    if (autoInp) {
                        autoInp.checked = true;
                        selectedCard.classList.add('common-check-option--selected');
                    }
                }
            }

            if (!selectedCard) return;

            var heroCard = primaryWrap.querySelector('.common-check-option');
            if (heroCard && selectedCard !== heroCard && accBody) {
                // Swap: selected → primary top; previous primary → additional list.
                if (selectedCard.parentNode === accBody || accBody.contains(selectedCard)) {
                    var insertBefore = selectedCard.nextSibling;
                    primaryWrap.appendChild(selectedCard);
                    if (insertBefore) accBody.insertBefore(heroCard, insertBefore);
                    else accBody.appendChild(heroCard);
                } else {
                    // Selected somehow outside both — still force into primary.
                    if (accBody && heroCard.parentNode === primaryWrap) {
                        accBody.insertBefore(heroCard, accBody.firstChild);
                    }
                    primaryWrap.appendChild(selectedCard);
                }
                // Dp start 31-08 — preserve hidden state of heroCard (e.g. Soft Ogee when fixed glass is inactive)
                if (isProfileChoiceCardHidden(heroCard)) {
                    heroCard.style.display = 'none';
                    heroCard.classList.add('door-hidden');
                } else {
                    heroCard.style.display = '';
                    heroCard.classList.remove('door-hidden');
                }
                if (isProfileChoiceCardHidden(selectedCard)) {
                    selectedCard.style.display = 'none';
                    selectedCard.classList.add('door-hidden');
                } else {
                    selectedCard.style.display = '';
                    selectedCard.classList.remove('door-hidden');
                }
                // Dp end 31-08
            } else if (!heroCard && accBody) {
                primaryWrap.appendChild(selectedCard);
            }

            // Keep selection highlight on the promoted primary card only.
            section.querySelectorAll(
                'input[type="radio"][data-option-id="' + cfg.optionId + '"]'
            ).forEach(function (ri) {
                var c = ri.closest && ri.closest('.common-check-option');
                if (c) c.classList.toggle('common-check-option--selected', !!ri.checked);
            });

            var choiceDescEl = hero.querySelector(cfg.descSel);
            if (choiceDescEl) {
                var newDesc = mapCollectionDoorWording(
                    (selectedCard.getAttribute('data-choice-description') || '').trim()
                );
                choiceDescEl.textContent = newDesc;
                choiceDescEl.style.display = newDesc ? '' : 'none';
            }

            if (collapseAccordion) collapseProfileAdditionalAccordion(accordion);
        });
        try { syncSdlProfileSectionCopy(optionsContainer); } catch (eSdlCopyHero) { }
    }

    function syncPanelProfileHero(optionsContainer) {
        // Keep checked/default choice in the top primary slot (no accordion collapse here —
        // collapse only after an explicit user pick).
        promoteSelectedProfileToHero(optionsContainer, { collapseAccordion: false });
        try { syncSdlProfileVisibility(optionsContainer); } catch (eSdlHero) { }
    }

    function nestSdlProfileInStileSection(optionsContainer) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer) return null;
        var sdlWrap = optionsContainer.querySelector('.door-option-wrap[data-option-id="sdl_profile"]');
        var stileWrap = optionsContainer.querySelector('.door-option-wrap[data-option-id="stile_and_rail_profile"]');
        // console.log("stileWrap", stileWrap);
        if (!sdlWrap || !stileWrap) return null;
        var hero = stileWrap.querySelector('.door-stile-rail-hero');
        if (!hero) return null;
        var insertsOuter = stileWrap.querySelector('.door-inserts-additional-options.screen-and-storm-inserts');
        var anchor = insertsOuter || hero;
        var alreadyNested = sdlWrap.getAttribute('data-sdl-nested') === '1';
        if (!alreadyNested) {
            sdlWrap.setAttribute('data-sdl-nested', '1');
            customizeSdlProfileSection(sdlWrap);
        }
        if (sdlWrap.parentNode !== stileWrap || sdlWrap.previousSibling !== anchor) {
            if (anchor.nextSibling) {
                stileWrap.insertBefore(sdlWrap, anchor.nextSibling);
            } else {
                stileWrap.appendChild(sdlWrap);
            }
        }
        // --- Dp start ---
        // --- Dp start 16-07 ---
        try { syncAppliedMoldingSectionVisibility(optionsContainer); } catch (eAmNest) { }
        // --- Dp end 16-07 ---
        var appliedMoldingWrap = optionsContainer.querySelector('.door-option-wrap[data-option-id="applied_molding"]')
            || optionsContainer.querySelector('.door-option-wrap[data-option-id="applied_molding_choice"]');

        var isAppliedMoldingVisible = appliedMoldingWrap
            && !appliedMoldingWrap.classList.contains('door-hidden')
            && appliedMoldingWrap.style.display !== 'none';

        if (isAppliedMoldingVisible) {
            if (sdlWrap.parentNode !== appliedMoldingWrap.parentNode || sdlWrap.previousSibling !== appliedMoldingWrap) {
                if (appliedMoldingWrap.nextSibling) {
                    appliedMoldingWrap.parentNode.insertBefore(sdlWrap, appliedMoldingWrap.nextSibling);
                } else {
                    appliedMoldingWrap.parentNode.appendChild(sdlWrap);
                }
            }
        } else {
            if (sdlWrap.parentNode !== stileWrap || sdlWrap.previousSibling !== anchor) {
                if (anchor.nextSibling) {
                    stileWrap.insertBefore(sdlWrap, anchor.nextSibling);
                } else {
                    stileWrap.appendChild(sdlWrap);
                }
            }
        }
        // --- Dp end --
        /* MERGE: sdl_enable_toggle — start */
        // Mount the toggle when SDL can be offered. RM5 gets a visible locked toggle
        // unless Col AG is SDL Only (no toggle; cards show directly).
        var nestRm5Lock = false;
        try { nestRm5Lock = isRm5AppliedMoldingStileSelected(optionsContainer); } catch (eNestRm5) { nestRm5Lock = false; }
        var nestSdlOnly = shouldHideSdlToggleForSdlOnly();
        if (nestSdlOnly) {
            try { hideSdlEnableSwitchKeepForcedOpen(optionsContainer); } catch (eNestSdlOnly) { }
        } else if (stileAllowsSdlProfileSection(optionsContainer) && (!hasForcedSdlProfileDefault() || nestRm5Lock)) {
            try { ensureSdlEnableSwitch(optionsContainer, sdlWrap); } catch (eSdlNestToggle) { }
        } else {
            try {
                if (hasForcedSdlProfileDefault()) hideSdlEnableSwitchKeepForcedOpen(optionsContainer);
                else hideSdlEnableSwitch(optionsContainer);
            } catch (eSdlNestHide) { }
        }
        /* MERGE: sdl_enable_toggle — end */
        syncSdlProfileVisibility(optionsContainer);
        return alreadyNested ? false : true;
    }

    function initSdlProfileNest(optionsContainer) {
        if (!optionsContainer) optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer) return;
        if (optionsContainer.getAttribute('data-sdl-stile-bound') !== '1') {
            function onAppliedMoldingOrStileChange() {
                // --- Dp start ---
                try { nestSdlProfileInStileSection(optionsContainer); } catch (eNest) { }
                // --- Dp end --
                scheduleSdlProfileVisibilitySync(optionsContainer);
            }
            optionsContainer.addEventListener('change', function (ev) {
                var t = ev.target;
                if (!t || t.type !== 'radio') return;
                var oid = String(t.getAttribute('data-option-id') || '');
                if (oid !== 'stile_and_rail_profile' && oid !== 'applied_molding' && oid !== 'applied_molding_choice') return;
                onAppliedMoldingOrStileChange();
            });
            optionsContainer.addEventListener('click', function (ev) {
                var card = ev.target && ev.target.closest ? ev.target.closest('.common-check-option') : null;
                if (!card) return;
                var inp = card.querySelector(
                    'input[type="radio"][data-option-id="stile_and_rail_profile"],' +
                    'input[type="radio"][data-option-id="applied_molding_choice"],' +
                    'input[type="radio"][data-option-id="applied_molding"]'
                );
                if (!inp) return;
                setTimeout(onAppliedMoldingOrStileChange, 0);
            });
            optionsContainer.setAttribute('data-sdl-stile-bound', '1');
        }
        var maxTries = 20;
        var tries = 0;
        function loop() {
            tries++;
            var moved = nestSdlProfileInStileSection(optionsContainer);
            if (moved === true || moved === false) {
                scheduleSdlProfileVisibilitySync(optionsContainer);
                setTimeout(function () { scheduleSdlProfileVisibilitySync(optionsContainer); }, 100);
                setTimeout(function () { scheduleSdlProfileVisibilitySync(optionsContainer); }, 350);
                return;
            }
            if (tries >= maxTries) return;
            setTimeout(loop, 250);
        }
        setTimeout(loop, 0);
    }

    /** List price for selected stile/rail (priceValue only — no price_when overrides). */
    function getStileAndRailProfileListPrice(basePrice, config, schema) {
        if (!Array.isArray(schema) || !config) return 0;
        for (var si = 0; si < schema.length; si++) {
            var sOpt = schema[si];
            if (!optionIsStileAndRailProfile(sOpt)) continue;
            var selected = config[sOpt.id];
            if (selected == null || selected === '') return 0;
            var sChoices = Array.isArray(sOpt.options) ? sOpt.options : [];
            var sStr = String(selected);
            var sCh = sChoices.find(function (c) { return String(c && c.value != null ? c.value : '') === sStr; });
            if (!sCh) return 0;
            var sType = sCh.priceType || sCh.price_type || 'fixed';
            var sVal = parseFloat(sCh.priceValue != null ? sCh.priceValue : sCh.price_value);
            if (isNaN(sVal)) sVal = 0;
            if (sType === 'percent') return (parseFloat(basePrice) || 0) * sVal;
            return sVal;
        }
        return 0;
    }

    function optionIsPanelProfile(opt) {
        if (!opt) return false;
        return String(opt.id || '').toLowerCase().replace(/-/g, '_') === 'panel_profile';
    }

    function optionIsLocksetPrep(opt) {
        if (!opt) return false;
        return String(opt.id || '').toLowerCase().replace(/-/g, '_') === 'lockset_prep';
    }

    function optionIsHingeFinish(opt) {
        if (!opt) return false;
        return String(opt.id || '').toLowerCase().replace(/-/g, '_') === 'hinge_finish';
    }

    function optionIsTopStyle(opt) {
        if (!opt) return false;
        var id = String(opt.id || '').toLowerCase().replace(/-/g, '_');
        var lab = String(opt.label || '').toLowerCase();
        if (lab.indexOf('top style') !== -1) return true;
        if (id.indexOf('top') !== -1 && id.indexOf('style') !== -1) return true;
        // Fallback: detect by known choice values used elsewhere (round_top / arch_top).
        try {
            var choices = Array.isArray(opt.options) ? opt.options : [];
            for (var i = 0; i < choices.length; i++) {
                var v = String(choices[i] && choices[i].value != null ? choices[i].value : '').toLowerCase();
                if (v === 'round_top' || v === 'arch_top') return true;
            }
        } catch (e) { }
        return false;
    }

    /**
     * UI render order for the main option sections.
     * Only affects display sequence (no pricing/visibility logic).
     *
     * Requested order:
     * 1) door-unit-design-group (door_unit_design + sidelight_design + transom_design)
     * 2) top_style
     * 3) wood_type_storm_porch
     * 4) wood_type
     * 4) screen_and_storm_inserts
     * 5) screen_type
     * 6) glass_type
     * 7) screen_storm_insert_frame_color
     * 8) door_location
     * 9) pre_hung
     * 10) measurement_type
     * 11) stile_and_rail_profile
     * 12) panel_profile
     * 13) hinge_finish
     * 14) lockset_prep
     * 15) (post-lockset accordions are injected after lockset_prep)
     * 16) swing_direction
     * 17) glass_bevel
     * 18) applied_molding
     */
    var desiredOptionOrder = [
        'door_unit_design',
        'panel_unit_design',
        'sidelight_design',
        'transom_design',
        'pre_hung',
        'top_style',
        'wood_type_storm_porch',
        'wood_type',
        'screen_and_storm_inserts',
        'screen_type',
        'storm_glass_type',
        'glass_type',
        'screen_storm_insert_frame_color',
        'screen_and_storm_inserts_additional_options',
        'swing_direction',
        'door_location',
        'measurement_type',
        'stile_and_rail_profile',
        'applied_molding',
        // --- Dp start 17-07 (sdl_profile ordered after applied_molding) ---
        'sdl_profile',
        // --- Dp end 17-07 (sdl_profile ordered after applied_molding) ---
        'panel_profile',
        'hinge_finish',
        'lockset_prep',
        'shelf',
        'glass_bevel',
        'additional_options',
        'hardware_options',
        'casing_options'
    ];
    var desiredOptionRank = Object.create(null);
    for (var _ri = 0; _ri < desiredOptionOrder.length; _ri++) desiredOptionRank[desiredOptionOrder[_ri]] = _ri;

    function schemaForDoorRenderOrder(schema) {
        if (!Array.isArray(schema) || !schema.length) return schema || [];

        return schema
            .map(function (o, idx) { return { o: o, idx: idx }; })
            .sort(function (a, b) {
                var aKey = a && a.o ? normalizeOptionIdKey(a.o.id) : '';
                var bKey = b && b.o ? normalizeOptionIdKey(b.o.id) : '';
                var aHas = aKey && desiredOptionRank[aKey] != null;
                var bHas = bKey && desiredOptionRank[bKey] != null;
                if (aHas && bHas) return desiredOptionRank[aKey] - desiredOptionRank[bKey];
                if (aHas && !bHas) return -1;
                if (!aHas && bHas) return 1;
                return a.idx - b.idx;
            })
            .map(function (x) { return x.o; });
    }


    function buildOptionsFromRange(min, max, step) {
        var opts = [];
        var mn = parseFloat(min);
        var mx = parseFloat(max);
        var st = (step != null && step !== '') ? parseFloat(step) : 1;
        if (isNaN(mn) || isNaN(mx) || st <= 0) return opts;
        var n = Math.round((mx - mn) / st) + 1;
        for (var i = 0; i < n; i++) {
            var v = mn + i * st;
            if (v > mx) break;
            v = Math.round(v * 100) / 100;
            opts.push({ value: v, label: String(v) });
        }
        return opts;
    }

    function isSchemaOptionWrapHidden(optId, container) {
        if (!optId || !container) return false;
        var wrap = container.querySelector('.door-option-wrap[data-option-id="' + optId + '"]');
        if (!wrap) return false;
        if (wrap.classList && wrap.classList.contains('door-hidden')) return true;
        if (wrap.getAttribute && wrap.getAttribute('data-empty-hidden') === '1') return true;
        if (wrap.hidden) return true;
        if (wrap.style && wrap.style.display === 'none') return true;
        return false;
    }

    function getCurrentConfigFromSchema() {
        if (!doorConfigSchema) return null;
        var container = document.getElementById('door-configurator-options');
        if (!container) return null;
        var config = {};
        var optType;
        doorConfigSchema.forEach(function (opt) {
            optType = (opt.type || '').toLowerCase();
            if (optType === 'dimension') {
                var cmSel = container.querySelector('select[data-option-id="' + opt.id + '"][data-unit="cm"], input[data-option-id="' + opt.id + '"][data-unit="cm"]');
                var inSel = container.querySelector('select[data-option-id="' + opt.id + '"][data-unit="in"], input[data-option-id="' + opt.id + '"][data-unit="in"]');
                var intSel = container.querySelector('select[data-option-id="' + opt.id + '"][data-unit="in-int"]');
                var fracSel = container.querySelector('select[data-option-id="' + opt.id + '"][data-unit="in-frac"]');
                if (cmSel && cmSel.value !== '') config[opt.id + '_cm'] = cmSel.value;
                if (inSel && inSel.value !== '') config[opt.id + '_in'] = inSel.value;
                if (intSel && String(intSel.value || '') !== '') {
                    config[opt.id] = intSel.value;
                    if (fracSel && String(fracSel.value || '') !== '') config[opt.id + '_fraction'] = fracSel.value;
                } else if (fracSel && String(fracSel.value || '') !== '' && !intSel) {
                    config[opt.id] = fracSel.value;
                }
                return;
            }
            // Hidden options (e.g. Hinges under Slab) must not ride along on submit.
            if (isSchemaOptionWrapHidden(opt.id, container)) {
                if (optType === 'checkbox') config[opt.id] = [];
                else config[opt.id] = null;
                return;
            }
            var inputs = all('select[data-option-id="' + opt.id + '"], input[data-option-id="' + opt.id + '"]', container);
            if (optType === 'checkbox') {
                config[opt.id] = inputs.filter(function (el) { return el.checked; }).map(function (el) { return el.value; });
            } else if (optType === 'radio') {
                var checkedRadio = inputs.filter(function (el) { return el.checked; })[0];
                if (checkedRadio && (
                    isInactiveScreenStormTypeOption(opt.id, container)
                    || isInactivePanelProfileOption(opt.id)
                )) {
                    config[opt.id] = null;
                } else {
                    config[opt.id] = checkedRadio ? (checkedRadio.value || null) : null;
                }
            } else if (inputs.length) {
                if (isInactiveScreenStormTypeOption(opt.id, container) || isInactivePanelProfileOption(opt.id)) {
                    config[opt.id] = null;
                    return;
                }
                var v = inputs[0].value;
                config[opt.id] = optType === 'number' && v !== '' ? parseFloat(v) : (v || null);
            }
        });

        // Extra UI-only options (not backed by metaobjects) that should still be captured in config.
        try {
            var extraIds = ['transom_count', 'door_location_exposure', 'panel_unit_design'];
            extraIds.forEach(function (id) {
                if (isSchemaOptionWrapHidden(id, container)) {
                    config[id] = null;
                    return;
                }
                var checked = container.querySelector('input[type="radio"][data-option-id="' + id + '"]:checked');
                if (checked) config[id] = checked.value || null;
            });
            var addlInps = container.querySelectorAll('input[type="checkbox"][data-option-id="screen_and_storm_inserts_additional_options"]:checked');
            if (addlInps.length) {
                var vals = [];
                addlInps.forEach(function (el) {
                    if (!el) return;
                    // Skip checkboxes that live under a hidden parent option wrap.
                    var parentWrap = el.closest ? el.closest('.door-option-wrap[data-option-id], .door-inserts-additional-options') : null;
                    if (parentWrap) {
                        if (parentWrap.classList && parentWrap.classList.contains('door-hidden')) return;
                        if (parentWrap.style && parentWrap.style.display === 'none') return;
                    }
                    vals.push(el.value);
                });
                config['screen_and_storm_inserts_additional_options'] = vals;
            } else {
                config['screen_and_storm_inserts_additional_options'] = [];
            }
        } catch (eExtraCfg) { }

        // Measurement dimension <select>s render from a Liquid template and DON'T carry a
        // data-option-id, so the schema loop above never captures them. Without this they
        // are missing from the saved options_json (nothing to store / restore). Capture
        // each by its deterministic select id AND the row's linked schema dimension id so
        // both the storefront restore and the admin editable dropdowns can read them back.
        try {
            var measSelects = container.querySelectorAll(
                '.door-measurement-static-panels select, .door-measurement-static-panel select, .door-measurement-embedded-dimensions select, .door-measurement-static-rows select, .door-measure-dimension-row select, .door-measure-dimension-inputs-row select'
            );
            measSelects.forEach(function (sel) {
                if (!sel) return;
                var keyById = sel.id || (sel.getAttribute && sel.getAttribute('data-option-id')) || '';
                var isThickSel = /thickness|thick/i.test(String(keyById));
                // Skip hidden panels — except Door Thickness: Finished Opening uses
                // finished-door-thickness while Exact panel is often door-hidden on Slab/Rough.
                if (sel.closest && sel.closest('.door-hidden') && !isThickSel) return;
                var v = sel.value;
                if (v == null || v === '') return;
                // Dp start 26-08 — prefer dropdown label (3/8, 1 1/8) over option value (0.375, 1.125)
                // for human-facing summary / inches text. Keep raw value on the select id for restore.
                var labelTxt = '';
                try {
                    // Dp merge code 10-09 start — resolve label by matching .value (selectedIndex can desync → last "15/16")
                    var opLab = null;
                    if (sel.options && sel.options.length) {
                        var oiMatch;
                        for (oiMatch = 0; oiMatch < sel.options.length; oiMatch++) {
                            if (String(sel.options[oiMatch].value) === String(v)) {
                                opLab = sel.options[oiMatch];
                                break;
                            }
                        }
                        if (!opLab && sel.selectedIndex >= 0) {
                            opLab = sel.options[sel.selectedIndex];
                        }
                    }
                    labelTxt = opLab ? String(opLab.textContent || '').trim() : '';
                    // Dp merge code 10-09 end
                } catch (eLab) { labelTxt = ''; }
                var isFracOrThick = /frac|thickness|thick/i.test(String(keyById))
                    || (sel.classList && (sel.classList.contains('door-dimension-frac-select') || sel.classList.contains('door-dimension-select')));
                if (keyById) {
                    // Prefer visible-panel thickness over hidden exact-panel duplicate.
                    if (isThickSel && sel.closest && sel.closest('.door-hidden') && config[keyById]) return;
                    config[keyById] = v;
                    // Dp merge code 10-09 start — always keep raw decimal sibling for admin/quote readers
                    if (isFracOrThick) {
                        config[keyById + '_value'] = v;
                    }
                    // Dp merge code 10-09 end
                    if (isFracOrThick && labelTxt && labelTxt !== v) {
                        config[keyById + '_label'] = labelTxt;
                    }
                }
                var row = sel.closest ? sel.closest('.door-measure-dimension-row') : null;
                var embedId = row && row.getAttribute ? (row.getAttribute('data-embed-dimension-id') || '') : '';
                if (embedId) {
                    var isFrac = /frac/i.test(keyById) || (sel.classList && sel.classList.contains('door-dimension-frac-select'));
                    // Dp merge code 10-09 start — store raw decimal on embed fraction; label only as display sibling
                    var storeVal = v;
                    if (isFrac && labelTxt) {
                        storeVal = v;
                    }
                    var titleEl = row.querySelector ? row.querySelector('.door-measure-dimension-title') : null;
                    var titleLow = titleEl ? String(titleEl.textContent || '').toLowerCase() : '';
                    if ((!isFrac && /thickness|thick/.test(titleLow) || isThickSel) && labelTxt) storeVal = labelTxt;
                    if (isThickSel && sel.closest && sel.closest('.door-hidden') && config[isFrac ? (embedId + '_fraction') : embedId]) {
                        /* keep visible value */
                    } else {
                        if (isFrac) {
                            config[embedId + '_fraction'] = v;
                            config[embedId + '_fraction_value'] = v;
                            if (labelTxt && labelTxt !== v) config[embedId + '_fraction_label'] = labelTxt;
                        } else {
                            config[embedId] = storeVal;
                        }
                    }
                    // Dp merge code 10-09 end
                }
                // Dp end 26-08
            });
            // Dp start 02-09 — visible Rough Opening selects (rough-height-int) win over stale rough_height_int
            (function dpSyncRoughOpeningSelectKeys(cfg, rootEl) {
                if (!cfg) return;
                function pickSelectLabel(sel) {
                    if (!sel) return '';
                    try {
                        var op = sel.options && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
                        return op ? String(op.textContent || op.value || '').trim() : String(sel.value || '').trim();
                    } catch (ePick) {
                        return String(sel.value || '').trim();
                    }
                }
                function readRoughFromDom(kind) {
                    var intV = '';
                    var fracV = '';
                    if (!rootEl || !rootEl.querySelectorAll) return { intV: intV, fracV: fracV };
                    rootEl.querySelectorAll(
                        '.door-measurement-static-panel--rough:not(.door-hidden) .door-measure-dimension-row,' +
                        ' .door-measurement-static-panels .door-measurement-static-panel--rough:not(.door-hidden) .door-measure-dimension-row'
                    ).forEach(function (row) {
                        if (!row || (row.closest && row.closest('.door-hidden'))) return;
                        var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
                        var title = titleEl ? String(titleEl.textContent || '').toLowerCase().replace(/\s+/g, ' ').trim() : '';
                        if (kind === 'width' && title.indexOf('rough opening width') === -1) return;
                        if (kind === 'height' && title.indexOf('rough opening height') === -1) return;
                        row.querySelectorAll('select').forEach(function (sel) {
                            if (!sel || sel.disabled) return;
                            var sid = String(sel.id || '').toLowerCase();
                            var lab = pickSelectLabel(sel);
                            if (!lab) return;
                            if (/frac|fraction/.test(sid) || (sel.classList && sel.classList.contains('door-dimension-frac-select'))) {
                                if (!fracV) fracV = lab;
                            } else if (!intV) {
                                intV = lab;
                            }
                        });
                    });
                    if (!intV && !fracV) {
                        var intSel = rootEl.querySelector('select#rough-' + kind + '-int, select[id^="rough-' + kind + '-int"]');
                        var fracSel = rootEl.querySelector('select#rough-' + kind + '-frac, select[id^="rough-' + kind + '-frac"]');
                        intV = pickSelectLabel(intSel);
                        fracV = pickSelectLabel(fracSel);
                    }
                    return { intV: intV, fracV: fracV };
                }
                function writeRough(kind, intV, fracV) {
                    if (!intV && !fracV) return;
                    if (kind === 'width') {
                        if (intV) {
                            cfg['rough-width-int'] = intV;
                            cfg.rough_width_int = intV;
                        }
                        if (fracV) {
                            cfg['rough-width-frac'] = fracV;
                            cfg.rough_width_frac = fracV;
                        }
                    } else {
                        if (intV) {
                            cfg['rough-height-int'] = intV;
                            cfg.rough_height_int = intV;
                        }
                        if (fracV) {
                            cfg['rough-height-frac'] = fracV;
                            cfg.rough_height_frac = fracV;
                        }
                    }
                }
                var domW = readRoughFromDom('width');
                var domH = readRoughFromDom('height');
                if (domW.intV || domW.fracV) writeRough('width', domW.intV, domW.fracV);
                else if (cfg['rough-width-int']) cfg.rough_width_int = cfg['rough-width-int'];
                if (domH.intV || domH.fracV) writeRough('height', domH.intV, domH.fracV);
                else if (cfg['rough-height-int']) cfg.rough_height_int = cfg['rough-height-int'];
                if (cfg['rough-height-frac'] || cfg['rough-height-frac_label']) {
                    cfg.rough_height_frac = cfg['rough-height-frac_label'] || cfg['rough-height-frac'];
                }
                if (cfg['rough-width-frac'] || cfg['rough-width-frac_label']) {
                    cfg.rough_width_frac = cfg['rough-width-frac_label'] || cfg['rough-width-frac'];
                }
            })(config, container);
            // Dp end 02-09
            // Dp start 26-08 — normalize any thickness select into door_thickness for quote / draft / PDF
            (function dpCaptureDoorThicknessAlias(cfg, rootEl) {
                if (!cfg || !rootEl || !rootEl.querySelectorAll) return;
                var thickKeys = [
                    'finished-door-thickness', 'finished_door_thickness',
                    'exact-door-thickness-frac', 'exact_door_thickness_frac',
                    'panel-door-thickness-frac', 'door-thickness', 'door_thickness'
                ];
                var best = '';
                var bestLabel = '';
                thickKeys.forEach(function (k) {
                    if (bestLabel) return;
                    if (cfg[k + '_label']) { bestLabel = String(cfg[k + '_label']).trim(); best = String(cfg[k] || '').trim(); }
                    else if (cfg[k] && !best) best = String(cfg[k]).trim();
                });
                if (!bestLabel && !best) {
                    rootEl.querySelectorAll('select[id*="thickness"], select[id*="thick"]').forEach(function (sel) {
                        if (!sel || !sel.value) return;
                        var op = sel.options && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
                        var lab = op ? String(op.textContent || '').trim() : '';
                        var hidden = !!(sel.closest && sel.closest('.door-hidden'));
                        if (hidden && bestLabel) return;
                        if (lab) { bestLabel = lab; best = String(sel.value); }
                        else if (!best) best = String(sel.value);
                    });
                }
                var display = bestLabel || best;
                if (!display) return;
                // Map decimals via same helper used below when available later — simple inline:
                var thickMap = {
                    '1.125': '1 1/8', '1.25': '1 1/4', '1.375': '1 3/8', '1.5': '1 1/2',
                    '1.75': '1 3/4', '2.25': '2 1/4', '2.5': '2 1/2', '2.75': '2 3/4'
                };
                if (thickMap[display]) display = thickMap[display];
                cfg.door_thickness = display;
                cfg.exact_door_thickness = display;
                cfg.exact_door_thickness_inches = display + ' inches';
                if (best && !cfg['exact-door-thickness-frac']) cfg['exact-door-thickness-frac'] = best;
                if (bestLabel) {
                    cfg['exact-door-thickness-frac_label'] = bestLabel;
                    cfg['finished-door-thickness_label'] = bestLabel;
                }
            })(config, container);
            // Dp end 26-08
            // Dp start 26-08 — store combined inches on measurement structure for quote / draft / PDF.
            (function dpStoreMeasurementInchesStructure(cfg) {
                if (!cfg) return;
                function fracToDec(raw) {
                    var s = String(raw == null ? '' : raw).trim();
                    if (!s || s === '0' || s === '00' || s === '0/0') return 0;
                    if (/^\d+\/\d+$/.test(s)) {
                        var bits = s.split('/');
                        var a = parseFloat(bits[0]);
                        var b = parseFloat(bits[1]);
                        return (b > 0 && !isNaN(a)) ? (a / b) : 0;
                    }
                    if (/^\d+\s+\d+\/\d+$/.test(s)) {
                        var m = s.match(/^(\d+)\s+(\d+)\/(\d+)$/);
                        if (m) return (parseFloat(m[1]) || 0) + ((parseFloat(m[3]) > 0) ? (parseFloat(m[2]) / parseFloat(m[3])) : 0);
                    }
                    var n = parseFloat(s);
                    return isNaN(n) ? 0 : n;
                }
                function fracToDisplayLabel(raw) {
                    var s = String(raw == null ? '' : raw).trim();
                    if (!s) return '';
                    if (s === '0' || s === '00' || s === '0/0') return '0';
                    if (/^\d+\s+\d+\/\d+$/.test(s) || /^\d+\/\d+$/.test(s)) return s;
                    var thickMap = {
                        '1.125': '1 1/8', '1.25': '1 1/4', '1.375': '1 3/8', '1.5': '1 1/2',
                        '1.75': '1 3/4', '2.25': '2 1/4', '2.5': '2 1/2', '2.75': '2 3/4'
                    };
                    if (thickMap[s]) return thickMap[s];
                    var n = parseFloat(s);
                    if (isNaN(n)) return s;
                    for (var tk in thickMap) {
                        if (Object.prototype.hasOwnProperty.call(thickMap, tk) && Math.abs(parseFloat(tk) - n) < 0.0001) return thickMap[tk];
                    }
                    var fracMap = [
                        { v: 0, l: '0' }, { v: 0.0625, l: '1/16' }, { v: 0.125, l: '1/8' }, { v: 0.1875, l: '3/16' },
                        { v: 0.25, l: '1/4' }, { v: 0.3125, l: '5/16' }, { v: 0.375, l: '3/8' }, { v: 0.4375, l: '7/16' },
                        { v: 0.5, l: '1/2' }, { v: 0.5625, l: '9/16' }, { v: 0.625, l: '5/8' }, { v: 0.6875, l: '11/16' },
                        { v: 0.75, l: '3/4' }, { v: 0.8125, l: '13/16' }, { v: 0.875, l: '7/8' }, { v: 0.9375, l: '15/16' }
                    ];
                    if (n >= 0 && n < 1) {
                        for (var i = 0; i < fracMap.length; i++) {
                            if (Math.abs(fracMap[i].v - n) < 0.0001) return fracMap[i].l;
                        }
                        return s;
                    }
                    var intPart = Math.floor(n + 1e-9);
                    var fracPart = Math.round((n - intPart) * 10000) / 10000;
                    var fracLab = '';
                    for (var j = 0; j < fracMap.length; j++) {
                        if (Math.abs(fracMap[j].v - fracPart) < 0.0001) { fracLab = fracMap[j].l; break; }
                    }
                    if (!fracLab || fracLab === '0') return String(intPart);
                    return intPart + ' ' + fracLab;
                }
                function readCfg() {
                    for (var i = 0; i < arguments.length; i++) {
                        var k = arguments[i];
                        // Prefer dropdown label (3/8) over data-value (0.375).
                        if (cfg[k + '_label'] != null && String(cfg[k + '_label']).trim() !== '') return String(cfg[k + '_label']).trim();
                        if (cfg[k] != null && String(cfg[k]) !== '') return String(cfg[k]).trim();
                    }
                    return '';
                }
                function setCombined(baseKey, intKeys, fracKeys) {
                    var intV = '';
                    var fracV = '';
                    for (var i = 0; i < intKeys.length; i++) {
                        if (cfg[intKeys[i]] != null && String(cfg[intKeys[i]]) !== '') {
                            intV = String(cfg[intKeys[i]]).trim();
                            break;
                        }
                    }
                    // Dp merge code 10-09 start — prefer live decimal / *_value over stale *_label ("15/16")
                    for (var j = 0; j < fracKeys.length; j++) {
                        var fk = fracKeys[j];
                        var rawF = '';
                        var labF = '';
                        var valF = '';
                        if (cfg[fk] != null && String(cfg[fk]).trim() !== '') rawF = String(cfg[fk]).trim();
                        if (cfg[fk + '_value'] != null && String(cfg[fk + '_value']).trim() !== '') {
                            valF = String(cfg[fk + '_value']).trim();
                        }
                        if (cfg[fk + '_label'] != null && String(cfg[fk + '_label']).trim() !== '') {
                            labF = String(cfg[fk + '_label']).trim();
                        }
                        var pickF = valF || rawF;
                        if (pickF && labF) {
                            var pickDisp = fracToDisplayLabel(pickF);
                            var labDisp = fracToDisplayLabel(labF);
                            if (pickDisp && labDisp && pickDisp !== labDisp && /^(?:0|[1-9]\d*)(?:\.\d+)?$/.test(pickF)) {
                                fracV = pickF;
                                break;
                            }
                        }
                        if (pickF) {
                            fracV = pickF;
                            break;
                        }
                        if (labF) {
                            fracV = labF;
                            break;
                        }
                    }
                    // Dp merge code 10-09 end
                    if (!intV && !fracV) return;
                    fracV = fracToDisplayLabel(fracV);
                    intV = /^\d+(\.\d+)?$/.test(intV) && parseFloat(intV) >= 1 && String(intV).indexOf('.') !== -1
                        ? fracToDisplayLabel(intV)
                        : intV;
                    var display = intV;
                    if (fracV && fracV !== '0' && fracV !== '00' && fracV !== '0/0') {
                        display = intV ? (intV + ' ' + fracV) : fracV;
                    }
                    var inches = (parseFloat(String(intV).split(/\s+/)[0]) || 0) + fracToDec(fracV);
                    if (/\d+\s+\d+\/\d+/.test(String(intV))) inches = fracToDec(intV);
                    if (display) cfg[baseKey] = display;
                    if (inches > 0 || intV) cfg[baseKey + '_in'] = inches;
                    if (display) cfg[baseKey + '_inches'] = display + ' inches';
                }
                setCombined('exact_door_width', ['exact_door_width_int', 'exact-door-width-int', 'door_width'], ['exact_door_width_frac', 'exact-door-width-frac', 'exact_door_width_fraction']);
                setCombined('exact_door_height', ['door_height', 'exact_door_height', 'exact-door-height-int'], ['door_height_fraction', 'door_height_frac', 'exact_door_height_frac']);
                setCombined('rough_opening_width', ['rough_width_int', 'rough-width-int'], ['rough_width_frac', 'rough-width-frac']);
                setCombined('rough_opening_height', ['rough_height_int', 'rough-height-int'], ['rough_height_frac', 'rough-height-frac']);
                setCombined('sidelight_width_combined', ['sidelight_width', 'sidelight_width_int', 'sidelight-width'], ['sidelight_width_fraction', 'sidelight_width_frac']);
                setCombined('transom_height_combined', ['panel_transom_height_int', 'panel-transom-height-int'], ['panel_transom_height_frac', 'panel_transom_height_fraction']);
                // Dp merge code 10-09 start — jamb panel-* selects → combined keys (quote/admin fraction repair)
                setCombined('jamb_unit_width', ['panel_width_int', 'panel-width-int'], ['panel_width_frac', 'panel-width-frac', 'panel_width_fraction']);
                setCombined('jamb_unit_height', ['panel_height_int', 'panel-height-int'], ['panel_height_frac', 'panel-height-frac', 'panel_height_fraction']);
                setCombined('transom_width_combined', ['transom_width_int', 'transom-width-int', 'panel_transom_width_int'], ['transom_width_frac', 'transom-width-frac', 'transom_width_fraction', 'panel_transom_width_frac']);
                // Dp merge code 10-09 end
                setCombined('pre_hung_unit_depth', ['jamb_pre_hung_int', 'panel_pre_hung_int', 'rough_pre_hung_int', 'exact_pre_hung_int'], ['jamb_pre_hung_frac', 'panel_pre_hung_frac', 'exact_pre_hung_frac']);
                setCombined('finished_opening_width', ['finished_width_int', 'finished-width-int'], ['finished_width_frac', 'finished-width-frac', 'finished_width_fraction']);
                setCombined('finished_opening_height', ['finished_height_int', 'finished-height-int'], ['finished_height_frac', 'finished-height-frac', 'finished_height_fraction']);
                var thick = readCfg('exact-door-thickness-frac', 'exact_door_thickness_frac', 'door_thickness', 'exact_door_thickness');
                if (thick) {
                    thick = fracToDisplayLabel(thick);
                    cfg.exact_door_thickness = thick;
                    cfg.exact_door_thickness_inches = thick + ' inches';
                    cfg.door_thickness = thick;
                }
                // Dp start 26-08 — Slab / Brick Molding: Rough Opening Size UI uses Finished Opening
                // fields (rough panel hidden). Mirror visible W/H/T into the keys expected by
                // measurement_type so quote details / draft / PDF always receive values.
                (function dpMirrorActiveMeasurementKeys(cfgInner, rootEl) {
                    if (!cfgInner) return;
                    function readAny(keys) {
                        for (var i = 0; i < keys.length; i++) {
                            var k = keys[i];
                            if (cfgInner[k] != null && String(cfgInner[k]).trim() !== '') return String(cfgInner[k]).trim();
                            var alt = String(k).indexOf('_') !== -1 ? String(k).replace(/_/g, '-') : String(k).replace(/-/g, '_');
                            if (alt !== k && cfgInner[alt] != null && String(cfgInner[alt]).trim() !== '') return String(cfgInner[alt]).trim();
                        }
                        return '';
                    }
                    function writeKey(primary, aliases, val) {
                        if (val == null || String(val).trim() === '') return;
                        cfgInner[primary] = val;
                        (aliases || []).forEach(function (a) { if (a) cfgInner[a] = val; });
                    }
                    var mt = String(cfgInner.measurement_type || cfgInner['measurement-type'] || '').toLowerCase().replace(/-/g, '_');
                    var finishedVis = !!(rootEl && rootEl.querySelector && rootEl.querySelector('.door-measurement-static-panel--finished:not(.door-hidden)'));
                    var roughVis = !!(rootEl && rootEl.querySelector && rootEl.querySelector('.door-measurement-static-panel--rough:not(.door-hidden)'));
                    var exactVis = !!(rootEl && rootEl.querySelector && rootEl.querySelector('.door-measurement-static-panel--exact:not(.door-hidden)'));
                    var fw = readAny(['finished_width_int', 'finished-width-int']);
                    var fwf = readAny(['finished_width_frac', 'finished-width-frac', 'finished_width_fraction']);
                    var fh = readAny(['finished_height_int', 'finished-height-int']);
                    var fhf = readAny(['finished_height_frac', 'finished-height-frac', 'finished_height_fraction']);
                    var rw = readAny(['rough-width-int', 'rough_width_int']);
                    var rwf = readAny(['rough-width-frac', 'rough-width-frac_label', 'rough_width_frac', 'rough_width_fraction']);
                    var rh = readAny(['rough-height-int', 'rough_height_int']);
                    var rhf = readAny(['rough-height-frac', 'rough-height-frac_label', 'rough_height_frac', 'rough_height_fraction']);
                    // Dp start 02-09 — read live Rough Opening W/H from visible panel (not Exact Door H)
                    if (roughVis && rootEl && rootEl.querySelectorAll) {
                        rootEl.querySelectorAll(
                            '.door-measurement-static-panel--rough:not(.door-hidden) .door-measure-dimension-row'
                        ).forEach(function (row) {
                            if (!row || (row.closest && row.closest('.door-hidden'))) return;
                            var titleEl = row.querySelector('.door-measure-dimension-title') || row.querySelector('h4');
                            var title = titleEl ? String(titleEl.textContent || '').toLowerCase().replace(/\s+/g, ' ').trim() : '';
                            var isWidth = title.indexOf('rough opening width') !== -1;
                            var isHeight = title.indexOf('rough opening height') !== -1;
                            if (!isWidth && !isHeight) return;
                            row.querySelectorAll('select').forEach(function (sel) {
                                if (!sel || sel.disabled) return;
                                var sid = String(sel.id || '').toLowerCase();
                                var op = sel.options && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
                                var lab = op ? String(op.textContent || op.value || '').trim() : String(sel.value || '').trim();
                                if (!lab) return;
                                if (/frac|fraction/.test(sid) || (sel.classList && sel.classList.contains('door-dimension-frac-select'))) {
                                    if (isWidth) rwf = lab;
                                    if (isHeight) rhf = lab;
                                } else {
                                    if (isWidth) rw = lab;
                                    if (isHeight) rh = lab;
                                }
                            });
                        });
                    }
                    // Dp end 02-09
                    var ew = readAny(['exact_door_width_int', 'exact-door-width-int']);
                    var ewf = readAny(['exact_door_width_frac', 'exact-door-width-frac', 'exact_door_width_fraction']);
                    var eh = readAny(['door_height', 'exact_door_height', 'exact-door-height-int']);
                    var ehf = readAny(['door_height_fraction', 'door_height_frac', 'exact_door_height_frac']);
                    var thk = readAny([
                        'finished-door-thickness_label', 'finished_door_thickness_label',
                        'finished-door-thickness', 'finished_door_thickness',
                        'exact-door-thickness-frac_label', 'exact_door_thickness_frac_label',
                        'exact_door_thickness_frac', 'exact-door-thickness-frac',
                        'door_thickness', 'exact_door_thickness'
                    ]);
                    if (thk) thk = fracToDisplayLabel(thk);
                    // Dp start 02-09 — mirror finished→rough ONLY when Rough Opening Size is selected
                    // (Slab + Finished Opening Size must keep finished_* keys / label).
                    var mtIsRough = mt.indexOf('rough') !== -1;
                    var mtIsFinished = mt.indexOf('finished') !== -1;
                    if (mtIsRough && !mtIsFinished && (fw || fh || ew || eh || rw || rh)) {
                        if (roughVis && (rw || rh)) {
                            writeKey('rough_width_int', ['rough-width-int'], rw || fw || ew);
                            writeKey('rough_width_frac', ['rough-width-frac', 'rough_width_fraction'], rwf || fwf || ewf || '0');
                            writeKey('rough_height_int', ['rough-height-int'], rh);
                            writeKey('rough_height_frac', ['rough-height-frac', 'rough_height_fraction'], rhf || '0');
                        } else if (!roughVis && finishedVis) {
                            // Slab / Brick Molding + Rough Opening tab: finished panel visible, rough hidden
                            writeKey('rough_width_int', ['rough-width-int'], fw || ew || rw);
                            writeKey('rough_width_frac', ['rough-width-frac', 'rough_width_fraction'], fwf || ewf || rwf || '0');
                            writeKey('rough_height_int', ['rough-height-int'], fh || eh || rh);
                            writeKey('rough_height_frac', ['rough-height-frac', 'rough_height_fraction'], fhf || ehf || rhf || '0');
                        }
                        setCombined('rough_opening_width', ['rough_width_int', 'rough-width-int'], ['rough_width_frac', 'rough-width-frac', 'rough_width_fraction']);
                        setCombined('rough_opening_height', ['rough_height_int', 'rough-height-int'], ['rough_height_frac', 'rough-height-frac', 'rough_height_fraction']);
                    }
                    // Dp end 02-09
                    // Finished Opening selected — keep finished_* filled from whatever panel is active.
                    if (mt.indexOf('finished') !== -1 || finishedVis) {
                        writeKey('finished_width_int', ['finished-width-int'], fw || rw || ew);
                        writeKey('finished_width_frac', ['finished-width-frac', 'finished_width_fraction'], fwf || rwf || ewf || '0');
                        writeKey('finished_height_int', ['finished-height-int'], fh || rh || eh);
                        writeKey('finished_height_frac', ['finished-height-frac', 'finished_height_fraction'], fhf || rhf || ehf || '0');
                        setCombined('finished_opening_width', ['finished_width_int', 'finished-width-int'], ['finished_width_frac', 'finished-width-frac', 'finished_width_fraction']);
                        setCombined('finished_opening_height', ['finished_height_int', 'finished-height-int'], ['finished_height_frac', 'finished-height-frac', 'finished_height_fraction']);
                        // Dp merge code 10-09 start — Finished Opening Size tab → Rough Opening Size keys
                        // Prefer live rough when finished is still default 36x80 (do not clobber 91x96).
                        var finIsDefault09 = (String(fw || rw || ew || '') === '36'
                            && String(fh || rh || eh || '') === '80'
                            && String(fwf || rwf || ewf || '0') === '0'
                            && String(fhf || rhf || ehf || '0') === '0');
                        if (!(finIsDefault09 && (rw || rh))) {
                            writeKey('rough_width_int', ['rough-width-int'], fw || rw || ew);
                            writeKey('rough_width_frac', ['rough-width-frac', 'rough_width_fraction'], fwf || rwf || ewf || '0');
                            writeKey('rough_height_int', ['rough-height-int'], fh || rh || eh);
                            writeKey('rough_height_frac', ['rough-height-frac', 'rough_height_fraction'], fhf || rhf || ehf || '0');
                            setCombined('rough_opening_width', ['rough_width_int', 'rough-width-int'], ['rough_width_frac', 'rough-width-frac', 'rough_width_fraction']);
                            setCombined('rough_opening_height', ['rough_height_int', 'rough-height-int'], ['rough_height_frac', 'rough-height-frac', 'rough_height_fraction']);
                        } else if (rw || rh) {
                            // Hydrate finished panel from rough so Finished Opening Size tab shows Rough Opening Size
                            writeKey('finished_width_int', ['finished-width-int'], rw || fw);
                            writeKey('finished_width_frac', ['finished-width-frac', 'finished_width_fraction'], rwf || fwf || '0');
                            writeKey('finished_height_int', ['finished-height-int'], rh || fh);
                            writeKey('finished_height_frac', ['finished-height-frac', 'finished_height_fraction'], rhf || fhf || '0');
                            setCombined('finished_opening_width', ['finished_width_int', 'finished-width-int'], ['finished_width_frac', 'finished-width-frac', 'finished_width_fraction']);
                            setCombined('finished_opening_height', ['finished_height_int', 'finished-height-int'], ['finished_height_frac', 'finished-height-frac', 'finished_height_fraction']);
                        }
                        // Dp merge code 10-09 end
                    }
                    if (thk) {
                        writeKey('exact_door_thickness_frac', ['exact-door-thickness-frac', 'door_thickness', 'finished-door-thickness'], thk);
                        cfgInner.exact_door_thickness = thk;
                        cfgInner.exact_door_thickness_inches = thk + ' inches';
                        cfgInner.door_thickness = thk;
                    }
                    // Pre-Hung Unit Depth from visible selects (int + frac).
                    var phInt = '';
                    var phFrac = '';
                    if (rootEl && rootEl.querySelectorAll) {
                        rootEl.querySelectorAll('.door-measure-row--prehung-depth-exact:not(.door-hidden) select, .door-measure-dimension-row:not(.door-hidden) select').forEach(function (sel) {
                            if (!sel || (sel.closest && sel.closest('.door-hidden'))) return;
                            var sid = String(sel.id || '').toLowerCase();
                            var titleEl = sel.closest && sel.closest('.door-measure-dimension-row');
                            var title = '';
                            if (titleEl) {
                                var tNode = titleEl.querySelector('.door-measure-dimension-title');
                                title = tNode ? String(tNode.textContent || '').toLowerCase() : '';
                            }
                            if (title.indexOf('pre-hung') === -1 && title.indexOf('pre hung') === -1 && sid.indexOf('pre_hung') === -1 && sid.indexOf('pre-hung') === -1 && sid.indexOf('prehung') === -1) {
                                return;
                            }
                            var op = sel.options && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
                            var lab = op ? String(op.textContent || op.value || '').trim() : String(sel.value || '').trim();
                            if (!lab) return;
                            if (/frac|fraction/.test(sid) || (sel.classList && sel.classList.contains('door-dimension-frac-select'))) phFrac = lab;
                            else if (!phInt) phInt = lab;
                        });
                    }
                    if (!phInt && !phFrac) {
                        phInt = readAny(['jamb_pre_hung_int', 'panel_pre_hung_int', 'rough_pre_hung_int', 'exact_pre_hung_int', 'exact-pre-hung-int']);
                        phFrac = readAny(['jamb_pre_hung_frac', 'panel_pre_hung_frac', 'exact_pre_hung_frac', 'exact-pre-hung-frac']);
                    }
                    if (phInt || phFrac) {
                        if (phInt) writeKey('exact_pre_hung_int', ['exact-pre-hung-int'], phInt);
                        if (phFrac) writeKey('exact_pre_hung_frac', ['exact-pre-hung-frac', 'exact_pre_hung'], phFrac);
                        setCombined('pre_hung_unit_depth', ['exact_pre_hung_int', 'exact-pre-hung-int', 'jamb_pre_hung_int'], ['exact_pre_hung_frac', 'exact-pre-hung-frac', 'jamb_pre_hung_frac']);
                    }
                })(cfg, container);
                // Dp end 26-08
            })(config);
            // Dp end 26-08
        } catch (eMeasCfg) { }
        return config;
    }


    // Dp start 17-08 — storefront Stops/Astragals (56.25" allowance, qty 4 / panel count)
    function dpPorchInchLabel(inches) {
        if (isNaN(inches)) return '';
        var rounded = Math.round(inches * 16) / 16;
        if (rounded < 0) rounded = 0;
        var intPart = Math.floor(rounded + 1e-9);
        var fracPart = Math.round((rounded - intPart) * 1000) / 1000;
        var map = [
            { value: 0, label: '00' }, { value: 0.0625, label: '1/16' }, { value: 0.125, label: '1/8' },
            { value: 0.1875, label: '3/16' }, { value: 0.25, label: '1/4' }, { value: 0.3125, label: '5/16' },
            { value: 0.375, label: '3/8' }, { value: 0.4375, label: '7/16' }, { value: 0.5, label: '1/2' },
            { value: 0.5625, label: '9/16' }, { value: 0.625, label: '5/8' }, { value: 0.6875, label: '11/16' },
            { value: 0.75, label: '3/4' }, { value: 0.8125, label: '13/16' }, { value: 0.875, label: '7/8' },
            { value: 0.9375, label: '15/16' }
        ];
        var fracLabel = '';
        var bestDiff = 1;
        map.forEach(function (entry) {
            var diff = Math.abs(entry.value - fracPart);
            if (diff < bestDiff) { bestDiff = diff; fracLabel = entry.label; }
        });
        if (bestDiff > 1e-4) fracLabel = '';
        if (!fracLabel || fracLabel === '0' || fracLabel === '00') return String(intPart);
        return intPart + ' ' + fracLabel;
    }
    function dpPorchStopsAstragalsFromOpening(op) {
        var out = { stops: '', astragals: '' };
        if (!op) return out;
        var h = (parseFloat(op.height_int || op.heightInt) || 0) + (parseFloat(op.height_frac || op.heightFrac) || 0);
        if (!h) return out;
        var panels = Math.max(1, parseInt(op.panels || op.quantity, 10) || 1);
        var hLabel = dpPorchInchLabel(h);
        var tbLabel = dpPorchInchLabel(Math.max(0, h - 56.25));
        out.stops = '(4) ' + tbLabel + '" top and bottom; (4) ' + hLabel + '" left and right';
        out.astragals = '(' + panels + ') ' + hLabel + '"';
        return out;
    }
    // Dp end 17-08

    function getCurrentConfig() {
        var cfg = getCurrentConfigFromSchema() || {};
        try {
            var hwList = getHardwareSelectionsForConfig();
            if (window.DoorConf2Update && typeof window.DoorConf2Update.mergeLandingHardwareIntoSelections === 'function') {
                hwList = window.DoorConf2Update.mergeLandingHardwareIntoSelections(hwList);
            }
            // Dp start 27-08 — copy Hardware Swing Direction onto schema keys for admin restore
            if (window.DoorConf2Update && typeof window.DoorConf2Update.mergeLandingHardwareSchemaKeys === 'function') {
                cfg = window.DoorConf2Update.mergeLandingHardwareSchemaKeys(cfg, hwList);
            }
            // Dp end 27-08
            cfg._hardware_selections = hwList;
            cfg.hardware_options = hwList.length ? hwList : null;
        } catch (eHwCfg) { }
        try {
            var casingList = getCasingSelectionsForConfig();
            cfg._casing_selections = casingList;
            cfg.casing_options = casingList.length ? casingList : null;
        } catch (eCasingCfg) { }
        try {
            var listEl = document.querySelector('.door-panel-unit-size-list');
            if (listEl) {
                var panels = [];
                listEl.querySelectorAll('.door-panel-unit-size-entry').forEach(function (entry) {
                    var wInt = entry.querySelector('[data-panel-dimension="width-int"]');
                    var wFrac = entry.querySelector('[data-panel-dimension="width-frac"]');
                    var hInt = entry.querySelector('[data-panel-dimension="height-int"]');
                    var hFrac = entry.querySelector('[data-panel-dimension="height-frac"]');
                    var thick = entry.querySelector('[data-panel-dimension="thickness"]');
                    var qty = entry.querySelector('[data-panel-dimension="quantity"]');
                    panels.push({
                        width_int: wInt ? wInt.value : '',
                        width_frac: wFrac ? wFrac.value : '',
                        height_int: hInt ? hInt.value : '',
                        height_frac: hFrac ? hFrac.value : '',
                        thickness: thick ? thick.value : '',
                        quantity: qty ? qty.value : '1'
                    });
                });
                cfg.panel_unit_individual_measurements = panels;
                cfg._panel_unit_individual_measurements = panels;
            }
        } catch (ePanelsCfg) { }
        // Dp start 17-08
        try {
            if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.applyPanelUnitEnclosureOpeningsToConfig === 'function') {
                cfg = window.DoorConf2Measurements.applyPanelUnitEnclosureOpeningsToConfig(cfg) || cfg;
            }
        } catch (eEncCfg) { }
        // Dp end 17-08
        try { pruneInactiveScreenStormSelections(cfg); } catch (ePruneIns) { }
        try { pruneInactivePanelProfileSelection(cfg); } catch (ePrunePp) { }
        return cfg;
    }

    // Build line item properties for Shopify cart from current config + schema (labels as keys, choice labels as values)
    function getLineItemPropertiesFromSchema() {
        var config = getCurrentConfig();
        if (!doorConfigSchema || !Array.isArray(doorConfigSchema)) return {};
        var props = {};
        doorConfigSchema.forEach(function (opt) {
            var label = opt.label || opt.id;
            var optType = (opt.type || '').toLowerCase();
            if (optType === 'dimension') {
                var vCm = config[opt.id + '_cm'];
                var vIn = config[opt.id + '_in'];
                if (vCm != null && vCm !== '') props[label + ' (cm)'] = String(vCm);
                if (vIn != null && vIn !== '') props[label + ' (inches)'] = String(vIn);
                return;
            }
            var val = config[opt.id];
            if (val === null || val === undefined || val === '') return;
            if (normalizeOptionIdKey(opt.id) === 'screen_and_storm_inserts_additional_options') return;
            if (isInactiveScreenStormTypeOption(opt.id)) return;
            if (isInactivePanelProfileOption(opt.id)) return;
            // Dp start 27-08 — do not persist placeholder Select as Hardware Swing Direction
            var oidNormLip = normalizeOptionIdKey(opt.id);
            if ((oidNormLip === 'swing_direction' || oidNormLip === 'hardware_swing_direction')
                && /^(select|please select|not selected|none|n\/a)$/i.test(String(val).trim())) {
                return;
            }
            // Dp end 27-08
            if (optType === 'checkbox') {
                var arr = Array.isArray(val) ? val : [];
                if (arr.length === 0) return;
                var choices = opt.options || [];
                var labels = arr.map(function (v) {
                    var c = choices.find(function (o) { return String(o.value || '') === String(v); });
                    return c && (c.label || c.value) ? (c.label || c.value) : v;
                });
                props[label] = labels.join(', ');
            } else if ((optType === 'select' || optType === 'radio') && Array.isArray(opt.options)) {
                var ch = opt.options.find(function (o) { return String(o.value || '') === String(val); });
                props[label] = ch && (ch.label || ch.value) ? (ch.label || ch.value) : String(val);
            } else {
                props[label] = String(val);
            }
        });

        // Hardware products (multi-select with finish + qty); stored in config.hardware_options / _hardware_selections.
        try {
            var hwRows = config._hardware_selections || config.hardware_options;
            if (Array.isArray(hwRows) && hwRows.length) {
                hwRows.forEach(function (row, idx) {
                    if (!row || typeof row !== 'object') return;
                    var line = formatHardwareSelectionSummaryLine(row);
                    if (line) props[idx === 0 ? 'Hardware' : 'Hardware ' + (idx + 1)] = line;
                });
            }
        } catch (eHwProps) { }

        // Casing product (single select with length + qty); stored in config.casing_options / _casing_selections.
        try {
            var casingRows = config._casing_selections || config.casing_options;
            if (Array.isArray(casingRows) && casingRows.length) {
                casingRows.forEach(function (row, idx) {
                    if (!row || typeof row !== 'object') return;
                    var line = String(row.title || row.product_id || '');
                    if (row.length_label) line += ' — ' + row.length_label;
                    if (row.qty && row.qty > 1) line += ' (×' + row.qty + ')';
                    if (line) props[idx === 0 ? 'Casing' : 'Casing ' + (idx + 1)] = line;
                });
            }
        } catch (eCasingProps) { }

        // Extra UI-only options (not backed by schema metaobjects).
        try {
            if (config.transom_count) {
                var label = 'Single or Double Transom?';
                var v = String(config.transom_count || '');
                if (v === 'single_transom_across_both_doors') props[label] = 'Single transom across both doors';
                else if (v === 'two_transoms_one_over_each_door') props[label] = 'Two transoms, one over each door';
                else props[label] = v;
            }
        } catch (eExtraProps) { }
        try {
            if (config.door_location_exposure) {
                props['Where will the door be located?'] = String(config.door_location_exposure || '');
            }
        } catch (eExposureProps) { }
        try {
            if (config.panel_unit_design) {
                var panelUnitLabels = {
                    design_porch_enclosure_system: 'Design a Porch Enclosure System',
                    order_individual_panels: 'Order Individual Panels'
                };
                var panelUnitVal = String(config.panel_unit_design || '');
                props['Panel Unit Design'] = panelUnitLabels[panelUnitVal] || panelUnitVal;
            }
        } catch (ePanelUnitProps) { }
        // Dp start 17-08
        try {
            var encOpeningsProps = config.panel_unit_enclosure_openings || config._panel_unit_enclosure_openings || [];
            if (Array.isArray(encOpeningsProps) && encOpeningsProps.length && String(config.panel_unit_design || '').indexOf('enclosure') !== -1) {
                var thickMapProps = {
                    '1.125': '1 1/8', '1.25': '1 1/4', '1.375': '1 3/8',
                    '1.5': '1 1/2', '1.75': '1 3/4', '2.25': '2 1/4'
                };
                function panelUnitInchProps(intVal, fracVal) {
                    var n = (parseFloat(intVal) || 0) + (parseFloat(fracVal) || 0);
                    if (!n && String(intVal || '') === '') return '';
                    return String(n);
                }
                function panelUnitSillInchProps(intVal, fracVal) {
                    var intN = parseFloat(intVal);
                    var fracN = parseFloat(fracVal) || 0;
                    if ((intVal == null || String(intVal) === '') && !fracN) return '';
                    var intLabel = isNaN(intN) ? '5' : String(Math.round(intN));
                    if (!fracN) return intLabel;
                    var fracMap = { 0.125: '1/8', 0.25: '1/4', 0.375: '3/8', 0.5: '1/2', 0.625: '5/8', 0.75: '3/4', 0.875: '7/8' };
                    var fLabel = '';
                    Object.keys(fracMap).forEach(function (k) {
                        if (!fLabel && Math.abs(parseFloat(k) - fracN) < 0.0001) fLabel = fracMap[k];
                    });
                    return fLabel ? (intLabel + ' ' + fLabel) : String((isNaN(intN) ? 0 : intN) + fracN);
                }
                function panelUnitHumanizeProps(v) {
                    return String(v || '').replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
                }
                encOpeningsProps.forEach(function (op, idx) {
                    if (!op) return;
                    var prefix = encOpeningsProps.length > 1 ? ((idx === 0 ? 'Porch Opening #' : 'Panel Opening #') + (idx + 1) + ' ') : '';
                    var wTxt = panelUnitInchProps(op.width_int, op.width_frac);
                    var hTxt = panelUnitInchProps(op.height_int, op.height_frac);
                    if (wTxt) props[prefix + 'Finished Opening Width'] = wTxt + '"';
                    if (hTxt) props[prefix + 'Finished Opening Height'] = hTxt + '"';
                    var panelThickRawProps = op.thickness != null && String(op.thickness).trim() !== '' ? String(op.thickness).trim() : '1.125';
                    props[prefix + 'Panel Thickness'] = (thickMapProps[panelThickRawProps] || panelThickRawProps) + '"';
                    if (op.panels) props[prefix + 'Panels per opening'] = String(op.panels);
                    var trimOnProps = op.trim_system === 'true' || op.trim_system === true || op.trim_system === '1' || op.trim_system === 1;
                    props[prefix + 'Add Trim System'] = trimOnProps ? 'On' : 'Off';
                    if (trimOnProps) {
                        var sTxt = panelUnitSillInchProps(op.sill_depth || '5', op.sill_frac || '0');
                        if (sTxt) props[prefix + 'Sill Width'] = sTxt + '"';
                        // Dp start 17-08
                        var saProps = dpPorchStopsAstragalsFromOpening(op);
                        if (saProps.stops) props[prefix + 'Stops'] = saProps.stops;
                        if (saProps.astragals) props[prefix + 'Astragals'] = saProps.astragals;
                        // Dp end 17-08
                    }
                    (op.doors || []).forEach(function (door, doorIdx) {
                        if (!door) return;
                        var dnRaw = door.door_number || door.doorNumber || door.number || door.index;
                        var dn = parseInt(dnRaw, 10);
                        if (!dn || dn < 1) dn = doorIdx + 1;
                        if (door.swing_direction || door.swingDirection) {
                            props[prefix + 'Door #' + dn + ' Swing Direction'] = panelUnitHumanizeProps(door.swing_direction || door.swingDirection);
                        }
                        if (door.hinge_finish || door.hingeFinish) {
                            props[prefix + 'Door #' + dn + ' Hinge Finish'] = panelUnitHumanizeProps(door.hinge_finish || door.hingeFinish);
                        }
                        if (door.lockset_preparation || door.locksetPreparation) {
                            props[prefix + 'Door #' + dn + ' Lockset Preparation'] = panelUnitHumanizeProps(door.lockset_preparation || door.locksetPreparation);
                        }
                    });
                });
            }
        } catch (eEncProps) { }
        // Dp end 17-08
        try {
            var addlLabels = getSelectedInsertsAdditionalOptionLabels(config);
            if (addlLabels.length) props['Additional Options'] = addlLabels.join(', ');
        } catch (eAddlProps) { }
        // Dp start 27-08 — landing hardware dropdowns (Hardware Swing Direction, Finish, …)
        try {
            if (window.DoorConf2Update && typeof window.DoorConf2Update.buildLandingHardwareLineItemProperties === 'function') {
                var lhProps = window.DoorConf2Update.buildLandingHardwareLineItemProperties() || {};
                Object.keys(lhProps).forEach(function (k) {
                    if (!k || lhProps[k] == null) return;
                    var lv = String(lhProps[k]).trim();
                    if (!lv || /^(select|please select|not selected|none|n\/a)$/i.test(lv)) return;
                    props[k] = lv;
                });
            }
        } catch (eLhProps) { }
        // Dp end 27-08
        return props;
    }

    function renderDynamicOptions(schema, container) {
        doorConfigSchema = schema;
        try { window.__doorConfigSchema = schema; } catch (eSchemaExpose) { }
        if (!Array.isArray(schema) || !schema.length) return;

        // Dp start 10-08
        if (container) {
            container.innerHTML = '';
        }
        // Dp end 10-08

        var _fullExposureWoods = {
            african_mahogany: true,
            vertical_grain_douglas_fir: true,
            honduran_mahogany: true,
            spanish_cedar: true,
            wester_red_cedar: true,
            western_red_cedar: true
        };
        var _partialExposureWoods = {
            african_mahogany: true,
            vertical_grain_douglas_fir: true,
            honduran_mahogany: true,
            spanish_cedar: true,
            wester_red_cedar: true,
            western_red_cedar: true,
            black_walnut: true,
            quarter_sawn_white_oak: true,
            cherry: true,
            red_oak: true,
            maple: true,
            white_oak: true,
            ash: true,
            ash_storm_porch: true
        };
        var WOOD_EXPOSURE_ALLOWED_IDS = {
            full_exposure: _fullExposureWoods,
            partial_exposure: _partialExposureWoods,
            protected_location: null
        };

        function normalizeWoodChoiceKey(v) {
            return String(v == null ? '' : v)
                .toLowerCase()
                .replace(/&/g, ' and ')
                .replace(/[^a-z0-9]+/g, '_')
                .replace(/^_+|_+$/g, '');
        }

        // Dp start VDN-598 27-10
        // Wood choices follow the metaobject choices order (admin re-order shows on the storefront).
        // Only the configurator_defaults choice is moved to the top; without a default the first
        // metaobject choice is already first and stays the default.
        function dpWoodChoicesDefaultFirst(woodOpt, choices) {
            var list = Array.isArray(choices) ? choices.slice() : [];
            if (!woodOpt || list.length < 2) return list;
            var woodOptId = String(woodOpt.id || '');
            var woodOptIdNorm = woodOptId.toLowerCase().replace(/-/g, '_');
            var defVal = getDefaultSelectionForOption(woodOptId) || getDefaultSelectionForOption(woodOptIdNorm) || '';
            if (!defVal) return list;
            var defKey = normalizeChoiceKey(defVal);
            var defWoodKey = normalizeWoodChoiceKey(defVal);
            var defIdx = -1;
            for (var wi = 0; wi < list.length; wi++) {
                var wc = list[wi];
                if (!wc) continue;
                if (
                    normalizeChoiceKey(wc.value) === defKey
                    || normalizeChoiceKey(wc.label) === defKey
                    || (defWoodKey && (normalizeWoodChoiceKey(wc.value) === defWoodKey || normalizeWoodChoiceKey(wc.label) === defWoodKey))
                    || defaultSelectionValuesMatch(woodOptId, defVal, wc.value)
                ) {
                    defIdx = wi;
                    break;
                }
            }
            if (defIdx > 0) {
                list = [list[defIdx]].concat(list.slice(0, defIdx), list.slice(defIdx + 1));
            }
            return list;
        }
        // Dp end VDN-598 27-10

        function resolveWoodExposureKey(card, radio, optionEl) {
            var labelText = '';
            if (card && card.querySelector) {
                var lbl = card.querySelector('.common-check-option-label');
                if (lbl) labelText = String(lbl.textContent || '').trim();
            }
            if (!labelText && optionEl) {
                labelText = String(optionEl.textContent || '').trim();
            }
            var raw = (card && card.getAttribute('data-wood-key'))
                || (optionEl && optionEl.getAttribute('data-wood-key'))
                || (card && card.getAttribute('data-choice-value'))
                || (radio && radio.value)
                || (optionEl && optionEl.value)
                || labelText
                || '';
            var key = normalizeWoodChoiceKey(raw);
            if (key) return key;
            return normalizeWoodChoiceKey(labelText);
        }

        function isWoodCardVisibleForExposure(card) {
            if (!card) return false;
            if (card.style && card.style.display === 'none') return false;
            if (card.classList && card.classList.contains('door-hidden')) return false;
            if (card.getAttribute('data-wood-exposure-hidden') === '1') return false;
            if (card.getAttribute('data-product-tag-hidden') === '1') return false;
            return true;
        }

        function ensureVisibleWoodSelected(searchRoot) {
            if (!searchRoot || !searchRoot.querySelector) return;
            ['wood_type', 'wood_type_storm_porch'].forEach(function (woodOptId) {
                var checked = searchRoot.querySelector('input[type="radio"][data-option-id="' + woodOptId + '"]:checked');
                var needsReplacement = false;
                if (checked && !checked.disabled) {
                    var checkedCard = checked.closest ? checked.closest('.common-check-option') : null;
                    if (isWoodCardVisibleForExposure(checkedCard)) return;
                    needsReplacement = true;
                } else {
                    var selEarly = searchRoot.querySelector('select[data-option-id="' + woodOptId + '"]');
                    if (selEarly) {
                        var currentOptEarly = selEarly.options && selEarly.selectedIndex >= 0 ? selEarly.options[selEarly.selectedIndex] : null;
                        if (!currentOptEarly || !currentOptEarly.value) return;
                        if (!currentOptEarly.hidden && !currentOptEarly.disabled) return;
                        needsReplacement = true;
                    } else {
                        return;
                    }
                }
                if (!needsReplacement) return;
                var radios = all('input[type="radio"][data-option-id="' + woodOptId + '"]', searchRoot);
                var picked = null;
                for (var i = 0; i < radios.length; i++) {
                    var r = radios[i];
                    if (r.disabled) continue;
                    var card = r.closest ? r.closest('.common-check-option') : null;
                    if (!isWoodCardVisibleForExposure(card)) continue;
                    picked = r;
                    break;
                }
                if (picked) {
                    radios.forEach(function (ri) {
                        ri.checked = false;
                        var c = ri.closest ? ri.closest('.common-check-option') : null;
                        if (c) c.classList.remove('common-check-option--selected');
                    });
                    picked.checked = true;
                    var pickedCard = picked.closest ? picked.closest('.common-check-option') : null;
                    if (pickedCard) pickedCard.classList.add('common-check-option--selected');
                    try { picked.dispatchEvent(new Event('change', { bubbles: true })); } catch (eAutoWood) { }
                    return;
                }
                var sel = searchRoot.querySelector('select[data-option-id="' + woodOptId + '"]');
                if (!sel) return;
                var currentOpt = sel.options && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
                if (currentOpt && currentOpt.value && !currentOpt.hidden && !currentOpt.disabled) return;
                var firstVisible = Array.prototype.find.call(sel.options || [], function (o) {
                    return o && o.value && !o.hidden && !o.disabled;
                });
                if (firstVisible) {
                    sel.value = firstVisible.value;
                    try { sel.dispatchEvent(new Event('change', { bubbles: true })); } catch (eAutoSel) { }
                } else if (sel.value) {
                    sel.value = '';
                    try { sel.dispatchEvent(new Event('change', { bubbles: true })); } catch (eClearSel) { }
                }
            });
        }

        function applyWoodExposureFilter(targetContainer) {
            if (!targetContainer) return;
            var exposureInput = targetContainer.querySelector('input[type="radio"][data-option-id="door_location_exposure"]:checked');
            if (!exposureInput) exposureInput = document.querySelector('input[type="radio"][data-option-id="door_location_exposure"]:checked');
            var exposureValue = normalizeWoodChoiceKey(exposureInput ? exposureInput.value : '');
            var allowedMap = WOOD_EXPOSURE_ALLOWED_IDS[exposureValue] || null;
            var hasAllowedMap = !!allowedMap;
            var searchRoot = targetContainer || document;
            var woodSelects = all('select[data-option-id]', searchRoot).filter(function (sel) {
                if (!sel || !sel.getAttribute) return false;
                if (sel.getAttribute('data-select-wood') === '1') return true;
                var sid = String(sel.getAttribute('data-option-id') || '').toLowerCase().replace(/-/g, '_');
                return sid.indexOf('wood') !== -1 && sid !== 'door_location_exposure';
            });
            woodSelects.forEach(function (sel) {
                var selectedOption = sel.options && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
                var selectedAllowed = true;
                all('option', sel).forEach(function (op) {
                    var key = resolveWoodExposureKey(null, null, op);
                    var isPlaceholder = op.value == null || String(op.value) === '';
                    var tagHiddenOp = op.getAttribute && op.getAttribute('data-product-tag-hidden') === '1';
                    var show = !tagHiddenOp && (!hasAllowedMap || isPlaceholder || !!allowedMap[key]);
                    op.hidden = !show;
                    op.disabled = !show;
                    if (selectedOption === op && !show) selectedAllowed = false;
                });
                if (!selectedAllowed) {
                    var firstVisible = Array.prototype.find.call(sel.options || [], function (o) {
                        return o && o.value && !o.hidden && !o.disabled;
                    });
                    sel.value = firstVisible ? firstVisible.value : '';
                    try { sel.dispatchEvent(new Event('change', { bubbles: true })); } catch (eWoodSelect) { }
                }
            });

            var woodCards = all('.common-check-option', searchRoot).filter(function (card) {
                if (!card || !card.querySelector) return false;
                if (card.classList && card.classList.contains('door-wood-exposure-card')) return false;
                if (card.classList && card.classList.contains('select-wood-option')) return true;
                if (card.getAttribute && card.getAttribute('data-select-wood-option') === '1') return true;
                var inp = card.querySelector('input[type="radio"][data-option-id]');
                if (!inp || !inp.getAttribute) return false;
                var rid = String(inp.getAttribute('data-option-id') || '').toLowerCase().replace(/-/g, '_');
                return rid.indexOf('wood') !== -1 && rid !== 'door_location_exposure';
            });
            woodCards.forEach(function (card) {
                var radio = card.querySelector('input[type="radio"][data-option-id]');
                if (!radio) return;
                var cardKey = resolveWoodExposureKey(card, radio, null);
                var tagHidden = card.getAttribute && card.getAttribute('data-product-tag-hidden') === '1';
                var showCard = !tagHidden && (!hasAllowedMap || !!allowedMap[cardKey]);
                card.style.display = showCard ? '' : 'none';
                if (!showCard) card.setAttribute('data-wood-exposure-hidden', '1');
                else card.removeAttribute('data-wood-exposure-hidden');
                radio.disabled = !showCard;
                if (!showCard && radio.checked) {
                    radio.checked = false;
                    card.classList.remove('common-check-option--selected');
                }
            });
            ensureVisibleWoodSelected(searchRoot);
        }

        function computeInchesFractionOptions(unitInDef) {
            // Supports common fractional steps based on configured step.
            // If step is 0.25 => 0, 1/4, 1/2, 3/4
            // If step is 0.5  => 0, 1/2
            // If step is 1    => 0
            var step = unitInDef && unitInDef.step != null ? parseFloat(unitInDef.step) : 0.25;
            if (isNaN(step) || step <= 0) step = 0.25;

            if (step <= 0.26) {
                return [
                    { value: '0', label: '0' },
                    { value: '0.25', label: '1/4' },
                    { value: '0.5', label: '1/2' },
                    { value: '0.75', label: '3/4' }
                ];
            }
            if (step <= 0.51) {
                return [
                    { value: '0', label: '0' },
                    { value: '0.5', label: '1/2' }
                ];
            }
            return [{ value: '0', label: '0' }];
        }

        function formatInchesValue(inInt, fracVal) {
            var v = parseFloat(inInt) + parseFloat(fracVal);
            if (isNaN(v)) return '';
            // Avoid float artifacts (e.g. 1.4999999)
            v = Math.round(v * 100) / 100;
            var s = v.toFixed(2);
            s = s.replace(/\.00$/, '').replace(/(\.\d*?[1-9])0+$/, '$1');
            return s;
        }

        function setSplitInchesUI(optionsContainer, opt, vIn) {
            if (!optionsContainer || !opt || opt.type !== 'dimension') return;
            var unitIn = opt.unit_in || opt.range_in || {};
            var fracOptions = computeInchesFractionOptions(unitIn);

            var intSel = optionsContainer.querySelector('select[data-option-id="' + opt.id + '"][data-unit="in-int"]');
            var fracSel = optionsContainer.querySelector('select[data-option-id="' + opt.id + '"][data-unit="in-frac"]');
            var hiddenIn = optionsContainer.querySelector('input[data-option-id="' + opt.id + '"][data-unit="in"]');
            if (!intSel || !fracSel || !hiddenIn) return;

            if (vIn == null || vIn === '') {
                hiddenIn.value = '';
                intSel.value = '';
                fracSel.value = '';
                return;
            }

            var num = parseFloat(vIn);
            if (isNaN(num)) return;
            var intPart = Math.floor(num + 1e-9);
            var fracPart = Math.round((num - intPart) * 100) / 100;

            if (intPart < 1 || intPart > 50) {
                hiddenIn.value = '';
                intSel.value = '';
                fracSel.value = '';
                return;
            }

            // Match fraction to nearest allowed option.
            var fracStr = '';
            var found = fracOptions.find(function (f) {
                return Math.abs(parseFloat(f.value) - fracPart) < 1e-6;
            });
            if (found) fracStr = found.value;

            if (!fracStr) {
                hiddenIn.value = '';
                intSel.value = '';
                fracSel.value = '';
                return;
            }

            intSel.value = String(intPart);
            fracSel.value = fracStr;
            hiddenIn.value = formatInchesValue(intPart, fracStr);
        }

        function measurementMethodRadio(opt) {
            if (!opt || String(opt.type || '').toLowerCase() !== 'radio') return false;
            if (!Array.isArray(opt.options) || opt.options.length !== 2) return false;
            var labels = opt.options.map(function (x) {
                return String(x && (x.label || x.value) || '').toLowerCase();
            });
            return labels.some(function (t) { return t.indexOf('exact') !== -1; }) &&
                labels.some(function (t) { return t.indexOf('finished') !== -1 || t.indexOf('opening') !== -1; });
        }

        function isMeasurementVisualDimension(opt) {
            if (!opt || String(opt.type || '').toLowerCase() !== 'dimension') return false;
            var unitIn = opt.unit_in || opt.range_in || {};
            var hasInches = unitIn && (unitIn.min != null || unitIn.max != null || unitIn.step != null ||
                (Array.isArray(unitIn.options) && unitIn.options.length > 0));
            if (!hasInches) return false;
            var id = String(opt.id || '').toLowerCase().replace(/-/g, '_');
            var lab = String(opt.label || '').toLowerCase();
            if (opt.showWhen && typeof opt.showWhen === 'object') {
                var swKey = Object.keys(opt.showWhen)[0];
                if (swKey && String(swKey).toLowerCase().replace(/-/g, '_').indexOf('measurement') !== -1) return true;
            }
            if (id === 'measurement_type') return false;
            if (id.indexOf('exact') !== -1 || id.indexOf('finished') !== -1 || id.indexOf('opening') !== -1) return true;
            if (lab.indexOf('exact') !== -1 || lab.indexOf('finished') !== -1 || lab.indexOf('opening') !== -1) return true;
            if ((lab.indexOf('width') !== -1 || lab.indexOf('height') !== -1 || lab.indexOf('thick') !== -1) &&
                (lab.indexOf('door') !== -1 || lab.indexOf('opening') !== -1 || lab.indexOf('jamb') !== -1)) return true;
            return false;
        }

        function measureDimensionFigureKind(opt) {
            var lab = String(opt.label || '').toLowerCase();
            if (lab.indexOf('thick') !== -1) return 'thickness';
            if (lab.indexOf('height') !== -1) return 'height';
            if (lab.indexOf('width') !== -1) return 'width';
            return 'width';
        }

        function getMeasureDimensionSvg(kind) {
            var k = String(kind || 'width');
            if (k === 'thickness') {
                return '<svg class="door-measure-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 140" aria-hidden="true">' +
                    '<rect x="72" y="28" width="10" height="88" fill="none" stroke="#374151" stroke-width="2" rx="1"/>' +
                    '<path d="M52 26 H92" stroke="#374151" stroke-width="1.6" fill="none"/>' +
                    '<path d="M52 23 v6 M92 23 v6" stroke="#374151" stroke-width="1.2"/>' +
                    '<polygon points="52,26 58,21 58,31" fill="#374151"/>' +
                    '<polygon points="92,26 86,21 86,31" fill="#374151"/>' +
                    '</svg>';
            }
            if (k === 'height') {
                return '<svg class="door-measure-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 140" aria-hidden="true">' +
                    '<rect x="44" y="28" width="42" height="92" fill="none" stroke="#374151" stroke-width="2" rx="1"/>' +
                    '<path d="M28 22 V118" stroke="#374151" stroke-width="1.6" fill="none"/>' +
                    '<path d="M25 22 h6 M25 118 h6" stroke="#374151" stroke-width="1.2"/>' +
                    '<polygon points="28,22 23,28 33,28" fill="#374151"/>' +
                    '<polygon points="28,118 23,112 33,112" fill="#374151"/>' +
                    '</svg>';
            }
            return '<svg class="door-measure-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 140" aria-hidden="true">' +
                '<rect x="38" y="32" width="44" height="88" fill="none" stroke="#374151" stroke-width="2" rx="1"/>' +
                '<path d="M28 24 H92" stroke="#374151" stroke-width="1.6" fill="none"/>' +
                '<path d="M28 21 v6 M92 21 v6" stroke="#374151" stroke-width="1.2"/>' +
                '<polygon points="28,24 34,19 34,29" fill="#374151"/>' +
                '<polygon points="92,24 86,19 86,29" fill="#374151"/>' +
                '</svg>';
        }

        function defaultMeasureDimensionHint(opt) {
            var lab = String(opt.label || '').toLowerCase();
            var opening = lab.indexOf('opening') !== -1 || lab.indexOf('finished') !== -1;
            var isPetGate = isPetGatesCollectionActive();
            if (opening && lab.indexOf('width') !== -1) {
                return 'Enter the widest measurement for the inside left jamb to inside right jamb.';
            }
            if (opening && lab.indexOf('height') !== -1) {
                return 'Enter the longest measurement for the inside top jamb to floor or sill.';
            }
            if (opening && lab.indexOf('thick') !== -1) {
                return isPetGate
                    ? 'Enter the measurement for the thickness of your gate.'
                    : 'Enter the measurement for the thickness of your door.';
            }
            if (lab.indexOf('width') !== -1) {
                return isPetGate
                    ? 'Enter the largest measurement for the width of your gate.'
                    : 'Enter the largest measurement for the width of your door.';
            }
            if (lab.indexOf('height') !== -1) {
                return isPetGate
                    ? 'Enter the tallest measurement for the height of your gate.'
                    : 'Enter the tallest measurement for the height of your door.';
            }
            if (lab.indexOf('thick') !== -1) {
                return isPetGate
                    ? 'Enter the measurement for the thickness of your gate.'
                    : 'Enter the measurement for the thickness of your door.';
            }
            return 'Select whole inches and fraction.';
        }

        function syncMeasurementTabVisibility(method, measureOptionId) {
            doorConf2MeasurementsCall('syncMeasurementTabVisibilityCore', method, measureOptionId, container, doorConfigSchema);
        }

        function appendMeasurementTypeHeader(sectionEl, opt) {
            sectionEl.classList.add('door-measurement-type-section');

            var eyebrowEl = document.createElement('p');
            eyebrowEl.className = 'door-measurement-type-eyebrow';
            eyebrowEl.textContent = '';
            sectionEl.appendChild(eyebrowEl);

            var topBar = document.createElement('div');
            topBar.className = 'door-section-title door-option-title mb-16';

            var heading = document.createElement('span');
            heading.className = 'door-measurement-type-heading';
            heading.textContent = 'Measurements';
            heading.setAttribute('data-option-id', String(opt && opt.id ? opt.id : 'measurement_type'));

            // Dp start 23-07
            var labelText = 'How To Measure For Your Door';
            var ariaLabelText = 'How to measure for your door';
            try {
                var colHandle = '';
                try { colHandle = getCollectionHandleFromUrl(); } catch (eCol) { }
                if (!colHandle) {
                    var mainCfg = document.getElementById('door-configurator');
                    if (mainCfg) {
                        colHandle = normProductTagSlug(mainCfg.getAttribute('data-route-collection') || '');
                    }
                }
                var isSidelightCol = false;
                var isTransomCol = false;
                var isEntranceUnit = false;
                if (colHandle) {
                    if (colHandle.indexOf('entrance-unit') !== -1 || colHandle.indexOf('entrance-units') !== -1) isEntranceUnit = true;
                    else if (colHandle.indexOf('sidelight') !== -1) isSidelightCol = true;
                    else if (colHandle.indexOf('transom') !== -1) isTransomCol = true;
                }
                if (!isEntranceUnit && !isSidelightCol && !isTransomCol) {
                    var mainCfg = document.getElementById('door-configurator');
                    if (mainCfg) {
                        var tagsAttr = (mainCfg.getAttribute('data-product-tags') || '').toLowerCase();
                        if (tagsAttr.indexOf('entrance-unit') !== -1 || tagsAttr.indexOf('entrance-units') !== -1) isEntranceUnit = true;
                        else if (tagsAttr.indexOf('sidelight') !== -1) isSidelightCol = true;
                        else if (tagsAttr.indexOf('transom') !== -1) isTransomCol = true;
                        if (!isEntranceUnit && !isSidelightCol && !isTransomCol) {
                            var prodName = (mainCfg.getAttribute('data-product-name') || '').toLowerCase();
                            if (prodName.indexOf('entrance-unit') !== -1 || prodName.indexOf('entrance-units') !== -1) isEntranceUnit = true;
                            else if (prodName.indexOf('sidelight') !== -1) isSidelightCol = true;
                            else if (prodName.indexOf('transom') !== -1) isTransomCol = true;
                        }
                    }
                }
                if (isEntranceUnit) {
                    isSidelightCol = false;
                    isTransomCol = false;
                }
                if (isSidelightCol) {
                    labelText = 'How To Measure For Sidelight';
                    ariaLabelText = 'How to measure for sidelight';
                } else if (isTransomCol) {
                    labelText = 'How To Measure For Transom';
                    ariaLabelText = 'How to measure for transom';
                }
            } catch (eCheck) { }

            var helpBtn = document.createElement('button');
            helpBtn.type = 'button';
            helpBtn.className = 'door-measurement-help-btn common-btn btn-secondary btn-small door-setup-tooltip-btn';
            helpBtn.setAttribute('aria-label', ariaLabelText);
            helpBtn.innerHTML =
                labelText + ' ' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.03206 4.92901C7.79606 4.92901 7.60406 4.85301 7.45606 4.70101C7.30806 4.54501 7.23406 4.35301 7.23406 4.12501C7.23406 3.90101 7.30806 3.71301 7.45606 3.56101C7.60406 3.40901 7.79606 3.33301 8.03206 3.33301C8.27206 3.33301 8.46606 3.40901 8.61406 3.56101C8.76206 3.71301 8.83606 3.90101 8.83606 4.12501C8.83606 4.35301 8.76206 4.54501 8.61406 4.70101C8.46606 4.85301 8.27206 4.92901 8.03206 4.92901ZM8.68606 6.59101L8.64406 7.64701V11.337L9.51406 11.631V11.859H6.66406V11.631L7.52206 11.337V7.78501C7.47406 7.72501 7.40406 7.66501 7.31206 7.60501C7.22406 7.54501 7.12406 7.48701 7.01206 7.43101C6.90006 7.37501 6.78606 7.32701 6.67006 7.28701V7.08301L8.53006 6.59101H8.68606Z" fill="currentColor"></path><circle cx="8" cy="8" r="7.5" stroke="currentColor"></circle></svg>';
            /*
            var helpBtn = document.createElement('button');
            helpBtn.type = 'button';
            helpBtn.className = 'door-measurement-help-btn common-btn btn-secondary btn-small door-setup-tooltip-btn';
            helpBtn.setAttribute('aria-label', 'How to measure for your door');
            helpBtn.innerHTML =
                'How To Measure For Your Door ' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.03206 4.92901C7.79606 4.92901 7.60406 4.85301 7.45606 4.70101C7.30806 4.54501 7.23406 4.35301 7.23406 4.12501C7.23406 3.90101 7.30806 3.71301 7.45606 3.56101C7.60406 3.40901 7.79606 3.33301 8.03206 3.33301C8.27206 3.33301 8.46606 3.40901 8.61406 3.56101C8.76206 3.71301 8.83606 3.90101 8.83606 4.12501C8.83606 4.35301 8.76206 4.54501 8.61406 4.70101C8.46606 4.85301 8.27206 4.92901 8.03206 4.92901ZM8.68606 6.59101L8.64406 7.64701V11.337L9.51406 11.631V11.859H6.66406V11.631L7.52206 11.337V7.78501C7.47406 7.72501 7.40406 7.66501 7.31206 7.60501C7.22406 7.54501 7.12406 7.48701 7.01206 7.43101C6.90006 7.37501 6.78606 7.32701 6.67006 7.28701V7.08301L8.53006 6.59101H8.68606Z" fill="currentColor"></path><circle cx="8" cy="8" r="7.5" stroke="currentColor"></circle></svg>';
            */
            // Dp end 23-07

            helpBtn.addEventListener('click', function (e) {
                e.preventDefault();
                var evt;
                try {
                    evt = new CustomEvent('door-measurement-help', { bubbles: true });
                } catch (err) {
                    evt = document.createEvent('Event');
                    evt.initEvent('door-measurement-help', true, true);
                }
                var rootCfg = document.getElementById('door-configurator');
                (rootCfg || sectionEl).dispatchEvent(evt);
            });

            topBar.appendChild(heading);
            topBar.appendChild(helpBtn);
            sectionEl.appendChild(topBar);

            var promptWrap = document.createElement('div');
            promptWrap.className = 'door-measurement-type-prompt';

            var qText = 'How will you measure?';
            var subText = 'The method you use matters to get the right fit.';

            var qEl = document.createElement('p');
            qEl.className = 'door-measurement-type-question fw-700 mb-8';
            var strong = document.createElement('span');
            strong.textContent = qText;
            qEl.appendChild(strong);

            var subEl = document.createElement('p');
            subEl.className = 'door-measurement-type-sub mb-24';
            subEl.textContent = subText;

            promptWrap.appendChild(qEl);
            promptWrap.appendChild(subEl);
            sectionEl.appendChild(promptWrap);
        }

        // Option accordions: render `headerId` as a collapsible section whose contents are choices from `contentId`.
        var accordionPairs = [
            { headerId: 'sidelight_design', contentId: 'sidelight_location' },
            { headerId: 'sidelight_design', contentId: 'sidelight_style' },
            // Transom aliases to support different key naming in metaobjects
            { headerId: 'transom_design', contentId: 'transom_style' },
            { headerId: 'transom_designs', contentId: 'transom_style' },
            { headerId: 'transome_design', contentId: 'transom_style' },
            { headerId: 'transome_designs', contentId: 'transom_style' }
        ];
        function findOpt(id) {
            return schema.find(function (x) { return x && String(x.id || '') === String(id); });
        }
        function hasOpt(id) { return !!findOpt(id); }
        function findAccordionForHeader(id) {
            return accordionPairs.find(function (p) { return p.headerId === String(id); }) || null;
        }
        function findAccordionForContent(id) {
            return accordionPairs.find(function (p) { return p.contentId === String(id); }) || null;
        }

        // Resolve one active header per content id (first matching pair wins).
        var activeAccordionByContent = {};
        accordionPairs.forEach(function (p) {
            if (activeAccordionByContent[p.contentId]) return;
            if (hasOpt(p.headerId) && hasOpt(p.contentId)) {
                activeAccordionByContent[p.contentId] = p;
            }
        });

        var hasMeasurementTypeBlock = schema.some(function (o) { return o && isMeasurementTypeOptionId(o.id); });
        var embeddedDimensionIds = {};
        var embeddedDimensionsOrdered = [];
        if (hasMeasurementTypeBlock) {
            schema.forEach(function (o) {
                if (!o || isMeasurementTypeOptionId(o.id)) return;
                if (String(o.type || '').toLowerCase() !== 'dimension' || !isMeasurementVisualDimension(o)) return;
                var uid = o.unit_in || o.range_in || {};
                var willSplit = uid && (uid.min != null || uid.max != null || uid.step != null || Array.isArray(uid.options) || uid.options);
                if (!willSplit) return;
                embeddedDimensionIds[String(o.id)] = true;
                embeddedDimensionsOrdered.push(o);
            });
        }

        function appendDimensionControlsTo(parentEl, opt, embedAsRow) {
            var unitInEarly = opt.unit_in || opt.range_in || {};
            var willHaveInchSplitEarly = unitInEarly && (unitInEarly.min != null || unitInEarly.max != null ||
                unitInEarly.step != null || Array.isArray(unitInEarly.options) || unitInEarly.options);
            var useMeasureVisual = isMeasurementVisualDimension(opt) && willHaveInchSplitEarly;

            var dimRow = document.createElement('div');
            dimRow.className = useMeasureVisual ? 'door-measure-dimension-row' : 'door-row door-dimension-row';
            if (embedAsRow) {
                dimRow.setAttribute('data-embed-dimension-id', String(opt.id));
            }
            if (useMeasureVisual && !embedAsRow) {
                parentEl.classList.add('door-measure-dimension-section');
            }

            if (!useMeasureVisual) {
                var dimLabel = document.createElement('label');
                dimLabel.className = 'door-row-label';
                dimLabel.textContent = opt.label;
                dimRow.appendChild(dimLabel);
            }

            var dimInputs = document.createElement('div');
            dimInputs.className = useMeasureVisual ? 'door-measure-dimension-inputs' : 'door-row-inputs';
            var getDimOptions = function (unitDef) {
                if (!unitDef) return [];
                if (Array.isArray(unitDef.options)) return unitDef.options;
                if (unitDef.min != null && unitDef.max != null) {
                    return buildOptionsFromRange(unitDef.min, unitDef.max, unitDef.step != null ? unitDef.step : 1);
                }
                return [];
            };
            var unitCm = opt.unit_cm || opt.range_cm || {};
            var unitIn = opt.unit_in || opt.range_in || {};
            var cmOpts = getDimOptions(unitCm);
            function addDimSelect(unit, unitLabel, options) {
                var sel = document.createElement('select');
                sel.setAttribute('data-option-id', opt.id);
                sel.setAttribute('data-unit', unit);
                sel.className = 'door-input-select door-dimension-select' + (useMeasureVisual ? ' door-measure-dimension-dd' : '');
                sel.id = 'door-opt-' + opt.id + '-' + unit;
                sel.name = 'attributes[' + (opt.label || opt.id) + ' ' + unitLabel + ']';
                var ph = document.createElement('option');
                ph.value = '';
                ph.textContent = 'Select';
                ph.id = buildOptionDomId(sel.id, 'placeholder', 0);
                sel.appendChild(ph);
                options.forEach(function (o) {
                    var op = document.createElement('option');
                    op.value = o.value != null && o.value !== '' ? String(o.value) : '';
                    op.textContent = o.label != null ? o.label : String(o.value || '');
                    op.id = buildOptionDomId(sel.id, op.value || op.textContent, sel.options.length);
                    sel.appendChild(op);
                });
                sel.addEventListener('change', updateEstimatedPrice);
                dimInputs.appendChild(sel);
                var u = document.createElement('span');
                u.className = 'door-unit-label';
                u.textContent = unitLabel;
                dimInputs.appendChild(u);
            }
            if (cmOpts.length) addDimSelect('cm', 'cm', cmOpts);

            if (unitIn && (unitIn.min != null || unitIn.max != null || unitIn.step != null || Array.isArray(unitIn.options) || unitIn.options)) {
                var fracOptions = computeInchesFractionOptions(unitIn);

                var intSel = document.createElement('select');
                intSel.setAttribute('data-option-id', opt.id);
                intSel.setAttribute('data-unit', 'in-int');
                intSel.className = 'door-input-select door-dimension-int-select' + (useMeasureVisual ? ' door-measure-dimension-dd' : '');
                intSel.id = 'door-opt-' + opt.id + '-in-int';
                intSel.name = '';
                var phInt = document.createElement('option');
                phInt.value = '';
                phInt.textContent = 'Select';
                phInt.id = buildOptionDomId(intSel.id, 'placeholder', 0);
                intSel.appendChild(phInt);
                for (var ii = 1; ii <= 50; ii++) {
                    var opInt = document.createElement('option');
                    opInt.value = String(ii);
                    opInt.textContent = String(ii);
                    opInt.id = buildOptionDomId(intSel.id, opInt.value, ii);
                    intSel.appendChild(opInt);
                }

                var fracSel = document.createElement('select');
                fracSel.setAttribute('data-option-id', opt.id);
                fracSel.setAttribute('data-unit', 'in-frac');
                fracSel.className = 'door-input-select door-dimension-frac-select' + (useMeasureVisual ? ' door-measure-dimension-dd' : '');
                fracSel.id = 'door-opt-' + opt.id + '-in-frac';
                fracSel.name = '';
                var phFrac = document.createElement('option');
                phFrac.value = '';
                phFrac.textContent = 'Select';
                phFrac.id = buildOptionDomId(fracSel.id, 'placeholder', 0);
                fracSel.appendChild(phFrac);
                fracOptions.forEach(function (f) {
                    var opF = document.createElement('option');
                    opF.value = f.value;
                    opF.textContent = f.label;
                    opF.id = buildOptionDomId(fracSel.id, opF.value || opF.textContent, fracSel.options.length);
                    fracSel.appendChild(opF);
                });

                var hiddenIn = document.createElement('input');
                hiddenIn.type = 'hidden';
                hiddenIn.setAttribute('data-option-id', opt.id);
                hiddenIn.setAttribute('data-unit', 'in');
                hiddenIn.id = 'door-opt-' + opt.id + '-in';
                hiddenIn.value = '';

                function syncHidden() {
                    var iVal = intSel.value;
                    var fVal = fracSel.value;
                    if (iVal === '' || fVal === '') {
                        hiddenIn.value = '';
                    } else {
                        hiddenIn.value = formatInchesValue(iVal, fVal);
                    }
                    updateEstimatedPrice();
                }

                intSel.addEventListener('change', syncHidden);
                fracSel.addEventListener('change', syncHidden);

                dimInputs.appendChild(intSel);
                dimInputs.appendChild(fracSel);
                dimInputs.appendChild(hiddenIn);

                var u = document.createElement('span');
                u.className = 'door-unit-label';
                u.textContent = 'inches';
                dimInputs.appendChild(u);
            }

            if (useMeasureVisual && dimInputs.querySelector('select[data-unit="in-int"]')) {
                var fig = document.createElement('div');
                fig.className = 'door-measure-dimension-figure';
                fig.innerHTML = getMeasureDimensionSvg(measureDimensionFigureKind(opt));

                var body = document.createElement('div');
                body.className = 'door-measure-dimension-body';
                var titleEl = document.createElement('h4');
                titleEl.className = 'door-measure-dimension-title';
                titleEl.textContent = (function () {
                    var label = opt.label || opt.id || '';
                    if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.petGatesExactMeasureTitleCopy === 'function') {
                        label = window.DoorConf2Measurements.petGatesExactMeasureTitleCopy(label);
                    }
                    return mapCollectionMeasureTitle(label);
                })();
                titleEl.setAttribute('data-option-id', String(opt.id || ''));

                var hintEl = document.createElement('p');
                hintEl.className = 'door-measure-dimension-hint';
                var hintRaw = '';
                if (opt.description) {
                    hintRaw = typeof opt.description === 'string' ? opt.description : (opt.description && (opt.description.value || opt.description.text)) || '';
                }
                hintRaw = String(hintRaw || '').trim();
                if (!hintRaw) hintRaw = defaultMeasureDimensionHint(opt);
                if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.petGatesExactMeasureHintCopy === 'function') {
                    hintRaw = window.DoorConf2Measurements.petGatesExactMeasureHintCopy(hintRaw);
                }
                hintEl.textContent = mapCollectionDoorWording(hintRaw);

                var inputRow = document.createElement('div');
                inputRow.className = 'door-measure-dimension-inputs-row';
                while (dimInputs.firstChild) {
                    inputRow.appendChild(dimInputs.firstChild);
                }
                body.appendChild(titleEl);
                body.appendChild(hintEl);
                body.appendChild(inputRow);
                dimRow.appendChild(fig);
                dimRow.appendChild(body);
            } else {
                dimRow.appendChild(dimInputs);
            }

            parentEl.appendChild(dimRow);
        }

        var schemaOrdered = schemaForDoorRenderOrder(schema);
        var doorUnitDesignGroup = null;
        var deferredDoorSetupWrap = null;
        var doorUnitGroupMemberIds = ['door_unit_design', 'sidelight_design', 'transom_design'];
        var lastDoorUnitGroupId = null;
        for (var dgi = doorUnitGroupMemberIds.length - 1; dgi >= 0; dgi--) {
            var dgmId = doorUnitGroupMemberIds[dgi];
            if (schemaOrdered.some(function (o) { return o && String(o.id || '') === dgmId; })) {
                lastDoorUnitGroupId = dgmId;
                break;
            }
        }
        function appendDeferredDoorSetupToUnitGroup() {
            if (!deferredDoorSetupWrap || !doorUnitDesignGroup) return;
            doorUnitDesignGroup.appendChild(deferredDoorSetupWrap);
            deferredDoorSetupWrap = null;
        }
        schemaOrdered.forEach(function (opt) {
            var optId = String(opt.id || '');
            var optIdNorm = normalizeOptionIdKey(optId);
            if (hasMeasurementTypeBlock && embeddedDimensionIds[optId]) {
                return;
            }
            // glass_bevel is rendered as a switch directly under the glass_type cards.
            if (optIdNorm === 'glass_bevel') {
                return;
            }
            // Rendered inside the Screen & Storm Inserts "Additional Options" accordion.
            if (optIdNorm === 'screen_and_storm_inserts_additional_options') {
                return;
            }
            // door_location is rendered inside the wood_type section as exposure cards.
            if (optIdNorm === 'door_location') {
                return;
            }
            // pre_hung section is hidden.
            if (optIdNorm === 'pre_hung') {
                return;
            }
            // swing_direction: skip if no options.
            if (optIdNorm === 'swing_direction' && (!opt.options || !opt.options.length)) {
                return;
            }
            // applied_molding: skip if no options.
            if (optIdNorm === 'applied_molding' && (!opt.options || !opt.options.length)) {
                return;
            }
            // Dp start 10-08
            var isDoorUnitGroupOpt = (optId === 'door_unit_design' || optId === 'sidelight_design' || optId === 'transom_design');
            if (isDoorUnitGroupOpt) {
                if (!doorUnitDesignGroup && container) {
                    doorUnitDesignGroup = container.querySelector('.door-unit-design-group');
                }
                if (!doorUnitDesignGroup && container) {
                    if (!container.querySelector('.door-product-name')) {
                        try {
                            var rootCfgEl = document.getElementById('door-configurator');
                            var pn = rootCfgEl ? (rootCfgEl.getAttribute('data-product-name') || '') : '';
                            pn = String(pn || '').trim();
                            if (pn) {
                                var nameEl = document.createElement('div');
                                nameEl.className = 'door-section door-product-name';
                                var p = document.createElement('h2');
                                p.className = ' mb-24 p-xl';
                                var s = document.createElement('span');
                                s.textContent = pn;
                                p.appendChild(s);
                                nameEl.appendChild(p);
                                container.appendChild(nameEl);
                            }
                        } catch (eProdName) { }
                    }
                    doorUnitDesignGroup = document.createElement('div');
                    doorUnitDesignGroup.className = 'door-section door-unit-design-group';
                    container.appendChild(doorUnitDesignGroup);
                }
            }
            if (container && container.querySelector('.door-option-wrap[data-option-id="' + opt.id + '"]')) {
                return;
            }
            // Dp end 10-08
            var shouldAppendIntoDoorUnitGroup = !!doorUnitDesignGroup && (optId === 'door_unit_design' || optId === 'sidelight_design' || optId === 'transom_design');
            var section = document.createElement('div');
            section.className = 'door-section door-option-wrap';
            section.setAttribute('data-option-id', opt.id);
            var isMeasureMethodHeader = measurementMethodRadio(opt) || isMeasurementTypeOptionId(opt.id);
            var accordionHeader = findAccordionForHeader(optId);
            var accordionContent = findAccordionForContent(optId);
            var isRowOnly = (opt.type || '').toLowerCase() === 'dimension'
                || ((opt.type || '').toLowerCase() === 'select' && opt.unit_label)
                || !!accordionHeader;

            // Render content options only inside their header accordion (when both exist).
            var activeForThisContent = activeAccordionByContent[optId];
            if (activeForThisContent) {
                return;
            }

            // Special UI: header option becomes a single accordion header,
            // and the accordion content is rendered from the content option choices.
            var activeForThisHeader = null;
            Object.keys(activeAccordionByContent).forEach(function (contentId) {
                var p = activeAccordionByContent[contentId];
                if (p && p.headerId === optId) activeForThisHeader = p;
            });
            if (accordionHeader && activeForThisHeader) {
                var headerDescription = opt.description;

                // Header
                section.classList.add('door-option-accordion');

                var headerBtn = document.createElement('button');
                headerBtn.type = 'button';
                headerBtn.className = 'door-accordion-header';

                var headerRow = document.createElement('div');
                headerRow.className = 'door-option-header-row';

                var leftWrap = document.createElement('div');
                leftWrap.className = 'door-option-title-wrap';
                var headerText = document.createElement('div');
                headerText.className = 'door-accordion-header-text door-option-title';
                headerText.textContent = opt.label || 'Details';
                leftWrap.appendChild(headerText);
                if (headerDescription) {
                    var d = typeof headerDescription === 'string' ? headerDescription : (headerDescription && (headerDescription.value || headerDescription.text)) || '';
                    d = String(d || '').trim();
                    if (d) {
                        var dEl = document.createElement('div');
                        dEl.className = 'door-option-desc' + (String(optId || '').toLowerCase().replace(/-/g, '_') === 'panel_profile' ? ' d-none' : '');
                        setDoorOptionDescriptionText(dEl, d);
                        leftWrap.appendChild(dEl);
                    }
                }
                headerRow.appendChild(leftWrap);

                headerBtn.appendChild(headerRow);

                var accordionPlusSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
                    '<rect x="7" width="2" height="16" rx="1" fill="currentColor"></rect>' +
                    '<rect x="16" y="7" width="2" height="16" rx="1" transform="rotate(90 16 7)" fill="currentColor"></rect>' +
                    '</svg>';
                var accordionMinusSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
                    '<rect x="0" y="7" width="16" height="2" rx="1" fill="currentColor"></rect>' +
                    '</svg>';

                var sign = document.createElement('span');
                sign.className = 'door-accordion-sign';
                sign.innerHTML = accordionPlusSvg;
                var isSidelightAccordion = String(optId || '') === 'sidelight_design';
                var isTransomAccordion = String(optId || '').indexOf('transom') !== -1;
                var removeBtn = null;
                function headerActionOptionIds() {
                    if (isSidelightAccordion) return ['sidelight_location', 'sidelight_style'];
                    if (isTransomAccordion) return ['transom_style'];
                    return [];
                }
                function syncHeaderActions() {
                    if (!removeBtn) return;
                    var ids = headerActionOptionIds();
                    var anyChecked = false;
                    for (var i0 = 0; i0 < ids.length; i0++) {
                        if (body.querySelector('input[type="radio"][data-option-id="' + ids[i0] + '"]:checked')) {
                            anyChecked = true;
                            break;
                        }
                    }
                    removeBtn.style.setProperty('display', anyChecked ? '' : 'none', 'important');
                    sign.style.setProperty('display', anyChecked ? 'none' : '', 'important');
                }
                if (isSidelightAccordion || isTransomAccordion) {
                    removeBtn = document.createElement('button');
                    removeBtn.type = 'button';
                    removeBtn.className = 'door-accordion-remove-btn common-btn btn-woodDust btn-small';
                    removeBtn.innerHTML =
                        'Remove ' +
                        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
                        '<path d="M10.6667 3.99967V3.46634C10.6667 2.7196 10.6667 2.34624 10.5213 2.06102C10.3935 1.81014 10.1895 1.60616 9.93865 1.47833C9.65344 1.33301 9.28007 1.33301 8.53333 1.33301H7.46667C6.71993 1.33301 6.34656 1.33301 6.06135 1.47833C5.81046 1.60616 5.60649 1.81014 5.47866 2.06102C5.33333 2.34624 5.33333 2.7196 5.33333 3.46634V3.99967M6.66667 7.66634V10.9997M9.33333 7.66634V10.9997M2 3.99967H14M12.6667 3.99967V11.4663C12.6667 12.5864 12.6667 13.1465 12.4487 13.5743C12.2569 13.9506 11.951 14.2566 11.5746 14.4484C11.1468 14.6663 10.5868 14.6663 9.46667 14.6663H6.53333C5.41323 14.6663 4.85318 14.6663 4.42535 14.4484C4.04903 14.2566 3.74307 13.9506 3.55132 13.5743C3.33333 13.1465 3.33333 12.5864 3.33333 11.4663V3.99967" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>' +
                        '</svg>';
                    removeBtn.addEventListener('click', function (ev) {
                        ev.preventDefault();
                        ev.stopPropagation();
                        try {
                            var ids = headerActionOptionIds();
                            var hadSidelight = false;
                            var hadTransom = false;
                            if (isSidelightAccordion) {
                                hadSidelight = !!body.querySelector('input[type="radio"][data-option-id="sidelight_style"]:checked');
                            }
                            if (isTransomAccordion) {
                                hadTransom = !!body.querySelector('input[type="radio"][data-option-id="transom_style"]:checked');
                            }

                            ids.forEach(function (id0) {
                                var qs = 'input[type="radio"][data-option-id="' + id0 + '"]';
                                body.querySelectorAll(qs).forEach(function (inp) { inp.checked = false; });
                                body.querySelectorAll('.door-option-wrap[data-option-id="' + id0 + '"] .common-check-option').forEach(function (c) {
                                    c.classList.remove('common-check-option--selected');
                                });
                            });

                            applyHideWhen(doorConfigSchema, container);
                            applyChoiceVisibility(doorConfigSchema, container);
                            applyProductTagChoiceVisibility(doorConfigSchema, container);
                            applyWoodExposureFilter(container);
                            syncPanelProfileHero(container);
                            syncMeasurementTypeSectionPreHungGate(doorConfigSchema, container);
                            syncHingeFinishVisibility(doorConfigSchema, container);
                            syncLocksetPrepVisibility(doorConfigSchema, container);
                            syncMeasurementTabCardVisibility(container, doorConfigSchema);
                            syncSlabSidelightMeasurementUI(container, doorConfigSchema);
                            runMeasurementUiSync();
                            if (
                                window.DoorIntExtPricingRule
                                && typeof window.DoorIntExtPricingRule.syncSidelightTransomAddonsFromStyleSelection === 'function'
                            ) {
                                window.DoorIntExtPricingRule.syncSidelightTransomAddonsFromStyleSelection(null, {
                                    removedSidelight: isSidelightAccordion && hadSidelight,
                                    removedTransom: isTransomAccordion && hadTransom
                                });
                            }
                            if (
                                window.DoorIntExtPricingRule
                                && typeof window.DoorIntExtPricingRule.refreshGeneralIntExtOversizedFromDomIfReady === 'function'
                            ) {
                                window.DoorIntExtPricingRule.refreshGeneralIntExtOversizedFromDomIfReady(null);
                            } else if (
                                window.DoorIntExtPricingRule
                                && typeof window.DoorIntExtPricingRule.syncEstimatedPriceDisplay === 'function'
                            ) {
                                window.DoorIntExtPricingRule.syncEstimatedPriceDisplay({ source: 'sidelightTransomRemove' });
                            }
                            updateEstimatedPrice();
                            updateDoorPreview();
                            syncHeaderActions();
                            syncSidelightTransomAccordionHeaderUi(container);
                        } catch (e) {
                            updateEstimatedPrice();
                            updateDoorPreview();
                            syncHeaderActions();
                        }
                    });
                }
                if (removeBtn) headerBtn.appendChild(removeBtn);
                headerBtn.appendChild(sign);

                // Body
                var body = document.createElement('div');
                body.className = 'door-accordion-body';

                function appendRadioGrid(contentOpt) {
                    if (!contentOpt) return;
                    var radioWrap = document.createElement('div');
                    var contentOptIdLower = String(contentOpt.id || '').toLowerCase();
                    var contentOptLabelLower = String(contentOpt.label || '').toLowerCase();
                    var isSidelightStyleCards = String(contentOpt.id || '') === 'sidelight_style';
                    var isTransomStyleCards = String(contentOpt.id || '') === 'transom_style'
                        && String(optId || '').indexOf('transom') !== -1;
                    var isSelectWoodCards = contentOptIdLower.indexOf('wood') !== -1 || contentOptLabelLower.indexOf('wood') !== -1;
                    radioWrap.className = 'common-check-options' + (isSelectWoodCards ? ' select-wood-options' : '');

                    var gridChoices = contentOpt.options || [];
                    if (String(contentOpt.id || '') === 'door_unit_design' && gridChoices.length > 2) {
                        gridChoices = gridChoices.slice(0, 2); // remove last 2 options
                    }
                    // Dp start VDN-598 27-10
                    if (isSelectWoodCards && gridChoices.length > 1) {
                        gridChoices = dpWoodChoicesDefaultFirst(contentOpt, gridChoices);
                    }
                    // Dp end VDN-598 27-10
                    gridChoices.forEach(function (o) {
                        var card = document.createElement('label');
                        card.className = 'common-check-option'
                            + (isSidelightStyleCards ? ' sidelight-style-option' : '')
                            + (isTransomStyleCards ? ' transom-style-option' : '')
                            + (isSelectWoodCards ? ' select-wood-option' : '');
                        card.setAttribute('data-choice-value', o.value != null && o.value !== '' ? String(o.value) : '');
                        if (isSelectWoodCards) {
                            card.setAttribute('data-wood-key', normalizeWoodChoiceKey(o.label || o.value || ''));
                            card.setAttribute('data-select-wood-option', '1');
                        }

                        var radio = document.createElement('input');
                        radio.type = 'radio';
                        radio.name = 'attributes[' + (contentOpt.label || contentOpt.id) + ']';
                        radio.value = o.value != null && o.value !== '' ? String(o.value) : '';
                        radio.setAttribute('data-option-id', contentOpt.id);
                        radio.style.position = 'absolute';
                        radio.style.opacity = '0';
                        radio.style.pointerEvents = 'none';
                        card.appendChild(radio);

                        // Door unit design cards should be text-only (no thumbnail image).
                        if (o.image && String(contentOpt.id || '') !== 'door_unit_design') {
                            var img = document.createElement('img');
                            img.src = typeof o.image === 'string' ? o.image : (o.image && (o.image.url || o.image.src)) || '';
                            img.alt = o.label || o.value || '';
                            img.className = 'common-check-option-image';
                            if (img.src) card.appendChild(img);
                        }
                        // Dp start VDN-598 22-10
                        var rawTag1 = o.add_tag || o.addTag || o['add_tag'] || o['Add Tag'] || o['add-tag'] || '';
                        var tagImgSrc1 = '';
                        if (typeof rawTag1 === 'string') {
                            tagImgSrc1 = rawTag1;
                        } else if (rawTag1 && typeof rawTag1 === 'object') {
                            tagImgSrc1 = rawTag1.url || (rawTag1.value && (rawTag1.value.url || (typeof rawTag1.value === 'string' ? rawTag1.value : ''))) || rawTag1.src || (rawTag1.preview_image && (rawTag1.preview_image.url || rawTag1.preview_image)) || '';
                        }
                        if (tagImgSrc1) {
                            var tag1Lower = String(tagImgSrc1).toLowerCase();
                            if (tag1Lower.indexOf('recommend') !== -1 && tag1Lower.indexOf('premium') === -1) {
                                tagImgSrc1 = DP_LIVE_RECOMMENDED_FLAG;
                            } else if (tag1Lower.indexOf('premium') !== -1) {
                                tagImgSrc1 = DP_LIVE_PREMIUM_FLAG;
                            } else {
                                tagImgSrc1 = dpLiveWoodFlagSrc(tagImgSrc1);
                            }
                            var tagImg1 = document.createElement('img');
                            tagImg1.src = tagImgSrc1;
                            tagImg1.alt = 'Tag';
                            tagImg1.className = 'common-check-option-tag-image';
                            card.appendChild(tagImg1);
                        }
                        // Dp end VDN-598 22-10

                        var textWrap = document.createElement('div');
                        textWrap.className = 'common-check-option-text';

                        var text = document.createElement('span');
                        text.className = 'common-check-option-label';
                        text.textContent = o.label || o.value || '';
                        textWrap.appendChild(text);

                        if (o.description) {
                            var desc = document.createElement('span');
                            desc.className = 'common-check-option-desc';

                            var dd = o.description;
                            var descText = '';
                            if (typeof dd === 'string' || typeof dd === 'number' || typeof dd === 'boolean') {
                                descText = String(dd);
                            } else if (dd && typeof dd === 'object') {
                                if (typeof dd.value === 'string') descText = dd.value;
                                else if (typeof dd.text === 'string') descText = dd.text;
                                else if (typeof dd.label === 'string') descText = dd.label;
                                else if (typeof dd.html === 'string') {
                                    var tmp = document.createElement('div');
                                    tmp.innerHTML = dd.html;
                                    descText = tmp.textContent || tmp.innerText || '';
                                } else {
                                    ['content', 'description', 'subtext', 'note'].forEach(function (k) {
                                        if (!descText && dd && typeof dd[k] === 'string') descText = dd[k];
                                    });
                                }
                            }
                            descText = String(descText || '').trim();
                            if (descText) {
                                descText = mapCollectionDoorWording(descText);
                                desc.textContent = descText;
                                textWrap.appendChild(desc);
                            }
                        }

                        card.appendChild(textWrap);

                        radio.addEventListener('change', function () {
                            radioWrap.querySelectorAll('.common-check-option').forEach(function (c) { c.classList.remove('common-check-option--selected'); });
                            if (this.checked && this.closest) {
                                var selCard = this.closest('.common-check-option');
                                if (selCard) selCard.classList.add('common-check-option--selected');
                            }
                            updateEstimatedPrice();
                        });

                        radioWrap.appendChild(card);
                    });

                    var innerWrap = document.createElement('div');
                    innerWrap.className = 'door-option-wrap';
                    innerWrap.setAttribute('data-option-id', contentOpt.id);
                    innerWrap.style.border = '0';
                    innerWrap.style.padding = '0';
                    innerWrap.style.margin = '0';
                    innerWrap.appendChild(radioWrap);

                    // Add a title before the sidelight style grid (inside the sidelight accordion).
                    if (optId === 'sidelight_design' && String(contentOpt.id || '') === 'sidelight_style') {
                        var preTitle = document.createElement('p');
                        preTitle.className = 'mb-16';
                        preTitle.textContent = 'Select your sidelight style';
                        preTitle.style.margin = '12px 0 0 0';
                        body.appendChild(preTitle);
                    }

                    // Add a title before the transom style grid (inside the transom accordion).
                    if (String(optId || '') === 'transom_design' && String(contentOpt.id || '') === 'transom_style') {
                        var preTitleTransom = document.createElement('p');
                        preTitleTransom.className = 'mb-16';
                        preTitleTransom.textContent = 'Select your transom style';
                        preTitleTransom.style.margin = '12px 0 0 0';
                        body.appendChild(preTitleTransom);
                    }

                    body.appendChild(innerWrap);
                }

                function appendTransomCountOption() {
                    var wrap = document.createElement('div');
                    wrap.className = 'door-option-wrap door-transom-count-wrap';
                    wrap.setAttribute('data-option-id', 'transom_count');
                    wrap.style.border = '0';
                    wrap.style.padding = '0';
                    wrap.style.margin = '1rem 0 0 0';

                    var q = document.createElement('p');
                    q.className = 'fw-700 mb-8';
                    q.textContent = 'Single or Double Transom?';
                    wrap.appendChild(q);

                    var sub = document.createElement('p');
                    sub.className = 'door-option-desc mb-16';
                    sub.textContent = mapCollectionDoorWording('Would you like a single over both doors or double transom, with one transom over each door?');
                    wrap.appendChild(sub);

                    var radioWrap = document.createElement('div');
                    radioWrap.className = 'common-check-options';

                    var choices = [
                        { value: 'single_transom_across_both_doors', label: 'Single transom across both doors' },
                        { value: 'two_transoms_one_over_each_door', label: 'Two transoms, one over each door' }
                    ];

                    choices.forEach(function (o) {
                        var card = document.createElement('label');
                        card.className = 'common-check-option';
                        card.setAttribute('data-choice-value', o.value);

                        var radio = document.createElement('input');
                        radio.type = 'radio';
                        radio.name = 'attributes[Single or Double Transom?]';
                        radio.value = o.value;
                        radio.setAttribute('data-option-id', 'transom_count');
                        radio.style.position = 'absolute';
                        radio.style.opacity = '0';
                        radio.style.pointerEvents = 'none';
                        card.appendChild(radio);

                        var textWrap = document.createElement('div');
                        textWrap.className = 'common-check-option-text';
                        var text = document.createElement('span');
                        text.className = 'common-check-option-label';
                        text.textContent = o.label;
                        textWrap.appendChild(text);
                        card.appendChild(textWrap);

                        radio.addEventListener('change', function () {
                            radioWrap.querySelectorAll('.common-check-option').forEach(function (c) { c.classList.remove('common-check-option--selected'); });
                            if (this.checked && this.closest) {
                                var selCard = this.closest('.common-check-option');
                                if (selCard) selCard.classList.add('common-check-option--selected');
                            }
                            updateEstimatedPrice();
                            updateDoorPreview();
                        });

                        radioWrap.appendChild(card);
                    });

                    wrap.appendChild(radioWrap);
                    body.appendChild(wrap);

                    function syncVisibility() {
                        var optionsRoot = document.getElementById('door-configurator-options');
                        var doorUnitNow = optionsRoot
                            ? optionsRoot.querySelector('input[type="radio"][data-option-id="door_unit_design"]:checked')
                            : null;
                        var isDoubleNow = !!doorUnitNow && String(doorUnitNow.value || '') === 'double_door';
                        // Dp start 10-08
                        var shouldShowTransomCount = isDoubleNow;
                        wrap.classList.toggle('door-hidden', !shouldShowTransomCount);

                        if (!shouldShowTransomCount) {
                            wrap.querySelectorAll('input[type="radio"][data-option-id="transom_count"]').forEach(function (inp) {
                                inp.checked = false;
                            });
                            wrap.querySelectorAll('.common-check-option').forEach(function (c) {
                                c.classList.remove('common-check-option--selected');
                            });
                        }
                        try { syncTransomSectionVisibility(optionsRoot); } catch (eTransomSync) { }
                        // Dp end 10-08
                    }

                    // Initial sync and keep in sync with door unit changes.
                    syncVisibility();
                    document.addEventListener('change', function (e) {
                        var t = e && e.target;
                        if (!t || t.tagName !== 'INPUT') return;
                        var oid = t.getAttribute('data-option-id');
                        if (oid === 'door_unit_design') syncVisibility();
                    });
                }

                // Sidelight accordion should contain two choice blocks in order.
                if (optId === 'sidelight_design') {
                    appendRadioGrid(findOpt('sidelight_location'));
                    appendRadioGrid(findOpt('sidelight_style'));
                } else {
                    var activeContentOpt = findOpt(activeForThisHeader.contentId);
                    // If transom_design has no backend options, skip rendering this accordion.
                    if (isTransomAccordion) {
                        var hasTransomChoices = !!(activeContentOpt && Array.isArray(activeContentOpt.options) && activeContentOpt.options.length > 0);
                        if (!hasTransomChoices) {
                            if (shouldAppendIntoDoorUnitGroup && optId === lastDoorUnitGroupId) appendDeferredDoorSetupToUnitGroup();
                            if (optId === 'transom_design') doorUnitDesignGroup = null;
                            return;
                        }
                    }
                    appendRadioGrid(activeContentOpt);
                }

                // Add "Single or Double Transom?" option after all transom checkboxes/cards.
                if (String(optId || '').indexOf('transom') !== -1) {
                    appendTransomCountOption();
                }

                if (isSidelightAccordion || isTransomAccordion) {
                    // Delegate sync to any input change within this accordion body.
                    body.addEventListener('change', function (e) {
                        var t = e && e.target;
                        if (!t || t.tagName !== 'INPUT') return;
                        if (t.type !== 'radio') return;
                        syncHeaderActions();
                    });
                    syncHeaderActions();
                }

                headerBtn.addEventListener('click', function () {
                    var opened = body.classList.toggle('door-accordion-body--open');
                    sign.innerHTML = opened ? accordionMinusSvg : accordionPlusSvg;
                });

                section.appendChild(headerBtn);
                section.appendChild(body);

                if (shouldAppendIntoDoorUnitGroup) {
                    doorUnitDesignGroup.appendChild(section);
                    if (optId === lastDoorUnitGroupId) appendDeferredDoorSetupToUnitGroup();
                    if (optId === 'transom_design') doorUnitDesignGroup = null;
                } else {
                    container.appendChild(section);
                }
                return;
            }

            if (!isRowOnly) {
                if (isMeasureMethodHeader) {
                    appendMeasurementTypeHeader(section, opt);
                } else {
                    var headerRow = document.createElement('div');
                    headerRow.className = 'door-option-header-row';

                    var leftWrap = document.createElement('div');
                    leftWrap.className = 'door-option-title-wrap';
                    var title = document.createElement('h3');
                    title.className = 'door-section-title door-option-title';
                    var titleText = document.createElement('span');
                    var optIdNormHeader = normalizeOptionIdKey(opt.id);
                    var isSdlProfileOpt = optIdNormHeader === 'sdl_profile';
                    if (isSdlProfileOpt) {
                        var sdlDescHeader = document.createElement('p');
                        sdlDescHeader.className = 'door-option-desc door-sdl-profile-desc';
                        applySdlProfileDescText(sdlDescHeader, getSdlProfileSectionCopy(container));
                        leftWrap.appendChild(sdlDescHeader);
                    } else {
                        titleText.textContent = (optIdNormHeader === 'door_sweep') ? 'Door Sweep' : opt.label;
                        title.appendChild(titleText);
                        leftWrap.appendChild(title);
                    }
                    if (opt.description && optIdNormHeader !== 'panel_profile' && optIdNormHeader !== 'stile_and_rail_profile' && !isSdlProfileOpt) {
                        var d = typeof opt.description === 'string' ? opt.description : (opt.description && (opt.description.value || opt.description.text)) || '';
                        d = String(d || '').trim();
                        if (d) {
                            var dEl = document.createElement('p');
                            dEl.className = 'door-option-desc';
                            setDoorOptionDescriptionText(dEl, d);
                            leftWrap.appendChild(dEl);
                        }
                    }
                    headerRow.appendChild(leftWrap);

                    // Only for "Screen & Storm Inserts": show tooltip-style drawer trigger button.
                    try {
                        var labelLower = String(opt.label || '').toLowerCase();
                        var isInsertsOption = labelLower.indexOf('screen') !== -1 && labelLower.indexOf('storm') !== -1 && labelLower.indexOf('insert') !== -1;
                        var optIdLower = String(opt.id || '').toLowerCase();
                        var isWoodOption = (optIdLower.indexOf('wood') !== -1 || labelLower.indexOf('wood') !== -1);
                        var isScreenTypeOption = (labelLower.indexOf('screen') !== -1 && labelLower.indexOf('type') !== -1)
                            || (optIdLower.indexOf('screen') !== -1 && optIdLower.indexOf('type') !== -1)
                            || optIdLower === 'select_screen';
                        // --- Dp start 15-07 ---
                        var isStormGlassOption = (labelLower.indexOf('glass') !== -1)
                            || optIdLower.indexOf('glass') !== -1
                            || optIdLower === 'storm_glass_type'
                            || optIdLower === 'storm_glass';
                        // --- Dp end 15-07 ---
                        var isStileRailProfile = optionIsStileAndRailProfile(opt);
                        var isPanelProfileOpt = optionIsPanelProfile(opt);
                        var isPanelUnitDesignOpt = optionIsPanelUnitDesign(opt);
                        var rawOptId = String(opt.id || '');
                        var safeOptId = rawOptId ? rawOptId.replace(/[^a-zA-Z0-9_-]/g, '-') : '';
                        var woodTooltipId = (isWoodOption && safeOptId) ? ('door-wood-options-tooltip--' + safeOptId) : '';

                        // For "Stile and Rail Profile": show Edge Profile drawer button (same modal as theme's edge_profile).
                        if (isStileRailProfile && title && !title.querySelector('.door-edge-profile-btn')) {
                            var edgeBtn2 = document.createElement('button');
                            edgeBtn2.type = 'button';
                            edgeBtn2.className = 'wood-species-open-btn common-btn btn-secondary btn-small door-edge-profile-btn';
                            edgeBtn2.setAttribute('data-wood-drawer-open', '');
                            edgeBtn2.setAttribute('aria-haspopup', 'dialog');
                            edgeBtn2.setAttribute('aria-controls', getEdgeProfileDrawerAriaControls() || getDoorSetupDrawerAriaControls());
                            edgeBtn2.innerHTML = 'About Stile and Rail Profiles' +
                                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.03206 4.92901C7.79606 4.92901 7.60406 4.85301 7.45606 4.70101C7.30806 4.54501 7.23406 4.35301 7.23406 4.12501C7.23406 3.90101 7.30806 3.71301 7.45606 3.56101C7.60406 3.40901 7.79606 3.33301 8.03206 3.33301C8.27206 3.33301 8.46606 3.40901 8.61406 3.56101C8.76206 3.71301 8.83606 3.90101 8.83606 4.12501C8.83606 4.35301 8.76206 4.54501 8.61406 4.70101C8.46606 4.85301 8.27206 4.92901 8.03206 4.92901ZM8.68606 6.59101L8.64406 7.64701V11.337L9.51406 11.631V11.859H6.66406V11.631L7.52206 11.337V7.78501C7.47406 7.72501 7.40406 7.66501 7.31206 7.60501C7.22406 7.54501 7.12406 7.48701 7.01206 7.43101C6.90006 7.37501 6.78606 7.32701 6.67006 7.28701V7.08301L8.53006 6.59101H8.68606Z" fill="currentColor"></path><circle cx="8" cy="8" r="7.5" stroke="currentColor"></circle></svg>';
                            ;
                            edgeBtn2.addEventListener('click', function (ev) {
                                ev.preventDefault();
                                ev.stopPropagation();
                                edgeBtn2.setAttribute('aria-controls', getEdgeProfileDrawerAriaControls() || getDoorSetupDrawerAriaControls());
                                // Open Edge Profile Options drawer (not Door Setup Options).
                                if (!openEdgeProfileDrawer()) openDoorSetupDrawer();
                            });
                            title.appendChild(edgeBtn2);
                        }
                        // For "Panel Profile": show Panel Profile modal button (same pattern as other sections).
                        if (isPanelProfileOpt && title && !title.querySelector('.door-panel-profile-btn')) {
                            var panelBtn = document.createElement('button');
                            panelBtn.type = 'button';
                            panelBtn.className = 'wood-species-open-btn common-btn btn-secondary btn-small door-panel-profile-btn';
                            panelBtn.setAttribute('data-panel-profile-open', '');
                            panelBtn.setAttribute('aria-haspopup', 'dialog');
                            panelBtn.setAttribute('aria-controls', getPanelProfileDrawerAriaControls());
                            panelBtn.innerHTML = 'About Panel Profiles' +
                                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.03206 4.92901C7.79606 4.92901 7.60406 4.85301 7.45606 4.70101C7.30806 4.54501 7.23406 4.35301 7.23406 4.12501C7.23406 3.90101 7.30806 3.71301 7.45606 3.56101C7.60406 3.40901 7.79606 3.33301 8.03206 3.33301C8.27206 3.33301 8.46606 3.40901 8.61406 3.56101C8.76206 3.71301 8.83606 3.90101 8.83606 4.12501C8.83606 4.35301 8.76206 4.54501 8.61406 4.70101C8.46606 4.85301 8.27206 4.92901 8.03206 4.92901ZM8.68606 6.59101L8.64406 7.64701V11.337L9.51406 11.631V11.859H6.66406V11.631L7.52206 11.337V7.78501C7.47406 7.72501 7.40406 7.66501 7.31206 7.60501C7.22406 7.54501 7.12406 7.48701 7.01206 7.43101C6.90006 7.37501 6.78606 7.32701 6.67006 7.28701V7.08301L8.53006 6.59101H8.68606Z" fill="currentColor"></path><circle cx="8" cy="8" r="7.5" stroke="currentColor"></circle></svg>';
                            panelBtn.addEventListener('click', function (ev) {
                                ev.preventDefault();
                                ev.stopPropagation();
                                panelBtn.setAttribute('aria-controls', getPanelProfileDrawerAriaControls());
                                openPanelProfileDrawer();
                            });
                            title.appendChild(panelBtn);
                        }
                        if (isPanelUnitDesignOpt && title && !title.querySelector('.door-panel-unit-design-btn')) {
                            var panelUnitBtn = document.createElement('button');
                            panelUnitBtn.type = 'button';
                            panelUnitBtn.className = 'wood-species-open-btn common-btn btn-secondary btn-small door-panel-unit-design-btn';
                            panelUnitBtn.setAttribute('data-panel-unit-design-open', '');
                            panelUnitBtn.setAttribute('aria-haspopup', 'dialog');
                            panelUnitBtn.setAttribute('aria-controls', getPanelProfileDrawerAriaControls());
                            panelUnitBtn.innerHTML = 'About Panel Unit Design' +
                                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.03206 4.92901C7.79606 4.92901 7.60406 4.85301 7.45606 4.70101C7.30806 4.54501 7.23406 4.35301 7.23406 4.12501C7.23406 3.90101 7.30806 3.71301 7.45606 3.56101C7.60406 3.40901 7.79606 3.33301 8.03206 3.33301C8.27206 3.33301 8.46606 3.40901 8.61406 3.56101C8.76206 3.71301 8.83606 3.90101 8.83606 4.12501C8.83606 4.35301 8.76206 4.54501 8.61406 4.70101C8.46606 4.85301 8.27206 4.92901 8.03206 4.92901ZM8.68606 6.59101L8.64406 7.64701V11.337L9.51406 11.631V11.859H6.66406V11.631L7.52206 11.337V7.78501C7.47406 7.72501 7.40406 7.66501 7.31206 7.60501C7.22406 7.54501 7.12406 7.48701 7.01206 7.43101C6.90006 7.37501 6.78606 7.32701 6.67006 7.28701V7.08301L8.53006 6.59101H8.68606Z" fill="currentColor"></path><circle cx="8" cy="8" r="7.5" stroke="currentColor"></circle></svg>';
                            panelUnitBtn.addEventListener('click', function (ev) {
                                ev.preventDefault();
                                ev.stopPropagation();
                                panelUnitBtn.setAttribute('aria-controls', getPanelProfileDrawerAriaControls());
                                openPanelProfileDrawer();
                            });
                            title.appendChild(panelUnitBtn);
                        }
                        // For "Lockset Prep": show Lockset Prep modal button.
                        if (optionIsLocksetPrep(opt) && title && !title.querySelector('.door-lockset-prep-btn')) {
                            var locksetBtn = document.createElement('button');
                            locksetBtn.type = 'button';
                            locksetBtn.className = 'wood-species-open-btn common-btn btn-secondary btn-small door-lockset-prep-btn';
                            locksetBtn.setAttribute('data-lockset-prep-open', '');
                            locksetBtn.setAttribute('aria-haspopup', 'dialog');
                            locksetBtn.setAttribute('aria-controls', getLocksetPrepDrawerAriaControls());
                            locksetBtn.innerHTML = 'About Lockset Prep' +
                                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.03206 4.92901C7.79606 4.92901 7.60406 4.85301 7.45606 4.70101C7.30806 4.54501 7.23406 4.35301 7.23406 4.12501C7.23406 3.90101 7.30806 3.71301 7.45606 3.56101C7.60406 3.40901 7.79606 3.33301 8.03206 3.33301C8.27206 3.33301 8.46606 3.40901 8.61406 3.56101C8.76206 3.71301 8.83606 3.90101 8.83606 4.12501C8.83606 4.35301 8.76206 4.54501 8.61406 4.70101C8.46606 4.85301 8.27206 4.92901 8.03206 4.92901ZM8.68606 6.59101L8.64406 7.64701V11.337L9.51406 11.631V11.859H6.66406V11.631L7.52206 11.337V7.78501C7.47406 7.72501 7.40406 7.66501 7.31206 7.60501C7.22406 7.54501 7.12406 7.48701 7.01206 7.43101C6.90006 7.37501 6.78606 7.32701 6.67006 7.28701V7.08301L8.53006 6.59101H8.68606Z" fill="currentColor"></path><circle cx="8" cy="8" r="7.5" stroke="currentColor"></circle></svg>';
                            locksetBtn.addEventListener('click', function (ev) {
                                ev.preventDefault();
                                ev.stopPropagation();
                                locksetBtn.setAttribute('aria-controls', getLocksetPrepDrawerAriaControls());
                                openLocksetPrepDrawer();
                            });
                            title.appendChild(locksetBtn);
                        }
                        if (isInsertsOption) {
                            var tipBtn = document.createElement('button');
                            tipBtn.type = 'button';
                            tipBtn.className = 'inserts-tooltip-btn common-btn btn-secondary btn-small';
                            tipBtn.setAttribute('data-inserts-drawer-open', '');
                            tipBtn.setAttribute('aria-haspopup', 'dialog');
                            var insertsModalEl = document.querySelector('.inserts-info-snippet .inserts-info-modal[id]')
                                || document.querySelector('.inserts-info-modal[id*="inserts_info_drawer"]');
                            if (insertsModalEl && insertsModalEl.id) {
                                tipBtn.setAttribute('aria-controls', insertsModalEl.id);
                            }
                            tipBtn.innerHTML = 'About Inserts <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.03206 4.92901C7.79606 4.92901 7.60406 4.85301 7.45606 4.70101C7.30806 4.54501 7.23406 4.35301 7.23406 4.12501C7.23406 3.90101 7.30806 3.71301 7.45606 3.56101C7.60406 3.40901 7.79606 3.33301 8.03206 3.33301C8.27206 3.33301 8.46606 3.40901 8.61406 3.56101C8.76206 3.71301 8.83606 3.90101 8.83606 4.12501C8.83606 4.35301 8.76206 4.54501 8.61406 4.70101C8.46606 4.85301 8.27206 4.92901 8.03206 4.92901ZM8.68606 6.59101L8.64406 7.64701V11.337L9.51406 11.631V11.859H6.66406V11.631L7.52206 11.337V7.78501C7.47406 7.72501 7.40406 7.66501 7.31206 7.60501C7.22406 7.54501 7.12406 7.48701 7.01206 7.43101C6.90006 7.37501 6.78606 7.32701 6.67006 7.28701V7.08301L8.53006 6.59101H8.68606Z" fill="currentColor"/><circle cx="8" cy="8" r="7.5" stroke="currentColor"/></svg>';
                            title.appendChild(tipBtn);
                            tipBtn.addEventListener('click', function (ev) {
                                ev.preventDefault();
                                ev.stopPropagation();
                                openInsertsInfoDrawer(tipBtn);
                            });
                        }
                        if (isWoodOption && woodTooltipId) {
                            var woodTipBtn = document.createElement('button');
                            woodTipBtn.type = 'button';
                            woodTipBtn.className = 'inserts-tooltip-btn common-btn btn-secondary btn-small';
                            woodTipBtn.setAttribute('aria-haspopup', 'dialog');
                            woodTipBtn.setAttribute('aria-controls', woodTooltipId);
                            woodTipBtn.innerHTML = 'About Wood Options <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.03206 4.92901C7.79606 4.92901 7.60406 4.85301 7.45606 4.70101C7.30806 4.54501 7.23406 4.35301 7.23406 4.12501C7.23406 3.90101 7.30806 3.71301 7.45606 3.56101C7.60406 3.40901 7.79606 3.33301 8.03206 3.33301C8.27206 3.33301 8.46606 3.40901 8.61406 3.56101C8.76206 3.71301 8.83606 3.90101 8.83606 4.12501C8.83606 4.35301 8.76206 4.54501 8.61406 4.70101C8.46606 4.85301 8.27206 4.92901 8.03206 4.92901ZM8.68606 6.59101L8.64406 7.64701V11.337L9.51406 11.631V11.859H6.66406V11.631L7.52206 11.337V7.78501C7.47406 7.72501 7.40406 7.66501 7.31206 7.60501C7.22406 7.54501 7.12406 7.48701 7.01206 7.43101C6.90006 7.37501 6.78606 7.32701 6.67006 7.28701V7.08301L8.53006 6.59101H8.68606Z" fill="currentColor"/><circle cx="8" cy="8" r="7.5" stroke="currentColor"/></svg>';
                            title.appendChild(woodTipBtn);
                            woodTipBtn.addEventListener('click', function (ev) {
                                ev.preventDefault();
                                ev.stopPropagation();
                                if (!openWoodSpeciesDrawer()) {
                                    var el = document.getElementById(woodTooltipId);
                                    if (!el) return;
                                    el.style.display = (el.style.display === 'none' || !el.style.display) ? '' : 'none';
                                }
                            });
                        }
                        if (isScreenTypeOption) {
                            var screenTypesBtn = document.createElement('button');
                            screenTypesBtn.type = 'button';
                            screenTypesBtn.className = 'inserts-tooltip-btn common-btn btn-secondary btn-small';
                            screenTypesBtn.setAttribute('aria-haspopup', 'dialog');
                            screenTypesBtn.setAttribute('aria-controls', getScreenTypesDrawerAriaControls() || '');
                            screenTypesBtn.innerHTML = 'About Screen Types <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.03206 4.92901C7.79606 4.92901 7.60406 4.85301 7.45606 4.70101C7.30806 4.54501 7.23406 4.35301 7.23406 4.12501C7.23406 3.90101 7.30806 3.71301 7.45606 3.56101C7.60406 3.40901 7.79606 3.33301 8.03206 3.33301C8.27206 3.33301 8.46606 3.40901 8.61406 3.56101C8.76206 3.71301 8.83606 3.90101 8.83606 4.12501C8.83606 4.35301 8.76206 4.54501 8.61406 4.70101C8.46606 4.85301 8.27206 4.92901 8.03206 4.92901ZM8.68606 6.59101L8.64406 7.64701V11.337L9.51406 11.631V11.859H6.66406V11.631L7.52206 11.337V7.78501C7.47406 7.72501 7.40406 7.66501 7.31206 7.60501C7.22406 7.54501 7.12406 7.48701 7.01206 7.43101C6.90006 7.37501 6.78606 7.32701 6.67006 7.28701V7.08301L8.53006 6.59101H8.68606Z" fill="currentColor"/><circle cx="8" cy="8" r="7.5" stroke="currentColor"/></svg>';
                            title.appendChild(screenTypesBtn);
                            screenTypesBtn.addEventListener('click', function (ev) {
                                ev.preventDefault();
                                ev.stopPropagation();
                                openScreenTypesDrawer();
                            });
                        }
                        if (isStormGlassOption) {
                            var glassTypesBtn = document.createElement('button');
                            glassTypesBtn.type = 'button';
                            glassTypesBtn.className = 'inserts-tooltip-btn common-btn btn-secondary btn-small';
                            glassTypesBtn.setAttribute('aria-haspopup', 'dialog');
                            glassTypesBtn.setAttribute('aria-controls', getStormGlassDrawerAriaControls() || '');
                            glassTypesBtn.innerHTML = 'About Glass Types <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.03206 4.92901C7.79606 4.92901 7.60406 4.85301 7.45606 4.70101C7.30806 4.54501 7.23406 4.35301 7.23406 4.12501C7.23406 3.90101 7.30806 3.71301 7.45606 3.56101C7.60406 3.40901 7.79606 3.33301 8.03206 3.33301C8.27206 3.33301 8.46606 3.40901 8.61406 3.56101C8.76206 3.71301 8.83606 3.90101 8.83606 4.12501C8.83606 4.35301 8.76206 4.54501 8.61406 4.70101C8.46606 4.85301 8.27206 4.92901 8.03206 4.92901ZM8.68606 6.59101L8.64406 7.64701V11.337L9.51406 11.631V11.859H6.66406V11.631L7.52206 11.337V7.78501C7.47406 7.72501 7.40406 7.66501 7.31206 7.60501C7.22406 7.54501 7.12406 7.48701 7.01206 7.43101C6.90006 7.37501 6.78606 7.32701 6.67006 7.28701V7.08301L8.53006 6.59101H8.68606Z" fill="currentColor"/><circle cx="8" cy="8" r="7.5" stroke="currentColor"/></svg>';
                            title.appendChild(glassTypesBtn);
                            glassTypesBtn.addEventListener('click', function (ev) {
                                ev.preventDefault();
                                ev.stopPropagation();
                                openStormGlassDrawer();
                            });
                        }
                    } catch (e) { }

                    // --- Dp start 14-07  ---
                    if (!optionIsAppliedMolding(opt)) {
                        section.appendChild(headerRow);
                    }
                    // --- Dp end 14-07  ---

                    // Insert an informational "location exposure" card set under the header row for wood_type.
                    try {
                        var optIdForWoodTitle = String(opt && opt.id != null ? opt.id : '').toLowerCase().replace(/-/g, '_');
                        /* MERGE: wood_exposure_storm_porch — start */
                        // Screen & Storm / porch products use wood_type_storm_porch as their wood
                        // option id; render the same "Where will the door be located?" cards there.
                        // Guard: never render twice if a schema has both wood options.
                        // Interior-doors tag: do not need location exposure.
                        var exposureAlreadyRendered = !!(container && container.querySelector && container.querySelector('.door-wood-exposure'));
                        if (!exposureAlreadyRendered
                            && (optIdForWoodTitle === 'wood_type' || optIdForWoodTitle === 'wood_type_storm_porch')) {
                            /* MERGE: wood_exposure_storm_porch — end */
                            if (!isInteriorDoorProduct()) {
                                var exposureWrap = document.createElement('div');
                                exposureWrap.className = 'door-wood-exposure mb-40';

                                var exposureTitle = document.createElement('p');
                                exposureTitle.className = 'fw-600 mb-24 door-collection-wording';
                                exposureTitle.textContent = mapCollectionDoorWording('Where will the door be located?');
                                exposureWrap.appendChild(exposureTitle);

                                var exposureCards = document.createElement('div');
                                exposureCards.className = 'common-check-options door-wood-exposure-cards';

                                var exposureChoices = [
                                    {
                                        value: 'Full Exposure',
                                        label: 'Full Exposure',
                                        desc: 'Directly impacted by the elements, such as rain, sun, snow, etc.'
                                    },
                                    {
                                        value: 'Partial Exposure',
                                        label: 'Partial Exposure',
                                        desc: 'Partially exposed to some elements, such as rain, sun, snow, etc.'
                                    },
                                    {
                                        value: 'Protected Location',
                                        label: 'Protected Location',
                                        desc: 'Completely sheltered from the direct effect of rain, sun, snow, etc.'
                                    }
                                ];

                                exposureChoices.forEach(function (c) {
                                    var card = document.createElement('label');
                                    card.className = 'common-check-option door-wood-exposure-card';
                                    card.setAttribute('data-choice-value', String(c.value || c.label || ''));

                                    var radio = document.createElement('input');
                                    radio.type = 'radio';
                                    radio.name = 'attributes[Where will the door be located?]';
                                    radio.value = String(c.value || c.label || '');
                                    radio.setAttribute('data-option-id', 'door_location_exposure');
                                    radio.style.position = 'absolute';
                                    radio.style.opacity = '0';
                                    radio.style.pointerEvents = 'none';
                                    card.appendChild(radio);

                                    // Keep an image-shaped block so existing card CSS layouts match.
                                    var imgPh = document.createElement('div');
                                    imgPh.className = 'common-check-option-image door-wood-exposure-image';
                                    card.appendChild(imgPh);

                                    var textWrap = document.createElement('div');
                                    textWrap.className = 'common-check-option-text';

                                    var lbl = document.createElement('span');
                                    lbl.className = 'common-check-option-label';
                                    lbl.textContent = c.label;
                                    textWrap.appendChild(lbl);

                                    var d = document.createElement('span');
                                    d.className = 'common-check-option-desc';
                                    d.textContent = c.desc;
                                    textWrap.appendChild(d);

                                    card.appendChild(textWrap);
                                    exposureCards.appendChild(card);

                                    card.addEventListener('click', function () {
                                        radio.checked = true;
                                        try { radio.dispatchEvent(new Event('change', { bubbles: true })); } catch (eExpClick) { }
                                    });

                                    radio.addEventListener('change', function () {
                                        exposureCards.querySelectorAll('.common-check-option').forEach(function (x) { x.classList.remove('common-check-option--selected'); });
                                        if (this.checked && this.closest) {
                                            var sel = this.closest('.common-check-option');
                                            if (sel) sel.classList.add('common-check-option--selected');
                                        }
                                        applyProductTagChoiceVisibility(doorConfigSchema, container);
                                        applyWoodExposureFilter(container);
                                        var doorUnitChecked = container.querySelector('input[type="radio"][data-option-id="door_unit_design"]:checked');
                                        if (doorUnitChecked) {
                                            try { doorUnitChecked.dispatchEvent(new Event('change', { bubbles: true })); } catch (eExpDoorUnit) { }
                                        }
                                        updateEstimatedPrice();
                                        try { updateDoorPreview(); } catch (eExpPreview) { }
                                        try { hideEmptyOptionSections(container); } catch (eExpEmpty) { }
                                    });
                                });

                                exposureWrap.appendChild(exposureCards);
                                section.appendChild(exposureWrap);
                                // Dp merge code 10-09 start — seed default location (configurator_defaults or Full Exposure)
                                try { applyDoorLocationExposureDefaultSelection(container); } catch (eExpDefSeed) { }
                                // Dp merge code 10-09 end
                            }

                            // Dp start VDN-598 22-10
                            var woodOptionsBlock = document.createElement('div');
                            woodOptionsBlock.className = 'door-wood-options-intro mb-24';

                            var woodOptionsTitle = document.createElement('div');
                            woodOptionsTitle.className = 'fw-600 mb-8';
                            woodOptionsTitle.textContent = 'Wood Options';
                            woodOptionsBlock.appendChild(woodOptionsTitle);

                            var woodOptionsSub = document.createElement('p');
                            // Dp start VDN-598 27-10
                            // "and location" only when the location exposure cards are rendered (not interior doors);
                            // door wording follows the collection (gate / sidelight / transom) like the exposure title.
                            // Porch-panel collection products use porch panel wording instead of door type.
                            var woodSubShowsLocation = !isInteriorDoorProduct();
                            var woodSubIsPorchPanel = false;
                            try { woodSubIsPorchPanel = isPorchPanelCollectionProduct(); } catch (eWoodSubPorch) { }
                            var woodSubOriginalText;
                            if (woodSubIsPorchPanel) {
                                woodSubOriginalText = woodSubShowsLocation
                                    ? 'These are the wood species most suitable for your porch panel location.'
                                    : 'These are the wood species most suitable for your porch panel.';
                            } else {
                                woodSubOriginalText = woodSubShowsLocation
                                    ? 'These are the wood species most suitable for your door type and location.'
                                    : 'These are the wood species most suitable for your door type.';
                            }
                            woodOptionsSub.className = 'door-wood-options-subtext door-collection-wording mb-16';
                            woodOptionsSub.setAttribute('data-door-original-desc', woodSubOriginalText);
                            woodOptionsSub.textContent = mapCollectionDoorWording(woodSubOriginalText);
                            // Dp end VDN-598 27-10
                            woodOptionsBlock.appendChild(woodOptionsSub);

                            // Find tag image URLs from wood option choices or any option in the schema for the key legend
                            var keyRecImgUrl = '';
                            var keyPremImgUrl = '';
                            function extractTagUrlFromChoice(wc) {
                                if (!wc) return '';
                                var rawWc = wc.add_tag || wc.addTag || wc['add_tag'] || wc['Add Tag'] || wc['add-tag'] || '';
                                if (typeof rawWc === 'string') return rawWc;
                                if (rawWc && typeof rawWc === 'object') {
                                    return rawWc.url || (rawWc.value && (rawWc.value.url || (typeof rawWc.value === 'string' ? rawWc.value : ''))) || rawWc.src || (rawWc.preview_image && (rawWc.preview_image.url || rawWc.preview_image)) || '';
                                }
                                return '';
                            }
                            var woodChoicesList = (opt && (opt.options || opt.choices)) || [];
                            woodChoicesList.forEach(function (wc) {
                                var u = extractTagUrlFromChoice(wc);
                                if (u) {
                                    var uLower = u.toLowerCase();
                                    if (uLower.indexOf('recommend') !== -1 && !keyRecImgUrl) keyRecImgUrl = u;
                                    if (uLower.indexOf('premium') !== -1 && !keyPremImgUrl) keyPremImgUrl = u;
                                }
                            });
                            // If not found in current opt, search the whole schema for tag images
                            if ((!keyRecImgUrl || !keyPremImgUrl) && Array.isArray(schema)) {
                                schema.forEach(function (scOpt) {
                                    var scChoices = (scOpt && (scOpt.options || scOpt.choices)) || [];
                                    scChoices.forEach(function (scC) {
                                        var u2 = extractTagUrlFromChoice(scC);
                                        if (u2) {
                                            var u2Lower = u2.toLowerCase();
                                            if (u2Lower.indexOf('recommend') !== -1 && !keyRecImgUrl) keyRecImgUrl = u2;
                                            if (u2Lower.indexOf('premium') !== -1 && !keyPremImgUrl) keyPremImgUrl = u2;
                                        }
                                    });
                                });
                            }
                            keyRecImgUrl = DP_LIVE_RECOMMENDED_FLAG;
                            keyPremImgUrl = DP_LIVE_PREMIUM_FLAG;

                            var recBadgeHtml = '<img class="door-wood-key-img" src="' + keyRecImgUrl + '" alt="Recommended">';
                            var premBadgeHtml = '<img class="door-wood-key-img" src="' + keyPremImgUrl + '" alt="Premium">';

                            var woodOptionsKey = document.createElement('div');
                            woodOptionsKey.className = 'door-wood-options-key mb-16';
                            woodOptionsKey.style.display = 'flex';
                            woodOptionsKey.style.flexDirection = 'column';
                            woodOptionsKey.style.gap = '8px';
                            woodOptionsKey.innerHTML = '<div class="door-wood-key-row mb-8" >' +
                                recBadgeHtml +
                                '<span class="door-wood-key-desc">Our standard wood, a beautiful and durable species offering the best value for the price.</span>' +
                                '</div>' +
                                '<div class="door-wood-key-row">' +
                                premBadgeHtml +
                                '<span class="door-wood-key-desc">Premium woods from our Legacy Heritage collection</span>' +
                                '</div>';
                            woodOptionsBlock.appendChild(woodOptionsKey);

                            section.appendChild(woodOptionsBlock);
                            // Dp end VDN-598 22-10
                        }
                    } catch (e2) { }
                }
            }

            if ((opt.type || '').toLowerCase() === 'select') {
                var optIdLowerSel = String(opt.id || '').toLowerCase();
                var optIdNormSel = normalizeOptionIdKey(opt.id);
                var labelLowerSel = String(opt.label || '').toLowerCase();
                var isScreenTypeSelect = optIdLowerSel === 'screen_type'
                    || optIdLowerSel === 'select_screen';
                var isStormGlassSelect = (labelLowerSel.indexOf('storm') !== -1 && labelLowerSel.indexOf('glass') !== -1)
                    || optIdLowerSel === 'storm_glass_type'
                    || optIdLowerSel === 'storm_glass';
                var sel = document.createElement('select');
                sel.setAttribute('data-option-id', opt.id);
                sel.id = 'door-opt-' + opt.id;
                sel.name = 'attributes[' + (opt.label || opt.id) + ']';
                var optIdLower2 = String(opt.id || '').toLowerCase();
                var labelLower2 = String(opt.label || '').toLowerCase();
                var isWoodSelect2 = optIdLower2.indexOf('wood') !== -1 || labelLower2.indexOf('wood') !== -1;
                var rawOptId2 = String(opt.id || '');
                var safeOptId2 = rawOptId2 ? rawOptId2.replace(/[^a-zA-Z0-9_-]/g, '-') : '';
                var woodTooltipId2 = (isWoodSelect2 && safeOptId2) ? ('door-wood-options-tooltip--' + safeOptId2) : '';

                function normalizeChoiceDescription(d) {
                    try {
                        var out = '';
                        if (!d) return '';
                        if (typeof d === 'string' || typeof d === 'number' || typeof d === 'boolean') out = String(d).trim();
                        else if (typeof d === 'object') {
                            if (typeof d.value === 'string') out = d.value.trim();
                            else if (typeof d.text === 'string') out = d.text.trim();
                            else if (typeof d.label === 'string') out = d.label.trim();
                            else if (typeof d.html === 'string') {
                                var tmp = document.createElement('div');
                                tmp.innerHTML = d.html;
                                out = (tmp.textContent || tmp.innerText || '').trim();
                            } else {
                                for (var i = 0; i < 4; i++) {
                                    var key = ['content', 'description', 'subtext', 'note'][i];
                                    if (d && typeof d[key] === 'string') {
                                        out = d[key].trim();
                                        break;
                                    }
                                }
                            }
                        }
                        return mapCollectionDoorWording(out);
                    } catch (e) { }
                    return '';
                }

                var woodTooltipDefaultText = '';
                if (woodTooltipId2) {
                    woodTooltipDefaultText = normalizeChoiceDescription(opt.description);
                    if (!woodTooltipDefaultText) {
                        (opt.options || []).forEach(function (o) {
                            if (woodTooltipDefaultText) return;
                            var t = normalizeChoiceDescription(o && o.description != null ? o.description : '');
                            if (t) woodTooltipDefaultText = t;
                        });
                    }
                }

                var woodTooltipEl = null;
                if (woodTooltipId2) {
                    woodTooltipEl = document.createElement('div');
                    woodTooltipEl.id = woodTooltipId2;
                    woodTooltipEl.className = 'door-wood-options-tooltip';
                    woodTooltipEl.style.display = 'none';
                    woodTooltipEl.style.marginTop = '0.5rem';
                    woodTooltipEl.style.padding = '0.6rem 0.85rem';
                    woodTooltipEl.style.borderRadius = '6px';
                    woodTooltipEl.style.border = '1px solid #fde68a';
                    woodTooltipEl.style.background = '#fffbeb';
                    woodTooltipEl.style.color = '#713f12';
                    woodTooltipEl.style.fontSize = '0.9rem';
                    woodTooltipEl.style.lineHeight = '1.35';
                    woodTooltipEl.textContent = woodTooltipDefaultText || '';
                }

                var placeholderLabel = opt.placeholder_label || ('Select ' + (opt.label || opt.id));
                var skipEmptyPlaceholder = optionWantsNoneAsDefaultSelect(opt.id);
                if (!skipEmptyPlaceholder) {
                    var placeholder = document.createElement('option');
                    placeholder.value = '';
                    placeholder.textContent = placeholderLabel;
                    sel.appendChild(placeholder);
                }
                var selectChoices = opt.options || [];
                if (String(opt.id || '') === 'door_unit_design' && selectChoices.length > 2) {
                    selectChoices = selectChoices.slice(0, 2); // remove last 2 options
                }
                selectChoices.forEach(function (o) {
                    var op = document.createElement('option');
                    op.value = o.value != null && o.value !== '' ? String(o.value) : '';
                    op.textContent = o.label || o.value || '';
                    if (isWoodSelect2) {
                        op.setAttribute('data-wood-key', normalizeWoodChoiceKey(o.label || o.value || ''));
                    }
                    if (woodTooltipId2 && o && o.description != null) {
                        var choiceDesc = normalizeChoiceDescription(o.description);
                        if (choiceDesc) {
                            op.setAttribute('data-choice-description', choiceDesc);
                            op.title = choiceDesc;
                        }
                    }
                    sel.appendChild(op);
                });
                if (skipEmptyPlaceholder) {
                    // Only set the value here; enhance after the select is placed in the DOM.
                    var noneValEarly = resolveNoneChoiceValueForOption(opt.id, selectChoices);
                    if (noneValEarly) sel.value = noneValEarly;
                }

                // Finish option: show an image preview for the selected choice (if images exist in schema).
                var finishPreviewImg = null;
                if (String(opt.id || '') === 'finish') {
                    try {
                        finishPreviewImg = document.createElement('img');
                        finishPreviewImg.className = 'door-finish-preview-image';
                        finishPreviewImg.alt = '';
                        finishPreviewImg.loading = 'lazy';
                        finishPreviewImg.style.maxWidth = '100%';
                        finishPreviewImg.style.height = 'auto';
                        finishPreviewImg.style.display = 'none';
                        finishPreviewImg.style.marginTop = '0.75rem';

                        function finishImgSrcForValue(val) {
                            var v = String(val == null ? '' : val);
                            for (var fi = 0; fi < selectChoices.length; fi++) {
                                var ch = selectChoices[fi];
                                if (!ch) continue;
                                if (String(ch.value == null ? '' : ch.value) !== v) continue;
                                return resolveChoiceImageSrc(ch) || '';
                            }
                            return '';
                        }

                        function syncFinishPreview() {
                            if (!finishPreviewImg) return;
                            var src = finishImgSrcForValue(sel.value);
                            if (src) {
                                finishPreviewImg.src = src;
                                finishPreviewImg.style.display = 'block';
                            } else {
                                finishPreviewImg.removeAttribute('src');
                                finishPreviewImg.style.display = 'none';
                            }
                        }

                        sel.addEventListener('change', syncFinishPreview);
                        sel.addEventListener('input', syncFinishPreview);
                        // Initial sync (in case a saved config pre-selects it).
                        setTimeout(syncFinishPreview, 0);
                    } catch (eFinishImg) {
                        finishPreviewImg = null;
                    }
                }
                sel.addEventListener('change', updateEstimatedPrice);
                sel.addEventListener('input', updateEstimatedPrice);

                function updateWoodTooltip() {
                    if (!woodTooltipEl) return;
                    try {
                        var selectedOption = sel.options[sel.selectedIndex];
                        var desc = selectedOption ? (selectedOption.getAttribute('data-choice-description') || selectedOption.title || '') : '';
                        woodTooltipEl.textContent = desc || woodTooltipDefaultText || '';
                    } catch (e) { }
                }
                if (woodTooltipEl) {
                    sel.addEventListener('change', updateWoodTooltip);
                    sel.addEventListener('input', updateWoodTooltip);
                    updateWoodTooltip();
                }

                if (opt.unit_label) {
                    var row = document.createElement('div');
                    row.className = 'door-row door-select-row';
                    var lab = document.createElement('label');
                    lab.className = 'door-row-label';
                    lab.textContent = opt.label;
                    lab.setAttribute('for', 'door-opt-' + opt.id);
                    row.appendChild(lab);
                    var inputWrap = document.createElement('div');
                    inputWrap.className = 'door-row-inputs';
                    sel.className = 'door-input-select';
                    inputWrap.appendChild(sel);

                    // If the header/title row isn't rendered, show the button next to the select.
                    if (woodTooltipEl && isRowOnly) {
                        var woodTipBtn2 = document.createElement('button');
                        woodTipBtn2.type = 'button';
                        woodTipBtn2.className = 'inserts-tooltip-btn common-btn btn-secondary btn-small';
                        woodTipBtn2.setAttribute('aria-haspopup', 'dialog');
                        woodTipBtn2.setAttribute('aria-controls', woodTooltipId2);
                        woodTipBtn2.innerHTML = 'About Wood Options <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.03206 4.92901C7.79606 4.92901 7.60406 4.85301 7.45606 4.70101C7.30806 4.54501 7.23406 4.35301 7.23406 4.12501C7.23406 3.90101 7.30806 3.71301 7.45606 3.56101C7.60406 3.40901 7.79606 3.33301 8.03206 3.33301C8.27206 3.33301 8.46606 3.40901 8.61406 3.56101C8.76206 3.71301 8.83606 3.90101 8.83606 4.12501C8.83606 4.35301 8.76206 4.54501 8.61406 4.70101C8.46606 4.85301 8.27206 4.92901 8.03206 4.92901ZM8.68606 6.59101L8.64406 7.64701V11.337L9.51406 11.631V11.859H6.66406V11.631L7.52206 11.337V7.78501C7.47406 7.72501 7.40406 7.66501 7.31206 7.60501C7.22406 7.54501 7.12406 7.48701 7.01206 7.43101C6.90006 7.37501 6.78606 7.32701 6.67006 7.28701V7.08301L8.53006 6.59101H8.68606Z" fill="currentColor"/><circle cx="8" cy="8" r="7.5" stroke="currentColor"/></svg>';
                        woodTipBtn2.addEventListener('click', function (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                            if (!openWoodSpeciesDrawer()) {
                                if (!woodTooltipEl) return;
                                woodTooltipEl.style.display = (woodTooltipEl.style.display === 'none' || !woodTooltipEl.style.display) ? '' : 'none';
                            }
                        });
                        inputWrap.appendChild(woodTipBtn2);
                    }

                    var unitSpan = document.createElement('span');
                    unitSpan.className = 'door-unit-label';
                    unitSpan.textContent = opt.unit_label;
                    inputWrap.appendChild(unitSpan);
                    row.appendChild(inputWrap);
                    section.appendChild(row);
                } else {
                    if ((isScreenTypeSelect || isStormGlassSelect) && Array.isArray(opt.options) && opt.options.length) {
                        var cardWrap = document.createElement('div');
                        cardWrap.className = 'common-check-options';
                        (opt.options || []).forEach(function (o) {
                            var card = document.createElement('label');
                            card.className = 'common-check-option';
                            card.setAttribute('data-choice-value', o.value != null && o.value !== '' ? String(o.value) : '');

                            var radio = document.createElement('input');
                            radio.type = 'radio';
                            radio.name = 'attributes[' + (opt.label || opt.id) + ']';
                            radio.value = o.value != null && o.value !== '' ? String(o.value) : '';
                            radio.setAttribute('data-option-id', opt.id);
                            radio.style.position = 'absolute';
                            radio.style.opacity = '0';
                            radio.style.pointerEvents = 'none';
                            card.appendChild(radio);

                            var imgSrc = resolveChoiceImageSrc(o);
                            if (imgSrc) {
                                var img = document.createElement('img');
                                img.src = imgSrc;
                                img.alt = o.label || o.value || '';
                                img.className = 'common-check-option-image';
                                card.appendChild(img);
                            }

                            var textWrap3 = document.createElement('div');
                            textWrap3.className = 'common-check-option-text';
                            var text3 = document.createElement('span');
                            text3.className = 'common-check-option-label';
                            text3.textContent = o.label || o.value || '';
                            textWrap3.appendChild(text3);
                            if (isScreenTypeSelect) {
                                var choiceDesc = normalizeChoiceDescriptionText(o.description);
                                if (choiceDesc) {
                                    var descEl = document.createElement('span');
                                    descEl.className = 'door-option-desc';
                                    descEl.textContent = choiceDesc;
                                    textWrap3.appendChild(descEl);
                                }
                            }
                            card.appendChild(textWrap3);

                            radio.addEventListener('change', function () {
                                cardWrap.querySelectorAll('.common-check-option').forEach(function (c) { c.classList.remove('common-check-option--selected'); });
                                if (this.checked && this.closest) {
                                    var selectedCard = this.closest('.common-check-option');
                                    if (selectedCard) selectedCard.classList.add('common-check-option--selected');
                                }
                                updateEstimatedPrice();
                            });

                            cardWrap.appendChild(card);
                        });
                        section.appendChild(cardWrap);
                        if (optIdNormSel === 'glass_type' || optIdNormSel === 'storm_glass_type') appendGlassBevelSwitchToSection(section, schema);
                    } else if (isAdditionalOptionsSelectOption(opt.id)) {
                        sel.className = 'door-input-select';
                        try {
                            if (headerRow && sel.parentNode !== headerRow) {
                                headerRow.appendChild(sel);
                            } else {
                                var hdrSel = section.querySelector('.door-option-header-row');
                                if (hdrSel) hdrSel.appendChild(sel);
                                else section.appendChild(sel);
                            }
                        } catch (eAddlSelPlace) {
                            section.appendChild(sel);
                        }
                        if (!section.classList.contains('additional-options-card')) {
                            section.classList.add('additional-options-card');
                        }
                        if (optionWantsNoneAsDefaultSelect(opt.id)) {
                            applyNoneDefaultToSelect(sel, opt.id, selectChoices);
                        }
                        enhanceDoorSelectWithDivDropdown(sel);
                        if (optIdNormSel === 'glass_type' || optIdNormSel === 'storm_glass_type') appendGlassBevelSwitchToSection(section, schema);
                    } else {
                        section.appendChild(sel);
                        if (optIdNormSel === 'glass_type' || optIdNormSel === 'storm_glass_type') appendGlassBevelSwitchToSection(section, schema);
                    }
                }

                if (woodTooltipEl) {
                    section.appendChild(woodTooltipEl);
                }
                if (finishPreviewImg) {
                    section.appendChild(finishPreviewImg);
                }
            } else if ((opt.type || '').toLowerCase() === 'dimension') {
                appendDimensionControlsTo(section, opt, false);
            } else if (opt.type === 'number') {
                var lab = document.createElement('label');
                lab.setAttribute('for', 'door-opt-' + opt.id);
                lab.textContent = opt.label;
                section.appendChild(lab);
                var num = document.createElement('input');
                num.type = 'number';
                num.id = 'door-opt-' + opt.id;
                num.setAttribute('data-option-id', opt.id);
                num.name = 'attributes[' + (opt.label || opt.id) + ']';
                if (opt.min != null) num.min = opt.min;
                if (opt.max != null) num.max = opt.max;
                section.appendChild(num);
            } else if ((opt.type || '').toLowerCase() === 'radio') {
                var radioWrap = document.createElement('div');
                var optIdLowerRadio = String(opt.id || '').toLowerCase();
                var optLabelLowerRadio = String(opt.label || '').toLowerCase();
                var isSelectWoodRadio = optIdLowerRadio.indexOf('wood') !== -1 || optLabelLowerRadio.indexOf('wood') !== -1;
                var isMeasureTypeOpt = isMeasurementTypeOptionId(opt.id);
                var optionsToRender = opt.options || [];
                var optIdNormRadio = String(opt && opt.id != null ? opt.id : '').toLowerCase().replace(/-/g, '_');
                var shouldRenderMainRadioCards = optIdNormRadio !== 'door_sweep' && optIdNormRadio !== 'door_seal_kit';
                var doorUnitSetupChoices = [];
                if (isMeasureTypeOpt) {
                    optionsToRender = buildMeasurementTypeTabOptionList(opt, schema, container);
                }
                if (String(opt.id || '') === 'door_unit_design' && optionsToRender.length > 2) {
                    optionsToRender = optionsToRender.slice(0, 2); // remove last 2 options
                }
                if (optionIsPanelUnitDesign(opt) && optionsToRender.length > 2) {
                    optionsToRender = optionsToRender.slice(0, 2);
                }
                if (optIdNormRadio === 'door_unit_design') {
                    doorUnitSetupChoices = getPreHungDoorSetupChoices(schema);
                }

                // Door Sweep / Door Stops with Seals: render as <select> in the header row
                // (not card radios). Default to "No …"; no empty "Select …" placeholder.
                if (optIdNormRadio === 'door_sweep' || optIdNormRadio === 'door_seal_kit') {
                    var sweepSel = document.createElement('select');
                    sweepSel.setAttribute('data-option-id', opt.id);
                    sweepSel.id = 'door-opt-' + opt.id;
                    sweepSel.name = 'attributes[' + (opt.label || opt.id) + ']';
                    sweepSel.className = 'door-input-select';

                    (optionsToRender || []).forEach(function (o) {
                        var op = document.createElement('option');
                        op.value = o.value != null && o.value !== '' ? String(o.value) : '';
                        op.textContent = o.label || o.value || '';
                        sweepSel.appendChild(op);
                    });

                    sweepSel.addEventListener('change', updateEstimatedPrice);
                    sweepSel.addEventListener('input', updateEstimatedPrice);
                    try {
                        sweepSel.addEventListener('change', updateDoorPreview);
                        sweepSel.addEventListener('input', updateDoorPreview);
                    } catch (eSweepPreview) { }

                    // Put select in the header row first, then enhance (div UI needs a parent).
                    try {
                        if (headerRow && sweepSel.parentNode !== headerRow) {
                            headerRow.appendChild(sweepSel);
                        } else {
                            section.appendChild(sweepSel);
                        }
                    } catch (eSweepPlace) {
                        section.appendChild(sweepSel);
                    }
                    if (!section.classList.contains('additional-options-card')) {
                        section.classList.add('additional-options-card');
                    }
                    applyNoneDefaultToSelect(sweepSel, opt.id, optionsToRender);
                    enhanceDoorSelectWithDivDropdown(sweepSel);
                } else {
                    var isMeasurementTabsRadio = measurementMethodRadio({ type: 'radio', options: optionsToRender })
                        || (isMeasureTypeOpt && optionsToRender.length >= 2);
                    var measureTypeStaticWrap = null;
                    var panelIntroEl = null;
                    var checkedMeasure = null;
                    radioWrap.className = 'common-check-options' + (isSelectWoodRadio ? ' select-wood-options' : '') + (isMeasurementTabsRadio ? ' door-measure-tabs' : '') + (optIdNormRadio === 'swing_direction' || optIdNormRadio === 'panel_profile' || optIdNormRadio === 'stile_and_rail_profile' || optIdNormRadio === 'applied_molding' || optIdNormRadio === 'sdl_profile' ? ' grid-4' : '');
                    var preHungRadioWrap = null;
                    var optionCardsToRender = optionsToRender;
                    if (optIdNormRadio === 'door_unit_design' && doorUnitSetupChoices.length) {
                        preHungRadioWrap = document.createElement('div');
                        preHungRadioWrap.className = 'common-check-options mt-18' + (isSelectWoodRadio ? ' select-wood-options' : '');
                        optionCardsToRender = doorUnitSetupChoices.concat(optionsToRender);
                    }
                    if (optionIsPanelUnitDesign(opt)) {
                        var panelOrderPrompt = document.createElement('p');
                        panelOrderPrompt.className = 'door-panel-unit-order-prompt p-medium fw-600 primaryFont mb-16';
                        var panelPromptText = '';
                        if (opt.description) {
                            var panelPromptDesc = typeof opt.description === 'string' ? opt.description : (opt.description && (opt.description.value || opt.description.text)) || '';
                            panelPromptText = String(panelPromptDesc || '').trim();
                        }
                        panelOrderPrompt.textContent = panelPromptText || 'How would you like to order your Porch Panels?';
                        section.appendChild(panelOrderPrompt);
                    }
                    // --- Dp start 16-07  ---
                    var screenInsertsFirstDefaultApplied = false;
                    var locksetNoPrepDefaultApplied = false;
                    // --- Dp end 16-07  ---

                    // Dp start 21-10 — dynamic default choice resolution (works for any wood or option type)
                    var optIdNormForTag = String(opt.id || '').toLowerCase().replace(/-/g, '_');
                    var defValForOpt = getDefaultSelectionForOption(opt.id) || getDefaultSelectionForOption(optIdNormForTag) || '';
                    var targetDefaultChoiceKey = '';
                    if (defValForOpt) {
                        targetDefaultChoiceKey = normalizeChoiceKey(defValForOpt);
                    } else if (optionCardsToRender && optionCardsToRender.length) {
                        // If no explicit configurator_defaults metafield, the very first choice is the default
                        var firstChoiceObj = optionCardsToRender[0];
                        targetDefaultChoiceKey = normalizeChoiceKey(firstChoiceObj.value || firstChoiceObj.label || '');
                    }

                    // Pre-scan option cards to find uploaded recommended and premium tag image URLs
                    var recommendedTagUrl = '';
                    var premiumTagUrl = '';
                    if (optionCardsToRender && optionCardsToRender.length) {
                        optionCardsToRender.forEach(function (chkOpt) {
                            var rawChk = chkOpt.add_tag || chkOpt.addTag || chkOpt['add_tag'] || chkOpt['Add Tag'] || chkOpt['add-tag'] || '';
                            var chkUrl = '';
                            if (typeof rawChk === 'string') {
                                chkUrl = rawChk;
                            } else if (rawChk && typeof rawChk === 'object') {
                                chkUrl = rawChk.url || (rawChk.value && (rawChk.value.url || (typeof rawChk.value === 'string' ? rawChk.value : ''))) || rawChk.src || (rawChk.preview_image && (rawChk.preview_image.url || rawChk.preview_image)) || '';
                            }
                            if (chkUrl) {
                                var chkLower = chkUrl.toLowerCase();
                                if (chkLower.indexOf('recommend') !== -1 && !recommendedTagUrl) {
                                    recommendedTagUrl = chkUrl;
                                }
                                if (chkLower.indexOf('premium') !== -1 && !premiumTagUrl) {
                                    premiumTagUrl = chkUrl;
                                }
                            }
                        });
                        if (!recommendedTagUrl && premiumTagUrl && premiumTagUrl.toLowerCase().indexOf('premium') !== -1) {
                            recommendedTagUrl = premiumTagUrl.replace(/premium/gi, 'recommended');
                        }
                        if (!premiumTagUrl && recommendedTagUrl && recommendedTagUrl.toLowerCase().indexOf('recommend') !== -1) {
                            premiumTagUrl = recommendedTagUrl.replace(/recommend(ed)?/gi, 'premium');
                        }
                        if (recommendedTagUrl) recommendedTagUrl = dpLiveWoodFlagSrc(recommendedTagUrl);
                        if (premiumTagUrl) premiumTagUrl = dpLiveWoodFlagSrc(premiumTagUrl);
                    }
                    // Dp end 21-10

                    // Dp start VDN-598 Q.A changes 21-10
                    // Recommended is not the same as default: the default choice still renders first,
                    // but the Recommended tag stays on the choice whose own add_tag is the recommended
                    // image (e.g. African Mahogany). Fallback: first choice in metaobject order.
                    // Recommended cards = every choice whose own add_tag (backend) is the recommended image
                    // + African Mahogany for wood (always Recommended, with or without a tag image).
                    // If neither exists, the first choice in metaobject order stays Recommended.
                    var dpChoiceOwnTagUrl = function (c) {
                        if (!c) return '';
                        var raw = c.add_tag || c.addTag || c['add_tag'] || c['Add Tag'] || c['add-tag'] || '';
                        if (typeof raw === 'string') return raw;
                        if (raw && typeof raw === 'object') {
                            return raw.url || (raw.value && (raw.value.url || (typeof raw.value === 'string' ? raw.value : ''))) || raw.src || (raw.preview_image && (raw.preview_image.url || raw.preview_image)) || '';
                        }
                        return '';
                    };
                    var dpChoiceHasOwnRecommendedTag = function (c) {
                        return String(dpChoiceOwnTagUrl(c) || '').toLowerCase().indexOf('recommend') !== -1;
                    };
                    var dpRecommendedChoice = null;
                    var dpRecommendedChoices = [];
                    if ((recommendedTagUrl || premiumTagUrl || isSelectWoodRadio) && optionCardsToRender && optionCardsToRender.length) {
                        for (var rci = 0; rci < optionCardsToRender.length; rci++) {
                            var rco = optionCardsToRender[rci];
                            if (!rco) continue;
                            var rcoIsAfricanMahogany = isSelectWoodRadio
                                && normalizeWoodChoiceKey(rco.label || rco.value || '').indexOf('african_mahogany') !== -1;
                            if (dpChoiceHasOwnRecommendedTag(rco) || rcoIsAfricanMahogany) {
                                dpRecommendedChoices.push(rco);
                            }
                        }
                        if (!dpRecommendedChoices.length && (recommendedTagUrl || premiumTagUrl)) {
                            dpRecommendedChoices.push(optionCardsToRender[0]);
                        }
                        dpRecommendedChoice = dpRecommendedChoices[0] || null;
                    }
                    // Dp end VDN-598 Q.A changes 21-10

                    // Dp start VDN-598 Q.A changes 21-10
                    // Tagged options (e.g. wood): the configurator_defaults choice renders first and stays
                    // the selected default. The Recommended tag is driven by dpRecommendedChoice, not position.
                    // Dp end VDN-598 Q.A changes 21-10
                    if (defValForOpt && (recommendedTagUrl || premiumTagUrl) && optionCardsToRender.length > 1) {
                        var defaultCardIdx = -1;
                        for (var dci = 0; dci < optionCardsToRender.length; dci++) {
                            var dco = optionCardsToRender[dci];
                            if (!dco) continue;
                            if (
                                normalizeChoiceKey(dco.value) === targetDefaultChoiceKey
                                || normalizeChoiceKey(dco.label) === targetDefaultChoiceKey
                                || defaultSelectionValuesMatch(opt.id, defValForOpt, dco.value)
                            ) {
                                defaultCardIdx = dci;
                                break;
                            }
                        }
                        if (defaultCardIdx > 0) {
                            optionCardsToRender = [optionCardsToRender[defaultCardIdx]].concat(
                                optionCardsToRender.slice(0, defaultCardIdx),
                                optionCardsToRender.slice(defaultCardIdx + 1)
                            );
                        }
                    }

                    // Dp start VDN-598 27-10
                    if (isSelectWoodRadio && optionCardsToRender && optionCardsToRender.length > 1) {
                        optionCardsToRender = dpWoodChoicesDefaultFirst(opt, optionCardsToRender);
                    }
                    // Dp end VDN-598 27-10

                    // Dp start VDN-598 22-10
                    optionCardsToRender.forEach(function (o, oIdx) {
                        // Dp end VDN-598 22-10
                        var hideMeasureTabExtras = isMeasurementTabsRadio && isMeasureTypeOpt;
                        var renderOptionId = o && o._renderOptionId ? String(o._renderOptionId) : String(opt.id || '');
                        var renderOptionLabel = o && o._renderOptionLabel ? String(o._renderOptionLabel) : String(opt.label || opt.id || '');
                        var cardOwnerWrap = (preHungRadioWrap && o && o._renderOptionId) ? preHungRadioWrap : radioWrap;
                        var card = document.createElement('label');
                        card.className = 'common-check-option'
                            + (String(opt.id || '') === 'sidelight_style' ? ' sidelight-style-option' : '')
                            + (isSelectWoodRadio ? ' select-wood-option' : '')
                            + (isMeasurementTabsRadio ? ' door-measure-tab' : '');
                        if (o.measureVis && isMeasureTypeOpt) {
                            card.setAttribute('data-measure-vis', o.measureVis);
                        }
                        card.setAttribute('data-choice-value', o.value != null && o.value !== '' ? String(o.value) : '');
                        if (isSelectWoodRadio) {
                            card.setAttribute('data-wood-key', normalizeWoodChoiceKey(o.label || o.value || ''));
                            card.setAttribute('data-select-wood-option', '1');
                        }
                        var radio = document.createElement('input');
                        radio.type = 'radio';
                        radio.name = 'attributes[' + renderOptionLabel + ']';
                        radio.value = o.value != null && o.value !== '' ? String(o.value) : '';
                        radio.setAttribute('data-option-id', renderOptionId);
                        radio.style.position = 'absolute';
                        radio.style.opacity = '0';
                        if (!isMeasurementTabsRadio) radio.style.pointerEvents = 'none';

                        // --- Dp start 16-07  ---
                        if (optionIsScreenAndStormInserts(opt) && !doorRestorePending() && !screenInsertsFirstDefaultApplied) {
                            radio.checked = true;
                            card.classList.add('common-check-option--selected');
                            screenInsertsFirstDefaultApplied = true;
                        }
                        if (optionIsLocksetPrep(opt) && !doorRestorePending() && !locksetNoPrepDefaultApplied) {
                            var locksetChoiceKey = normalizeChoiceKey(o.value);
                            var locksetDef = getDefaultSelectionForOption('lockset_prep');
                            var wantLocksetKey = (locksetDef != null && String(locksetDef).trim() !== '')
                                ? normalizeChoiceKey(locksetDef)
                                : 'no_lock_prep';
                            if (locksetChoiceKey === wantLocksetKey) {
                                radio.checked = true;
                                card.classList.add('common-check-option--selected');
                                locksetNoPrepDefaultApplied = true;
                            }
                        }
                        // --- Dp end 16-07  ---

                        card.appendChild(radio);
                        // Door unit design *style* cards stay text-only. Embedded Door Setup rows use
                        // o._renderOptionId (e.g. pre_hung) — those must still show choice thumbnails.
                        var skipDoorUnitDesignThumb = (String(opt.id || '') === 'door_unit_design' || optionIsPanelUnitDesign(opt)) && !o._renderOptionId;
                        if (!hideMeasureTabExtras && !skipDoorUnitDesignThumb) {
                            var thumbSrc = resolveChoiceImageSrc(o);
                            if (!thumbSrc && o.image) {
                                thumbSrc = typeof o.image === 'string' ? o.image : (o.image && (o.image.url || o.image.src)) || '';
                            }
                            if (thumbSrc) {
                                var img = document.createElement('img');
                                img.src = thumbSrc;
                                img.alt = o.label || o.value || '';
                                img.className = 'common-check-option-image';
                                card.appendChild(img);
                            }
                        }

                        // Dp start 16-10 — render add_tag image tag from config_choice metaobject
                        var rawTag2 = o.add_tag || o.addTag || o['add_tag'] || o['Add Tag'] || o['add-tag'] || '';
                        var tagImgSrc2 = '';
                        if (typeof rawTag2 === 'string') {
                            tagImgSrc2 = rawTag2;
                        } else if (rawTag2 && typeof rawTag2 === 'object') {
                            tagImgSrc2 = rawTag2.url || (rawTag2.value && (rawTag2.value.url || (typeof rawTag2.value === 'string' ? rawTag2.value : ''))) || rawTag2.src || (rawTag2.preview_image && (rawTag2.preview_image.url || rawTag2.preview_image)) || '';
                        }

                        // Dp start VDN-598 Q.A changes 21-10
                        // var dpIsRecommendedCard = dpRecommendedChoice ? (o === dpRecommendedChoice) : (oIdx === 0);
                        var dpIsRecommendedCard = dpRecommendedChoices.length
                            ? (dpRecommendedChoices.indexOf(o) !== -1)
                            : (oIdx === 0);
                        // Dp end VDN-598 Q.A changes 21-10
                        // Dp start 21-10 — first item must be Recommended, rest must be Premium
                        // Dp start VDN-598 Q.A changes 21-10
                        // if (oIdx === 0) {
                        if (dpIsRecommendedCard) {
                            // Dp end VDN-598 Q.A changes 21-10
                            // If first item has premium tag or if recommendedTagUrl is available, ensure it uses Recommended tag
                            if (recommendedTagUrl) {
                                tagImgSrc2 = recommendedTagUrl;
                            } else if (tagImgSrc2 && tagImgSrc2.toLowerCase().indexOf('premium') !== -1) {
                                tagImgSrc2 = tagImgSrc2.replace(/premium/gi, 'recommended');
                            }
                        } else {
                            // Remaining items: if it mistakenly has recommended tag image, revert/reset to premium tag
                            if (tagImgSrc2) {
                                if (tagImgSrc2.toLowerCase().indexOf('recommend') !== -1) {
                                    if (premiumTagUrl) {
                                        tagImgSrc2 = premiumTagUrl;
                                    } else {
                                        tagImgSrc2 = tagImgSrc2.replace(/recommend(ed)?/gi, 'premium');
                                    }
                                }
                            }
                        }

                        if (tagImgSrc2 && !hideMeasureTabExtras) {
                            // Dp start VDN-598 Q.A changes 21-10
                            // var isRecommended = (oIdx === 0);
                            var isRecommended = dpIsRecommendedCard;
                            // Dp end VDN-598 Q.A changes 21-10
                            tagImgSrc2 = isRecommended ? DP_LIVE_RECOMMENDED_FLAG : DP_LIVE_PREMIUM_FLAG;
                            var tagImg2 = document.createElement('img');
                            tagImg2.src = tagImgSrc2;
                            tagImg2.alt = 'Tag';
                            tagImg2.className = 'common-check-option-tag-image';
                            if (isRecommended) {
                                tagImg2.classList.add('common-check-option-tag-image--recommended');
                            } else {
                                tagImg2.classList.add('common-check-option-tag-image--premium');
                            }
                            card.appendChild(tagImg2);
                        }
                        // Dp start VDN-598 Q.A changes 21-10
                        // No tag image in metafield: still show Recommended on the recommended wood card.
                        else if (dpIsRecommendedCard && isSelectWoodRadio && !hideMeasureTabExtras) {
                            var dpRecBadge = document.createElement('span');
                            dpRecBadge.className = 'door-wood-badge door-wood-badge--recommended common-check-option-tag-image common-check-option-tag-image--recommended';
                            dpRecBadge.textContent = 'Recommended';
                            card.appendChild(dpRecBadge);
                        }
                        // Dp end VDN-598 Q.A changes 21-10
                        // Dp end 16-10
                        var textWrap2 = document.createElement('div');
                        textWrap2.className = 'common-check-option-text';

                        var text = document.createElement('span');
                        text.className = 'common-check-option-label';
                        text.textContent = hideMeasureTabExtras ? displayLabelForMeasurementTabChoice(o) : (o.label || o.value || '');
                        textWrap2.appendChild(text);

                        if (o.description && !hideMeasureTabExtras) {
                            var desc = document.createElement('span');
                            desc.className = 'common-check-option-desc';

                            var d = o.description;
                            var descText = '';
                            if (typeof d === 'string' || typeof d === 'number' || typeof d === 'boolean') {
                                descText = String(d);
                            } else if (d && typeof d === 'object') {
                                if (typeof d.value === 'string') descText = d.value;
                                else if (typeof d.text === 'string') descText = d.text;
                                else if (typeof d.label === 'string') descText = d.label;
                                else if (typeof d.html === 'string') {
                                    var tmp = document.createElement('div');
                                    tmp.innerHTML = d.html;
                                    descText = tmp.textContent || tmp.innerText || '';
                                } else {
                                    ['content', 'description', 'subtext', 'note'].forEach(function (k) {
                                        if (!descText && d && typeof d[k] === 'string') descText = d[k];
                                    });
                                }
                            }
                            descText = descText.trim();
                            if (descText) {
                                descText = mapCollectionDoorWording(descText);
                                desc.textContent = descText;
                                textWrap2.appendChild(desc);
                                try { card.setAttribute('data-choice-description', descText); } catch (eSetChoiceDesc) { }
                            }
                        }
                        card.appendChild(textWrap2);
                        if (isMeasurementTabsRadio && isMeasureTypeOpt) {
                            card.addEventListener('click', function (e) {
                                if (e && e.target && e.target.closest) {
                                    if (e.target.closest('select') || e.target.closest('.door-div-select') || e.target.closest('.door-div-select__list')) return;
                                }
                                var measureTabWasChecked = radio.checked;
                                radio.checked = true;
                                applyMeasurementTypeTabSelection(radio, opt.id, container, doorConfigSchema);
                                if (!measureTabWasChecked) {
                                    try {
                                        if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.resetPetGatesMeasurementOnTabChange === 'function') {
                                            window.DoorConf2Measurements.resetPetGatesMeasurementOnTabChange(radio);
                                        }
                                    } catch (ePetTabReset) { }
                                }
                                try { updateEstimatedPrice(); } catch (eMeasTabPrice) { }
                            });
                        }
                        radio.addEventListener('change', function () {
                            if (optionIsPanelProfile(opt) || optionIsStileAndRailProfile(opt)) {
                                section.querySelectorAll('input[type="radio"][data-option-id="' + renderOptionId + '"]').forEach(function (ri) {
                                    var cAll = ri.closest && ri.closest('.common-check-option');
                                    if (cAll) cAll.classList.remove('common-check-option--selected');
                                });
                            } else {
                                cardOwnerWrap.querySelectorAll('.common-check-option').forEach(function (c) { c.classList.remove('common-check-option--selected'); });
                            }
                            if (this.checked && this.closest) {
                                var selCard = this.closest('.common-check-option');
                                if (selCard) selCard.classList.add('common-check-option--selected');
                            }
                            if (isMeasurementTabsRadio && isMeasureTypeOpt) {
                                applyMeasurementTypeTabSelection(this, opt.id, container, doorConfigSchema);
                                try {
                                    if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.resetPetGatesMeasurementOnTabChange === 'function') {
                                        window.DoorConf2Measurements.resetPetGatesMeasurementOnTabChange(this);
                                    }
                                } catch (ePetTabResetChange) { }
                            } else if (isMeasurementTabsRadio) {
                                var modeFromClick = measurementModeFromCheckedTab(this, container, doorConfigSchema);
                                syncMeasurementTabVisibility(modeFromClick, opt.id);
                                if (panelIntroEl) panelIntroEl.classList.remove('door-hidden');
                            }
                            if (optionIsPanelUnitDesign(opt)) {
                                syncPanelUnitDesignMeasurements(section, opt.id);
                            }
                            if (optionIsStileAndRailProfile(opt)) {
                                try {
                                    promoteSelectedProfileToHero(container, { collapseAccordion: true });
                                } catch (eStileHeroSwap) { }
                                try { updateDoorPreview(); } catch (eStilePrev) { }
                                try { scheduleSdlProfileVisibilitySync(container); } catch (eSdlStile) { }
                            } else if (optionIsPanelProfile(opt)) {
                                try {
                                    promoteSelectedProfileToHero(container, { collapseAccordion: true });
                                } catch (ePanelHeroSwap) { }
                                updateEstimatedPrice();
                            } else {
                                updateEstimatedPrice();
                            }
                        });
                        cardOwnerWrap.appendChild(card);
                    });
                    // Panel Profile: wrap the radio grid in the same accordion design used for
                    // Screen & Storm Inserts "Additional Options" (same classes + plus/minus toggle).
                    try {
                        if (optionIsPanelProfile(opt) || optionIsStileAndRailProfile(opt)) {
                            var isStileRail = optionIsStileAndRailProfile(opt);
                            var heroClass = isStileRail ? 'door-stile-rail-hero' : 'door-panel-profile-hero';
                            var primaryClass = isStileRail ? 'common-check-options door-stile-rail-primary-option' : 'common-check-options door-panel-profile-primary-option';
                            var contentClass = isStileRail ? 'door-stile-rail-primary-content' : 'door-panel-profile-primary-content';
                            var sectionDescClass = isStileRail ? 'door-stile-rail-section-desc' : 'door-panel-profile-section-desc';
                            var choiceDescClass = isStileRail ? 'door-stile-rail-choice-desc' : 'door-panel-profile-choice-desc';
                            var accordionClass = isStileRail
                                ? 'door-option-accordion door-inserts-additional-options-accordion door-stile-rail-accordion'
                                : 'door-option-accordion door-inserts-additional-options-accordion door-panel-profile-accordion';
                            var accordionTitle = isStileRail ? 'Additional Stile and Rail Profile Options' : 'Additional Panel Profile Options';

                            var panelHero = document.createElement('div');
                            panelHero.className = heroClass;

                            var panelPrimaryWrap = document.createElement('div');
                            panelPrimaryWrap.className = primaryClass;
                            // ===== DEFAULT OPTIONS (custom.configurator_defaults metafield) - START =====
                            // If a default (product/collection) is configured for this option and the
                            // matching choice currently lives inside the accordion, promote it to the
                            // hero/first position so the default (e.g. Craftsman) shows up top instead
                            // of the standard first choice (e.g. Quarter Bead). Only stile/panel profile.
                            try {
                                var _heroDefVal = getDefaultSelectionForOption(opt.id);
                                if (_heroDefVal != null && _heroDefVal !== '') {
                                    var _heroCards = radioWrap.querySelectorAll('.common-check-option');
                                    var _heroMatch = null;
                                    for (var _hci = 0; _hci < _heroCards.length; _hci++) {
                                        var _hc = _heroCards[_hci];
                                        var _hcVal = _hc.getAttribute('data-choice-value') || '';
                                        if (!_hcVal) {
                                            var _hcInp = _hc.querySelector('input[data-option-id]');
                                            _hcVal = _hcInp ? (_hcInp.value || '') : '';
                                        }
                                        if (defaultSelectionValuesMatch(opt.id, _heroDefVal, _hcVal)) {
                                            _heroMatch = _hc;
                                            break;
                                        }
                                    }
                                    if (_heroMatch && radioWrap.firstElementChild !== _heroMatch) {
                                        radioWrap.insertBefore(_heroMatch, radioWrap.firstElementChild);
                                    }
                                }
                            } catch (eHeroDefault) { }
                            // ===== DEFAULT OPTIONS (custom.configurator_defaults metafield) - END =====
                            var firstPanelCard = radioWrap.firstElementChild;
                            if (firstPanelCard) {
                                panelPrimaryWrap.appendChild(firstPanelCard);
                                panelHero.appendChild(panelPrimaryWrap);
                            }

                            var panelRight = document.createElement('div');
                            panelRight.className = contentClass;
                            var sectionDesc = '';
                            if (opt.description) {
                                if (typeof opt.description === 'string') {
                                    sectionDesc = opt.description.trim();
                                } else {
                                    sectionDesc = normalizeChoiceDescriptionText(opt.description);
                                }
                            }
                            if (sectionDesc) {
                                var sectionDescP = document.createElement('p');
                                sectionDescP.className = 'door-option-desc ' + sectionDescClass;
                                setDoorOptionDescriptionText(sectionDescP, sectionDesc);
                                panelRight.appendChild(sectionDescP);
                            }
                            // Render the selected-choice description for BOTH Panel Profile and
                            // Stile and Rail Profile so the two sections look/behave identically.
                            var panelChoiceDesc = (firstPanelCard && firstPanelCard.getAttribute) ? (firstPanelCard.getAttribute('data-choice-description') || '').trim() : '';
                            panelChoiceDesc = mapCollectionDoorWording(panelChoiceDesc);
                            var panelRightP = document.createElement('p');
                            panelRightP.className = choiceDescClass;
                            panelRightP.textContent = panelChoiceDesc;
                            if (!panelChoiceDesc) panelRightP.style.display = 'none';
                            panelRight.appendChild(panelRightP);
                            panelHero.appendChild(panelRight);
                            section.appendChild(panelHero);
                            var ppAccordion = document.createElement('div');
                            ppAccordion.className = accordionClass;
                            var ppOuter = document.createElement('div');
                            ppOuter.className = 'door-inserts-additional-options screen-and-storm-inserts';

                            var ppBtn = document.createElement('button');
                            ppBtn.type = 'button';
                            ppBtn.className = 'door-accordion-header door-inserts-additional-options-title ';

                            var ppHeaderRow = document.createElement('div');
                            ppHeaderRow.className = 'door-option-header-row';

                            var ppHeaderText = document.createElement('div');
                            ppHeaderText.className = 'door-accordion-header-text';
                            ppHeaderText.textContent = accordionTitle;
                            ppHeaderRow.appendChild(ppHeaderText);
                            ppBtn.appendChild(ppHeaderRow);

                            var ppPlusSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
                                '<rect x="7" width="2" height="16" rx="1" fill="currentColor"></rect>' +
                                '<rect x="16" y="7" width="2" height="16" rx="1" transform="rotate(90 16 7)" fill="currentColor"></rect>' +
                                '</svg>';
                            var ppMinusSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
                                '<rect x="0" y="7" width="16" height="2" rx="1" fill="currentColor"></rect>' +
                                '</svg>';

                            var ppSign = document.createElement('span');
                            ppSign.className = 'door-accordion-sign';
                            ppSign.innerHTML = ppPlusSvg;
                            ppBtn.appendChild(ppSign);

                            var ppBody = document.createElement('div');
                            ppBody.className = 'door-accordion-body';
                            ppBody.appendChild(radioWrap);

                            ppBtn.addEventListener('click', function () {
                                var opened = ppBody.classList.toggle('door-accordion-body--open');
                                ppSign.innerHTML = opened ? ppMinusSvg : ppPlusSvg;
                            });
                            var hasAdditionalOptions = !!(radioWrap.children && radioWrap.children.length > 0);
                            if (isStileRail) {
                                if (hasAdditionalOptions) {
                                    ppAccordion.appendChild(ppBtn);
                                    ppAccordion.appendChild(ppBody);
                                    ppOuter.appendChild(ppAccordion);
                                    section.appendChild(ppOuter);
                                }
                            } else if (optionIsPanelProfile(opt)) {
                                if (hasAdditionalOptions) {
                                    ppAccordion.appendChild(ppBtn);
                                    ppAccordion.appendChild(ppBody);
                                    ppOuter.appendChild(ppAccordion);
                                    section.appendChild(ppOuter);
                                }
                            }
                        } else {
                            if (shouldRenderMainRadioCards) {
                                if (preHungRadioWrap) {
                                    var preHungSection = document.createElement('div');
                                    preHungSection.className = 'door-section door-option-wrap';
                                    preHungSection.setAttribute('data-option-id', 'pre_hung');
                                    preHungSection.appendChild(preHungRadioWrap);
                                    deferredDoorSetupWrap = preHungSection;
                                }
                                // --- Dp start 14-07  ---
                                if (optionIsAppliedMolding(opt)) {
                                    var amAccordion = document.createElement('div');
                                    amAccordion.className = 'door-option-accordion door-inserts-additional-options-accordion door-stile-rail-accordion';

                                    var amOuter = document.createElement('div');
                                    amOuter.className = 'door-inserts-additional-options screen-and-storm-inserts';

                                    var amBtn = document.createElement('button');
                                    amBtn.type = 'button';
                                    amBtn.className = 'door-accordion-header door-inserts-additional-options-title';

                                    var amHeaderRow = document.createElement('div');
                                    amHeaderRow.className = 'door-option-header-row';

                                    var amHeaderText = document.createElement('div');
                                    amHeaderText.className = 'door-accordion-header-text';
                                    amHeaderText.textContent = opt.label || 'Choose your Applied Molding';
                                    amHeaderRow.appendChild(amHeaderText);
                                    amBtn.appendChild(amHeaderRow);

                                    var amPlusSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
                                        '<rect x="7" width="2" height="16" rx="1" fill="currentColor"></rect>' +
                                        '<rect x="16" y="7" width="2" height="16" rx="1" transform="rotate(90 16 7)" fill="currentColor"></rect>' +
                                        '</svg>';
                                    var amMinusSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
                                        '<rect x="0" y="7" width="16" height="2" rx="1" fill="currentColor"></rect>' +
                                        '</svg>';

                                    var amSign = document.createElement('span');
                                    amSign.className = 'door-accordion-sign';
                                    /* MERGE: product_wise_applied_molding_accordion — start */
                                    // Start collapsed; user opens to see RM5 / molding choices.
                                    amSign.innerHTML = amPlusSvg;
                                    /* MERGE: product_wise_applied_molding_accordion — end */
                                    amBtn.appendChild(amSign);

                                    var amBody = document.createElement('div');
                                    /* MERGE: product_wise_applied_molding_accordion — start */
                                    amBody.className = 'door-accordion-body';
                                    /* MERGE: product_wise_applied_molding_accordion — end */
                                    amBody.appendChild(radioWrap);

                                    amBtn.addEventListener('click', function () {
                                        var opened = amBody.classList.toggle('door-accordion-body--open');
                                        amSign.innerHTML = opened ? amMinusSvg : amPlusSvg;
                                    });

                                    amAccordion.appendChild(amBtn);
                                    amAccordion.appendChild(amBody);
                                    amOuter.appendChild(amAccordion);
                                    section.appendChild(amOuter);
                                } else {
                                    section.appendChild(radioWrap);
                                }
                                // --- Dp end 14-07  ---
                            }
                        }
                    } catch (ePanelProfileAccordion) {
                        if (shouldRenderMainRadioCards) {
                            if (preHungRadioWrap) {
                                var preHungSection2 = document.createElement('div');
                                preHungSection2.className = 'door-section door-option-wrap';
                                preHungSection2.setAttribute('data-option-id', 'pre_hung');
                                preHungSection2.appendChild(preHungRadioWrap);
                                deferredDoorSetupWrap = preHungSection2;
                            }
                            // --- Dp start 14-07  ---
                            if (optionIsAppliedMolding(opt)) {
                                var amAccordion = document.createElement('div');
                                amAccordion.className = 'door-option-accordion door-inserts-additional-options-accordion door-stile-rail-accordion';

                                var amOuter = document.createElement('div');
                                amOuter.className = 'door-inserts-additional-options screen-and-storm-inserts';

                                var amBtn = document.createElement('button');
                                amBtn.type = 'button';
                                amBtn.className = 'door-accordion-header door-inserts-additional-options-title';

                                var amHeaderRow = document.createElement('div');
                                amHeaderRow.className = 'door-option-header-row';

                                var amHeaderText = document.createElement('div');
                                amHeaderText.className = 'door-accordion-header-text';
                                amHeaderText.textContent = opt.label || 'Choose your Applied Molding';
                                amHeaderRow.appendChild(amHeaderText);
                                amBtn.appendChild(amHeaderRow);

                                var amPlusSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
                                    '<rect x="7" width="2" height="16" rx="1" fill="currentColor"></rect>' +
                                    '<rect x="16" y="7" width="2" height="16" rx="1" transform="rotate(90 16 7)" fill="currentColor"></rect>' +
                                    '</svg>';
                                var amMinusSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
                                    '<rect x="0" y="7" width="16" height="2" rx="1" fill="currentColor"></rect>' +
                                    '</svg>';

                                var amSign = document.createElement('span');
                                amSign.className = 'door-accordion-sign';
                                /* MERGE: product_wise_applied_molding_accordion — start */
                                amSign.innerHTML = amPlusSvg;
                                /* MERGE: product_wise_applied_molding_accordion — end */
                                amBtn.appendChild(amSign);

                                var amBody = document.createElement('div');
                                /* MERGE: product_wise_applied_molding_accordion — start */
                                amBody.className = 'door-accordion-body';
                                /* MERGE: product_wise_applied_molding_accordion — end */
                                amBody.appendChild(radioWrap);

                                amBtn.addEventListener('click', function () {
                                    var opened = amBody.classList.toggle('door-accordion-body--open');
                                    amSign.innerHTML = opened ? amMinusSvg : amPlusSvg;
                                });

                                amAccordion.appendChild(amBtn);
                                amAccordion.appendChild(amBody);
                                amOuter.appendChild(amAccordion);
                                section.appendChild(amOuter);
                            } else {
                                section.appendChild(radioWrap);
                            }
                            // --- Dp end 14-07  ---
                        }
                    }

                    if (optionIsPanelUnitDesign(opt)) {
                        mountPanelUnitEnclosureMeasurements(section);
                        mountPanelUnitIndividualMeasurements(section);
                        syncPanelUnitDesignMeasurements(section, opt.id);
                    }

                    if (optIdNormRadio === 'glass_type' || optIdNormRadio === 'storm_glass_type') appendGlassBevelSwitchToSection(section, schema);
                }

                // Door Sweep section: "Choose Swing Direction" uses the same choices as the dynamic swing_direction option (metaobject).
                try {
                    var optIdNorm = String(opt && opt.id != null ? opt.id : '').toLowerCase().replace(/-/g, '_');
                    if (optIdNorm === 'door_sweep') {
                        var swingOptEmbed = findSwingDirectionOption(schema);
                        var swingRadioOk = swingOptEmbed && String(swingOptEmbed.type || '').toLowerCase() === 'radio' &&
                            Array.isArray(swingOptEmbed.options) && swingOptEmbed.options.length > 0;

                        var doorSweepTitle = document.createElement('p');
                        doorSweepTitle.className = 'fw-600 pt-24 mb-16 d-none';
                        doorSweepTitle.textContent = (swingOptEmbed && swingOptEmbed.label) ? String(swingOptEmbed.label) : 'Choose Swing Direction';
                        section.appendChild(doorSweepTitle);

                        var doorSweepExtra = document.createElement('div');
                        doorSweepExtra.className = 'common-check-options door-sweep-extra-options  grid-4';
                        if (swingRadioOk) {
                            doorSweepExtra.setAttribute('data-swing-from-schema', '1');
                        }

                        if (swingRadioOk) {
                            swingOptEmbed.options.forEach(function (o) {
                                var card = document.createElement('label');
                                card.className = 'common-check-option door-sweep-extra-option';
                                card.setAttribute('data-choice-value', o.value != null && o.value !== '' ? String(o.value) : '');

                                var radio = document.createElement('input');
                                radio.type = 'radio';
                                radio.name = 'attributes[' + (swingOptEmbed.label || swingOptEmbed.id) + ']';
                                radio.value = o.value != null && o.value !== '' ? String(o.value) : '';
                                radio.setAttribute('data-option-id', swingOptEmbed.id);
                                radio.style.position = 'absolute';
                                radio.style.opacity = '0';
                                radio.style.pointerEvents = 'none';
                                card.appendChild(radio);

                                var imgSrcEmbed = resolveChoiceImageSrc(o);
                                if (imgSrcEmbed) {
                                    var imgE = document.createElement('img');
                                    imgE.src = imgSrcEmbed;
                                    imgE.alt = o.label || o.value || '';
                                    imgE.className = 'common-check-option-image';
                                    card.appendChild(imgE);
                                } else {
                                    var imgPh = document.createElement('div');
                                    imgPh.className = 'common-check-option-image door-sweep-extra-option-image';
                                    card.appendChild(imgPh);
                                }

                                var textWrapPh = document.createElement('div');
                                textWrapPh.className = 'common-check-option-text';
                                var textPh = document.createElement('span');
                                textPh.className = 'common-check-option-label';
                                textPh.textContent = o.label || o.value || '';
                                textWrapPh.appendChild(textPh);
                                if (o.description) {
                                    var descPh = document.createElement('span');
                                    descPh.className = 'common-check-option-desc';
                                    var descTextPh = normalizeChoiceDescriptionText(o.description);
                                    if (descTextPh) {
                                        descPh.textContent = descTextPh;
                                        textWrapPh.appendChild(descPh);
                                    }
                                }
                                card.appendChild(textWrapPh);

                                var swingIdStr = String(swingOptEmbed.id || '');
                                radio.addEventListener('change', function () {
                                    all('input[type="radio"][data-option-id="' + swingIdStr + '"]', container).forEach(function (ri) {
                                        var c = ri.closest && ri.closest('.common-check-option');
                                        if (c) c.classList.remove('common-check-option--selected');
                                    });
                                    if (this.checked && this.closest) {
                                        var selCardPh = this.closest('.common-check-option');
                                        if (selCardPh) selCardPh.classList.add('common-check-option--selected');
                                    }
                                    updateEstimatedPrice();
                                });
                                doorSweepExtra.appendChild(card);
                            });
                        }

                        section.appendChild(doorSweepExtra);
                    }
                } catch (eDoorSweepExtra) { }
                // After Screen & Storm Inserts card grid, add an "Additional Options" accordion
                // that reveals selectable inner options.
                try {
                    // --- Dp start 16-07  ---
                    if (optionIsScreenAndStormInserts(opt)) {
                        // --- Dp end 16-07  ---
                        var addlWrap = document.createElement('div');
                        addlWrap.className = 'door-inserts-additional-options screen-and-storm-inserts';

                        var addlAccordion = document.createElement('div');
                        addlAccordion.className = 'door-option-accordion door-inserts-additional-options-accordion';

                        var addlBtn = document.createElement('button');
                        addlBtn.type = 'button';
                        addlBtn.className = 'door-accordion-header door-inserts-additional-options-title';

                        var addlHeaderRow = document.createElement('div');
                        addlHeaderRow.className = 'door-option-header-row';

                        var addlHeaderText = document.createElement('div');
                        addlHeaderText.className = 'door-accordion-header-text';
                        addlHeaderText.textContent = 'Additional Options';
                        addlHeaderRow.appendChild(addlHeaderText);
                        addlBtn.appendChild(addlHeaderRow);

                        var addlPlusSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
                            '<rect x="7" width="2" height="16" rx="1" fill="currentColor"></rect>' +
                            '<rect x="16" y="7" width="2" height="16" rx="1" transform="rotate(90 16 7)" fill="currentColor"></rect>' +
                            '</svg>';
                        var addlMinusSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
                            '<rect x="0" y="7" width="16" height="2" rx="1" fill="currentColor"></rect>' +
                            '</svg>';

                        var addlSign = document.createElement('span');
                        addlSign.className = 'door-accordion-sign';
                        addlSign.innerHTML = addlPlusSvg;
                        addlBtn.appendChild(addlSign);

                        var addlBody = document.createElement('div');
                        addlBody.className = 'door-accordion-body';

                        // Build inner option cards based on selected inserts type.
                        var addlState = {};
                        function rememberAddlState() {
                            try {
                                var inps = addlBody.querySelectorAll('input[type="checkbox"][data-option-id="screen_and_storm_inserts_additional_options"]');
                                inps.forEach(function (inp) { addlState[String(inp.value || '')] = !!inp.checked; });
                            } catch (eS) { }
                        }
                        // Dp strat 29-07
                        function syncAddlInsertsOptionsVisibility() {
                            var fixedGlassEligible = false;
                            try {
                                fixedGlassEligible = checkMetafieldTrue('fixed-glass-eligible', false);
                            } catch (e) { }

                            var fixedScreenEligible = false;
                            try {
                                fixedScreenEligible = checkMetafieldTrue('fixed-screen-eligible', false);
                            } catch (e) { }

                            var topBottomEligible = false;
                            try {
                                topBottomEligible = checkMetafieldTrue('top-bottom-insert-eligible', false);
                            } catch (e) { }

                            var fixedGlassInp = addlBody.querySelector('input[type="checkbox"][data-option-id="screen_and_storm_inserts_additional_options"][value="fixed_glass"]');
                            var fixedScreenInp = addlBody.querySelector('input[type="checkbox"][data-option-id="screen_and_storm_inserts_additional_options"][value="fixed_screen"]');

                            if (fixedGlassInp) {
                                var fixedGlassCard = fixedGlassInp.closest('.door-inserts-additional-options-card');
                                if (fixedGlassCard) {
                                    if (!fixedGlassEligible) {
                                        fixedGlassCard.classList.add('door-hidden');
                                        if (fixedGlassInp.checked) {
                                            fixedGlassInp.checked = false;
                                            fixedGlassCard.classList.remove('common-check-option--selected');
                                            addlState['fixed_glass'] = false;
                                        }
                                    } else {
                                        fixedGlassCard.classList.remove('door-hidden');
                                    }
                                }
                            }

                            if (fixedScreenInp) {
                                var fixedScreenCard = fixedScreenInp.closest('.door-inserts-additional-options-card');
                                if (fixedScreenCard) {
                                    if (!fixedScreenEligible) {
                                        fixedScreenCard.classList.add('door-hidden');
                                        if (fixedScreenInp.checked) {
                                            fixedScreenInp.checked = false;
                                            fixedScreenCard.classList.remove('common-check-option--selected');
                                            addlState['fixed_screen'] = false;
                                        }
                                    } else {
                                        fixedScreenCard.classList.remove('door-hidden');
                                    }
                                }
                            }

                            var isFixedGlassSelected = fixedGlassInp && fixedGlassInp.checked && fixedGlassEligible;
                            var isFixedScreenSelected = fixedScreenInp && fixedScreenInp.checked && fixedScreenEligible;

                            var tbGlassInp = addlBody.querySelector('input[type="checkbox"][data-option-id="screen_and_storm_inserts_additional_options"][value="top_bottom_inserts_glass"]');
                            var tbScreenInp = addlBody.querySelector('input[type="checkbox"][data-option-id="screen_and_storm_inserts_additional_options"][value="top_bottom_inserts_screen"]');
                            var tbGeneralInp = addlBody.querySelector('input[type="checkbox"][data-option-id="screen_and_storm_inserts_additional_options"][value="top_bottom_inserts"]');

                            if (tbGlassInp) {
                                var card = tbGlassInp.closest('.door-inserts-additional-options-card');
                                if (card) {
                                    if (!topBottomEligible || isFixedGlassSelected) {
                                        card.classList.add('door-hidden');
                                        if (tbGlassInp.checked) {
                                            tbGlassInp.checked = false;
                                            card.classList.remove('common-check-option--selected');
                                            addlState['top_bottom_inserts_glass'] = false;
                                        }
                                    } else {
                                        card.classList.remove('door-hidden');
                                    }
                                }
                            }

                            if (tbScreenInp) {
                                var card = tbScreenInp.closest('.door-inserts-additional-options-card');
                                if (card) {
                                    if (!topBottomEligible || isFixedScreenSelected) {
                                        card.classList.add('door-hidden');
                                        if (tbScreenInp.checked) {
                                            tbScreenInp.checked = false;
                                            card.classList.remove('common-check-option--selected');
                                            addlState['top_bottom_inserts_screen'] = false;
                                        }
                                    } else {
                                        card.classList.remove('door-hidden');
                                    }
                                }
                            }

                            if (tbGeneralInp) {
                                var card = tbGeneralInp.closest('.door-inserts-additional-options-card');
                                if (card) {
                                    if (!topBottomEligible) {
                                        card.classList.add('door-hidden');
                                        if (tbGeneralInp.checked) {
                                            tbGeneralInp.checked = false;
                                            card.classList.remove('common-check-option--selected');
                                            addlState['top_bottom_inserts'] = false;
                                        }
                                    } else {
                                        card.classList.remove('door-hidden');
                                    }
                                }
                            }

                            // Hide the entire accordion if all cards inside it are hidden
                            try {
                                var visibleCards = addlBody.querySelectorAll('.door-inserts-additional-options-card:not(.door-hidden)');
                                if (visibleCards.length === 0) {
                                    addlWrap.style.display = 'none';
                                    addlWrap.classList.add('door-hidden');
                                    addlWrap.setAttribute('data-addl-empty', '1');
                                } else {
                                    addlWrap.style.display = '';
                                    addlWrap.classList.remove('door-hidden');
                                    addlWrap.removeAttribute('data-addl-empty');
                                }
                            } catch (eVis) { }
                        }
                        // Dp end 29-07
                        function buildAddlCard(choice) {
                            var card = document.createElement('label');
                            card.className = 'common-check-option door-inserts-additional-options-card';
                            card.setAttribute('data-choice-value', choice.value);

                            var cb = document.createElement('input');
                            cb.type = 'checkbox';
                            cb.name = 'attributes[Additional Options][]';
                            cb.value = choice.value;
                            cb.setAttribute('data-option-id', 'screen_and_storm_inserts_additional_options');
                            cb.style.position = 'absolute';
                            cb.style.opacity = '0';
                            cb.style.pointerEvents = 'none';
                            card.appendChild(cb);

                            var textWrap = document.createElement('div');
                            textWrap.className = 'common-check-option-text';

                            var lbl = document.createElement('span');
                            lbl.className = 'common-check-option-label';
                            lbl.textContent = choice.label;
                            textWrap.appendChild(lbl);

                            var desc = document.createElement('span');
                            desc.className = 'common-check-option-desc';
                            desc.textContent = choice.desc;
                            textWrap.appendChild(desc);

                            card.appendChild(textWrap);

                            // Restore checked state if previously selected.
                            if (addlState[choice.value]) {
                                cb.checked = true;
                                card.classList.add('common-check-option--selected');
                            }
                            cb.addEventListener('change', function () {
                                // --- Dp start 17-07 (mutually exclusive additional options) ---
                                if (cb.checked) {
                                    var otherValue = '';
                                    if (choice.value === 'top_bottom_inserts_screen') otherValue = 'fixed_screen';
                                    else if (choice.value === 'fixed_screen') otherValue = 'top_bottom_inserts_screen';
                                    else if (choice.value === 'top_bottom_inserts_glass') otherValue = 'fixed_glass';
                                    else if (choice.value === 'fixed_glass') otherValue = 'top_bottom_inserts_glass';

                                    if (otherValue) {
                                        var otherInp = addlBody.querySelector('input[value="' + otherValue + '"]');
                                        if (otherInp) {
                                            otherInp.checked = false;
                                            var otherCard = otherInp.closest('.door-inserts-additional-options-card');
                                            if (otherCard) {
                                                otherCard.classList.remove('common-check-option--selected');
                                            }
                                            addlState[otherValue] = false;
                                        }
                                    }
                                }
                                // --- Dp end 17-07 (mutually exclusive additional options) ---
                                card.classList.toggle('common-check-option--selected', !!cb.checked);
                                addlState[choice.value] = !!cb.checked;
                                // Dp strat 29-07
                                try {
                                    syncAddlInsertsOptionsVisibility();
                                } catch (eSync) { }
                                // Dp end 29-07
                                // Re-evaluate choice show_when (e.g. stile soft_ogee when fixed_glass).
                                try {
                                    if (doorConfigSchema) {
                                        applyChoiceVisibility(doorConfigSchema, container);
                                        applyProductTagChoiceVisibility(doorConfigSchema, container);
                                        try { syncStileSoftOgeeForFixedGlass(container); } catch (eSoftAfterAddl) { }
                                        try { hideEmptyOptionSections(container); } catch (eEmptyAfterAddl) { }
                                        try { promoteSelectedProfileToHero(container, { collapseAccordion: false }); } catch (eHeroAfterAddl) { }
                                        try { scheduleSdlProfileVisibilitySync(container); } catch (eSdlAfterAddl) { }
                                    }
                                } catch (eChoiceAfterAddl) { }
                                updateEstimatedPrice();
                            });

                            return card;
                        }
                        function rebuildAddlCards(mode, opts) {
                            opts = opts || {};
                            // Parent inserts mode change → do not carry prior Additional Options.
                            if (opts.resetState) addlState = {};
                            else rememberAddlState();
                            addlBody.innerHTML = '';

                            var choices = getInsertsAdditionalOptionsChoicesForMode(schema, mode);
                            // --- Dp start 16-07  ---
                            if (choices.length === 0) {
                                if (mode === 'screen_insert_only') {
                                    choices = [
                                        {
                                            value: 'top_bottom_inserts_screen',
                                            label: 'Top & Bottom Inserts (optional)',
                                            desc: 'Separate screen inserts for the door top and bottom (2 inserts included)'
                                        }
                                    ];
                                    try {
                                        if (!shouldHideFixedScreen()) {
                                            choices.push({
                                                value: 'fixed_screen',
                                                label: 'Fixed Screen (optional)',
                                                desc: 'Permanent, built-in screen instead of removable inserts'
                                            });
                                        }
                                    } catch (eFs) { }
                                } else if (mode === 'storm_glass_only') {
                                    choices = [
                                        {
                                            value: 'top_bottom_inserts_glass',
                                            label: 'Top & Bottom Inserts (optional)',
                                            desc: 'Separate storm glass inserts for the door top and bottom (2 inserts included)'
                                        }
                                    ];
                                    try {
                                        if (!shouldHideFixedGlass()) {
                                            choices.push({
                                                value: 'fixed_glass',
                                                label: 'Fixed Glass (optional)', // Dp strat 29-07
                                                desc: 'Permanent, built-in tempered glass panel instead of removable inserts'
                                            });
                                        }
                                    } catch (eFg) { }
                                } else {
                                    choices = [
                                        {
                                            value: 'top_bottom_inserts',
                                            label: 'Top & Bottom Inserts (optional)',
                                            desc: 'Separate screen and glass inserts for the door top and bottom (4 inserts included)'
                                        }
                                    ];
                                }
                            } else {
                                // Dp strat 29-07 — Ensure custom fixed options are appended if missing from schema choices
                                if (mode === 'screen_insert_only') {
                                    try {
                                        if (!shouldHideFixedScreen()) {
                                            var hasFixedScreen = choices.some(function (c) { return c && c.value === 'fixed_screen'; });
                                            if (!hasFixedScreen) {
                                                choices.push({
                                                    value: 'fixed_screen',
                                                    label: 'Fixed Screen (optional)',
                                                    desc: 'Permanent, built-in screen instead of removable inserts'
                                                });
                                            }
                                        }
                                    } catch (e) { }
                                } else if (mode === 'storm_glass_only') {
                                    try {
                                        if (!shouldHideFixedGlass()) {
                                            var hasFixedGlass = choices.some(function (c) { return c && c.value === 'fixed_glass'; });
                                            if (!hasFixedGlass) {
                                                choices.push({
                                                    value: 'fixed_glass',
                                                    label: 'Fixed Glass (optional)',
                                                    desc: 'Permanent, built-in tempered glass panel instead of removable inserts'
                                                });
                                            }
                                        }
                                    } catch (eFg) { }
                                }
                                // Dp end 29-07
                            }
                            // --- Dp end 16-07  ---
                            // dp start 21-07
                            // Filter Top & Bottom only when metafield is true (false/unset = hide)
                            try {
                                if (shouldHideTopBottomInserts()) {
                                    choices = choices.filter(function (c) {
                                        return c.value !== 'top_bottom_inserts'
                                            && c.value !== 'top_bottom_inserts_screen'
                                            && c.value !== 'top_bottom_inserts_glass';
                                    });
                                }
                            } catch (eFilter) { }
                            // Filter Fixed Screen only when metafield is true (false/unset = hide)
                            try {
                                if (shouldHideFixedScreen()) {
                                    choices = choices.filter(function (c) {
                                        return c.value !== 'fixed_screen';
                                    });
                                }
                            } catch (eFilter) { }
                            // Filter Fixed Glass only when metafield is true (false/unset = hide)
                            try {
                                if (shouldHideFixedGlass()) {
                                    choices = choices.filter(function (c) {
                                        return c.value !== 'fixed_glass';
                                    });
                                }
                            } catch (eFilter) { }
                            // Hide Additional Options tab when no choices left for current inserts mode
                            var showAccordion = choices.length > 0;
                            addlWrap.style.display = showAccordion ? '' : 'none';
                            if (showAccordion) {
                                addlWrap.classList.remove('door-hidden');
                                addlWrap.removeAttribute('data-addl-empty');
                            } else {
                                addlWrap.classList.add('door-hidden');
                                addlWrap.setAttribute('data-addl-empty', '1');
                                try {
                                    addlBody.classList.remove('door-accordion-body--open');
                                    if (addlSign) addlSign.innerHTML = addlPlusSvg;
                                } catch (eCollapse) { }
                                return;
                            }
                            // Dp end 22-07
                            // dp end 21-07

                            var addlCards = document.createElement('div');
                            addlCards.className = 'common-check-options door-inserts-additional-options-cards grid-1';

                            choices.forEach(function (c) { addlCards.appendChild(buildAddlCard(c)); });
                            addlBody.appendChild(addlCards);
                            // Dp strat 29-07
                            try {
                                syncAddlInsertsOptionsVisibility();
                            } catch (eSync) { }
                            // Dp end 29-07
                        }
                        // --- Dp start 16-07 ---
                        function selectedInsertsMode() {
                            try {
                                var checked = radioWrap.querySelector('input[type="radio"][data-option-id="' + opt.id + '"]:checked');
                                var v = checked ? String(checked.value || '') : '';
                                if (!v) {
                                    var sel = radioWrap.querySelector('select[data-option-id="' + opt.id + '"]');
                                    if (sel) v = String(sel.value || '');
                                }
                                var normV = normalizeChoiceKey(v);
                                if (normV === 'screen_insert_only' || normV === 'storm_glass_only' || normV === 'screen_and_storm_inserts_choice' || normV === 'screen_and_storm_inserts') return normV;
                            } catch (eM) { }
                            return 'screen_and_storm_inserts_choice';
                        }

                        rebuildAddlCards(selectedInsertsMode());
                        // Keep the additional options in sync with inserts selection changes.
                        radioWrap.addEventListener('change', function (ev) {
                            var t = ev && ev.target;
                            if (!t) return;
                            if (t.getAttribute('data-option-id') !== String(opt.id || '')) return;
                            // Switching parent Screen & Storm Inserts choice clears Additional Options
                            // and the screen/storm type that no longer applies to the new mode.
                            var nextInsertsMode = selectedInsertsMode();
                            try {
                                if (!insertsModeShowsStormGlassType(nextInsertsMode)) {
                                    clearStormGlassTypeSelections(container);
                                }
                                if (!insertsModeShowsScreenType(nextInsertsMode)) {
                                    clearScreenTypeSelections(container);
                                }
                            } catch (eClearInsTypes) { }
                            rebuildAddlCards(nextInsertsMode, { resetState: true });
                            try {
                                if (doorConfigSchema) {
                                    applyChoiceVisibility(doorConfigSchema, container);
                                    applyProductTagChoiceVisibility(doorConfigSchema, container);
                                    try { syncStileSoftOgeeForFixedGlass(container); } catch (eSoftIns) { }
                                    try { hideEmptyOptionSections(container); } catch (eEmptyIns) { }
                                    try { promoteSelectedProfileToHero(container, { collapseAccordion: false }); } catch (eHeroIns) { }
                                    try { scheduleSdlProfileVisibilitySync(container); } catch (eSdlIns) { }
                                }
                            } catch (eVisIns) { }
                            try { updateEstimatedPrice(); } catch (ePriceIns) { }
                        });
                        // --- Dp end 16-07 ---

                        addlBtn.addEventListener('click', function () {
                            var opened = addlBody.classList.toggle('door-accordion-body--open');
                            addlSign.innerHTML = opened ? addlMinusSvg : addlPlusSvg;
                        });

                        addlAccordion.appendChild(addlBtn);
                        addlAccordion.appendChild(addlBody);
                        addlWrap.appendChild(addlAccordion);

                        section.appendChild(addlWrap);
                    }
                } catch (eAddl) { }
                if (isMeasureTypeOpt) {
                    syncMeasurementTabCardVisibility(container, schema);
                    try { applySidelightTransomMeasurementTypeDefaultSelection(container, true); } catch (eSideTransRender) { }
                }

                if (isMeasurementTabsRadio) {
                    panelIntroEl = document.createElement('h3');
                    panelIntroEl.className = 'door-measurement-panel-intro p-medium mb-24 fw-600 primaryFont';
                    panelIntroEl.setAttribute('data-option-id', opt.id);
                    panelIntroEl.classList.add('door-hidden');
                    section.appendChild(panelIntroEl);

                    checkedMeasure = radioWrap.querySelector('.door-measure-tab input[type="radio"]:checked');
                    if (!isMeasureTypeOpt) {
                        if (checkedMeasure) {
                            var tabEl0 = checkedMeasure.closest('.door-measure-tab');
                            radioWrap.querySelectorAll('.door-measure-tab').forEach(function (c) { c.classList.remove('common-check-option--selected'); });
                            if (tabEl0) tabEl0.classList.add('common-check-option--selected');
                        } else {
                            var allTabs = radioWrap.querySelectorAll('.door-measure-tab');
                            for (var ti = 0; ti < allTabs.length; ti++) {
                                var tc = allTabs[ti];
                                if (String(tc.textContent || '').toLowerCase().indexOf('exact') !== -1) {
                                    var ri = tc.querySelector('input[type="radio"]');
                                    if (ri) {
                                        ri.checked = true;
                                        tc.classList.add('common-check-option--selected');
                                    }
                                    break;
                                }
                            }
                        }
                    } else {
                        // Sidelight/transom collections: force Exact Sidelight / Exact Transom default.
                        try { applySidelightTransomMeasurementTypeDefaultSelection(container, true); } catch (eSideTransTab) { }
                        checkedMeasure = radioWrap.querySelector('.door-measure-tab input[type="radio"]:checked');
                        if (checkedMeasure) {
                            var tabEl1 = checkedMeasure.closest('.door-measure-tab');
                            radioWrap.querySelectorAll('.door-measure-tab').forEach(function (c) { c.classList.remove('common-check-option--selected'); });
                            if (tabEl1) tabEl1.classList.add('common-check-option--selected');
                        }
                    }
                    checkedMeasure = radioWrap.querySelector('.door-measure-tab input[type="radio"]:checked');
                    if (checkedMeasure && panelIntroEl) {
                        if (isMeasureTypeOpt) {
                            applyMeasurementTypeTabSelection(checkedMeasure, opt.id, container, doorConfigSchema);
                        } else {
                            syncMeasurementTabVisibility(measurementModeFromCheckedTab(checkedMeasure, container, doorConfigSchema), opt.id);
                            panelIntroEl.classList.remove('door-hidden');
                        }
                    }
                }
                if (isMeasurementTypeOptionId(opt.id) && hasMeasurementTypeBlock) {
                    var staticTpl = document.getElementById('door-static-measurement-rows');
                    if (staticTpl && staticTpl.content) {
                        measureTypeStaticWrap = document.createElement('div');
                        measureTypeStaticWrap.className = 'door-measurement-static-rows door-measurement-embedded-dimensions';
                        measureTypeStaticWrap.appendChild(staticTpl.content.cloneNode(true));
                        // Give each static measurement <select> a meaningful id (based on panel + row title + int/frac)
                        assignStaticMeasurementRowSelectIds(measureTypeStaticWrap);
                        linkStaticMeasurementRowsToSchema(schema, measureTypeStaticWrap);
                        fixPanelDoorWidthAndTransomHeightOptionRanges(measureTypeStaticWrap);
                        assignUniqueOptionIds(measureTypeStaticWrap, 'door-measurement-static-rows-select');
                        applyStaticMeasurementDimensionDefaults(measureTypeStaticWrap);
                        try {
                            if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.applyFinishedRoughWidthIntDefaults === 'function') {
                                window.DoorConf2Measurements.applyFinishedRoughWidthIntDefaults(measureTypeStaticWrap, true);
                            }
                        } catch (eFinRoughBoot) { }
                        if (isMeasureTypeOpt) measureTypeStaticWrap.classList.add('door-hidden');
                        section.appendChild(measureTypeStaticWrap);
                    } else if (embeddedDimensionsOrdered.length) {
                        measureTypeStaticWrap = document.createElement('div');
                        measureTypeStaticWrap.className = 'door-measurement-embedded-dimensions';
                        embeddedDimensionsOrdered.forEach(function (dimOpt) {
                            appendDimensionControlsTo(measureTypeStaticWrap, dimOpt, true);
                        });
                        assignUniqueOptionIds(measureTypeStaticWrap, 'door-measurement-embedded-dimensions-select');
                        if (isMeasureTypeOpt) measureTypeStaticWrap.classList.add('door-hidden');
                        section.appendChild(measureTypeStaticWrap);
                    }
                    if (isMeasureTypeOpt && checkedMeasure && measureTypeStaticWrap) {
                        measureTypeStaticWrap.classList.remove('door-hidden');
                    }
                }
            } else if (opt.type === 'checkbox') {
                var wrap = document.createElement('div');
                wrap.className = 'door-setup-options';
                (opt.options || []).forEach(function (o) {
                    var lab = document.createElement('label');
                    lab.className = 'door-setup-option';
                    var cb = document.createElement('input');
                    cb.type = 'checkbox';
                    cb.setAttribute('data-option-id', opt.id);
                    cb.name = 'attributes[' + (opt.label || opt.id) + '][]';
                    cb.value = o.value;
                    lab.appendChild(cb);
                    lab.appendChild(document.createTextNode(o.label || o.value));
                    wrap.appendChild(lab);
                });
                section.appendChild(wrap);
            }
            if (shouldAppendIntoDoorUnitGroup) {
                doorUnitDesignGroup.appendChild(section);
                if (optId === lastDoorUnitGroupId) appendDeferredDoorSetupToUnitGroup();
                if (optId === 'transom_design') doorUnitDesignGroup = null;
            } else {
                if (normalizeOptionIdKey(optId) === 'sdl_profile') {
                    section.classList.add('door-hidden');
                    section.style.display = 'none';
                }
                container.appendChild(section);
            }

            // After Lockset Prep: insert "Additional Options" accordion (header shows "+" like other accordions).
            try {
                if (String(optId || '') === 'lockset_prep') {
                    var parentAfterLockset = shouldAppendIntoDoorUnitGroup ? doorUnitDesignGroup : container;
                    if (parentAfterLockset && !parentAfterLockset.querySelector('.door-post-lockset-additional-options')) {
                        var addlAcc = document.createElement('div');
                        addlAcc.className = 'door-option-accordion door-post-lockset-additional-options common-icon-accordion';
                        addlAcc.setAttribute('data-option-id', 'additional_options');

                        var addlBtn = document.createElement('button');
                        addlBtn.type = 'button';
                        addlBtn.className = 'door-accordion-header';

                        var addlHeaderRow = document.createElement('div');
                        addlHeaderRow.className = 'door-option-header-row';

                        var addlHeaderText = document.createElement('div');
                        addlHeaderText.className = 'door-accordion-header-text door-option-title';
                        addlHeaderText.textContent = 'Additional Options';
                        addlHeaderRow.appendChild(addlHeaderText);
                        addlBtn.appendChild(addlHeaderRow);

                        var plusSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
                            '<rect x="7" width="2" height="16" rx="1" fill="currentColor"></rect>' +
                            '<rect x="16" y="7" width="2" height="16" rx="1" transform="rotate(90 16 7)" fill="currentColor"></rect>' +
                            '</svg>';
                        var minusSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
                            '<rect x="0" y="7" width="16" height="2" rx="1" fill="currentColor"></rect>' +
                            '</svg>';

                        var sign = document.createElement('span');
                        sign.className = 'door-accordion-sign';
                        sign.innerHTML = plusSvg;
                        addlBtn.appendChild(sign);

                        var addlBody = document.createElement('div');
                        addlBody.className = 'door-accordion-body';

                        var addlInner = document.createElement('div');
                        addlInner.className = 'door-accordion-body-inner';
                        addlBody.appendChild(addlInner);

                        function moveCommonChecksIntoHeaderRow(blockEl) {
                            try {
                                if (!blockEl || !blockEl.querySelector) return;
                                var headerRowEl = blockEl.querySelector('.door-option-header-row');
                                var checksEl = blockEl.querySelector('.common-check-options');
                                if (!headerRowEl || !checksEl) return;
                                if (checksEl.parentNode === headerRowEl) return;
                                headerRowEl.appendChild(checksEl);
                            } catch (eMoveChecks) { }
                        }

                        // Move existing option sections into this accordion (retry after render).
                        try {
                            var root = document.getElementById('door-configurator') || document;
                            var optionOrder = ['priming', 'door_sweep', 'door_seal_kit', 'pet_door'];

                            function isInsideThisAccordion(node) {
                                return !!(node && node.closest && node.closest('.door-post-lockset-additional-options'));
                            }

                            function tryMoveOnce() {
                                var allFound = true;
                                optionOrder.forEach(function (oid) {
                                    var sel = '.door-option-wrap[data-option-id="' + oid + '"]';
                                    var wrap = root.querySelector(sel);
                                    if (!wrap) {
                                        wrap = root.querySelector('[data-option-id="' + oid + '"]');
                                    }
                                    if (!wrap) {
                                        allFound = false;
                                        return;
                                    }
                                    if (isInsideThisAccordion(wrap)) return;
                                    var block = wrap.closest ? (wrap.closest('.door-option-wrap') || wrap.closest('.door-section') || wrap.closest('section') || wrap) : wrap;
                                    if (!block) return;
                                    if (block.classList && block.classList.contains('door-post-lockset-additional-options')) return;
                                    addlInner.appendChild(block);

                                    try {
                                        if (oid === 'pet_door' && shouldHidePetDoor()) {
                                            block.classList.add('door-hidden');
                                            block.setAttribute('data-empty-hidden', '1');
                                            block.style.display = 'none';
                                            return;
                                        }
                                    } catch (ePetMoveHide) { }

                                    try {
                                        if ((oid === 'priming' || oid === 'door_sweep' || oid === 'door_seal_kit' || oid === 'pet_door') && block) {
                                            try {
                                                if (block.classList && !block.classList.contains('additional-options-card')) {
                                                    block.classList.add('additional-options-card');
                                                }
                                            } catch (eAddlCard) { }
                                            moveCommonChecksIntoHeaderRow(block);

                                            var guardAttr =
                                                (oid === 'door_seal_kit') ? 'data-seal-kit-img-hydrated'
                                                    : (oid === 'pet_door') ? 'data-pet-door-img-hydrated'
                                                        : 'data-sweep-img-hydrated';
                                            if (block.getAttribute(guardAttr)) return;
                                            var descEls = block.querySelectorAll('.door-option-desc');
                                            var imgUrl = '';
                                            var srcDescEl = null;
                                            for (var di = 0; di < descEls.length; di++) {
                                                var dEl = descEls[di];
                                                var foundUrl = getDoorOptionDescMediaUrl(dEl);
                                                if (!foundUrl) continue;
                                                imgUrl = foundUrl;
                                                srcDescEl = dEl;
                                                break;
                                            }
                                            if (imgUrl && srcDescEl) {
                                                srcDescEl.setAttribute('data-door-desc-media-url', imgUrl);
                                                setDoorOptionDescriptionText(
                                                    srcDescEl,
                                                    (srcDescEl.getAttribute('data-door-original-desc') || srcDescEl.textContent || '') + '\n' + imgUrl
                                                );

                                                var img = document.createElement('img');
                                                img.src = imgUrl;
                                                img.alt = '';
                                                img.loading = 'lazy';
                                                img.style.maxWidth = '100%';
                                                img.style.height = 'auto';
                                                img.style.display = 'block';

                                                if (oid === 'door_sweep' || oid === 'door_seal_kit' || oid === 'pet_door') {
                                                    var headerRowSweep = block.querySelector('.door-option-header-row');
                                                    var selectSweep = block.querySelector('select[data-option-id="' + oid + '"]');
                                                    if (headerRowSweep && selectSweep) {
                                                        moveSelectWithDivDropdown(selectSweep, headerRowSweep);
                                                    }
                                                    if (headerRowSweep && headerRowSweep.parentNode === block) {
                                                        headerRowSweep.insertAdjacentElement('afterend', img);
                                                    } else {
                                                        block.appendChild(img);
                                                    }
                                                } else {
                                                    srcDescEl.insertAdjacentElement('afterend', img);
                                                }
                                                block.setAttribute(guardAttr, '1');
                                            }
                                        }
                                    } catch (eSweepImg) { }
                                    enhanceAdditionalOptionsSelects(block);
                                });
                                enhanceAdditionalOptionsSelects(addlInner);
                                return allFound;
                            }

                            while (addlInner.firstChild) addlInner.removeChild(addlInner.firstChild);

                            var maxTries = 20;
                            var t = 0;
                            function loop() {
                                t++;
                                var done = tryMoveOnce();
                                if (done || t >= maxTries) return;
                                setTimeout(loop, 250);
                            }
                            setTimeout(loop, 0);
                        } catch (eMoveAddl2) { }

                        addlBtn.addEventListener('click', function () {
                            var opened = addlBody.classList.toggle('door-accordion-body--open');
                            sign.innerHTML = opened ? minusSvg : plusSvg;
                        });

                        addlAcc.appendChild(addlBtn);
                        addlAcc.appendChild(addlBody);

                        // Insert immediately after the Lockset Prep section.
                        if (section && section.parentNode === parentAfterLockset) {
                            parentAfterLockset.insertBefore(addlAcc, section.nextSibling);
                        } else {
                            parentAfterLockset.appendChild(addlAcc);
                        }

                        // After Additional Options: insert "Hardware" accordion and move `finish` option into it.
                        try {
                            if (parentAfterLockset && !parentAfterLockset.querySelector('.door-post-lockset-hardware-options')) {
                                var hwAcc = null;
                                var hwBtn = null;
                                var hwSign = null;
                                var hwBody = null;
                                var hwInner = null;
                                var hwSource = document.getElementById('door-suggested-hardware-accordion-source');
                                if (hwSource) {
                                    hwAcc = hwSource.querySelector('.door-post-lockset-hardware-options');
                                    if (hwAcc) {
                                        hwBtn = hwAcc.querySelector('.door-accordion-header');
                                        hwSign = hwAcc.querySelector('.door-accordion-sign');
                                        hwBody = hwAcc.querySelector('.door-accordion-body');
                                        hwInner = hwAcc.querySelector('.door-accordion-body-inner');
                                    }
                                }
                                if (!hwAcc) {
                                    hwAcc = document.createElement('div');
                                    hwAcc.className = 'door-option-accordion door-post-lockset-hardware-options common-icon-accordion';
                                    hwAcc.setAttribute('data-option-id', 'hardware_options');
                                    hwAcc.setAttribute('data-hardware-accordion', '1');

                                    hwBtn = document.createElement('button');
                                    hwBtn.type = 'button';
                                    hwBtn.className = 'door-accordion-header';

                                    var hwHeaderRow = document.createElement('div');
                                    hwHeaderRow.className = 'door-option-header-row';

                                    var hwHeaderText = document.createElement('div');
                                    hwHeaderText.className = 'door-accordion-header-text door-option-title';
                                    hwHeaderText.textContent = 'Hardware';
                                    hwHeaderRow.appendChild(hwHeaderText);
                                    hwBtn.appendChild(hwHeaderRow);

                                    hwSign = document.createElement('span');
                                    hwSign.className = 'door-accordion-sign';
                                    hwSign.innerHTML = plusSvg;
                                    hwBtn.appendChild(hwSign);

                                    hwBody = document.createElement('div');
                                    hwBody.className = 'door-accordion-body';

                                    hwInner = document.createElement('div');
                                    hwInner.className = 'door-accordion-body-inner';
                                    hwBody.appendChild(hwInner);

                                    hwAcc.appendChild(hwBtn);
                                    hwAcc.appendChild(hwBody);
                                }

                                var hwRecommendedProducts = readRecommendedHardwareProducts();
                                if (hwInner && hwRecommendedProducts.length) {
                                    renderHardwareOptionsGrid(hwInner, hwRecommendedProducts);
                                    hideLegacyRecommendedProductsBlock();
                                }

                                // Move Finish option into this accordion (retry after render).
                                try {
                                    var root2 = document.getElementById('door-configurator') || document;

                                    function isInsideHardwareAccordion(node) {
                                        return !!(node && node.closest && node.closest('.door-post-lockset-hardware-options'));
                                    }

                                    function hideHardwareSchemaChoiceGrid(blockEl) {
                                        if (!blockEl || !blockEl.querySelector) return;
                                        if (!blockEl.classList || !blockEl.classList.contains('door-option-wrap')) return;
                                        var cards = blockEl.querySelector('.common-check-options:not(.door-hardware-options-cards)');
                                        if (cards) cards.style.display = 'none';
                                    }

                                    function tryMoveHardwareOptionsOnce() {
                                        if (!hwRecommendedProducts.length) return true;
                                        var oidHw = 'hardware_options';
                                        var wrapHw = root2.querySelector('.door-option-wrap[data-option-id="' + oidHw + '"]');
                                        if (!wrapHw) return false;
                                        if (isInsideHardwareAccordion(wrapHw)) {
                                            hideHardwareSchemaChoiceGrid(wrapHw);
                                            return true;
                                        }
                                        var blockHw = wrapHw.closest
                                            ? (wrapHw.closest('.door-option-wrap') || wrapHw.closest('.door-section') || wrapHw.closest('section') || wrapHw)
                                            : wrapHw;
                                        if (!blockHw) return true;
                                        if (blockHw.classList && blockHw.classList.contains('door-post-lockset-hardware-options')) return true;
                                        try {
                                            if (blockHw.classList && !blockHw.classList.contains('hardware-options-card')) {
                                                blockHw.classList.add('hardware-options-card');
                                            }
                                        } catch (eHwCard2) { }
                                        hideHardwareSchemaChoiceGrid(blockHw);
                                        hwInner.appendChild(blockHw);
                                        return true;
                                    }

                                    function tryMoveFinishOnce() {
                                        var oid2 = 'finish';
                                        var sel2 = '.door-option-wrap[data-option-id="' + oid2 + '"]';
                                        var wrap2 = root2.querySelector(sel2) || root2.querySelector('[data-option-id="' + oid2 + '"]');
                                        if (!wrap2) return false;
                                        if (isInsideHardwareAccordion(wrap2)) return true;

                                        var block2 = wrap2.closest ? (wrap2.closest('.door-option-wrap') || wrap2.closest('.door-section') || wrap2.closest('section') || wrap2) : wrap2;
                                        if (!block2) return true;
                                        if (block2.classList && (block2.classList.contains('door-post-lockset-hardware-options') || block2.classList.contains('door-post-lockset-additional-options'))) {
                                            return true;
                                        }
                                        try {
                                            if (block2.classList && !block2.classList.contains('hardware-options-card')) {
                                                block2.classList.add('hardware-options-card');
                                            }
                                        } catch (eHwCard) { }
                                        hwInner.appendChild(block2);
                                        return true;
                                    }

                                    var maxTries2 = 20;
                                    var t2 = 0;
                                    function loop2() {
                                        t2++;
                                        var doneHw = tryMoveHardwareOptionsOnce();
                                        var done2 = tryMoveFinishOnce();
                                        if ((doneHw !== false) && done2) return;
                                        if (t2 >= maxTries2) return;
                                        setTimeout(loop2, 250);
                                    }
                                    setTimeout(loop2, 0);
                                } catch (eMoveFinish) { }

                                if (hwBtn && hwBody && hwSign && !hwBtn.getAttribute('data-hw-accordion-bound')) {
                                    hwBtn.setAttribute('data-hw-accordion-bound', '1');
                                    hwBtn.addEventListener('click', function () {
                                        var opened = hwBody.classList.toggle('door-accordion-body--open');
                                        hwSign.innerHTML = opened ? minusSvg : plusSvg;
                                        hwBtn.setAttribute('aria-expanded', opened ? 'true' : 'false');
                                        syncHardwareOptionsGridVisibility(hwAcc, opened);
                                    });
                                }

                                if (hwRecommendedProducts.length) {
                                    syncHardwareOptionsGridVisibility(hwAcc, hwBody && hwBody.classList.contains('door-accordion-body--open'));
                                }

                                // Insert Hardware accordion right after Additional Options accordion.
                                if (addlAcc && addlAcc.parentNode === parentAfterLockset) {
                                    parentAfterLockset.insertBefore(hwAcc, addlAcc.nextSibling);
                                } else {
                                    parentAfterLockset.appendChild(hwAcc);
                                }

                                // After Hardware: insert "Casing" accordion. Move casing-related options if present;
                                // otherwise, render 3 dummy items.
                                try {
                                    if (parentAfterLockset && !parentAfterLockset.querySelector('.door-post-lockset-casing-options')) {
                                        var casingAcc = document.createElement('div');
                                        casingAcc.className = 'door-option-accordion door-post-lockset-casing-options common-icon-accordion';
                                        casingAcc.setAttribute('data-option-id', 'casing_options');

                                        var casingBtn = document.createElement('button');
                                        casingBtn.type = 'button';
                                        casingBtn.className = 'door-accordion-header';

                                        var casingHeaderRow = document.createElement('div');
                                        casingHeaderRow.className = 'door-option-header-row';

                                        var casingHeaderText = document.createElement('div');
                                        casingHeaderText.className = 'door-accordion-header-text door-option-title';
                                        casingHeaderText.textContent = 'Casing';
                                        casingHeaderRow.appendChild(casingHeaderText);
                                        casingBtn.appendChild(casingHeaderRow);

                                        var casingSign = document.createElement('span');
                                        casingSign.className = 'door-accordion-sign';
                                        casingSign.innerHTML = plusSvg;
                                        casingBtn.appendChild(casingSign);

                                        var casingBody = document.createElement('div');
                                        casingBody.className = 'door-accordion-body';

                                        var casingInner = document.createElement('div');
                                        casingInner.className = 'door-accordion-body-inner';
                                        casingBody.appendChild(casingInner);

                                        // Try to move casing-related option blocks into this accordion (retry after render).
                                        // If none exist, insert dummy items.
                                        try {
                                            var root3 = document.getElementById('door-configurator') || document;

                                            function isInsideCasingAccordion(node) {
                                                return !!(node && node.closest && node.closest('.door-post-lockset-casing-options'));
                                            }

                                            function casingCandidateWraps() {
                                                try {
                                                    return Array.from(root3.querySelectorAll('.door-option-wrap[data-option-id]'))
                                                        .filter(function (el) {
                                                            var id = String(el.getAttribute('data-option-id') || '').toLowerCase();
                                                            return id === 'casing' || id.indexOf('casing_') === 0;
                                                        });
                                                } catch (e) {
                                                    return [];
                                                }
                                            }

                                            function tryMoveCasingOnce() {
                                                var movedAny = false;
                                                var wraps = casingCandidateWraps();
                                                if (!wraps || !wraps.length) return null; // not found yet
                                                wraps.forEach(function (wrap3) {
                                                    if (!wrap3 || isInsideCasingAccordion(wrap3)) return;
                                                    var block3 = wrap3.closest ? (wrap3.closest('.door-option-wrap') || wrap3.closest('.door-section') || wrap3.closest('section') || wrap3) : wrap3;
                                                    if (!block3) return;
                                                    if (block3.classList && (block3.classList.contains('door-post-lockset-casing-options') || block3.classList.contains('door-post-lockset-hardware-options') || block3.classList.contains('door-post-lockset-additional-options'))) {
                                                        return;
                                                    }
                                                    try {
                                                        if (block3.classList && !block3.classList.contains('additional-options-card')) {
                                                            block3.classList.add('additional-options-card');
                                                        }
                                                    } catch (eCard3) { }
                                                    moveCommonChecksIntoHeaderRow(block3);
                                                    casingInner.appendChild(block3);
                                                    movedAny = true;
                                                });
                                                return movedAny;
                                            }

                                            var maxTries3 = 20;
                                            var t3 = 0;
                                            function loop3() {
                                                t3++;
                                                var moved = tryMoveCasingOnce();
                                                // moved === null means "not found yet" (keep trying)
                                                if (moved === true) return;
                                                if (moved === false) {
                                                    // Found casing options list but none moved (already inside) - stop.
                                                    return;
                                                }
                                                if (t3 >= maxTries3) {
                                                    // No casing options exist; insert dummy items.
                                                    if (!casingInner.firstChild) {
                                                        for (var di3 = 1; di3 <= 3; di3++) {
                                                            var dummy = document.createElement('div');
                                                            dummy.className = 'door-section door-option-wrap additional-options-card';
                                                            dummy.setAttribute('data-option-id', 'casing_dummy_' + di3);
                                                            dummy.innerHTML =
                                                                '<div class="door-option-header-row">' +
                                                                '<div class="door-option-title-wrap">' +
                                                                '<h3 class="door-section-title door-option-title"><span>Casing option ' + di3 + '</span></h3>' +
                                                                '<p class="door-option-desc">Dummy casing item (no casing options found in schema).</p>' +
                                                                '</div>' +
                                                                '</div>';
                                                            casingInner.appendChild(dummy);
                                                        }
                                                    }
                                                    return;
                                                }
                                                setTimeout(loop3, 250);
                                            }
                                            setTimeout(loop3, 0);
                                        } catch (eMoveCasing) {
                                            // If anything goes wrong, still show dummy items.
                                            if (!casingInner.firstChild) {
                                                for (var di4 = 1; di4 <= 3; di4++) {
                                                    var dummy2 = document.createElement('div');
                                                    dummy2.className = 'door-section door-option-wrap additional-options-card';
                                                    dummy2.setAttribute('data-option-id', 'casing_dummy_' + di4);
                                                    dummy2.innerHTML =
                                                        '<div class="door-option-header-row">' +
                                                        '<div class="door-option-title-wrap">' +
                                                        '<h3 class="door-section-title door-option-title"><span>Casing option ' + di4 + '</span></h3>' +
                                                        '<p class="door-option-desc">Dummy casing item (no casing options found in schema).</p>' +
                                                        '</div>' +
                                                        '</div>';
                                                    casingInner.appendChild(dummy2);
                                                }
                                            }
                                        }

                                        casingBtn.addEventListener('click', function () {
                                            var opened = casingBody.classList.toggle('door-accordion-body--open');
                                            casingSign.innerHTML = opened ? minusSvg : plusSvg;
                                        });

                                        casingAcc.appendChild(casingBtn);
                                        casingAcc.appendChild(casingBody);

                                        // Insert Casing accordion right after Hardware accordion.
                                        if (hwAcc && hwAcc.parentNode === parentAfterLockset) {
                                            parentAfterLockset.insertBefore(casingAcc, hwAcc.nextSibling);
                                        } else {
                                            parentAfterLockset.appendChild(casingAcc);
                                        }
                                    }
                                } catch (eCasingAcc) { }
                            }
                        } catch (eHardwareAcc) { }
                    }
                }
            } catch (eLocksetAddl) { }

            if ((opt.type || '').toLowerCase() === 'radio' && isMeasurementTypeOptionId(opt.id) && hasMeasurementTypeBlock) {
                if (isMeasurementTabsRadio) {
                    try { applySidelightTransomMeasurementTypeDefaultSelection(container, true); } catch (eSideTransEnd) { }
                    var radioTabs = section.querySelector('.door-measure-tabs');
                    var chk = radioTabs ? radioTabs.querySelector('.door-measure-tab input[type="radio"]:checked') : null;
                    if (chk) {
                        applyMeasurementTypeTabSelection(chk, opt.id, container, doorConfigSchema);
                    }
                } else {
                    syncMeasurementTabVisibility('exact', opt.id);
                }
            }
        });
        try {
            var swingHide = findSwingDirectionOption(schema);
            if (swingHide && container.querySelector('.door-sweep-extra-options[data-swing-from-schema="1"]')) {
                var swingWrapHide = container.querySelector('.door-option-wrap[data-option-id="' + swingHide.id + '"]');
                if (swingWrapHide) swingWrapHide.classList.add('door-hidden');
            }
        } catch (eSwingDupHide) { }

        // Ensure default exposure filtering is applied after all option blocks are rendered.
        try {
            applyWoodExposureFilter(container);
            setTimeout(function () {
                applyWoodExposureFilter(container);
                if (doorConfigSchema) {
                    applyProductTagChoiceVisibility(doorConfigSchema, container);
                    syncSidelightTransomAccordionHeaderUi(container);
                    syncPanelProfileHero(container);
                    initSdlProfileNest(container);
                }
                try { hideEmptyOptionSections(container); } catch (eSwingEmpty) { }
                try { scheduleSdlProfileVisibilitySync(container); } catch (eSdlInit0) { }
            }, 0);
            if (doorConfigSchema) applyProductTagChoiceVisibility(doorConfigSchema, container);
            initSdlProfileNest(container);
            hideEmptyOptionSections(container);
            enhanceAdditionalOptionsSelects(container);
            applyCollectionMeasureRowVisibility(container);
            applyGardenGatesCollectionRulesFromMeasurements(container);
            setTimeout(function () {
                if (doorConfigSchema) applyProductTagChoiceVisibility(doorConfigSchema, container);
                applyWoodExposureFilter(container);
                hideEmptyOptionSections(container);
                enhanceAdditionalOptionsSelects(container);
                applyCollectionMeasureRowVisibility(container);
                applyGardenGatesCollectionRulesFromMeasurements(container);
                syncSidelightTransomAccordionHeaderUi(container);
                try { scheduleSdlProfileVisibilitySync(container); } catch (eSdlLate) { }
            }, 250);
            setTimeout(function () {
                try { scheduleSdlProfileVisibilitySync(container); } catch (eSdlLate2) { }
            }, 800);
        } catch (eWoodExposureInit) { }

        try {
            if (!schemaIncludesPanelUnitDesignOption(schema) && productIsPorchPanelProduct()) {
                appendStaticPanelUnitDesignSection(container);
            }
            initializePanelUnitDesignSections(container, schema);
        } catch (ePanelUnitInit) { }

        // Panel Profile / Stile and Rail Profile must always render a section, even
        // when the option is missing from the schema (metafield not configured).
        // Inject a default header-only section so the section never disappears.
        try { ensureProfileSectionsRendered(container, schema); } catch (eProfileFallback) { }
        try {
            if (window.DoorConf2Update && typeof window.DoorConf2Update.patchAriaControls === 'function') {
                window.DoorConf2Update.patchAriaControls();
                setTimeout(function () {
                    try { window.DoorConf2Update.patchAriaControls(); } catch (ePatchLate) { }
                }, 150);
            }
        } catch (ePatchAria) { }

        // Additive Additional Options fallback for products without lockset_prep only.
        // Must run after profile sections exist so placement is correct. Lockset products exit immediately.
        try {
            ensureAdditionalOptionsAccordion(container);
            setTimeout(function () { try { ensureAdditionalOptionsAccordion(container); } catch (eAddlEns2) { } }, 400);
            setTimeout(function () { try { ensureAdditionalOptionsAccordion(container); } catch (eAddlEns3) { } }, 1000);
        } catch (eAddlEns) { }

        // Hide hinge_finish when slab_only or no pre-hung selection.
        try { syncHingeFinishVisibility(schema, container); } catch (eHingeInit) { }
        // Screen & Storm: hide lockset_prep unless prehung on jamb / brickmold.
        try { syncLocksetPrepVisibility(schema, container); } catch (eLocksetInit) { }
        try { applyLocksetPrepNoneDefault(container); } catch (eLocksetInit2) { }

        // Post-render DOM reorder: reposition all [data-option-id] elements
        // according to desiredOptionOrder so dynamically-injected accordions
        // (additional_options, hardware_options, casing_options) follow the same order.
        try {
            var _reorderContainer = container;
            var _reorderDoorGroup = doorUnitDesignGroup;
            setTimeout(function () {
                try {
                    function reorderChildrenByOptionId(parent) {
                        if (!parent) return;
                        var kids = [];
                        for (var ci = 0; ci < parent.children.length; ci++) {
                            var ch = parent.children[ci];
                            if (ch.hasAttribute && ch.hasAttribute('data-option-id')) kids.push(ch);
                        }
                        if (kids.length < 2) return;
                        kids.sort(function (a, b) {
                            var aId = normalizeOptionIdKey(a.getAttribute('data-option-id') || '');
                            var bId = normalizeOptionIdKey(b.getAttribute('data-option-id') || '');
                            var aR = desiredOptionRank[aId] != null ? desiredOptionRank[aId] : 9999;
                            var bR = desiredOptionRank[bId] != null ? desiredOptionRank[bId] : 9999;
                            return aR - bR;
                        });
                        for (var ki = 0; ki < kids.length; ki++) {
                            parent.appendChild(kids[ki]);
                        }
                    }
                    reorderChildrenByOptionId(_reorderContainer);
                    if (_reorderDoorGroup && _reorderDoorGroup !== _reorderContainer) {
                        reorderChildrenByOptionId(_reorderDoorGroup);
                    }
                } catch (eInner) { }
            }, 800);
        } catch (eReorder) { }

        try {
            if (window.DoorConf2Update && typeof window.DoorConf2Update.hideThemeDrawerTriggers === 'function') {
                window.DoorConf2Update.hideThemeDrawerTriggers();
                setTimeout(window.DoorConf2Update.hideThemeDrawerTriggers, 0);
                setTimeout(window.DoorConf2Update.hideThemeDrawerTriggers, 300);
            }
        } catch (eHideTriggers) { }
    }

    // Collection-specific measurement rows: hide the "Exact Door" static rows
    // (.exact-door) when the current collection is "sidelights". Uses a class on
    // #door-configurator + a CSS rule so it survives template re-clones.
    function ensureCollectionMeasureRowStyle() {
        if (document.getElementById('door-collection-measure-style')) return;
        var style = document.createElement('style');
        style.id = 'door-collection-measure-style';
        style.textContent =
            '#door-configurator.door-collection-sidelights .door-measure-dimension-row.exact-door{display:none !important;}';
        (document.head || document.documentElement).appendChild(style);
    }
    var COLLECTIONS_HIDE_EXACT_DOOR = [
        'exterior-sidelights',
        'screen-storm-sidelights',
        'interior-sidelights',
        'exterior-transoms',
        'screen-storm-transoms',
        'interior-transoms'
    ];
    function isMeasureDebugOn() {
        try {
            if (window.__doorMeasureDebug === true) return true;
            if (window.localStorage && window.localStorage.getItem('door_measure_debug') === '1') return true;
        } catch (eDbgRead) { }
        return false;
    }
    function logMeasureDebug() {
        if (!isMeasureDebugOn()) return;
        try {
            var args = Array.prototype.slice.call(arguments);
            args.unshift('[door-conf2 measure]');
            console.log.apply(console, args);
        } catch (eDbgLog) { }
    }
    function isSidelightOrTransomCollectionHandle(handle) {
        var h = normProductTagSlug(handle || '');
        return h && COLLECTIONS_HIDE_EXACT_DOOR.indexOf(h) !== -1;
    }
    function isEntranceUnitsProduct() {
        try {
            var col = '';
            try { col = normProductTagSlug(getCollectionHandleFromUrl()); } catch (eUrl) { }
            if (col && (col.indexOf('entrance-unit') !== -1 || col.indexOf('entrance-units') !== -1)) return true;
            var root = document.getElementById('door-configurator') || document.getElementById('landing-product-configurator');
            if (root) {
                var routeCol = normProductTagSlug(root.getAttribute('data-route-collection') || '');
                if (routeCol && (routeCol.indexOf('entrance-unit') !== -1 || routeCol.indexOf('entrance-units') !== -1)) return true;
                var rawHandles = root.getAttribute('data-product-collection-handles') || '[]';
                try {
                    var handles = JSON.parse(rawHandles);
                    if (Array.isArray(handles)) {
                        for (var hi = 0; hi < handles.length; hi++) {
                            var ch = normProductTagSlug(handles[hi]);
                            if (ch && (ch.indexOf('entrance-unit') !== -1 || ch.indexOf('entrance-units') !== -1)) return true;
                        }
                    }
                } catch (eH) { }
                var tagsAttr = (root.getAttribute('data-product-tags') || '').toLowerCase();
                if (tagsAttr.indexOf('entrance-unit') !== -1 || tagsAttr.indexOf('entrance-units') !== -1) return true;
                var prodName = (root.getAttribute('data-product-name') || '').toLowerCase();
                if (prodName.indexOf('entrance-unit') !== -1 || prodName.indexOf('entrance-units') !== -1) return true;
            }
        } catch (eEnt) { }
        return false;
    }
    function getSidelightTransomCollectionType() {
        if (isEntranceUnitsProduct()) return '';
        var h = '';
        try { h = getCollectionHandleFromUrl(); } catch (eColTypeUrl) { }
        if (!h) {
            try {
                var main = document.getElementById('door-configurator');
                if (main) h = normProductTagSlug(main.getAttribute('data-route-collection') || '');
            } catch (eColTypeMain) { }
        }
        var type = '';
        if (h) {
            if (h.indexOf('transom') !== -1) type = 'transom';
            else if (h.indexOf('sidelight') !== -1) type = 'sidelight';
        }
        if (!type) {
            // Fallback to product tags / name when route collection is absent.
            try {
                var root = document.getElementById('door-configurator');
                var tagsAttr = root ? String(root.getAttribute('data-product-tags') || '').toLowerCase() : '';
                if (tagsAttr.indexOf('transom') !== -1) type = 'transom';
                else if (tagsAttr.indexOf('sidelight') !== -1) type = 'sidelight';
                if (!type) {
                    var nameAttr = root ? String(root.getAttribute('data-product-name') || '').toLowerCase() : '';
                    if (nameAttr.indexOf('transom') !== -1) type = 'transom';
                    else if (nameAttr.indexOf('sidelight') !== -1) type = 'sidelight';
                }
            } catch (eColTypeTags) { }
        }
        if (window.__doorMeasureLastColType !== (type || 'none')) {
            window.__doorMeasureLastColType = type || 'none';
            if (h) logMeasureDebug('collection-handle', h);
            logMeasureDebug('collection-type', type || 'none');
        }
        return type;
    }
    function isSidelightOrTransomCollectionActive() {
        return getSidelightTransomCollectionType() !== '';
    }
    function mapCollectionMeasureTitle(label) {
        var raw = String(label || '').trim();
        if (!raw) return raw;
        try {
            if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.petGatesExactMeasureTitleCopy === 'function') {
                raw = window.DoorConf2Measurements.petGatesExactMeasureTitleCopy(raw);
            }
        } catch (eGateTitle) { }
        var key = normalizeOptionIdKey(raw);
        // Dp start VDN-390 23-10
        if (
            key === 'pre_hung_unit_depth' || key === 'prehung_unit_depth' ||
            key === 'pre_hung_jamb_width' || key === 'prehung_jamb_width' ||
            key === 'pre_hung_jamb_depth' || key === 'prehung_jamb_depth'
        ) {
            return 'Pre-hung Jamb Depth';
        }
        // Dp end VDN-390 23-10
        if (key !== 'exact_door_thickness' && key !== 'door_thickness') return raw;
        if (!isSidelightOrTransomCollectionActive()) return raw;
        var t = getSidelightTransomCollectionType();
        if (t === 'transom') return 'Transom Thickness';
        return 'Sidelight Thickness';
    }

    /**
     * On sidelight/transom collections, rewrite standalone "door"/"doors"
     * in description copy to "sidelight(s)" / "transom(s)" (case-preserving).
     * On garden/pet gates, rewrite to "gate"/"gates".
     * Does not touch labels/titles — only descriptive text.
     */
    function mapCollectionDoorWording(text) {
        var raw = stripDescriptionMediaUrls(text);
        if (!raw) return raw;
        var type = getSidelightTransomCollectionType();
        var singular = '';
        var plural = '';
        if (type === 'transom') {
            singular = 'transom';
            plural = 'transoms';
        } else if (type === 'sidelight') {
            singular = 'sidelight';
            plural = 'sidelights';
        } else if (isGateCollectionActive()) {
            singular = 'gate';
            plural = 'gates';
        } else {
            return raw;
        }
        return raw.replace(/\b(doors?)\b/gi, function (match) {
            var isPlural = /s$/i.test(match);
            var repl = isPlural ? plural : singular;
            if (match === match.toUpperCase()) return repl.toUpperCase();
            if (match.charAt(0) === match.charAt(0).toUpperCase()) {
                return repl.charAt(0).toUpperCase() + repl.slice(1);
            }
            return repl;
        });
    }

    /**
     * Option descriptions sometimes append a Shopify CDN / image URL after the copy.
     * Extract that URL for the right-side media image (door sweep / seal / pet door).
     */
    function extractDescriptionMediaUrl(text) {
        var s = text == null ? '' : String(text);
        if (!s) return '';
        var m = s.match(/https?:\/\/[^\s<>"']+\.(?:png|jpe?g|gif|webp|svg|bmp|ico)(?:\?[^\s<>"']*)?/i);
        if (m && m[0]) return m[0];
        m = s.match(/https?:\/\/cdn\.shopify\.com\/s\/files\/[^\s<>"']+/i);
        return (m && m[0]) ? m[0] : '';
    }

    /**
     * Option descriptions sometimes append a Shopify CDN / image URL after the copy.
     * Never print those URLs in visible description text (or original-desc attributes).
     */
    function stripDescriptionMediaUrls(text) {
        var s = text == null ? '' : String(text);
        if (!s) return '';
        // Image URLs with common extensions
        s = s.replace(/https?:\/\/[^\s<>"']+\.(?:png|jpe?g|gif|webp|svg|bmp|ico)(?:\?[^\s<>"']*)?/gi, '');
        // Shopify CDN file URLs (with or without extension in the path)
        s = s.replace(/https?:\/\/cdn\.shopify\.com\/s\/files\/[^\s<>"']+/gi, '');
        // Any remaining bare http(s) URL left on its own line / trailing
        s = s.replace(/(?:^|\s)https?:\/\/[^\s<>"']+/gi, ' ');
        s = s.replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').replace(/[ \t]{2,}/g, ' ').trim();
        return s;
    }

    /**
     * Set option description text without printing media URLs, while preserving
     * the extracted URL on data-door-desc-media-url for right-side image hydration.
     */
    function setDoorOptionDescriptionText(el, rawText) {
        if (!el) return '';
        var raw = rawText == null ? '' : String(rawText);
        var mediaUrl = extractDescriptionMediaUrl(raw)
            || extractDescriptionMediaUrl(el.getAttribute('data-door-desc-media-url') || '');
        if (mediaUrl) el.setAttribute('data-door-desc-media-url', mediaUrl);
        else el.removeAttribute('data-door-desc-media-url');
        var cleaned = mapCollectionDoorWording(raw);
        el.setAttribute('data-door-original-desc', cleaned);
        el.textContent = cleaned;
        return mediaUrl;
    }

    /** Pull image URL from a .door-option-desc (attribute first, then live text). */
    function getDoorOptionDescMediaUrl(descEl) {
        if (!descEl) return '';
        var fromAttr = String(descEl.getAttribute('data-door-desc-media-url') || '').trim();
        if (fromAttr) return fromAttr;
        var live = String(descEl.textContent || '');
        var original = String(descEl.getAttribute('data-door-original-desc') || '');
        return extractDescriptionMediaUrl(live) || extractDescriptionMediaUrl(original);
    }

    function applyMappedDoorWordingToTextNode(el, attrName) {
        if (!el) return false;
        if (el.classList && el.classList.contains('door-sdl-profile-desc')) return false;
        if (el.getAttribute && el.getAttribute('data-skip-door-wording') === '1') return false;
        var attr = attrName || 'data-door-original-desc';
        var live = String(el.textContent || '');
        // Preserve media URL before stripping so right-side images still hydrate.
        var mediaUrl = el.getAttribute('data-door-desc-media-url')
            || extractDescriptionMediaUrl(live)
            || extractDescriptionMediaUrl(el.getAttribute(attr) || '');
        if (mediaUrl) el.setAttribute('data-door-desc-media-url', mediaUrl);
        if (!el.getAttribute(attr)) {
            // Prefer storing the pre-rewrite form without media URLs.
            var seed = stripDescriptionMediaUrls(live);
            // If live text was already rewritten to gate/sidelight/transom, keep door form as original when possible.
            try {
                if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.normalizeGateMeasureOriginalHint === 'function') {
                    seed = window.DoorConf2Measurements.normalizeGateMeasureOriginalHint(seed) || seed;
                }
            } catch (eSeedHint) { }
            el.setAttribute(attr, seed);
        } else {
            try {
                if (attr === 'data-door-original-hint'
                    && window.DoorConf2Measurements
                    && typeof window.DoorConf2Measurements.normalizeGateMeasureOriginalHint === 'function') {
                    var curOrig = el.getAttribute(attr) || '';
                    var fixed = window.DoorConf2Measurements.normalizeGateMeasureOriginalHint(curOrig);
                    if (fixed && fixed !== curOrig) el.setAttribute(attr, fixed);
                }
            } catch (eFixHint) { }
        }
        var original = stripDescriptionMediaUrls(el.getAttribute(attr) || live);
        // Keep attribute clean if an older render stored a URL.
        if (el.getAttribute(attr) !== original) {
            el.setAttribute(attr, original);
        }
        var next = mapCollectionDoorWording(original);
        if (live !== next) {
            el.textContent = next;
            return true;
        }
        return false;
    }

    function syncCollectionDoorWordingCopy(root) {
        root = root || document.getElementById('door-configurator') || document;
        if (!root || !root.querySelectorAll) return;
        var changed = 0;
        var descSelectors = [
            '.door-option-desc',
            '.common-check-option-desc',
            '.door-panel-profile-choice-desc',
            '.door-stile-rail-choice-desc',
            '.door-measure-dimension-hint',
            '.door-collection-wording',
            '.door-wood-exposure > p.fw-600'
        ].join(',');
        try {
            root.querySelectorAll(descSelectors).forEach(function (el) {
                if (el.classList && el.classList.contains('door-sdl-profile-desc')) return;
                if (el.getAttribute && el.getAttribute('data-skip-door-wording') === '1') return;
                var attr = el.classList && el.classList.contains('door-measure-dimension-hint')
                    ? 'data-door-original-hint'
                    : 'data-door-original-desc';
                if (applyMappedDoorWordingToTextNode(el, attr)) changed++;
            });
            root.querySelectorAll('[data-choice-description]').forEach(function (el) {
                var live = String(el.getAttribute('data-choice-description') || '');
                if (!live) return;
                if (!el.getAttribute('data-door-original-choice-desc')) {
                    el.setAttribute('data-door-original-choice-desc', stripDescriptionMediaUrls(live));
                }
                var original = stripDescriptionMediaUrls(el.getAttribute('data-door-original-choice-desc') || live);
                if (el.getAttribute('data-door-original-choice-desc') !== original) {
                    el.setAttribute('data-door-original-choice-desc', original);
                }
                var next = mapCollectionDoorWording(original);
                if (live !== next) {
                    el.setAttribute('data-choice-description', next);
                    if (el.title && String(el.title) === live) el.title = next;
                    changed++;
                }
            });
        } catch (eDoorWordSync) { }
        logMeasureDebug('sync-door-wording', {
            type: getSidelightTransomCollectionType() || 'none',
            changed: changed
        });
    }

    function syncCollectionMeasureTitles(container) {
        var root = document;
        // Some measurement blocks are re-cloned/re-mounted after initial render.
        // Always scan the whole configurator DOM so every "Door Thickness" copy is renamed.
        var renamed = 0;
        all('.door-measure-dimension-title, h4[data-door-original-title]', root).forEach(function (titleEl) {
            if (!titleEl) return;
            var live = String(titleEl.textContent || '').trim();
            var original = String(titleEl.getAttribute('data-door-original-title') || live || '').trim();
            if (!original) return;
            var originalKey = normalizeOptionIdKey(original);
            var liveKey = normalizeOptionIdKey(live);
            var isThick = originalKey === 'exact_door_thickness'
                || originalKey === 'door_thickness'
                || originalKey === 'gate_thickness'
                || originalKey === 'exact_gate_thickness'
                || liveKey === 'exact_door_thickness'
                || liveKey === 'door_thickness'
                || liveKey === 'gate_thickness'
                || liveKey === 'exact_gate_thickness'
                || liveKey === 'sidelight_thickness'
                || liveKey === 'transom_thickness';
            if (!isThick) return;
            if (!titleEl.getAttribute('data-door-original-title')
                || originalKey === 'sidelight_thickness'
                || originalKey === 'transom_thickness'
                || originalKey === 'gate_thickness'
                || originalKey === 'exact_gate_thickness') {
                var seed = (liveKey.indexOf('exact') !== -1 || originalKey.indexOf('exact') !== -1)
                    ? 'Exact Door Thickness'
                    : 'Door Thickness';
                // Prefer door/exact door as the stable original (never store Gate Thickness as original).
                if (originalKey === 'gate_thickness' || originalKey === 'exact_gate_thickness') {
                    seed = originalKey.indexOf('exact') !== -1 ? 'Exact Door Thickness' : 'Door Thickness';
                }
                titleEl.setAttribute('data-door-original-title', seed);
                original = seed;
            }
            var next = mapCollectionMeasureTitle(original);
            if (String(titleEl.textContent || '').trim() !== next) renamed++;
            titleEl.textContent = next;

            // Dp strat 29-07
            try {
                var rowEl = titleEl.closest('.door-measure-dimension-row');
                if (rowEl) {
                    var imgEl = rowEl.querySelector('img.door-measure-svg, img');
                    if (imgEl) {
                        var colType = getSidelightTransomCollectionType();
                        if (colType === 'sidelight') {
                            imgEl.src = 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/Sidelight_Thickness.svg?v=1785226038';
                        } else if (colType === 'transom') {
                            imgEl.src = 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/Transom_Thickness.svg?v=1785226034';
                        }
                    }
                }
            } catch (eImg) { }
            // Dp end 29-07
        });

        // Dp start 10-08
        try {
            var colType = getSidelightTransomCollectionType();
            if (colType === 'sidelight' || colType === 'transom') {
                all('.door-measure-dimension-row, .door-measure-static-row', root).forEach(function (rowEl) {
                    if (!rowEl) return;
                    var imgEl = rowEl.querySelector('img.door-measure-svg, img');
                    if (!imgEl) return;
                    var titleEl = rowEl.querySelector('.door-measure-dimension-title, h4, .door-measure-dimension-heading');
                    var titleText = String((titleEl && titleEl.textContent) || '').toLowerCase();
                    var panelEl = (rowEl.parentElement ? rowEl.parentElement.closest('.door-measurement-static-panel, .door-rough-panel-jamb-sidelight, .door-jamb-sidelight-addon, .door-measurement-slab-sidelight-panels') : null) || rowEl;
                    var panelClass = String(panelEl ? panelEl.className || '' : '').toLowerCase();
                    var rowClass = String(rowEl.className || '').toLowerCase();
                    var combined = (titleText + ' ' + panelClass + ' ' + rowClass).toLowerCase();

                    var isJamb = combined.indexOf('jamb') !== -1;
                    var isRough = combined.indexOf('rough') !== -1;
                    var isFinished = combined.indexOf('finish') !== -1;
                    var isWidth = titleText.indexOf('width') !== -1;
                    var isHeight = titleText.indexOf('height') !== -1;
                    var isThick = titleText.indexOf('thick') !== -1;

                    var baseCdn = 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/';

                    if (colType === 'sidelight') {
                        if (isJamb && isWidth) {
                            imgEl.src = baseCdn + 'measurements-sidelight-jamb-unit-width.svg';
                        } else if (isJamb && isHeight) {
                            imgEl.src = baseCdn + 'measurements-sidelight-jamb-unit-height.svg';
                        } else if (isRough && isWidth) {
                            imgEl.src = baseCdn + 'measurements-sidelight-rough-width.svg';
                        } else if (isRough && isHeight) {
                            imgEl.src = baseCdn + 'measurements-sidelight-rough-height.svg';
                        } else if (isFinished && isWidth) {
                            imgEl.src = baseCdn + 'measurements-sidelight-finished-width.svg';
                        } else if (isFinished && isHeight) {
                            imgEl.src = baseCdn + 'measurements-sidelight-finished-height.svg';
                        } else if (isWidth) {
                            imgEl.src = baseCdn + 'Sidelight_Width.svg?v=1781095652';
                        } else if (isHeight) {
                            imgEl.src = baseCdn + 'Sidelight_Height.svg?v=1784873863';
                        } else if (isThick) {
                            imgEl.src = baseCdn + 'Sidelight_Thickness.svg?v=1785226038';
                        }
                    } else if (colType === 'transom') {
                        // Pre-hung Jamb Width / opening depth — not the jamb-unit width diagram
                        var isPreHungDepth =
                            /pre[\s-]?hung/.test(combined) ||
                            /opening depth/.test(combined);
                        if (isPreHungDepth) {
                            imgEl.src = baseCdn + 'transom-rough-opening-depth.svg?v=1790071863';
                        } else if (isJamb && isWidth) {
                            imgEl.src = baseCdn + 'measurements-transom-jamb-unit-width.svg';
                        } else if (isJamb && isHeight) {
                            imgEl.src = baseCdn + 'measurements-transom-jamb-unit-height.svg';
                        } else if (isRough && isWidth) {
                            imgEl.src = baseCdn + 'transom-rough-opening-width.svg?v=1790071898';
                        } else if (isRough && isHeight) {
                            imgEl.src = baseCdn + 'transom-rough-opening-height.svg?v=1790071899';
                        } else if (isFinished && isWidth) {
                            imgEl.src = baseCdn + 'measurements-transom-finished-width.svg';
                        } else if (isFinished && isHeight) {
                            imgEl.src = baseCdn + 'measurements-transom-finished-height.svg';
                        } else if (isWidth) {
                            imgEl.src = baseCdn + 'Transom_Width.svg?v=1784873926';
                        } else if (isHeight) {
                            imgEl.src = baseCdn + 'Transom_Height.svg?v=1781095600';
                        } else if (isThick) {
                            imgEl.src = baseCdn + 'Transom_Thickness.svg?v=1785226034';
                        }
                    }
                });
            }
        } catch (eImgAll) { }
        // Dp end 10-08

        // Also rewrite option/choice/static descriptions that say "door(s)".
        try { syncCollectionDoorWordingCopy(document.getElementById('door-configurator') || document); } catch (eDoorWord) { }
        try { syncSdlProfileSectionCopy(document.getElementById('door-configurator-options')); } catch (eSdlCopyWord) { }
        // Re-apply garden/pet Gate titles+hints after wording sync so Door copy cannot flicker back.
        try {
            if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.applyPetGatesMeasurementDimensionCopy === 'function') {
                window.DoorConf2Measurements.applyPetGatesMeasurementDimensionCopy(
                    document.getElementById('door-configurator-options') || document
                );
            }
        } catch (eGateCopySync) { }
        logMeasureDebug('sync-titles', {
            type: getSidelightTransomCollectionType(),
            renamed: renamed
        });
    }
    function ensureCollectionMeasureTitleObserver() {
        if (window.__doorCollectionMeasureTitleObserverBound) return;
        if (typeof MutationObserver === 'undefined') return;
        var root = document.getElementById('door-configurator') || document.body;
        if (!root) return;
        window.__doorCollectionMeasureTitleObserverBound = true;
        var tmr = null;
        var syncing = false;
        var obs = new MutationObserver(function (mutations) {
            if (syncing) return;
            // Ignore text-only churn from our own renames; only react to structural DOM changes.
            var structural = false;
            for (var mi = 0; mi < mutations.length; mi++) {
                if (mutations[mi].type === 'childList') { structural = true; break; }
            }
            if (!structural) return;
            if (tmr) clearTimeout(tmr);
            tmr = setTimeout(function () {
                tmr = null;
                syncing = true;
                try { syncCollectionMeasureTitles(document); } catch (eColTitleObs) { }
                syncing = false;
            }, 200);
        });
        obs.observe(root, { childList: true, subtree: true });
    }
    function isGardenGatesCollectionActive() {
        try {
            if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.isGardenGatesCollection === 'function') {
                return window.DoorConf2Measurements.isGardenGatesCollection();
            }
        } catch (eGg) { }
        return false;
    }

    function isGateCollectionActive() {
        try {
            if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.isGateCollection === 'function') {
                return window.DoorConf2Measurements.isGateCollection();
            }
        } catch (eGate) { }
        return false;
    }

    function isPetGatesCollectionActive() {
        try {
            if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.isPetGatesCollection === 'function') {
                return window.DoorConf2Measurements.isPetGatesCollection();
            }
        } catch (ePet) { }
        return false;
    }

    function applyGardenGatesCollectionRulesFromMeasurements(container) {
        try {
            if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.applyGardenGatesCollectionRules === 'function') {
                window.DoorConf2Measurements.applyGardenGatesCollectionRules(container, doorConfigSchema);
            }
        } catch (eGgRules) { }
    }

    function applyCollectionMeasureRowVisibility(container) {
        if (!container) container = document.getElementById('door-configurator-options');
        var main = document.getElementById('door-configurator');
        if (main) {
            main.classList.toggle('door-collection-garden-gates', isGardenGatesCollectionActive());
            main.classList.toggle('door-collection-pet-gates', isPetGatesCollectionActive());
        }
        ensureCollectionMeasureTitleObserver();
        syncCollectionMeasureTitles(document);
        // Re-apply after async dropdown/enhancement clones settle.
        setTimeout(function () { try { syncCollectionMeasureTitles(document); } catch (eColTitle0) { } }, 0);
        setTimeout(function () { try { syncCollectionMeasureTitles(document); } catch (eColTitle1) { } }, 300);
        setTimeout(function () { try { syncCollectionMeasureTitles(document); } catch (eColTitle2) { } }, 1000);
        applyGardenGatesCollectionRulesFromMeasurements(container);
    }

    // ===== DEFAULT OPTIONS (custom.configurator_defaults metafield) - START =====
    // Default selections (product + collection level): pre-fill option values defined
    // by the `custom.configurator_defaults` metafield (passed via data-default-selections).
    // Applied once, after the page clears default selections, and only on visible
    // choices so hidden options are never forced. Customer can change them.
    // Parse data-default-selections (array of JSON objects, earlier = higher priority)
    // into a single merged { optionId: value } map.
    function getMergedDefaultSelections() {
        var main = document.getElementById('door-configurator');
        if (!main) return {};
        var raw = main.getAttribute('data-default-selections') || '';
        var merged = {};
        try {
            var arr = raw.trim() ? JSON.parse(raw) : [];
            if (!Array.isArray(arr)) arr = [arr];
            // Earlier entries win, so merge from the end.
            for (var i = arr.length - 1; i >= 0; i--) {
                var o = arr[i];
                if (o && typeof o === 'object') {
                    for (var k in o) { if (Object.prototype.hasOwnProperty.call(o, k)) merged[k] = o[k]; }
                }
            }
        } catch (e) { return {}; }
        return merged;
    }

    // Get the default value configured for a single option id (matches either the
    // raw id or its normalized form), or null if none.
    function getDefaultSelectionForOption(optId) {
        if (optId == null) return null;
        var merged = getMergedDefaultSelections();
        if (merged[optId] != null && merged[optId] !== '') return merged[optId];
        var nk = String(optId).toLowerCase().replace(/-/g, '_');
        if (merged[nk] != null && merged[nk] !== '') return merged[nk];
        return null;
    }

    /**
     * Expand configurator_defaults values to real choice values in the DOM.
     * e.g. stile_and_rail_profile:"rm5" → rm5_applied_molding / applied_molding_choice
     */
    function getDefaultSelectionValueCandidates(optId, rawVal) {
        var optNorm = String(optId || '').toLowerCase().replace(/-/g, '_').replace(/\s+/g, '_');
        var raw = String(rawVal == null ? '' : rawVal).trim();
        var valNorm = raw.toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
        var out = [];
        function pushCand(v) {
            var s = String(v == null ? '' : v).trim();
            if (!s) return;
            if (out.indexOf(s) === -1) out.push(s);
            var n = s.toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
            if (n && out.indexOf(n) === -1) out.push(n);
        }
        pushCand(raw);
        pushCand(valNorm);

        if (optNorm === 'stile_and_rail_profile') {
            if (
                valNorm === 'rm5'
                || valNorm === 'rm_5'
                || valNorm === 'rm5_applied_molding'
            ) {
                // Metafield "rm5" means default the merged RM5 Applied Molding stile option.
                pushCand('rm5_applied_molding');
                pushCand('rm5');
                pushCand('rm_5');
                pushCand('applied_molding_choice');
                pushCand('applied_molding');
            } else if (
                valNorm === 'applied_molding'
                || valNorm === 'applied_molding_choice'
                || (valNorm.length > 16 && valNorm.slice(-16) === '_applied_molding')
            ) {
                pushCand(valNorm);
                pushCand('rm5_applied_molding');
                pushCand('applied_molding_choice');
                pushCand('applied_molding');
            }
        }

        if (optNorm === 'sdl_profile') {
            // Allow short defaults like "cove" to match cove / cove_profile keys.
            if (valNorm && valNorm.indexOf('_profile') === -1) {
                pushCand(valNorm + '_profile');
            }
            if (valNorm.slice(-8) === '_profile') {
                pushCand(valNorm.slice(0, -8));
            }
        }

        // Dp merge code 10-09 start — door location: machine tokens ↔ storefront radio labels
        if (
            optNorm === 'door_location_exposure'
            || optNorm === 'door_location'
            || optNorm === 'where_will_the_door_be_located'
            || optNorm === 'exposure'
        ) {
            if (
                valNorm === 'full_exposure'
                || valNorm === 'full'
                || valNorm === 'exposed'
                || valNorm === 'exposed_location'
                || (valNorm.indexOf('full') !== -1 && valNorm.indexOf('partial') === -1)
            ) {
                pushCand('Full Exposure');
                pushCand('full_exposure');
                pushCand('exposed_location');
            } else if (
                valNorm === 'partial_exposure'
                || valNorm === 'partial'
                || valNorm === 'covered'
                || valNorm === 'covered_location'
                || valNorm.indexOf('partial') !== -1
            ) {
                pushCand('Partial Exposure');
                pushCand('partial_exposure');
                pushCand('covered_location');
            } else if (
                valNorm === 'protected_location'
                || valNorm === 'protected'
                || valNorm.indexOf('protected') !== -1
            ) {
                pushCand('Protected Location');
                pushCand('protected_location');
            }
        }
        // Dp merge code 10-09 end

        return out;
    }

    function escapeDefaultSelectorValue(s) {
        return String(s == null ? '' : s).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    }

    function findRadioInputForDefaultSelection(container, optId, rawVal) {
        if (!container || optId == null || rawVal == null || rawVal === '') return null;
        var optIdEsc = escapeDefaultSelectorValue(optId);
        var candidates = getDefaultSelectionValueCandidates(optId, rawVal);
        var ci;
        for (ci = 0; ci < candidates.length; ci++) {
            var valEsc = escapeDefaultSelectorValue(candidates[ci]);
            var input = container.querySelector(
                'input[type="radio"][data-option-id="' + optIdEsc + '"][value="' + valEsc + '"]'
            );
            if (input) return input;
            // Some cards store value only on data-choice-value.
            var card = container.querySelector(
                '.door-option-wrap[data-option-id="' + optIdEsc + '"] .common-check-option[data-choice-value="' + valEsc + '"]'
            );
            if (card) {
                var cardInp = card.querySelector('input[type="radio"][data-option-id="' + optIdEsc + '"]');
                if (cardInp) return cardInp;
            }
            // Dp merge code 10-09 start — exposure cards live under wood wrap (not door_location_exposure wrap)
            if (optIdEsc === 'door_location_exposure' || optIdEsc === 'door_location') {
                var expCard = container.querySelector(
                    '.door-wood-exposure-card[data-choice-value="' + valEsc + '"]'
                );
                if (expCard) {
                    var expInp = expCard.querySelector('input[type="radio"][data-option-id="door_location_exposure"]');
                    if (expInp) return expInp;
                }
            }
            // Dp merge code 10-09 end
        }

        var optNorm = String(optId || '').toLowerCase().replace(/-/g, '_');
        // Dp merge code 10-09 start — fuzzy match exposure radios (full_exposure ↔ Full Exposure)
        if (optNorm === 'door_location_exposure' || optNorm === 'door_location') {
            var expRadios = container.querySelectorAll('input[type="radio"][data-option-id="door_location_exposure"]');
            for (var eri = 0; eri < expRadios.length; eri++) {
                if (defaultSelectionValuesMatch('door_location_exposure', rawVal, expRadios[eri].value)) {
                    return expRadios[eri];
                }
            }
        }
        // Dp merge code 10-09 end
        if (optNorm === 'stile_and_rail_profile') {
            var targetCanon = '';
            try { targetCanon = canonicalStileProfileKey(rawVal); } catch (eCanonDef) {
                targetCanon = String(rawVal || '').toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
            }
            if (!targetCanon) return null;
            var radios = container.querySelectorAll('input[type="radio"][data-option-id="' + optIdEsc + '"]');
            for (var ri = 0; ri < radios.length; ri++) {
                var inp = radios[ri];
                var inpCanon = '';
                try { inpCanon = canonicalStileProfileKey(inp.value); } catch (eInpCanon) {
                    inpCanon = String(inp.value || '').toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
                }
                if (inpCanon && inpCanon === targetCanon) return inp;
                // Default "rm5" → prefer any applied-molding stile card if rm5_* isn't present.
                if (
                    targetCanon === 'rm5_applied_molding'
                    && (inpCanon === 'applied_molding' || inpCanon === 'rm5_applied_molding')
                ) {
                    return inp;
                }
            }
        }
        return null;
    }

    function defaultSelectionValuesMatch(optId, configuredVal, choiceVal) {
        var candidates = getDefaultSelectionValueCandidates(optId, configuredVal);
        var choiceNorm = String(choiceVal == null ? '' : choiceVal).trim().toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
        if (!choiceNorm) return false;
        for (var i = 0; i < candidates.length; i++) {
            var cNorm = String(candidates[i] || '').trim().toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
            if (cNorm && cNorm === choiceNorm) return true;
        }
        var optNorm = String(optId || '').toLowerCase().replace(/-/g, '_');
        if (optNorm === 'stile_and_rail_profile') {
            try {
                var a = canonicalStileProfileKey(configuredVal);
                var b = canonicalStileProfileKey(choiceVal);
                if (a && b && a === b) return true;
                if (a === 'rm5_applied_molding' && b === 'applied_molding') return true;
            } catch (eMatchCanon) { }
        }
        return false;
    }

    function sortDefaultSelectionKeys(keys) {
        var parentsFirst = ['door_unit_design', 'pre_hung', 'sidelight_location', 'sidelight_style', 'transom_style', 'transom_count', 'door_location_exposure', 'wood_type', 'wood_type_storm_porch'];
        var deferred = ['swing_direction'];
        var ordered = [];
        parentsFirst.forEach(function (k) {
            if (keys.indexOf(k) !== -1) ordered.push(k);
        });
        keys.forEach(function (k) {
            if (parentsFirst.indexOf(k) !== -1) return;
            if (deferred.indexOf(k) !== -1) return;
            ordered.push(k);
        });
        deferred.forEach(function (k) {
            if (keys.indexOf(k) !== -1) ordered.push(k);
        });
        return ordered;
    }

    function pulseDependentVisibilityFromDefaults(container) {
        if (!container) return;
        var refIds = ['door_unit_design', 'pre_hung', 'sidelight_location', 'sidelight_style', 'transom_style', 'transom_count', 'measurement_type', 'door_location_exposure', 'wood_type', 'wood_type_storm_porch'];
        refIds.forEach(function (refId) {
            var checked = container.querySelector('input[type="radio"][data-option-id="' + refId + '"]:checked');
            if (checked) {
                try { checked.dispatchEvent(new Event('change', { bubbles: true })); } catch (ePulse) { }
            }
            var sel = container.querySelector('select[data-option-id="' + refId + '"]');
            if (sel && String(sel.value || '') !== '') {
                try { sel.dispatchEvent(new Event('change', { bubbles: true })); } catch (ePulseSel) { }
            }
        });
        if (doorConfigSchema) {
            try { applyHideWhen(doorConfigSchema, container); } catch (ePulseHide) { }
            try { applyChoiceVisibility(doorConfigSchema, container); } catch (ePulseChoice) { }
            try { applyProductTagChoiceVisibility(doorConfigSchema, container); } catch (ePulseTag) { }
        }
        try { hideEmptyOptionSections(container); } catch (ePulseEmpty) { }
        try { updateDoorPreview(); } catch (ePulsePrev) { }
        try { updateEstimatedPrice(); } catch (ePulsePrice) { }
        try { scheduleSdlProfileVisibilitySync(container); } catch (ePulseSdl) { }
        // --- Dp start 16-07  ---
        try { applyScreenAndStormInsertsDefaultSelection(container); } catch (eInsDefPulse) { }
        try { applySidelightTransomMeasurementTypeDefaultSelection(container); } catch (eMeasColPulse) { }
        try { applyShelfDefaultFromConfiguratorDefaults(container); } catch (eShelfDefPulse) { }
        try { applyLocksetPrepNoneDefault(container); } catch (eLocksetDefPulse) { }
        // Dp merge code 10-09 start
        try { applyDoorLocationExposureDefaultSelection(container); } catch (eExpDefPulse) { }
        // Dp merge code 10-09 end
        // --- Dp end 16-07  ---
    }

    // --- Dp start 16-07  ---
    function applyScreenAndStormInsertsDefaultSelection(container) {
        if (!container || doorRestorePending()) return;
        var optId = 'screen_and_storm_inserts';
        var section = container.querySelector('.door-option-wrap[data-option-id="' + optId + '"]');
        if (!section) return;

        var radioWrap = section.querySelector('.common-check-options:not(.door-inserts-additional-options-cards)');
        if (!radioWrap) radioWrap = section.querySelector('.common-check-options');
        if (!radioWrap) return;

        var firstCard = null;
        var firstInp = null;
        var cards = radioWrap.querySelectorAll('.common-check-option');
        for (var ci = 0; ci < cards.length; ci++) {
            var card = cards[ci];
            if (card.closest('.door-inserts-additional-options')) continue;
            if (card.style.display === 'none' || card.classList.contains('door-hidden')) continue;
            if (card.getAttribute('data-product-tag-hidden') === '1') continue;
            if (card.getAttribute('data-choice-condition-hidden') === '1') continue;
            var inp = card.querySelector('input[type="radio"][data-option-id="' + optId + '"]');
            if (!inp || inp.disabled) continue;
            firstCard = card;
            firstInp = inp;
            break;
        }
        if (!firstInp || !firstCard) return;

        var alreadyFirst = firstInp.checked && firstCard.classList.contains('common-check-option--selected');
        if (alreadyFirst) {
            var wrongChecked = false;
            radioWrap.querySelectorAll('input[type="radio"][data-option-id="' + optId + '"]:checked').forEach(function (r) {
                if (r !== firstInp) wrongChecked = true;
            });
            if (!wrongChecked) return;
        }

        radioWrap.querySelectorAll('input[type="radio"][data-option-id="' + optId + '"]').forEach(function (r) {
            var isFirst = (r === firstInp);
            r.checked = isFirst;
            var c = r.closest && r.closest('.common-check-option');
            if (c) c.classList.toggle('common-check-option--selected', isFirst);
        });
        try { firstInp.dispatchEvent(new Event('change', { bubbles: true })); } catch (eChg) { }
    }
    // --- Dp end 16-07  ---

    // Dp merge code 10-09 start — mirror storefront default for "Where will the door be located?"
    // Prefer configurator_defaults; else select Full Exposure (first card) so wood filter +
    // admin/quote always see the same selection the customer sees without clicking.
    function applyDoorLocationExposureDefaultSelection(container) {
        if (!container || doorRestorePending()) return;
        var radios = container.querySelectorAll('input[type="radio"][data-option-id="door_location_exposure"]');
        if (!radios || !radios.length) return;
        var anyChecked = false;
        for (var ri = 0; ri < radios.length; ri++) {
            if (radios[ri].checked) { anyChecked = true; break; }
        }
        if (anyChecked) return;

        var defVal = getDefaultSelectionForOption('door_location_exposure');
        if (defVal == null || defVal === '') defVal = getDefaultSelectionForOption('door_location');
        if (defVal == null || defVal === '') {
            var mergedLoc = getMergedDefaultSelections();
            var locKeys = Object.keys(mergedLoc || {});
            for (var lki = 0; lki < locKeys.length; lki++) {
                var lk = locKeys[lki];
                var lkNorm = String(lk || '').toLowerCase().replace(/-/g, '_').replace(/[?\s]+/g, '_').replace(/_+/g, '_').replace(/^_|_$/g, '');
                if (
                    lkNorm === 'where_will_the_door_be_located'
                    || lkNorm === 'door_location_exposure'
                    || lkNorm === 'door_location'
                    || lkNorm === 'exposure'
                ) {
                    defVal = mergedLoc[lk];
                    break;
                }
            }
        }
        if (defVal == null || String(defVal).trim() === '') {
            defVal = 'Full Exposure';
        }

        var pick = findRadioInputForDefaultSelection(container, 'door_location_exposure', defVal);
        if (!pick) {
            pick = radios[0];
        }
        if (!pick) return;

        for (var uj = 0; uj < radios.length; uj++) {
            var r = radios[uj];
            var isPick = (r === pick);
            r.checked = isPick;
            var c = r.closest && r.closest('.common-check-option');
            if (c) c.classList.toggle('common-check-option--selected', isPick);
        }
        try { pick.dispatchEvent(new Event('change', { bubbles: true })); } catch (eExpDefChg) { }
    }
    // Dp merge code 10-09 end

    /** Collection-based measurement_type default (sidelight / transom → exact_* tab). */
    function applySidelightTransomMeasurementTypeDefaultSelection(container, force) {
        if (!container || doorRestorePending()) return;
        // Collection handle wins over configurator_defaults.measurement_type
        // (collection defaults intentionally skip measurement_type).
        try {
            if (
                window.DoorConf2Measurements
                && typeof window.DoorConf2Measurements.applySidelightTransomMeasurementTypeDefault === 'function'
            ) {
                window.DoorConf2Measurements.applySidelightTransomMeasurementTypeDefault(
                    container,
                    doorConfigSchema,
                    { force: force !== false }
                );
            }
        } catch (eMeasColDef) { }
    }

    var _collectionDefaultsApplied = false;
    function applyCollectionDefaultSelections(container) {
        if (_collectionDefaultsApplied) return;
        var main = document.getElementById('door-configurator');
        if (!main || !container) return;
        var merged = getMergedDefaultSelections();
        var keys = sortDefaultSelectionKeys(Object.keys(merged));
        if (!keys.length) { _collectionDefaultsApplied = true; return; }
        // Skip a choice ONLY if it's hidden by a visibility filter (door-hidden /
        // product-tag / wood-exposure / display:none). Collapsed accordions (.door-accordion-body)
        // are NOT treated as hidden, so deeper options (e.g. stile_and_rail_profile) still apply.
        function defaultChoiceHiddenByFilters(el) {
            var node = el;
            while (node && node !== container && node !== document.body) {
                if (!(node.classList && node.classList.contains('door-accordion-body'))) {
                    if (node.classList && node.classList.contains('door-hidden')) return true;
                    if (node.getAttribute) {
                        if (node.getAttribute('data-product-tag-hidden') === '1') return true;
                        if (node.getAttribute('data-wood-exposure-hidden') === '1') return true;
                        if (node.getAttribute('data-optional-shelf-hidden') === '1') return true;
                        if (node.getAttribute('data-choice-condition-hidden') === '1') return true;
                    }
                    if (node.style && node.style.display === 'none') return true;
                }
                node = node.parentNode;
            }
            return false;
        }
        var appliedAny = false;
        keys.forEach(function (optId) {
            // --- Dp start 16-07  ---
            var optIdNormDef = String(optId || '').toLowerCase().replace(/-/g, '_');
            if (optIdNormDef === 'screen_and_storm_inserts') return;
            // Entrance-units only: leave measurement tabs unselected on load.
            if (optIdNormDef === 'measurement_type') {
                var skipEntranceMtDefault = false;
                try {
                    if (
                        window.DoorConf2Measurements
                        && typeof window.DoorConf2Measurements.hasEntranceUnitsTag === 'function'
                    ) {
                        skipEntranceMtDefault = !!window.DoorConf2Measurements.hasEntranceUnitsTag();
                    } else {
                        var cfgEnt = document.getElementById('door-configurator')
                            || document.getElementById('landing-product-configurator');
                        var tagsEnt = cfgEnt ? String(cfgEnt.getAttribute('data-product-tags') || '').toLowerCase() : '';
                        skipEntranceMtDefault = tagsEnt.indexOf('entrance-units') !== -1;
                    }
                } catch (eSkipEntMt) { }
                if (skipEntranceMtDefault) return;
            }
            if (optIdNormDef === 'panel_profile' && shouldHidePanelProfile()) return;
            // --- Dp end 16-07  ---
            // Dp merge code 10-09 start — map location label / door_location defaults onto exposure radios
            var applyOptId = optId;
            var applyOptNorm = String(optId || '').toLowerCase().replace(/-/g, '_').replace(/[?\s]+/g, '_').replace(/_+/g, '_').replace(/^_|_$/g, '');
            if (
                applyOptNorm === 'door_location'
                || applyOptNorm === 'where_will_the_door_be_located'
                || applyOptNorm === 'exposure'
            ) {
                applyOptId = 'door_location_exposure';
            }
            // Dp merge code 10-09 end
            var val = String(merged[optId]);
            var input = findRadioInputForDefaultSelection(container, applyOptId, val);
            if (input) {
                if (defaultChoiceHiddenByFilters(input)) return; // hidden by filters, not collapse
                var card = input.closest('.common-check-option');
                // Uncheck sibling radios for this option first.
                container.querySelectorAll('input[type="radio"][data-option-id="' + escapeDefaultSelectorValue(optId) + '"]').forEach(function (r) {
                    r.checked = false;
                    var rc = r.closest && r.closest('.common-check-option');
                    if (rc) rc.classList.remove('common-check-option--selected');
                });
                // Dp merge code 10-09 start — also clear exposure siblings when applying via door_location alias
                if (applyOptId !== optId) {
                    container.querySelectorAll('input[type="radio"][data-option-id="' + escapeDefaultSelectorValue(applyOptId) + '"]').forEach(function (r) {
                        r.checked = false;
                        var rc2 = r.closest && r.closest('.common-check-option');
                        if (rc2) rc2.classList.remove('common-check-option--selected');
                    });
                }
                // Dp merge code 10-09 end
                input.checked = true;
                if (card) card.classList.add('common-check-option--selected');
                try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (e2) { }
                appliedAny = true;
                return;
            }
            var sel = container.querySelector('select[data-option-id="' + escapeDefaultSelectorValue(optId) + '"]');
            if (sel) {
                var measUnit = sel.getAttribute ? String(sel.getAttribute('data-unit') || '') : '';
                if (measUnit === 'in-int' || measUnit === 'in-frac') return;
                if (sel.getAttribute && sel.getAttribute('data-door-user-changed') === '1') return;
                var selIdDef = String(sel.id || '').toLowerCase();
                if (
                    selIdDef === 'exact-door-thickness-frac'
                    || selIdDef.indexOf('exact-door-thickness-frac') === 0
                    || selIdDef === 'door-thickness'
                ) return;
                var selCandidates = getDefaultSelectionValueCandidates(optId, val);
                var matchedSelVal = '';
                for (var sci = 0; sci < selCandidates.length; sci++) {
                    var cand = selCandidates[sci];
                    var hasOpt = Array.prototype.some.call(sel.options || [], function (op) {
                        return String(op.value || '') === String(cand);
                    });
                    if (hasOpt) { matchedSelVal = cand; break; }
                }
                if (!matchedSelVal) matchedSelVal = val;
                sel.value = matchedSelVal;
                try { sel.dispatchEvent(new Event('change', { bubbles: true })); } catch (e3) { }
                appliedAny = true;
            }
        });
        if (appliedAny) {
            if (doorConfigSchema) {
                try { applyHideWhen(doorConfigSchema, container); } catch (eDefHide) { }
                try { applyChoiceVisibility(doorConfigSchema, container); } catch (eDefChoice) { }
            }
            try { promoteSelectedProfileToHero(container, { collapseAccordion: false }); } catch (eDefHero) { }
            pulseDependentVisibilityFromDefaults(container);

            // Keep retrying until stile default (e.g. "rm5" → rm5_applied_molding) is actually selected.
            var stileDefRaw = merged.stile_and_rail_profile;
            if (stileDefRaw == null || stileDefRaw === '') {
                stileDefRaw = merged['stile-and-rail-profile'];
            }
            var stileDefaultOk = true;
            if (stileDefRaw != null && String(stileDefRaw) !== '') {
                var stileChecked = container.querySelector(
                    'input[type="radio"][data-option-id="stile_and_rail_profile"]:checked'
                );
                stileDefaultOk = !!(
                    stileChecked
                    && defaultSelectionValuesMatch('stile_and_rail_profile', stileDefRaw, stileChecked.value)
                );
            }
            if (stileDefaultOk) {
                _collectionDefaultsApplied = true;
            }
        }
    }
    // ===== DEFAULT OPTIONS (custom.configurator_defaults metafield) - END =====

    // Hide an option section/accordion (including its title) when it has no available
    // choices to show after all visibility filters have run. Re-evaluated on changes so
    // a section reappears if its choices become available later.
    function isMarkedHiddenEl(el) {
        if (!el || !el.getAttribute) return false;
        if (el.classList && el.classList.contains('door-hidden')) return true;
        if (el.getAttribute('data-product-tag-hidden') === '1') return true;
        if (el.getAttribute('data-wood-exposure-hidden') === '1') return true;
        if (el.style && el.style.display === 'none') return true;
        return false;
    }

    function isChoiceAvailableInSection(el, section) {
        var node = el;
        while (node && node !== section.parentNode) {
            // Accordion collapse uses the body wrapper; ignore it so collapsed
            // accordions are still considered to have content.
            if (!(node.classList && node.classList.contains('door-accordion-body'))) {
                if (isMarkedHiddenEl(node)) return false;
            }
            node = node.parentNode;
        }
        return true;
    }

    function sectionHasAvailableContent(section) {
        if (!section) return false;
        // Card-style choices (radio/checkbox cards).
        var cards = all('.common-check-option', section);
        for (var i = 0; i < cards.length; i++) {
            if (isChoiceAvailableInSection(cards[i], section)) return true;
        }
        // Door setup option labels.
        var setupOpts = all('.door-setup-option', section);
        for (var s = 0; s < setupOpts.length; s++) {
            if (isChoiceAvailableInSection(setupOpts[s], section)) return true;
        }
        // Native selects (incl. dimension/measurement selects) with at least one usable option.
        var selects = all('select', section);
        for (var j = 0; j < selects.length; j++) {
            var sel = selects[j];
            if (!isChoiceAvailableInSection(sel, section)) continue;
            var opts = sel.options || [];
            for (var k = 0; k < opts.length; k++) {
                var op = opts[k];
                if (!op) continue;
                if (op.hidden || op.disabled) continue;
                if (String(op.value == null ? '' : op.value) === '') continue;
                return true;
            }
        }
        // Free inputs (dimension/number/text) that are real controls.
        var inputs = all('input[type="number"], input[type="text"]', section);
        for (var m = 0; m < inputs.length; m++) {
            if (isChoiceAvailableInSection(inputs[m], section)) return true;
        }
        return false;
    }

    // --- Dp start ---
    function shouldHidePanelProfile() {
        var configEl = document.getElementById('door-configurator') || document.getElementById('landing-product-configurator');
        if (!configEl) return false;
        var val = configEl.getAttribute('data-number-of-wood-panels');
        if (val === null) return false;
        var trimmed = val.trim();
        return trimmed === '' || trimmed === '0';
    }

    function isInactivePanelProfileOption(optId) {
        var id = String(optId || '').toLowerCase().replace(/-/g, '_');
        if (id !== 'panel_profile') return false;
        try { return shouldHidePanelProfile(); } catch (eHidePp) { return false; }
    }

    function isInactivePanelProfileSummaryLabel(label) {
        var key = String(label || '').toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
        if (!key || key.indexOf('panel profile') === -1) return false;
        try { return shouldHidePanelProfile(); } catch (eHidePpLab) { return false; }
    }

    function pruneInactivePanelProfileSelection(config) {
        if (!config || typeof config !== 'object') return config;
        if (!shouldHidePanelProfile()) return config;
        if (Object.prototype.hasOwnProperty.call(config, 'panel_profile')) config.panel_profile = null;
        return config;
    }

    // dp start 21-07
    function checkMetafieldTrue(keyword, defaultValue) {
        // Dp start 22-07 — prefer exact data-* attr (supports explicit "false" from boolean metafields)
        function parseBoolToken(raw) {
            // Native boolean / null (Shopify sometimes exposes null for false)
            if (raw === true || raw === 1) return true;
            if (raw === false || raw === 0 || raw === null) return false;
            var v = String(raw == null ? '' : raw).trim().toLowerCase();
            if (v === '' || v === 'undefined') return null; // unset → use defaultValue
            if (v === 'true' || v === '1') return true;
            // "false" / "null" / "0" → false (null string = selected-false fallback)
            if (v === 'false' || v === '0' || v === 'null') return false;
            return null;
        }
        try {
            var configElExact = document.getElementById('door-configurator')
                || document.getElementById('landing-product-configurator')
                || (typeof document !== 'undefined' && document.querySelector && document.querySelector('#door-configurator'))
                || (typeof document !== 'undefined' && document.querySelector && document.querySelector('#landing-product-configurator'));
            if (configElExact && configElExact.getAttribute) {
                var exactName = 'data-' + String(keyword || '').replace(/_/g, '-');
                if (configElExact.hasAttribute(exactName)) {
                    var exactParsed = parseBoolToken(configElExact.getAttribute(exactName));
                    if (exactParsed !== null) return exactParsed;
                    // empty attr = unset → fall through to defaultValue at end
                }
            }
        } catch (eExact) { }
        // Dp end 22-07

        // Check window globals
        try {
            var keys = [keyword.replace(/-/g, '_'), keyword];
            for (var k = 0; k < keys.length; k++) {
                var key = keys[k];
                if (window.custom && window.custom[key] !== undefined && window.custom[key] !== null) {
                    var parsedCustom = parseBoolToken(window.custom[key]);
                    if (parsedCustom !== null) return parsedCustom;
                }
                if (window.product && window.product.metafields && window.product.metafields.custom && window.product.metafields.custom[key] !== undefined && window.product.metafields.custom[key] !== null) {
                    var mfVal = window.product.metafields.custom[key];
                    if (mfVal && typeof mfVal === 'object' && mfVal.value !== undefined) mfVal = mfVal.value;
                    var parsedMf = parseBoolToken(mfVal);
                    if (parsedMf !== null) return parsedMf;
                }
                if (window[key] !== undefined && window[key] !== null) {
                    var parsedWin = parseBoolToken(window[key]);
                    if (parsedWin !== null) return parsedWin;
                }
            }
        } catch (e) { }

        var configEl = document.getElementById('door-configurator')
            || document.getElementById('landing-product-configurator')
            || (typeof document !== 'undefined' && document.querySelector && document.querySelector('#door-configurator'))
            || (typeof document !== 'undefined' && document.querySelector && document.querySelector('#landing-product-configurator'));
        if (!configEl) return defaultValue;

        // Find attribute containing keyword
        if (configEl.attributes) {
            for (var i = 0; i < configEl.attributes.length; i++) {
                var attr = configEl.attributes[i];
                var name = String(attr.name).toLowerCase();
                if (name.indexOf(keyword.replace(/_/g, '-')) !== -1 || name.indexOf(keyword.replace(/-/g, '_')) !== -1) {
                    var parsedAttr = parseBoolToken(attr.value);
                    if (parsedAttr !== null) return parsedAttr;
                }
            }
        }
        return defaultValue;
    }

    // Metafield true/false: TRUE => show; unset/empty/false => hide
    function shouldHidePetDoor() {
        return !checkMetafieldTrue('pet-door-eligible', false);
    }
    // dp start 21-07
    // function shouldHideSelectStormGlass() {
    //     return checkMetafieldTrue('fixed-glass-eligible', true);
    // }
    // function shouldHideSelectScreen() {
    //     return checkMetafieldTrue('fixed-screen-eligible', true);
    // }
    // function shouldHideTopBottomInserts() {
    //     return !checkMetafieldTrue('top-bottom-insert-eligible', false);
    // }
    // dp end 21-07
    // Dp start 22-07
    // Metafield true/false: unset/empty => show default; false => hide; true => show
    function shouldHideSelectStormGlass() {
        return !checkMetafieldTrue('fixed-glass-eligible', true);
    }
    function shouldHideSelectScreen() {
        return false;
    }
    function shouldHideFixedScreen() {
        return !checkMetafieldTrue('fixed-screen-eligible', false);
    }
    function shouldHideFixedGlass() {
        return !checkMetafieldTrue('fixed-glass-eligible', false);
    }
    function shouldHideTopBottomInserts() {
        return !checkMetafieldTrue('top-bottom-insert-eligible', false);
    }
    /**
     * Hide glass_type only when both product metafields custom.number_of_glass_lights
     * and custom.light_area are empty (show if either is set).
     */
    function shouldHideGlassTypeOptions() {
        var configEl = document.getElementById('door-configurator')
            || document.getElementById('landing-product-configurator');
        if (!configEl) return false;
        var lights = String(configEl.getAttribute('data-number-of-glass-lights') || '').trim();
        var area = String(configEl.getAttribute('data-light-area') || '').trim();
        return lights === '' && area === '';
    }
    // Dp end 22-07

    function isScreenStormProduct() {
        var configEl = document.getElementById('door-configurator') || document.getElementById('landing-product-configurator');
        return !!(configEl && configEl.getAttribute('data-use-screen-storm-glass-meta') === 'true');
    }

    /** True when product has tag interior-doors (skip wood location exposure). */
    function isInteriorDoorProduct() {
        try {
            var configEl = document.getElementById('door-configurator')
                || document.getElementById('landing-product-configurator');
            if (!configEl) return false;
            if (configEl.getAttribute('data-use-interior-glass-meta') === 'true') return true;

            var tagsAttr = configEl.getAttribute('data-product-tags') || '';
            var tags = [];
            try {
                var parsed = typeof tagsAttr === 'string' && tagsAttr.trim() ? JSON.parse(tagsAttr) : [];
                tags = Array.isArray(parsed)
                    ? parsed.map(function (t) { return String(t).trim().toLowerCase(); }).filter(Boolean)
                    : [];
            } catch (eTags) {
                tags = String(tagsAttr || '').split(/[|,]/).map(function (t) {
                    return String(t).trim().toLowerCase();
                }).filter(Boolean);
            }
            for (var i = 0; i < tags.length; i++) {
                if (normProductTagSlug(tags[i]) === 'interior-doors') return true;
            }
        } catch (eInterior) { }
        return false;
    }

    /** Sidelight/transom card suffix — screen & storm uses Sidelight/Transom labels. */
    function getSidelightTransomLabelSuffix(isTransom) {
        if (isScreenStormProduct()) {
            return isTransom ? ' Screen & Storm Transom' : ' Screen & Storm Sidelight';
        }
        return getCollectionNameSuffix();
    }

    function getCollectionNameSuffix() {
        var configEl = document.getElementById('door-configurator') || document.getElementById('landing-product-configurator');
        if (!configEl) return '';
        var isScreenStorm = configEl.getAttribute('data-use-screen-storm-glass-meta') === 'true';
        var isInterior = configEl.getAttribute('data-use-interior-glass-meta') === 'true';
        if (isScreenStorm) {
            return ' Screen & Storm Door';
        } else if (isInterior) {
            return ' Interior Sidelight';
        } else {
            return ' Exterior Sidelight';
        }
    }
    // --- Dp end --

    // Ensure Panel Profile and Stile and Rail Profile always render a section, even
    // when the option is absent from the schema (its metafield was not configured).
    // Renders a default header-only section: title + "About …" button + one default
    // description line (no choice cards, no accordion). If the option is present in
    // the schema (and therefore rendered by the normal loop) this is a no-op.
    function ensureProfileSectionsRendered(container, schema) {
        if (!container) return;
        var infoSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.03206 4.92901C7.79606 4.92901 7.60406 4.85301 7.45606 4.70101C7.30806 4.54501 7.23406 4.35301 7.23406 4.12501C7.23406 3.90101 7.30806 3.71301 7.45606 3.56101C7.60406 3.40901 7.79606 3.33301 8.03206 3.33301C8.27206 3.33301 8.46606 3.40901 8.61406 3.56101C8.76206 3.71301 8.83606 3.90101 8.83606 4.12501C8.83606 4.35301 8.76206 4.54501 8.61406 4.70101C8.46606 4.85301 8.27206 4.92901 8.03206 4.92901ZM8.68606 6.59101L8.64406 7.64701V11.337L9.51406 11.631V11.859H6.66406V11.631L7.52206 11.337V7.78501C7.47406 7.72501 7.40406 7.66501 7.31206 7.60501C7.22406 7.54501 7.12406 7.48701 7.01206 7.43101C6.90006 7.37501 6.78606 7.32701 6.67006 7.28701V7.08301L8.53006 6.59101H8.68606Z" fill="currentColor"></path><circle cx="8" cy="8" r="7.5" stroke="currentColor"></circle></svg>';
        var defs = [
            {
                id: 'panel_profile',
                title: 'Panel Profile',
                desc: 'The standard panel profile for this door has been selected to match the design.',
                aboutLabel: 'About Panel Profiles',
                btnClass: 'door-panel-profile-btn',
                openAttr: 'data-panel-profile-open',
                getAria: function () { try { return getPanelProfileDrawerAriaControls(); } catch (e) { return ''; } },
                openDrawer: function () { try { openPanelProfileDrawer(); } catch (e) { } }
            },
            {
                id: 'stile_and_rail_profile',
                title: 'Stile and Rail Profile',
                desc: 'The standard stile and rail profile for this door has been selected to match the design.',
                aboutLabel: 'About Stile and Rail Profiles',
                btnClass: 'door-edge-profile-btn',
                openAttr: 'data-wood-drawer-open',
                getAria: function () { try { return getEdgeProfileDrawerAriaControls() || getDoorSetupDrawerAriaControls(); } catch (e) { return ''; } },
                openDrawer: function () { try { if (!openEdgeProfileDrawer()) openDoorSetupDrawer(); } catch (e) { } }
            }
        ];
        defs.forEach(function (def) {
            // --- Dp start ---
            if (def.id === 'panel_profile' && shouldHidePanelProfile()) return;
            // --- Dp end --
            // Already in the DOM (rendered by the schema loop)? Leave it alone.
            if (container.querySelector('[data-option-id="' + def.id + '"]')) return;
            // Present in the schema? The normal loop owns rendering it; do not duplicate.
            if (Array.isArray(schema) && schema.some(function (o) { return o && normalizeOptionIdKey(o.id) === def.id; })) return;

            var section = document.createElement('div');
            section.className = 'door-section door-option-wrap';
            section.setAttribute('data-option-id', def.id);
            section.setAttribute('data-default-profile-section', '1');

            var headerRow = document.createElement('div');
            headerRow.className = 'door-option-header-row';
            var leftWrap = document.createElement('div');
            leftWrap.className = 'door-option-title-wrap';
            var title = document.createElement('h3');
            title.className = 'door-section-title door-option-title';
            var titleText = document.createElement('span');
            titleText.textContent = def.title;
            title.appendChild(titleText);

            var aboutBtn = document.createElement('button');
            aboutBtn.type = 'button';
            aboutBtn.className = 'wood-species-open-btn common-btn btn-secondary btn-small ' + def.btnClass;
            aboutBtn.setAttribute(def.openAttr, '');
            aboutBtn.setAttribute('aria-haspopup', 'dialog');
            aboutBtn.setAttribute('aria-controls', def.getAria() || '');
            aboutBtn.innerHTML = def.aboutLabel + infoSvg;
            aboutBtn.addEventListener('click', function (ev) {
                ev.preventDefault();
                ev.stopPropagation();
                aboutBtn.setAttribute('aria-controls', def.getAria() || '');
                def.openDrawer();
            });
            title.appendChild(aboutBtn);
            leftWrap.appendChild(title);
            headerRow.appendChild(leftWrap);
            section.appendChild(headerRow);

            var descP = document.createElement('p');
            descP.className = 'door-option-desc';
            descP.textContent = def.desc;
            section.appendChild(descP);

            container.appendChild(section);
        });
    }

    function hideEmptyOptionSections(container) {
        if (!container) container = document.getElementById('door-configurator-options');
        if (!container) return;
        var sections = all('.door-option-wrap[data-option-id]', container);
        // Pass 1: clear our own markers so a stale display:none on a nested wrap does
        // not bias the content check of a parent section.
        sections.forEach(function (section) {
            if (section.getAttribute('data-empty-hidden') === '1') {
                section.removeAttribute('data-empty-hidden');
                section.style.display = '';
            }
        });
        // Pass 2: hide sections that have no available content (skip ones already
        // hidden by hideWhen/showWhen logic).
        sections.forEach(function (section) {
            var sid = String(section.getAttribute('data-option-id') || '');
            // dp start 21-07
            // Dp start 22-07 — hide only when metafield is explicitly false (unset/true = show)
            // Visibility for these is owned by applyHideWhen inserts-mode logic; skip empty-hide.
            // Hide select_storm_glass / storm_glass_type if shouldHideSelectStormGlass() is true
            if (sid === 'select_storm_glass' || sid === 'storm_glass' || sid === 'storm_glass_type') {
                try {
                    if (shouldHideSelectStormGlass()) {
                        section.classList.add('door-hidden');
                        section.setAttribute('data-empty-hidden', '1');
                        section.style.display = 'none';
                        return;
                    }
                    return;
                } catch (eGlassHide) { }
            }
            // Hide glass_type only when both number_of_glass_lights and light_area are empty
            if (sid === 'glass_type' || sid === 'glass-type') {
                try {
                    if (shouldHideGlassTypeOptions()) {
                        section.classList.add('door-hidden');
                        section.setAttribute('data-empty-hidden', '1');
                        section.setAttribute('hidden', 'true');
                        section.style.display = 'none';
                        return;
                    }
                    section.classList.remove('door-hidden');
                    section.removeAttribute('data-empty-hidden');
                    section.removeAttribute('hidden');
                    section.style.display = '';
                } catch (eGlassTypeHide) { }
            }
            // Hide select_screen or screen_type if shouldHideSelectScreen() is true
            if (sid === 'select_screen' || sid === 'screen_type') {
                try {
                    if (shouldHideSelectScreen()) {
                        section.classList.add('door-hidden');
                        section.setAttribute('data-empty-hidden', '1');
                        section.style.display = 'none';
                        return;
                    }
                    return;
                } catch (eScreenHide) { }
            }
            // Hide pet_door section if shouldHidePetDoor() is true
            if (sid === 'pet_door' || sid === 'pet-door') {
                try {
                    if (shouldHidePetDoor()) {
                        section.classList.add('door-hidden');
                        section.setAttribute('data-empty-hidden', '1');
                        section.style.display = 'none';
                        return;
                    }
                    section.classList.remove('door-hidden');
                    section.removeAttribute('data-empty-hidden');
                    section.removeAttribute('hidden');
                    section.style.display = '';
                } catch (ePetHide) { }
            }
            // Dp end 22-07
            // dp end 21-07
            if (sid === 'measurement_type') return;
            if (isGateCollectionActive() && sid === 'swing_direction') return;
            if (sid === 'panel_unit_design' || sid === 'porch_panel_project') return;
            if (isAdditionalOptionsSelectOption(sid) || sid === 'priming') return;
            if (sid === 'sdl_profile' && section.getAttribute('data-sdl-nested') === '1') return;
            // --- Dp start 16-07 ---
            if (sid === 'applied_molding' || sid === 'applied_molding_choice') {
                // Merged into stile_and_rail_profile — always hide this accordion section.
                section.classList.add('door-hidden');
                section.setAttribute('data-empty-hidden', '1');
                section.setAttribute('hidden', 'true');
                section.style.display = 'none';
                return;
            }
            // --- Dp end 16-07 ---
            // --- Dp start 20-07 ---
            // hide insert frame color if fixed glass or fixed screen is selected, but do not hide screen type or storm glass type
            if (sid === 'screen_storm_insert_frame_color') {
                var fixedActive = !!container.querySelector('input[type="checkbox"][data-option-id="screen_and_storm_inserts_additional_options"][value="fixed_glass"]:checked')
                    || !!container.querySelector('input[type="checkbox"][data-option-id="screen_and_storm_inserts_additional_options"][value="fixed_screen"]:checked');
                if (fixedActive) {
                    section.classList.add('door-hidden');
                    section.setAttribute('data-empty-hidden', '1');
                    section.style.display = 'none';
                    return;
                } else {
                    section.classList.remove('door-hidden');
                    section.removeAttribute('data-empty-hidden');
                    section.removeAttribute('hidden');
                    section.style.display = '';
                }
            }
            // --- Dp end 20-07 ---
            if (sid === 'sdl_profile') {
                /* MERGE: sdl_enable_toggle — start */
                // Visibility (toggle + choices) is owned by syncSdlProfileVisibility.
                try { scheduleSdlProfileVisibilitySync(container); } catch (eSdlEmptySync) { }
                return;
                /* MERGE: sdl_enable_toggle — end */
            }
            // --- Dp end 16-07 ---
            // Panel Profile / Stile and Rail Profile: always render the full section by
            // default (header, About button, hero, description). Only their inner
            // "Additional … Options" accordion is toggled (handled at render time per
            // metafield). Clear any stale hidden markers so the section never disappears
            // when its additional-options metafield is empty.
            if (sid === 'panel_profile' || sid === 'stile_and_rail_profile') {
                // --- Dp start ---
                if (sid === 'panel_profile' && shouldHidePanelProfile()) {
                    section.classList.add('door-hidden');
                    section.style.display = 'none';
                    section.setAttribute('hidden', 'true');
                    try { clearOptionRadioSelections(container, ['panel_profile']); } catch (eClearPp) { }
                    return;
                }
                // --- Dp end --
            }
            // Dp start 17-08 — Storm Glass Only + Fixed Glass must not empty-hide Stile and Rail Profile
            if (sid === 'stile_and_rail_profile') {
                var fgKeepsStile = !!container.querySelector(
                    'input[type="checkbox"][data-option-id="screen_and_storm_inserts_additional_options"][value="fixed_glass"]:checked'
                );
                if (fgKeepsStile && section.querySelector('input[type="radio"][data-option-id="stile_and_rail_profile"]')) {
                    section.classList.remove('door-hidden');
                    section.removeAttribute('data-empty-hidden');
                    section.removeAttribute('hidden');
                    section.style.display = '';
                    return;
                }
            }
            // Dp end 17-08
            if (section.classList && section.classList.contains('door-measurement-type-section')) return;
            if (section.classList.contains('door-hidden')) return;
            if (!sectionHasAvailableContent(section)) {
                section.setAttribute('data-empty-hidden', '1');
                section.style.display = 'none';
            }
        });

        // Hide accordions if their corresponding metafield/metaobject catalogs are empty or if they have no visible fields.
        try {
            // 1. Casing Options Accordion
            var casingAcc = container.querySelector('.door-post-lockset-casing-options');
            if (casingAcc) {
                var hasCasing = false;
                var casingEl = document.getElementById('door-recommended-casing-products');
                if (casingEl && casingEl.textContent) {
                    var parsed = JSON.parse(casingEl.textContent.trim());
                    if (Array.isArray(parsed) && parsed.length > 0) hasCasing = true;
                }
                casingAcc.style.display = hasCasing ? '' : 'none';
            }

            // 2. Hardware Options Accordion
            var hwAcc = container.querySelector('.door-post-lockset-hardware-options');
            if (hwAcc) {
                var hasHw = false;
                var hwEl = document.getElementById('door-recommended-hardware-products');
                if (hwEl && hwEl.textContent) {
                    var parsed = JSON.parse(hwEl.textContent.trim());
                    if (Array.isArray(parsed) && parsed.length > 0) hasHw = true;
                }
                if (!hasHw) {
                    var root = document.getElementById('door-configurator');
                    if (root) {
                        var raw = root.getAttribute('data-recommended-hardware-products');
                        if (raw) {
                            var parsed2 = JSON.parse(raw);
                            if (Array.isArray(parsed2) && parsed2.length > 0) hasHw = true;
                        }
                    }
                }
                hwAcc.style.display = hasHw ? '' : 'none';
            }

            // 3. Additional Options Accordion
            var addlAcc = container.querySelector('.door-post-lockset-additional-options');
            if (addlAcc) {
                var hasAddl = false;
                var pEl = document.getElementById('door-priming-services-catalog-json');
                var sEl = document.getElementById('door-sweeps-catalog-json');
                var skEl = document.getElementById('door-seal-kit-catalog-json');

                var catalogHasData = false;
                if (pEl && pEl.textContent) {
                    var parsed = JSON.parse(pEl.textContent.trim());
                    if (Array.isArray(parsed) && parsed.length > 0) catalogHasData = true;
                }
                if (!catalogHasData && sEl && sEl.textContent) {
                    var parsed = JSON.parse(sEl.textContent.trim());
                    if (Array.isArray(parsed) && parsed.length > 0) catalogHasData = true;
                }
                if (!catalogHasData && skEl && skEl.textContent) {
                    var parsed = JSON.parse(skEl.textContent.trim());
                    if (Array.isArray(parsed) && parsed.length > 0) catalogHasData = true;
                }

                // Even if catalogs have data, the accordion should only show if at least one option wrap is visible and has available content
                var addlOptionWraps = addlAcc.querySelectorAll('.door-option-wrap[data-option-id]');
                var locksetPresent = !!(container.querySelector('.door-option-wrap[data-option-id="lockset_prep"]'));
                for (var i = 0; i < addlOptionWraps.length; i++) {
                    var wrap = addlOptionWraps[i];
                    var isWrapVisible = wrap.style.display !== 'none' && !wrap.classList.contains('door-hidden') && !wrap.hidden;
                    if (isWrapVisible) {
                        var oid = String(wrap.getAttribute('data-option-id') || '');
                        // Lockset products: keep original visibility rule (pet_door / catalog).
                        // Non-lockset products: also allow priming / sweep / seal alone so Additional Options shows.
                        var allowOid = locksetPresent
                            ? (oid === 'pet_door' || catalogHasData)
                            : (oid === 'pet_door' || oid === 'priming' || oid === 'door_sweep' || oid === 'door_seal_kit' || catalogHasData);
                        if (allowOid) {
                            if (sectionHasAvailableContent(wrap)) {
                                hasAddl = true;
                                break;
                            }
                        }
                    }
                }
                addlAcc.style.display = hasAddl ? '' : 'none';
            }

            // 4. Screen & Storm Inserts "Additional Options" accordion (metaobject-driven)
            var insertsAddlWraps = container.querySelectorAll('.door-inserts-additional-options.screen-and-storm-inserts');
            insertsAddlWraps.forEach(function (wrap) {
                var insertsSection = wrap.closest('.door-option-wrap[data-option-id]');
                var optId = 'screen_and_storm_inserts';
                if (insertsSection) {
                    optId = insertsSection.getAttribute('data-option-id') || 'screen_and_storm_inserts';
                }

                // --- Dp start 14-07  ---
                if (optId === 'applied_molding' || optId === 'applied_molding_choice') {
                    // Merged into stile_and_rail_profile — always hide accordion.
                    wrap.style.display = 'none';
                    wrap.classList.add('door-hidden');
                    if (insertsSection) {
                        insertsSection.classList.add('door-hidden');
                        insertsSection.setAttribute('data-empty-hidden', '1');
                        insertsSection.setAttribute('hidden', 'true');
                        insertsSection.style.display = 'none';
                    }
                    return;
                }
                // --- Dp end 14-07  ---

                if (optId === 'stile_and_rail_profile' || optId === 'panel_profile') {
                    // Stile & rail profile or Panel profile accordion
                    var selectedValue = getSelectedChoiceValueFromDom(optId);
                    var hasVisibleChoices = false;
                    if (selectedValue) {
                        var bodyOptions = wrap.querySelectorAll('.door-accordion-body .common-check-option');
                        for (var cIdx = 0; cIdx < bodyOptions.length; cIdx++) {
                            var card = bodyOptions[cIdx];
                            // Dp start 31-08
                            var isCardHidden = isProfileChoiceCardHidden(card);
                            // Dp end 31-08
                            if (!isCardHidden) {
                                hasVisibleChoices = true;
                                break;
                            }
                        }
                    }
                    wrap.style.display = hasVisibleChoices ? '' : 'none';
                } else {
                    // Screen & storm inserts accordion
                    // --- Dp start 16-07  ---
                    // var hasConfigured = insertsAdditionalOptionsSchemaHasConfiguredChoices(doorConfigSchema);
                    // --- Dp end 16-07  ---
                    // Dp start 22-07 — hide when no real choices (do NOT force-show with fake [1])
                    var insertsMode = 'screen_and_storm_inserts';
                    var checkedInserts = insertsSection ? insertsSection.querySelector('input[type="radio"][data-option-id="' + optId + '"]:checked') : null;
                    if (checkedInserts && checkedInserts.value) {
                        insertsMode = normalizeChoiceKey(checkedInserts.value);
                    }
                    if (
                        insertsMode !== 'screen_insert_only'
                        && insertsMode !== 'storm_glass_only'
                        && insertsMode !== 'screen_and_storm_inserts_choice'
                        && insertsMode !== 'screen_and_storm_inserts'
                    ) {
                        insertsMode = 'screen_and_storm_inserts';
                    }
                    var insertsChoices = getInsertsAdditionalOptionsChoicesForMode(doorConfigSchema, insertsMode);
                    // Same hardcoded fallbacks as rebuildAddlCards
                    if (insertsChoices.length === 0) {
                        if (insertsMode === 'screen_insert_only') {
                            insertsChoices = [
                                { value: 'top_bottom_inserts_screen' }
                            ];
                            try {
                                if (!shouldHideFixedScreen()) {
                                    insertsChoices.push({ value: 'fixed_screen' });
                                }
                            } catch (eFs) { }
                        } else if (insertsMode === 'storm_glass_only') {
                            insertsChoices = [
                                { value: 'top_bottom_inserts_glass' }
                            ];
                            try {
                                if (!shouldHideFixedGlass()) {
                                    insertsChoices.push({ value: 'fixed_glass' });
                                }
                            } catch (eFg) { }
                        } else {
                            insertsChoices = [{ value: 'top_bottom_inserts' }];
                        }
                    } else {
                        // Dp strat 29-07 — Ensure custom fixed options are appended if missing from schema choices
                        if (insertsMode === 'screen_insert_only') {
                            try {
                                if (!shouldHideFixedScreen()) {
                                    var hasFixedScreen = insertsChoices.some(function (c) { return c && c.value === 'fixed_screen'; });
                                    if (!hasFixedScreen) {
                                        insertsChoices.push({ value: 'fixed_screen' });
                                    }
                                }
                            } catch (e) { }
                        } else if (insertsMode === 'storm_glass_only') {
                            try {
                                if (!shouldHideFixedGlass()) {
                                    var hasFixedGlass = insertsChoices.some(function (c) { return c && c.value === 'fixed_glass'; });
                                    if (!hasFixedGlass) {
                                        insertsChoices.push({ value: 'fixed_glass' });
                                    }
                                }
                            } catch (eFg) { }
                        }
                        // Dp end 29-07
                    }
                    try {
                        if (shouldHideTopBottomInserts()) {
                            insertsChoices = insertsChoices.filter(function (c) {
                                var v = c && c.value != null ? String(c.value) : '';
                                return v !== 'top_bottom_inserts'
                                    && v !== 'top_bottom_inserts_screen'
                                    && v !== 'top_bottom_inserts_glass';
                            });
                        }
                    } catch (eInsFilter) { }
                    try {
                        if (shouldHideFixedScreen()) {
                            insertsChoices = insertsChoices.filter(function (c) {
                                var v = c && c.value != null ? String(c.value) : '';
                                return v !== 'fixed_screen';
                            });
                        }
                    } catch (eInsFilter) { }
                    try {
                        if (shouldHideFixedGlass()) {
                            insertsChoices = insertsChoices.filter(function (c) {
                                var v = c && c.value != null ? String(c.value) : '';
                                return v !== 'fixed_glass';
                            });
                        }
                    } catch (eInsFilter) { }
                    // Respect rebuildAddlCards empty marker; never re-show blank accordion
                    var showInsertsAddl = insertsChoices.length > 0 && wrap.getAttribute('data-addl-empty') !== '1';
                    // original 16-07 (forced show when schema empty — caused blank Additional Options tab):
                    // if (insertsChoices.length === 0 && !hasConfigured) { insertsChoices = [1]; }
                    // wrap.style.display = insertsChoices.length > 0 ? '' : 'none';
                    wrap.style.display = showInsertsAddl ? '' : 'none';
                    wrap.classList.toggle('door-hidden', !showInsertsAddl);
                    // Dp end 22-07
                }
            });
        } catch (eAcc) { }
    }

    /**
     * Option ids to check for a show_when / hide_when ref.
     * Supports parent key → nested additional_options (e.g. screen_and_storm_inserts
     * + value fixed_glass lives on screen_and_storm_inserts_additional_options).
     */
    function getRelatedRefOptionIdsForWhen(refId) {
        var ids = [];
        var raw = String(refId == null ? '' : refId).trim();
        if (!raw) return ids;
        function pushId(id) {
            var s = String(id || '').trim();
            if (!s) return;
            if (ids.indexOf(s) === -1) ids.push(s);
        }
        pushId(raw);
        var norm = normalizeOptionIdKey(raw);
        pushId(norm);
        pushId(norm + '_additional_options');
        // Common aliases for Screen & Storm Inserts additional checkboxes.
        if (
            norm === 'screen_and_storm_inserts'
            || norm === 'screen_and_storm_inserts_choice'
            || norm.indexOf('screen_and_storm') === 0
        ) {
            pushId('screen_and_storm_inserts_additional_options');
            pushId('screen_and_storm_inserts');
            pushId('screen_and_storm_inserts_choice');
        }
        return ids;
    }

    function containerRefValueMatches(container, refId, refValue, isAnyValue) {
        if (!container) return false;
        var relatedIds = getRelatedRefOptionIdsForWhen(refId);
        if (!relatedIds.length) relatedIds = [String(refId || '')];

        if (isAnyValue) {
            for (var ai = 0; ai < relatedIds.length; ai++) {
                var anyDom = getSelectedChoiceValueFromDom(relatedIds[ai]);
                if (anyDom && String(anyDom) !== '') return true;
                var anyChecked = container.querySelector(
                    'input[data-option-id="' + relatedIds[ai] + '"]:checked'
                );
                if (anyChecked) return true;
            }
            return false;
        }

        var target = normalizeChoiceKey(refValue);
        if (!target) return false;

        for (var ri = 0; ri < relatedIds.length; ri++) {
            var optId = relatedIds[ri];
            var refInputs = all(
                'select[data-option-id="' + optId + '"], input[data-option-id="' + optId + '"]',
                container
            );
            if (!refInputs.length) continue;

            if (refInputs[0] && refInputs[0].type === 'checkbox') {
                var checkboxHit = refInputs.filter(function (el) { return el.checked; }).some(function (el) {
                    return normalizeChoiceKey(el.value) === target;
                });
                if (checkboxHit) return true;
                continue;
            }

            var domVal = getSelectedChoiceValueFromDom(optId);
            if (domVal && normalizeChoiceKey(domVal) === target) return true;

            if (refInputs[0] && refInputs[0].type === 'radio') {
                var checkedRadio = refInputs.filter(function (el) { return el.checked; })[0];
                if (checkedRadio && normalizeChoiceKey(checkedRadio.value) === target) return true;
                continue;
            }

            if (refInputs.length > 1) {
                if (refInputs.some(function (el) { return normalizeChoiceKey(el.value) === target; })) {
                    return true;
                }
                continue;
            }

            if (refInputs[0] && normalizeChoiceKey(refInputs[0].value) === target) return true;
        }
        return false;
    }

    var hideWhenBoundKeys = {};
    var choiceVisibilityBoundKeys = {};

    function applyHideWhen(schema, container) {
        if (!container) container = document.getElementById('door-configurator-options');
        if (!container) return;
        var refSelector = function (id) {
            return 'select[data-option-id="' + id + '"], input[data-option-id="' + id + '"]';
        };
        schema.forEach(function (opt) {
            var hideWhen = opt.hideWhen;
            var showWhen = opt.showWhen;
            var condition = hideWhen && typeof hideWhen === 'object' ? { type: 'hide', when: hideWhen } : (showWhen && typeof showWhen === 'object' ? { type: 'show', when: showWhen } : null);
            if (!condition) return;
            var wrap = container.querySelector('.door-option-wrap[data-option-id="' + opt.id + '"]')
                || container.querySelector('.door-measure-dimension-row[data-embed-dimension-id="' + opt.id + '"]');
            if (!wrap) return;
            var refId = Object.keys(condition.when)[0];
            var refValue = condition.when[refId];
            var relatedRefIds = getRelatedRefOptionIdsForWhen(refId);
            var refInput = null;
            for (var rii = 0; rii < relatedRefIds.length && !refInput; rii++) {
                refInput = container.querySelector(refSelector(relatedRefIds[rii]));
            }
            if (!refInput) return;
            var isAnyValue = String(refValue || '') === '__any__';
            var hideBoundKey = String(opt.id || '') + '::' + String(refId || '');
            function updateVisibility() {
                var matches = containerRefValueMatches(container, refId, refValue, isAnyValue);
                var shouldHide = condition.type === 'hide' ? matches : !matches;
                if (isGateCollectionActive() && normalizeOptionIdKey(opt.id) === 'swing_direction') {
                    shouldHide = false;
                }
                // --- Dp start 16-07 ---
                var optIdNormHide = normalizeOptionIdKey(opt.id);
                if (optIdNormHide === 'applied_molding' || optIdNormHide === 'applied_molding_choice') {
                    // Merged into stile_and_rail_profile — always hide.
                    shouldHide = true;
                }
                // --- Dp end 16-07 ---
                // Dp start 17-08 — Fixed Glass must not hide .door-option-wrap[data-option-id="stile_and_rail_profile"]
                if (optIdNormHide === 'stile_and_rail_profile') {
                    var fgKeepsStileWrap = !!container.querySelector(
                        'input[type="checkbox"][data-option-id="screen_and_storm_inserts_additional_options"][value="fixed_glass"]:checked'
                    );
                    if (fgKeepsStileWrap) shouldHide = false;
                }
                // Dp end 17-08
                wrap.classList.toggle('door-hidden', shouldHide);
                // Same as Hinges / Lockset: do not keep a selection under a hidden option.
                if (shouldHide) {
                    try {
                        wrap.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (inp) {
                            if (!inp || !inp.checked) return;
                            inp.checked = false;
                            var card = inp.closest && inp.closest('.common-check-option');
                            if (card) card.classList.remove('common-check-option--selected');
                        });
                        wrap.querySelectorAll('select').forEach(function (sel) {
                            if (!sel || sel.value === '') return;
                            sel.value = '';
                            try { sel.dispatchEvent(new Event('change', { bubbles: true })); } catch (eHideSelCh) { }
                        });
                    } catch (eClrHiddenOpt) { }
                }
                // Dp start 17-08
                if (optIdNormHide === 'stile_and_rail_profile' && !shouldHide) {
                    wrap.removeAttribute('data-empty-hidden');
                    wrap.removeAttribute('hidden');
                    wrap.style.display = '';
                }
                // Dp end 17-08
                // --- Dp start 16-07 ---
                if (shouldHide && (optIdNormHide === 'applied_molding' || optIdNormHide === 'applied_molding_choice')) {
                    wrap.style.display = 'none';
                    wrap.setAttribute('data-empty-hidden', '1');
                    wrap.setAttribute('hidden', 'true');
                }
                // --- Dp end 16-07 ---
                if (doorConfigSchema && measurementSchemaUsesJsonVisibility(doorConfigSchema)) {
                    syncMeasurementPanelsFromSchemaRows(container);
                }
            }
            if (!hideWhenBoundKeys[hideBoundKey]) {
                relatedRefIds.forEach(function (relatedId) {
                    var relatedInput = container.querySelector(refSelector(relatedId));
                    if (relatedInput) {
                        relatedInput.addEventListener('change', updateVisibility);
                        if (relatedInput.type !== 'checkbox' && relatedInput.type !== 'radio') {
                            relatedInput.addEventListener('input', updateVisibility);
                        }
                    }
                    all(refSelector(relatedId), container).forEach(function (el) {
                        el.addEventListener('change', updateVisibility);
                    });
                });
                hideWhenBoundKeys[hideBoundKey] = true;
            }
            updateVisibility();
        });

        // --- Dp start 16-07  ---
        try {
            var screenTypeWrap = container.querySelector('.door-option-wrap[data-option-id="screen_type"]')
                || container.querySelector('.door-option-wrap[data-option-id="select_screen"]');
            var stormGlassWrap = container.querySelector('.door-option-wrap[data-option-id="storm_glass_type"]')
                || container.querySelector('.door-option-wrap[data-option-id="storm_glass"]')
                || container.querySelector('.door-option-wrap[data-option-id="select_storm_glass"]');

            if (screenTypeWrap || stormGlassWrap) {
                var updateCustomScreenStormVisibility = function () {
                    var checkedInserts = container.querySelector('input[type="radio"][data-option-id="screen_and_storm_inserts"]:checked');
                    var selectedValue = checkedInserts ? checkedInserts.value : '';
                    if (!selectedValue) {
                        var insertsSel = container.querySelector('select[data-option-id="screen_and_storm_inserts"]');
                        if (insertsSel) selectedValue = insertsSel.value;
                    }
                    var valNorm = String(selectedValue || '').toLowerCase().replace(/[^a-z0-9]/g, '');

                    // dp start 21-07 / 16-07 original matching (kept for reference)
                    // var shouldShowScreen = valNorm.indexOf('screeninsertonly') !== -1
                    //     || valNorm.indexOf('screenandstorminsertschoice') !== -1
                    //     || valNorm.indexOf('screenstorminserts') !== -1;
                    // var shouldShowGlass = valNorm.indexOf('stormglassonly') !== -1
                    //     || valNorm.indexOf('screenandstorminsertschoice') !== -1
                    //     || valNorm.indexOf('screenstorminserts') !== -1;

                    // Dp start 22-07
                    // Match screen_and_storm_inserts (+ _choice), screen_insert_only, storm_glass_only.
                    // Previous check missed "screenandstorminserts" (required "choice" or omitted "and").
                    var shouldShowScreen = valNorm.indexOf('screeninsertonly') !== -1
                        || valNorm.indexOf('screenandstorminserts') !== -1
                        || valNorm.indexOf('screenstorminserts') !== -1;
                    var shouldShowGlass = valNorm.indexOf('stormglassonly') !== -1
                        || valNorm.indexOf('screenandstorminserts') !== -1
                        || valNorm.indexOf('screenstorminserts') !== -1;
                    // Metafield false => force hide; unset/true => allow mode-based show
                    try {
                        if (shouldHideSelectScreen()) shouldShowScreen = false;
                    } catch (eHideScr) { }
                    try {
                        if (shouldHideSelectStormGlass()) shouldShowGlass = false;
                    } catch (eHideGl) { }

                    if (screenTypeWrap) {
                        screenTypeWrap.classList.toggle('door-hidden', !shouldShowScreen);
                        if (!shouldShowScreen) {
                            screenTypeWrap.style.display = 'none';
                            try { clearScreenTypeSelections(container); } catch (eClearScr) { }
                        } else {
                            screenTypeWrap.classList.remove('door-hidden');
                            screenTypeWrap.removeAttribute('data-empty-hidden');
                            screenTypeWrap.removeAttribute('hidden');
                            screenTypeWrap.style.display = '';
                        }
                    }

                    if (stormGlassWrap) {
                        stormGlassWrap.classList.toggle('door-hidden', !shouldShowGlass);
                        if (!shouldShowGlass) {
                            stormGlassWrap.style.display = 'none';
                            try { clearStormGlassTypeSelections(container); } catch (eClearGl) { }
                        } else {
                            stormGlassWrap.classList.remove('door-hidden');
                            stormGlassWrap.removeAttribute('data-empty-hidden');
                            stormGlassWrap.removeAttribute('hidden');
                            stormGlassWrap.style.display = '';
                        }
                    }
                    // Dp end 22-07
                };

                var customBoundKey = 'screen_storm_type_custom::screen_and_storm_inserts';
                if (!hideWhenBoundKeys[customBoundKey]) {
                    var refSelectorInserts = 'select[data-option-id="screen_and_storm_inserts"], input[data-option-id="screen_and_storm_inserts"]';
                    all(refSelectorInserts, container).forEach(function (el) {
                        el.addEventListener('change', updateCustomScreenStormVisibility);
                        if (el.type !== 'checkbox' && el.type !== 'radio') {
                            el.addEventListener('input', updateCustomScreenStormVisibility);
                        }
                    });
                    hideWhenBoundKeys[customBoundKey] = true;
                }
                updateCustomScreenStormVisibility();
            }
        } catch (e) {
            console.error('Error in custom screen/storm type visibility check:', e);
        }
        // --- Dp end 16-07  ---
        // --- Dp start 16-07 ---
        try {
            syncAppliedMoldingSectionVisibility(container);
            scheduleSdlProfileVisibilitySync(container);
        } catch (eAmHideWhen) { }
        // --- Dp end 16-07 ---
    }

    function applyChoiceVisibility(schema, container) {
        if (!container) container = document.getElementById('door-configurator-options');
        if (!container) return;
        var ctx = getConfiguratorProductTagContext(schema);
        var productTags = ctx && ctx.productTags ? ctx.productTags : [];
        var hasDoubleDoorsTag = productTags.indexOf('double-doors') !== -1 || productTags.indexOf('double-door') !== -1;
        var refSelector = function (id) {
            return 'select[data-option-id="' + id + '"], input[data-option-id="' + id + '"]';
        };
        function escapeSelectorVal(s) {
            return String(s == null ? '' : s).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        }
        schema.forEach(function (opt) {
            var optionsList = opt.options || [];
            var hasChoiceCondition = optionsList.some(function (o) {
                return (o.showWhen && (typeof o.showWhen === 'object' || Array.isArray(o.showWhen)))
                    || (o.hideWhenListRaw != null && String(o.hideWhenListRaw) !== '')
                    || (o.showWhenListRaw != null && String(o.showWhenListRaw) !== '')
                    || (o.hideWhen && (typeof o.hideWhen === 'object' || Array.isArray(o.hideWhen)));
            });
            if (!hasChoiceCondition) return;
            var sel = container.querySelector('select[data-option-id="' + opt.id + '"]');
            var radioWrap = container.querySelector('.door-option-wrap[data-option-id="' + opt.id + '"] .common-check-options');
            var checkboxWrap = container.querySelector('.door-option-wrap[data-option-id="' + opt.id + '"] .door-setup-options');
            var optIdNormVis = normalizeOptionIdKey(opt.id);
            if (optIdNormVis === 'sdl_profile') return;
            // Dp start 09-07 — Door Sweep / Door Stops keep all schema choices (porch-panel empty dropdown)
            if (optIdNormVis === 'door_sweep' || optIdNormVis === 'door_seal_kit') return;
            // Dp end 09-07
            // --- Dp start 16-07 ---
            // Do not apply choice showWhen/hideWhen filters to Applied Molding cards.
            if (optIdNormVis === 'applied_molding' || optIdNormVis === 'applied_molding_choice') return;
            // --- Dp end 16-07 ---
            // Dp start 17-08 — Fixed Glass show_when must not hide all Stile profiles when Soft Ogee is not offered
            if (optIdNormVis === 'stile_and_rail_profile') {
                var hasSoftOgeeOpt = optionsList.some(function (o) {
                    return o && (normalizeChoiceKey(o.value) === 'soft_ogee' || normalizeChoiceKey(o.label) === 'soft_ogee');
                });
                var fgChoiceOn = !!container.querySelector(
                    'input[type="checkbox"][data-option-id="screen_and_storm_inserts_additional_options"][value="fixed_glass"]:checked'
                );
                if (fgChoiceOn && !hasSoftOgeeOpt) return;
            }
            // Dp end 17-08
            // Dp start 03-08 — product optional_shelf allow-list owns shelf visibility
            if (isOptionalShelfOptionId(opt.id) && getOptionalShelfAllowedKeys()) return;
            // Dp end 03-08
            function whenToRefs(when) {
                if (when == null) return [];
                if (typeof when === 'string' && when.trim()) {
                    try { when = JSON.parse(when); } catch (eWhenParse) { return []; }
                }
                var refs = [];
                function pushRef(refId, refValue) {
                    if (!refId || refValue == null || refValue === '') return;
                    refs.push({ refId: String(refId), refValue: refValue });
                }
                if (Array.isArray(when)) {
                    when.forEach(function (cond) {
                        if (!cond || typeof cond !== 'object') return;
                        if (cond.key != null && cond.value != null) {
                            pushRef(cond.key, cond.value);
                            return;
                        }
                        Object.keys(cond).forEach(function (k) {
                            var v = cond[k];
                            if (Array.isArray(v)) v.forEach(function (vv) { pushRef(k, vv); });
                            else pushRef(k, v);
                        });
                    });
                    return refs;
                }
                if (when && typeof when === 'object') {
                    Object.keys(when).forEach(function (k) {
                        var v = when[k];
                        if (Array.isArray(v)) v.forEach(function (vv) { pushRef(k, vv); });
                        else pushRef(k, v);
                    });
                }
                return refs;
            }
            function getChoiceShowWhenRefs(choice) {
                if (!choice) return [];
                if (choice.showWhenListRaw != null && String(choice.showWhenListRaw) !== '') {
                    return whenToRefs(choice.showWhenListRaw);
                }
                if (choice.showWhen) return whenToRefs(choice.showWhen);
                return [];
            }
            function getChoiceHideWhenRefs(choice) {
                if (!choice) return [];
                if (choice.hideWhenListRaw != null && String(choice.hideWhenListRaw) !== '') {
                    return whenToRefs(choice.hideWhenListRaw);
                }
                if (choice.hideWhen) return whenToRefs(choice.hideWhen);
                return [];
            }
            function refMatches(refId, refValue) {
                return containerRefValueMatches(container, refId, refValue, false);
            }
            var optWrap = container.querySelector('.door-option-wrap[data-option-id="' + escapeSelectorVal(String(opt.id || '')) + '"]');
            optionsList.forEach(function (choice, idx) {
                var showRefs = getChoiceShowWhenRefs(choice);
                var hideRefs = getChoiceHideWhenRefs(choice);
                var condition = showRefs.length
                    ? { type: 'show', refs: showRefs }
                    : (hideRefs.length ? { type: 'hide', refs: hideRefs } : null);
                if (!condition) return;
                var refs = condition.refs;
                if (refs.length === 0) return;
                var choiceBoundKey = String(opt.id || '') + '::' + String(choice.value != null ? choice.value : idx);
                function updateChoiceVisibility() {
                    var matches = refs.some(function (r) { return refMatches(r.refId, r.refValue); });
                    var shouldHide = condition.type === 'show' ? !matches : matches;
                    var choiceVal = choice.value != null && choice.value !== '' ? String(choice.value) : '';
                    // --- Dp start 15-07 ---
                    var isDoubleProduct = hasDoubleDoorsTag || (ctx && ctx.urlCollectionHandle && ctx.urlCollectionHandle.indexOf('double') !== -1);
                    var isEntranceUnits = ctx && ctx.urlCollectionHandle === 'entrance-units';
                    var designEl = container.querySelector('input[data-option-id="door_unit_design"]:checked, select[data-option-id="door_unit_design"]');
                    var selectedVal = '';
                    if (designEl) {
                        selectedVal = String(designEl.value || '').trim().toLowerCase();
                    }
                    var hasDesignOption = !!container.querySelector('input[data-option-id="door_unit_design"], select[data-option-id="door_unit_design"]');
                    var mode = 'single';
                    if (hasDesignOption && selectedVal) {
                        if (selectedVal.indexOf('double') !== -1) {
                            mode = 'double';
                        } else {
                            mode = 'single';
                        }
                    } else {
                        if (isEntranceUnits) {
                            mode = 'all';
                        } else if (isDoubleProduct) {
                            mode = 'double';
                        } else {
                            mode = 'single';
                        }
                    }
                    // --- Dp end 15-07 ---

                    var choiceValNorm = choiceVal.toLowerCase().replace(/-/g, '_');
                    var isDoubleOption = choiceValNorm.indexOf('double') !== -1;
                    var isSingleSwingOption = (choiceValNorm === 'in_left' || choiceValNorm === 'out_left' || choiceValNorm === 'in_right' || choiceValNorm === 'out_right');

                    // --- Dp start 15-07 ---
                    if (normalizeOptionIdKey(opt.id) === 'swing_direction') {
                        if (mode === 'single') {
                            if (isSingleSwingOption) {
                                shouldHide = false;
                            } else if (isDoubleOption) {
                                shouldHide = true;
                            }
                        } else if (mode === 'double') {
                            if (isSingleSwingOption) {
                                shouldHide = true;
                            } else if (isDoubleOption) {
                                shouldHide = false;
                            }
                        } else if (mode === 'all') {
                            shouldHide = false;
                        }
                    } else {
                        if (hasDoubleDoorsTag && (choiceVal.indexOf('double_in_swing_active_door') !== -1 || choiceVal.indexOf('double_out_swing_active_door') !== -1)) {
                            shouldHide = false;
                        }
                    }
                    // --- Dp end 15-07 ---
                    if (sel) {
                        var optionEl = sel.querySelector('option[value="' + escapeSelectorVal(choiceVal) + '"]');
                        if (optionEl) {
                            if (
                                shouldHide
                                && sel.getAttribute
                                && sel.getAttribute('data-door-user-changed') === '1'
                                && String(sel.value || '') === choiceVal
                            ) {
                                shouldHide = false;
                            }
                            optionEl.hidden = shouldHide;
                            optionEl.disabled = shouldHide;
                            if (shouldHide && String(sel.value || '') === choiceVal) {
                                // Swing: clear only — do not auto-pick first visible (metafield defaults handle that).
                                if (normalizeOptionIdKey(opt.id) === 'swing_direction') {
                                    sel.value = '';
                                } else {
                                    var firstVisible = Array.prototype.find.call(sel.options, function (o) { return !o.hidden && o.value; });
                                    sel.value = firstVisible ? firstVisible.value : '';
                                }
                                updateEstimatedPrice();
                            }
                        }
                    } else if (radioWrap) {
                        var cardScope = optWrap || radioWrap;
                        var cards = cardScope.querySelectorAll('.common-check-option[data-choice-value="' + escapeSelectorVal(choiceVal) + '"]');
                        Array.prototype.forEach.call(cards, function (card) {
                            var inp = card.querySelector && card.querySelector('input[type="radio"][data-option-id="' + escapeSelectorVal(String(opt.id || '')) + '"]');
                            if (!inp) return;
                            var woodHid = card.getAttribute && card.getAttribute('data-wood-exposure-hidden') === '1';
                            if (shouldHide) card.setAttribute('data-choice-condition-hidden', '1');
                            else card.removeAttribute('data-choice-condition-hidden');
                            var hideCard = !!(shouldHide || woodHid);
                            card.style.display = hideCard ? 'none' : '';
                            card.classList.toggle('door-hidden', hideCard);
                            if (shouldHide && inp.checked) {
                                inp.checked = false;
                                card.classList.remove('common-check-option--selected');
                                // Do not auto-select first visible swing — only metafield defaults / user pick.
                                if (normalizeOptionIdKey(opt.id) === 'swing_direction') {
                                    if (typeof updateEstimatedPrice === 'function') updateEstimatedPrice();
                                }
                            }
                        });
                    } else if (checkboxWrap) {
                        var labelWrap = checkboxWrap.querySelector('label.door-setup-option input[value="' + escapeSelectorVal(choiceVal) + '"]');
                        if (labelWrap && labelWrap.parentNode) {
                            labelWrap.parentNode.style.display = shouldHide ? 'none' : '';
                        }
                    }
                }
                if (!choiceVisibilityBoundKeys[choiceBoundKey]) {
                    refs.forEach(function (r) {
                        var relatedIds = getRelatedRefOptionIdsForWhen(r.refId);
                        relatedIds.forEach(function (relatedId) {
                            var refInput = container.querySelector(refSelector(relatedId));
                            if (refInput) {
                                refInput.addEventListener('change', updateChoiceVisibility);
                                if (refInput.type !== 'checkbox' && refInput.type !== 'radio') {
                                    refInput.addEventListener('input', updateChoiceVisibility);
                                }
                            }
                            all(refSelector(relatedId), container).forEach(function (el) {
                                el.addEventListener('change', updateChoiceVisibility);
                            });
                        });
                    });
                    choiceVisibilityBoundKeys[choiceBoundKey] = true;
                }
                updateChoiceVisibility();
            });
        });
        try { syncStileSoftOgeeForFixedGlass(container); } catch (eSoftOgeeVis) { }
    }

    /** Match Shopify product tags to config_choice slugs (interior-doors, arch-and-round-top). */
    function normProductTagSlug(s) {
        return String(s == null ? '' : s)
            .trim()
            .toLowerCase()
            .replace(/[\s_]+/g, '-')
            .replace(/-+/g, '-');
    }

    function parseShowWhenProductTagsRaw(showWhenProductTags) {
        var raw = showWhenProductTags;
        if (raw == null) return null;
        if (typeof raw === 'string' && raw.trim()) {
            try {
                raw = JSON.parse(raw);
            } catch (eParse) {
                return null;
            }
        }
        return raw;
    }

    /** Largest primary->secondaries map stored on any config_choice (shared catalog JSON). */
    function getGlobalShowWhenProductTagsMap(schema) {
        var map = null;
        var keyCount = 0;
        if (!schema || !schema.length) return null;
        schema.forEach(function (opt) {
            (opt.options || []).forEach(function (c) {
                var raw = parseShowWhenProductTagsRaw(c.showWhenProductTags);
                if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
                    var k = Object.keys(raw).length;
                    if (k > keyCount) {
                        map = raw;
                        keyCount = k;
                    }
                }
            });
        });
        return map;
    }

    function getTagSetsForChoiceFromGlobalMap(globalMap, choiceValue) {
        if (!globalMap || !choiceValue) return [];
        var choiceSlug = normProductTagSlug(choiceValue);
        var pairs = [];
        Object.keys(globalMap).forEach(function (primaryTag) {
            if (primaryTag === 'dontShowCollection') return;
            var secondaries = globalMap[primaryTag];
            if (!Array.isArray(secondaries)) return;
            var primaryNorm = normProductTagSlug(primaryTag);
            secondaries.forEach(function (secondaryTag) {
                if (normProductTagSlug(secondaryTag) === choiceSlug) {
                    pairs.push([primaryNorm, normProductTagSlug(secondaryTag)]);
                }
            });
        });
        return pairs;
    }

    function choiceIsInProductTagCatalog(globalMap, choiceValue) {
        return getTagSetsForChoiceFromGlobalMap(globalMap, choiceValue).length > 0;
    }

    /* MERGE: seo_pdp_url — start (getCollectionHandleFromUrl: path + ?config= + data-route-collection) */
    /* MERGE: pdp_config_id — skip numeric ?config= (collection.config_id); use PDP_ROUTE_COLLECTION */
    function getCollectionHandleFromUrl() {
        try {
            var match = window.location.pathname.match(/\/collections\/([^\/\?#]+)/);
            if (match) return normProductTagSlug(decodeURIComponent(match[1]));
        } catch (ePath) { }
        try {
            var params = new URLSearchParams(window.location.search || '');
            var fromQuery = params.get('config') || params.get('collection') || params.get('col');
            if (fromQuery && !/^\d+$/.test(String(fromQuery))) {
                return normProductTagSlug(fromQuery);
            }
        } catch (eQuery) { }
        try {
            if (window.PDP_ROUTE_COLLECTION) {
                return normProductTagSlug(window.PDP_ROUTE_COLLECTION);
            }
            var main = document.getElementById('door-configurator')
                || document.getElementById('landing-product-configurator');
            if (main) {
                var route = main.getAttribute('data-route-collection') || '';
                if (route) return normProductTagSlug(route);
            }
        } catch (eRoute) { }
        return '';
    }
    /* MERGE: seo_pdp_url — end */

    function getConfiguratorProductTagContext(schema) {
        var main = document.getElementById('door-configurator');
        var productTags = [];
        if (main) {
            var tagsAttr = main.getAttribute('data-product-tags') || '';
            try {
                var parsed = typeof tagsAttr === 'string' && tagsAttr.trim() ? JSON.parse(tagsAttr) : [];
                productTags = Array.isArray(parsed)
                    ? parsed.map(normProductTagSlug).filter(Boolean)
                    : [];
            } catch (e) {
                productTags = tagsAttr.split('|').map(normProductTagSlug).filter(Boolean);
            }
        }
        /* MERGE: product_wise_edge_profile_sdl — start */
        var productWiseEdgeProfile = null;
        try {
            if (window.DoorConf2Update && typeof window.DoorConf2Update.getProductWiseEdgeProfileSdlFromMain === 'function') {
                productWiseEdgeProfile = window.DoorConf2Update.getProductWiseEdgeProfileSdlFromMain();
            }
        } catch (ePwepsCtx) { }
        /* MERGE: product_wise_edge_profile_sdl — end */
        return {
            productTags: productTags,
            urlCollectionHandle: getCollectionHandleFromUrl(),
            globalTagMap: getGlobalShowWhenProductTagsMap(schema),
            productWiseEdgeProfile: productWiseEdgeProfile
        };
    }

    /** config_choice has show_when_product_tags in schema (Liquid outputs key when meta field exists). */
    function choiceHasShowWhenProductTagsField(choice) {
        return choice != null && Object.prototype.hasOwnProperty.call(choice, 'showWhenProductTags');
    }

    function hasTagRuleForChoice(choice) {
        var raw = choice && choice.showWhenProductTags;
        if (raw == null) return false;
        if (typeof raw === 'string') return raw.trim() !== '';
        if (Array.isArray(raw)) return true;
        if (typeof raw === 'object') return Object.keys(raw).length > 0;
        return false;
    }

    /**
     * Build tag requirement groups. Each group is AND; multiple groups are OR.
     * productTagsOnly: per config_choice show_when_product_tags JSON on the product only.
     */
    function normalizeTagSetsForChoice(showWhenProductTags, choiceValue, opts) {
        opts = opts || {};
        var productTagsOnly = !!opts.productTagsOnly;
        var raw = parseShowWhenProductTagsRaw(showWhenProductTags);
        if (raw == null) return [];
        if (typeof raw === 'string') {
            var oneTag = normProductTagSlug(raw);
            return oneTag ? [[oneTag]] : [];
        }
        var choiceSlug = normProductTagSlug(choiceValue || '');
        if (Array.isArray(raw)) {
            if (raw.length === 0) return [];
            if (typeof raw[0] === 'string') {
                var andSet = raw.map(normProductTagSlug).filter(Boolean);
                if (!andSet.length) return [];
                return [andSet];
            }
            return raw
                .map(function (set) {
                    if (!Array.isArray(set)) return null;
                    var normalized = set.map(normProductTagSlug).filter(Boolean);
                    return normalized.length ? normalized : null;
                })
                .filter(Boolean);
        }
        if (typeof raw === 'object') {
            var pairs = [];
            Object.keys(raw).forEach(function (primaryTag) {
                if (primaryTag === 'dontShowCollection') return;
                var secondaries = raw[primaryTag];
                if (!Array.isArray(secondaries)) return;
                var primaryNorm = normProductTagSlug(primaryTag);
                if (!primaryNorm) return;
                if (productTagsOnly) {
                    if (!secondaries.length) {
                        pairs.push([primaryNorm]);
                        return;
                    }
                    secondaries.forEach(function (secondaryTag) {
                        var secNorm = normProductTagSlug(secondaryTag);
                        if (!secNorm) return;
                        pairs.push([primaryNorm, secNorm]);
                    });
                    return;
                }
                if (!secondaries.length) {
                    pairs.push([primaryNorm]);
                    return;
                }
                secondaries.forEach(function (secondaryTag) {
                    var secNorm = normProductTagSlug(secondaryTag);
                    if (choiceSlug && secNorm !== choiceSlug) return;
                    pairs.push([primaryNorm, secNorm]);
                });
            });
            return pairs;
        }
        return [];
    }

    function tagSetsMatchProductTags(tagSets, productTags) {
        productTags = productTags || [];
        if (!Array.isArray(tagSets) || tagSets.length === 0) return false;
        return tagSets.some(function (set) {
            if (!Array.isArray(set) || set.length === 0) return false;
            return set.every(function (tag) {
                return productTags.indexOf(normProductTagSlug(tag)) !== -1;
            });
        });
    }

    function doorConf2MeasurementsInit() {
        if (!window.DoorConf2Measurements || typeof window.DoorConf2Measurements.init !== 'function') return;
        window.DoorConf2Measurements.init({
            getDoorConfigSchema: function () { return doorConfigSchema; },
            normalizeOptionIdKey: normalizeOptionIdKey,
            sanitizeForDomId: sanitizeForDomId,
            buildOptionDomId: buildOptionDomId,
            ensureSelectHasId: ensureSelectHasId,
            applyHideWhen: applyHideWhen,
            applyChoiceVisibility: applyChoiceVisibility,
            enhanceDoorSelectWithDivDropdown: enhanceDoorSelectWithDivDropdown,
            updateEstimatedPrice: updateEstimatedPrice,
            updateDoorPreview: updateDoorPreview,
            formatMoney: formatMoney,
            parseShowWhenProductTagsRaw: parseShowWhenProductTagsRaw,
            normProductTagSlug: normProductTagSlug,
            getConfiguratorProductTagContext: getConfiguratorProductTagContext,
            choiceHasShowWhenProductTagsField: choiceHasShowWhenProductTagsField,
            normalizeTagSetsForChoice: normalizeTagSetsForChoice,
            tagSetsMatchProductTags: tagSetsMatchProductTags,
            doorRestorePending: doorRestorePending,
            getDefaultSelectionForOption: getDefaultSelectionForOption,
            applyLocksetPrepNoneDefault: applyLocksetPrepNoneDefault,
            // Dp start 06-08 — porch swing thumbs use same resolver as data-option-id="swing_direction"
            resolveChoiceImageSrc: resolveChoiceImageSrc
            // Dp end 06-08
        });
    }

    function resolveChoiceProductTagShouldHide(opt, choice, ctx) {
        if (!choice || !ctx) return false;
        var choiceVal = choice.value != null && choice.value !== '' ? String(choice.value) : '';
        var productTags = ctx.productTags || [];
        var globalTagMap = ctx.globalTagMap;
        var urlCollectionHandle = ctx.urlCollectionHandle || '';
        // Dutch doors: hide Mortise Lock Prep on Lockset Prep.
        try {
            var optIdNormTag = normalizeOptionIdKey(opt && opt.id);
            var choiceKeyTag = normalizeChoiceKey(choiceVal);
            if (optIdNormTag === 'lockset_prep' && (choiceKeyTag === 'mortise_pocket' || choiceKeyTag === 'mortise_lock_prep')) {
                var hasDutch = productTags.indexOf('dutch-doors') !== -1 || productTags.indexOf('dutch-door') !== -1;
                if (hasDutch) return true;
            }
        } catch (eMortiseHide) { }
        var shouldHide = true;
        var tagSets = [];
        if (choiceHasShowWhenProductTagsField(choice)) {
            tagSets = normalizeTagSetsForChoice(choice.showWhenProductTags, choiceVal, {
                productTagsOnly: true
            });
            shouldHide = !tagSets.length || !tagSetsMatchProductTags(tagSets, productTags);
        } else if (globalTagMap && choiceIsInProductTagCatalog(globalTagMap, choiceVal)) {
            tagSets = getTagSetsForChoiceFromGlobalMap(globalTagMap, choiceVal);
            shouldHide = !tagSetsMatchProductTags(tagSets, productTags);
        } else {
            return false;
        }
        if (!shouldHide && urlCollectionHandle && choiceHasShowWhenProductTagsField(choice)) {
            var rawSwpt = parseShowWhenProductTagsRaw(choice.showWhenProductTags);
            if (rawSwpt && typeof rawSwpt === 'object' && !Array.isArray(rawSwpt) && Array.isArray(rawSwpt.dontShowCollection)) {
                if (rawSwpt.dontShowCollection.some(function (h) { return normProductTagSlug(h) === urlCollectionHandle; })) {
                    shouldHide = true;
                }
            }
        }
        return shouldHide;
    }

    // Dp start 03-08 — custom.optional_shelf allow-list (empty = keep default visibility)
    function isOptionalShelfOptionId(id) {
        var k = normalizeOptionIdKey(id);
        return k === 'shelf' || k === 'optional_shelf';
    }

    function getOptionalShelfAllowedKeys() {
        try {
            var main = document.getElementById('door-configurator')
                || document.getElementById('landing-product-configurator');
            if (!main || !main.getAttribute) return null;
            if (!main.hasAttribute('data-optional-shelf')) return null;
            var raw = main.getAttribute('data-optional-shelf');
            if (raw == null || String(raw).trim() === '') return null;
            var parts = String(raw).split(/[,|\n\r•]+/);
            var keys = [];
            for (var i = 0; i < parts.length; i++) {
                var k = normalizeChoiceKey(parts[i]);
                if (k && keys.indexOf(k) === -1) keys.push(k);
            }
            return keys.length ? keys : null;
        } catch (eShelfAllow) {
            return null;
        }
    }

    function isShelfChoiceInAllowList(choice, allowedKeys) {
        if (!allowedKeys || !allowedKeys.length) return true;
        if (!choice) return false;
        var val = normalizeChoiceKey(choice.value);
        var lbl = normalizeChoiceKey(choice.label || choice.title || '');
        if (val && allowedKeys.indexOf(val) !== -1) return true;
        if (lbl && allowedKeys.indexOf(lbl) !== -1) return true;
        return false;
    }

    /** Prefer configurator_defaults.shelf / optional_shelf when picking a visible shelf radio. */
    function getShelfDefaultSelectionValue() {
        try {
            var v = getDefaultSelectionForOption('shelf');
            if (v != null && String(v) !== '') return String(v);
            v = getDefaultSelectionForOption('optional_shelf');
            if (v != null && String(v) !== '') return String(v);
        } catch (eShelfDef) { }
        return '';
    }

    function findVisibleShelfRadioForDefault(container, optId, defVal) {
        if (!container || !optId) return null;
        var want = normalizeChoiceKey(defVal);
        var radios = container.querySelectorAll('input[type="radio"][data-option-id="' + optId + '"]');
        var fallback = null;
        for (var ri = 0; ri < radios.length; ri++) {
            var pick = radios[ri];
            var pickCard = pick.closest ? pick.closest('.common-check-option') : null;
            if (!pickCard) continue;
            if (pickCard.style.display === 'none' || pickCard.classList.contains('door-hidden')) continue;
            if (pickCard.getAttribute('data-optional-shelf-hidden') === '1') continue;
            if (pickCard.getAttribute('data-product-tag-hidden') === '1') continue;
            if (pickCard.getAttribute('data-choice-condition-hidden') === '1') continue;
            if (!fallback) fallback = pick;
            if (!want) continue;
            var key = normalizeChoiceKey(pick.value);
            var lblKey = '';
            var lblEl = pickCard.querySelector('.common-check-option-label');
            if (lblEl) lblKey = normalizeChoiceKey(lblEl.textContent);
            var choiceAttr = normalizeChoiceKey(pickCard.getAttribute('data-choice-value') || '');
            if (key === want || lblKey === want || choiceAttr === want) return pick;
            var candidates = getDefaultSelectionValueCandidates(optId, defVal);
            for (var ci = 0; ci < candidates.length; ci++) {
                var cNorm = normalizeChoiceKey(candidates[ci]);
                if (cNorm && (cNorm === key || cNorm === lblKey || cNorm === choiceAttr)) return pick;
            }
        }
        return want ? null : fallback;
    }

    function applyShelfDefaultFromConfiguratorDefaults(container) {
        if (!container || doorRestorePending()) return false;
        var defVal = getShelfDefaultSelectionValue();
        if (!defVal) return false;
        var optIds = ['shelf', 'optional_shelf'];
        for (var oi = 0; oi < optIds.length; oi++) {
            var optId = optIds[oi];
            var pick = findVisibleShelfRadioForDefault(container, optId, defVal);
            if (!pick) {
                pick = findRadioInputForDefaultSelection(container, optId, defVal);
                if (pick) {
                    var cardCheck = pick.closest ? pick.closest('.common-check-option') : null;
                    if (cardCheck && (
                        cardCheck.style.display === 'none'
                        || cardCheck.classList.contains('door-hidden')
                        || cardCheck.getAttribute('data-optional-shelf-hidden') === '1'
                        || cardCheck.getAttribute('data-product-tag-hidden') === '1'
                        || cardCheck.getAttribute('data-choice-condition-hidden') === '1'
                    )) {
                        pick = null;
                    }
                }
            }
            if (!pick) continue;
            container.querySelectorAll('input[type="radio"][data-option-id="' + optId + '"]').forEach(function (r) {
                r.checked = false;
                var rc = r.closest && r.closest('.common-check-option');
                if (rc) rc.classList.remove('common-check-option--selected');
            });
            pick.checked = true;
            var pickCard = pick.closest ? pick.closest('.common-check-option') : null;
            if (pickCard) pickCard.classList.add('common-check-option--selected');
            try { pick.dispatchEvent(new Event('change', { bubbles: true })); } catch (eChgShelf) { }
            return true;
        }
        return false;
    }

    function applyOptionalShelfChoiceVisibility(schema, container) {
        if (!container) container = document.getElementById('door-configurator-options');
        if (!container) return;
        var allowed = getOptionalShelfAllowedKeys();
        // No metafield values → do not touch default / tag / show-when logic
        if (!allowed || !allowed.length) {
            try { applyShelfDefaultFromConfiguratorDefaults(container); } catch (eShelfDefEmpty) { }
            return;
        }

        var optIds = [];
        if (Array.isArray(schema)) {
            schema.forEach(function (opt) {
                if (opt && isOptionalShelfOptionId(opt.id)) {
                    var id = String(opt.id);
                    if (optIds.indexOf(id) === -1) optIds.push(id);
                }
            });
        }
        if (optIds.indexOf('shelf') === -1) optIds.push('shelf');
        if (optIds.indexOf('optional_shelf') === -1) optIds.push('optional_shelf');

        optIds.forEach(function (optId) {
            var radios = container.querySelectorAll('input[type="radio"][data-option-id="' + optId + '"]');
            Array.prototype.forEach.call(radios, function (inp) {
                if (!inp) return;
                var card = inp.closest ? inp.closest('.common-check-option') : null;
                var key = normalizeChoiceKey(inp.value);
                var lblKey = '';
                if (card) {
                    var lblEl = card.querySelector('.common-check-option-label');
                    if (lblEl) lblKey = normalizeChoiceKey(lblEl.textContent);
                    if (!key) key = normalizeChoiceKey(card.getAttribute('data-choice-value') || '');
                }
                var allowedChoice = (key && allowed.indexOf(key) !== -1) || (lblKey && allowed.indexOf(lblKey) !== -1);
                if (card) {
                    if (allowedChoice) {
                        // Force-show allow-listed values (override tag / show-when hide).
                        card.style.display = '';
                        card.classList.remove('door-hidden');
                        card.removeAttribute('data-optional-shelf-hidden');
                        card.removeAttribute('data-product-tag-hidden');
                        card.removeAttribute('data-choice-condition-hidden');
                    } else {
                        card.style.display = 'none';
                        card.classList.add('door-hidden');
                        card.setAttribute('data-optional-shelf-hidden', '1');
                        if (inp.checked) {
                            inp.checked = false;
                            card.classList.remove('common-check-option--selected');
                        }
                    }
                } else if (!allowedChoice && inp.checked) {
                    inp.checked = false;
                }
            });

            var sel = container.querySelector('select[data-option-id="' + optId + '"]');
            if (sel) {
                Array.prototype.forEach.call(sel.options, function (optionEl) {
                    if (!optionEl || !optionEl.value) return;
                    var ok = allowed.indexOf(normalizeChoiceKey(optionEl.value)) !== -1
                        || allowed.indexOf(normalizeChoiceKey(optionEl.text)) !== -1;
                    optionEl.hidden = !ok;
                    optionEl.disabled = !ok;
                    if (!ok) {
                        optionEl.setAttribute('data-optional-shelf-hidden', '1');
                        optionEl.setAttribute('data-product-tag-hidden', '1');
                    } else {
                        optionEl.removeAttribute('data-optional-shelf-hidden');
                        optionEl.removeAttribute('data-product-tag-hidden');
                        optionEl.removeAttribute('data-choice-condition-hidden');
                    }
                });
                if (sel.value && allowed.indexOf(normalizeChoiceKey(sel.value)) === -1) {
                    var firstVisible = Array.prototype.find.call(sel.options, function (o) {
                        return o && o.value && !o.hidden && !o.disabled;
                    });
                    sel.value = firstVisible ? firstVisible.value : '';
                }
            }

            // Prefer configurator_defaults.shelf; else first visible allow-listed choice.
            var anyChecked = container.querySelector('input[type="radio"][data-option-id="' + optId + '"]:checked');
            if (!anyChecked) {
                var defVal = getShelfDefaultSelectionValue();
                var pick = findVisibleShelfRadioForDefault(container, optId, defVal);
                if (!pick && !defVal) {
                    pick = findVisibleShelfRadioForDefault(container, optId, '');
                }
                if (pick) {
                    pick.checked = true;
                    var pickCard = pick.closest ? pick.closest('.common-check-option') : null;
                    if (pickCard) pickCard.classList.add('common-check-option--selected');
                }
            }
        });
        try { applyShelfDefaultFromConfiguratorDefaults(container); } catch (eShelfDefAllow) { }
    }
    // Dp end 03-08

    // Dp start 10-08
    function syncTransomSectionVisibility(container) {
        if (!container) container = document.getElementById('door-configurator-options');
        if (!container) return;

        var transomSection = container.querySelector(
            '.door-option-wrap[data-option-id="transom_design"],' +
            '.door-option-wrap[data-option-id="transom_designs"],' +
            '.door-option-wrap[data-option-id="transome_design"],' +
            '.door-option-wrap[data-option-id="transome_designs"]'
        );
        if (!transomSection) return;

        var transomStyleCards = transomSection.querySelectorAll(
            '.transom-style-option,' +
            'input[type="radio"][data-option-id="transom_style"],' +
            'select[data-option-id="transom_style"]'
        );

        var hasVisibleTransomStyle = false;
        Array.prototype.forEach.call(transomStyleCards, function (el) {
            if (el.tagName === 'SELECT') {
                var visOpt = Array.prototype.find.call(el.options || [], function (op) {
                    return op && op.value && !op.hidden && !op.disabled;
                });
                if (visOpt) hasVisibleTransomStyle = true;
            } else {
                var card = el.classList.contains('common-check-option') ? el : (el.closest ? el.closest('.common-check-option') : null);
                if (card) {
                    var hiddenByStyle = card.style.display === 'none';
                    var hiddenByClass = card.classList.contains('door-hidden');
                    var hiddenByTag = card.getAttribute('data-product-tag-hidden') === '1';
                    var hiddenByWood = card.getAttribute('data-wood-exposure-hidden') === '1';
                    var hiddenByCond = card.getAttribute('data-choice-condition-hidden') === '1';
                    if (!hiddenByStyle && !hiddenByClass && !hiddenByTag && !hiddenByWood && !hiddenByCond) {
                        hasVisibleTransomStyle = true;
                    }
                }
            }
        });

        if (!hasVisibleTransomStyle) {
            transomSection.style.display = 'none';
            transomSection.classList.add('door-hidden');
        } else {
            transomSection.style.display = '';
            transomSection.classList.remove('door-hidden');
        }
    }
    // Dp end 10-08

    function applyProductTagChoiceVisibility(schema, container) {
        if (!container) container = document.getElementById('door-configurator-options');
        var main = document.getElementById('door-configurator');
        if (!main || !container) return;
        var ctx = getConfiguratorProductTagContext(schema);
        function escapeSelectorVal(s) {
            return String(s == null ? '' : s).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        }
        function applyHideToChoice(opt, choiceVal, shouldHide, container) {
            if (!container) return;
            try {
                if (normalizeOptionIdKey(opt && opt.id) === 'stile_and_rail_profile') {
                    if (isSoftOgeeStileChoice(choiceVal) && isSoftOgeeHiddenByInsertsMode(container)) {
                        shouldHide = true;
                    } else if (isFixedGlassForceSoftOgeeActive(container)) {
                        shouldHide = !isSoftOgeeStileChoice(choiceVal);
                    } else if (
                        isSoftOgeeStileChoice(choiceVal)
                        && isSoftOgeeRequiresFixedGlassSelection(container)
                    ) {
                        shouldHide = true;
                    }
                }
            } catch (eForceSoftHide) { }
            var optIdForRadio = escapeSelectorVal(String(opt.id || ''));
            var choiceEsc = escapeSelectorVal(choiceVal);
            var sel = container.querySelector('select[data-option-id="' + optIdForRadio + '"]');
            if (sel) {
                var optionEl = sel.querySelector('option[value="' + choiceEsc + '"]');
                if (optionEl) {
                    if (
                        shouldHide
                        && sel.getAttribute
                        && sel.getAttribute('data-door-user-changed') === '1'
                        && String(sel.value || '') === choiceVal
                    ) {
                        shouldHide = false;
                    }
                    optionEl.hidden = shouldHide;
                    optionEl.disabled = shouldHide;
                    if (shouldHide) optionEl.setAttribute('data-product-tag-hidden', '1');
                    else optionEl.removeAttribute('data-product-tag-hidden');
                    if (shouldHide && String(sel.value || '') === choiceVal) {
                        var firstVisible = Array.prototype.find.call(sel.options, function (o) { return !o.hidden && o.value; });
                        sel.value = firstVisible ? firstVisible.value : '';
                        if (typeof updateEstimatedPrice === 'function') updateEstimatedPrice();
                    }
                }
            }
            var cards = container.querySelectorAll(
                '.common-check-option[data-choice-value="' + choiceEsc + '"]'
            );
            var touchedRadio = false;
            Array.prototype.forEach.call(cards, function (card) {
                var inp = card.querySelector
                    ? card.querySelector('input[type="radio"][data-option-id="' + optIdForRadio + '"]')
                    : null;
                if (!inp) return;
                touchedRadio = true;
                var woodHidden = card.getAttribute && card.getAttribute('data-wood-exposure-hidden') === '1';
                var conditionHidden = card.getAttribute && card.getAttribute('data-choice-condition-hidden') === '1';
                var fixedGlassStileHidden = card.getAttribute && card.getAttribute('data-fixed-glass-stile-hidden') === '1';
                var hideCard = !!(shouldHide || woodHidden || conditionHidden || fixedGlassStileHidden);
                card.style.display = hideCard ? 'none' : '';
                card.classList.toggle('door-hidden', hideCard);
                if (shouldHide) card.setAttribute('data-product-tag-hidden', '1');
                else card.removeAttribute('data-product-tag-hidden');
                if (shouldHide && inp.checked) {
                    inp.checked = false;
                    card.classList.remove('common-check-option--selected');
                }
            });
            if (touchedRadio && shouldHide) {
                var optIdNormForAutoSel = String(optIdForRadio || '').toLowerCase().replace(/-/g, '_');
                var isWoodOption = optIdNormForAutoSel.indexOf('wood') !== -1;
                if (
                    !isWoodOption
                    && !optionIdSkipsDefaultRadioAutoSelect(optIdNormForAutoSel)
                    && !isInactivePanelProfileOption(optIdNormForAutoSel)
                ) {
                    var anyChecked = container.querySelector(
                        'input[type="radio"][data-option-id="' + optIdForRadio + '"]:checked'
                    );
                    if (!anyChecked) {
                        var allRadios = container.querySelectorAll(
                            'input[type="radio"][data-option-id="' + optIdForRadio + '"]'
                        );
                        for (var ri = 0; ri < allRadios.length; ri++) {
                            var pickInp = allRadios[ri];
                            var cardVis = pickInp.closest ? pickInp.closest('.common-check-option') : null;
                            if (!cardVis) continue;
                            if (cardVis.style.display === 'none' || cardVis.classList.contains('door-hidden')) continue;
                            if (cardVis.getAttribute('data-product-tag-hidden') === '1') continue;
                            if (cardVis.getAttribute('data-wood-exposure-hidden') === '1') continue;
                            if (cardVis.getAttribute('data-choice-condition-hidden') === '1') continue;
                            if (cardVis.getAttribute('data-fixed-glass-stile-hidden') === '1') continue;
                            if (cardVis.getAttribute('data-inserts-mode-stile-hidden') === '1') continue;
                            if (
                                optIdNormForAutoSel === 'stile_and_rail_profile'
                                && isSoftOgeeHiddenByInsertsMode(container)
                                && isSoftOgeeStileChoice(cardVis)
                            ) continue;
                            if (
                                optIdNormForAutoSel === 'stile_and_rail_profile'
                                && isFixedGlassForceSoftOgeeActive(container)
                                && !isSoftOgeeStileChoice(cardVis)
                            ) continue;
                            if (
                                optIdNormForAutoSel === 'stile_and_rail_profile'
                                && isSoftOgeeRequiresFixedGlassSelection(container)
                                && !isFixedGlassForceSoftOgeeActive(container)
                                && isSoftOgeeStileChoice(cardVis)
                            ) continue;
                            pickInp.checked = true;
                            cardVis.classList.add('common-check-option--selected');
                            if (typeof updateEstimatedPrice === 'function') updateEstimatedPrice();
                            break;
                        }
                    }
                }
            }
            var checkboxInps = container.querySelectorAll(
                'label.door-setup-option input[value="' + choiceEsc + '"][data-option-id="' + optIdForRadio + '"]'
            );
            Array.prototype.forEach.call(checkboxInps, function (labelInp) {
                if (labelInp.parentNode) {
                    labelInp.parentNode.style.display = shouldHide ? 'none' : '';
                }
            });
        }
        schema.forEach(function (opt) {
            var optionsList = opt.options || [];
            var optIdEsc = escapeSelectorVal(String(opt.id || ''));

            if (isGateCollectionActive() && normalizeOptionIdKey(opt.id) === 'swing_direction') {
                return;
            }

            // --- Dp start 16-07 ---
            // SDL: never hide choices via product tags / product-wise filters by default.
            // Applied Molding uses collection show_when_product_tags (+ product-wise rm5/all/hide).
            var optIdNormAlwaysShow = normalizeOptionIdKey(opt.id);
            if (optIdNormAlwaysShow === 'sdl_profile') {
                optionsList.forEach(function (choice) {
                    var choiceValAlways = choice.value != null && choice.value !== '' ? String(choice.value) : '';
                    applyHideToChoice(opt, choiceValAlways, false, container);
                });
                return;
            }
            // --- Dp end 16-07 ---

            // Dp start 09-07 — Door Sweep / Door Stops: keep schema choices visible.
            // Product-tag / global show_when maps were disabling every <option>, then the
            // custom .door-div-select rebuilt from enabled options only → empty dropdown
            // (especially porch-panel products). Priming (radios) was unaffected.
            if (optIdNormAlwaysShow === 'door_sweep' || optIdNormAlwaysShow === 'door_seal_kit') {
                optionsList.forEach(function (choice) {
                    var choiceValSweep = choice.value != null && choice.value !== '' ? String(choice.value) : '';
                    applyHideToChoice(opt, choiceValSweep, false, container);
                });
                return;
            }
            // Dp end 09-07

            // Dp start 03-08 — Optional Shelf: metafield allow-list overrides tag hide/show
            if (isOptionalShelfOptionId(opt.id)) {
                var shelfAllowed = getOptionalShelfAllowedKeys();
                if (shelfAllowed && shelfAllowed.length) {
                    optionsList.forEach(function (choice) {
                        var choiceValShelf = choice.value != null && choice.value !== '' ? String(choice.value) : '';
                        applyHideToChoice(opt, choiceValShelf, !isShelfChoiceInAllowList(choice, shelfAllowed), container);
                    });
                    return;
                }
                // Empty metafield → fall through to default tag / show-when logic
            }
            // Dp end 03-08

            if (isMeasurementTypeOptionId(opt.id)) {
                var hasMeasureControl = container.querySelector(
                    'input[type="radio"][data-option-id="' + optIdEsc + '"]'
                );
                if (!hasMeasureControl) return;
                if (isGateCollectionActive()) {
                    optionsList.forEach(function (choice) {
                        var choiceVal = choice.value != null && choice.value !== '' ? String(choice.value) : '';
                        var hideGateTab = true;
                        try {
                            if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.isGateCollectionAllowedMeasureTab === 'function') {
                                hideGateTab = !window.DoorConf2Measurements.isGateCollectionAllowedMeasureTab(choiceVal);
                            }
                        } catch (eGateMeasTab) { }
                        applyHideToChoice(opt, choiceVal, hideGateTab, container);
                    });
                    return;
                }
                optionsList.forEach(function (choice) {
                    var choiceVal = choice.value != null && choice.value !== '' ? String(choice.value) : '';
                    if (normalizeOptionIdKey(choiceVal) === 'exact_door_size') {
                        applyHideToChoice(opt, choiceVal, isSidelightOrTransomCollectionActive(), container);
                        return;
                    }
                    if (!isMeasurementSidelightTransomTabValue(choiceVal) && normalizeOptionIdKey(choiceVal) !== 'exact_door_size') {
                        applyHideToChoice(opt, choiceVal, false, container);
                        return;
                    }
                    applyHideToChoice(opt, choiceVal, resolveMeasurementTabProductTagShouldHide(schema, choiceVal), container);
                });
                return;
            }

            var hasAnyTagRule = optionsList.some(function (c) {
                return choiceHasShowWhenProductTagsField(c) || hasTagRuleForChoice(c);
            });
            /* MERGE: product_wise_edge_profile_sdl — start */
            var hasProductWiseFilter = false;
            if (ctx.productWiseEdgeProfile && window.DoorConf2Update && typeof window.DoorConf2Update.optionHasProductWiseEdgeProfileFilter === 'function') {
                hasProductWiseFilter = window.DoorConf2Update.optionHasProductWiseEdgeProfileFilter(opt.id, ctx.productWiseEdgeProfile);
            }
            /* MERGE: product_wise_edge_profile_sdl — end */
            if (!hasAnyTagRule && !ctx.globalTagMap && !hasProductWiseFilter) return;
            var hasControlInDom = container.querySelector(
                'select[data-option-id="' + optIdEsc + '"],' +
                ' input[type="radio"][data-option-id="' + optIdEsc + '"],' +
                ' label.door-setup-option input[data-option-id="' + optIdEsc + '"]'
            );
            if (!hasControlInDom) return;
            optionsList.forEach(function (choice) {
                var choiceVal = choice.value != null && choice.value !== '' ? String(choice.value) : '';
                var shouldHide = resolveChoiceProductTagShouldHide(opt, choice, ctx);
                /* MERGE: product_wise_edge_profile_sdl — start */
                try {
                    if (ctx.productWiseEdgeProfile && window.DoorConf2Update && typeof window.DoorConf2Update.resolveChoiceProductWiseEdgeProfileShouldHide === 'function') {
                        var pweHide = window.DoorConf2Update.resolveChoiceProductWiseEdgeProfileShouldHide(opt, choice, ctx.productWiseEdgeProfile);
                        if (pweHide === true) shouldHide = true;
                        // Product-level allow-list is authoritative for its own option: a value
                        // whitelisted in the metafield (e.g. sdl_profile:"cove") must show even
                        // when the config_choice show-when-tags don't match this product.
                        else if (pweHide === false) shouldHide = false;
                    }
                } catch (ePweHideChoice) { }
                /* MERGE: product_wise_edge_profile_sdl — end */
                applyHideToChoice(opt, choiceVal, shouldHide, container);
            });
        });
        try { syncMeasurementSidelightTransomTabVisibility(container, schema); } catch (eMeasTabTags) { }
        applyGardenGatesCollectionRulesFromMeasurements(container);
        // --- Dp start 16-07 ---
        // Do not revealAllAppliedMoldingChoices here — that would wipe collection
        // show_when_product_tags. Product-wise rm5/all/hide is applied in sync below.
        /* MERGE: product_wise_applied_molding_accordion — start */
        try { syncAppliedMoldingSectionVisibility(container); } catch (eAmPweAfterTags) { }
        /* MERGE: product_wise_applied_molding_accordion — end */
        // Do not revealAllSdl here — stile-related filtering is applied by scheduleSdlProfileVisibilitySync.
        // --- Dp end 16-07 ---
        try { scheduleSdlProfileVisibilitySync(container); } catch (eSdlTagVis) { }
        // Dp start 03-08
        try { applyOptionalShelfChoiceVisibility(schema, container); } catch (eOptShelf) { }
        // Dp end 03-08
        try { syncStileSoftOgeeForFixedGlass(container); } catch (eSoftOgeeTags) { }
        // Dp start 10-08
        try {
            syncTransomSectionVisibility(container);
        } catch (eTransomTagVis) { }
        // Dp end 10-08
        // Dp start 09-07 — refresh Door Sweep / Door Stops custom dropdown after tag pass
        try { refreshAdditionalOptionsSelectDropdowns(container); } catch (eAddlSelRefresh) { }
        // Dp end 09-07
    }

    function bindDynamicOptionsEvents(container) {
        if (!container) return;
        all('select[data-option-id], input[data-option-id]', container).forEach(function (el) {
            function onDynamicOptionChange() {
                if (isStileAndRailProfileInput(el)) return;
                updateEstimatedPrice();
            }
            el.addEventListener('change', onDynamicOptionChange);
            if (el.tagName.toLowerCase() === 'select' || el.type === 'number' || el.type === 'text') {
                el.addEventListener('input', onDynamicOptionChange);
            }
        });
    }

    function bindDelegatedPriceUpdate() {
        var container = document.getElementById('door-configurator');
        if (!container) return;
        function isOptionControlTarget(t) {
            if (!t || !t.getAttribute) return false;
            if (t.getAttribute('data-option-id')) return true;
            if (t.id && String(t.id).indexOf('door-opt-') === 0) return true;
            if (t.closest && (t.tagName === 'SELECT' || t.tagName === 'INPUT') &&
                (t.closest('.door-measurement-embedded-dimensions') ||
                    t.closest('.door-measurement-static-rows') ||
                    t.closest('.door-measurement-type-section') ||
                    t.closest('[data-panel-unit-individual-measurements]') ||
                    t.closest('[data-panel-unit-enclosure-measurements]') ||
                    t.closest('.door-porch-opening-entry'))) return true;
            return false;
        }
        function isStileAndRailProfileInteraction(t) {
            if (!t || !t.closest) return false;
            if (isStileAndRailProfileInput(t)) return true;
            return !!t.closest('.door-option-wrap[data-option-id="stile_and_rail_profile"]');
        }
        function refreshPriceForOptionTarget(t) {
            if (isStileAndRailProfileInteraction(t)) {
                if (
                    window.PriceScreenStorm
                    && typeof window.PriceScreenStorm.isScreenAndStormDoorsProductType === 'function'
                    && window.PriceScreenStorm.isScreenAndStormDoorsProductType()
                    && typeof window.PriceScreenStorm.applyScreenStormStileAndRailProfilePriceUpdate === 'function'
                ) {
                    window.PriceScreenStorm.applyScreenStormStileAndRailProfilePriceUpdate();
                } else {
                    applyStileAndRailProfilePriceUpdate();
                }
            } else {
                updateEstimatedPrice();
            }
            try { updateDoorPreview(); } catch (ePrev) { }
        }
        function shouldRecalculateFromClick(t) {
            if (!t || !t.closest) return false;
            if (isOptionControlTarget(t)) return true;
            var card = t.closest('.common-check-option');
            if (card && card.querySelector && card.querySelector('input[data-option-id]')) return true;
            var chk = t.closest('.door-setup-option');
            if (chk && chk.querySelector && chk.querySelector('input[data-option-id]')) return true;
            return false;
        }
        function markParentWraps(el) {
            if (!el || !el.closest) return;
            try {
                var node = el.closest('.door-option-wrap[data-option-id]');
                while (node) {
                    var pid = node.getAttribute('data-option-id');
                    if (pid) markOptionTouched(pid);
                    node = node.parentElement ? node.parentElement.closest('.door-option-wrap[data-option-id]') : null;
                }
                var measWrap = el.closest('.door-measurement-type-section[data-option-id]') ||
                    el.closest('.door-measurement-embedded-dimensions') ||
                    el.closest('.door-measurement-static-rows');
                if (measWrap) {
                    var measSection = measWrap.closest ? measWrap.closest('.door-measurement-type-section[data-option-id]') : measWrap;
                    if (measSection) {
                        var measId = measSection.getAttribute('data-option-id');
                        if (measId) markOptionTouched(measId);
                    }
                }
            } catch (e) { }
        }
        function handleOptionChange(e) {
            var t = e.target;
            if (isOptionControlTarget(t)) {
                var touchedId = t.getAttribute ? t.getAttribute('data-option-id') : '';
                if (touchedId) markOptionTouched(touchedId);
                markParentWraps(t);
                if (t && t.type === 'radio' && isMeasurementTypeOptionId(touchedId) && t.checked) {
                    applyMeasurementTypeTabSelection(t, touchedId, container, doorConfigSchema);
                }
                if (t && String(t.tagName || '').toUpperCase() === 'SELECT') {
                    // Persist selection ids/values for future price logic (esp. measurement dropdowns).
                    var prefix = (t.closest && t.closest('.door-measurement-static-rows'))
                        ? 'door-measurement-static-rows-select'
                        : ((t.closest && t.closest('.door-measurement-embedded-dimensions'))
                            ? 'door-measurement-embedded-dimensions-select'
                            : 'door-select');
                    recordDoorSelectMeta(t, prefix);
                    // Expose for theme scripts / debugging
                    try {
                        window.DoorConfiguratorSelectionMeta = {
                            bySelectId: getDoorSelectionMetaBySelectId(),
                            last: getDoorLastSelectionMeta()
                        };
                    } catch (eExpose) { }
                }
                refreshPriceForOptionTarget(t);
            }
        }
        container.addEventListener('change', handleOptionChange, true);
        container.addEventListener('input', handleOptionChange, true);
        // Re-evaluate empty option sections after any option interaction so a section
        // reappears if its choices become available (or hides if they go away).
        var _emptySectionRefreshTimer = null;
        function scheduleEmptySectionRefresh() {
            if (_emptySectionRefreshTimer) clearTimeout(_emptySectionRefreshTimer);
            _emptySectionRefreshTimer = setTimeout(function () {
                try { hideEmptyOptionSections(document.getElementById('door-configurator-options')); } catch (eEmpty) { }
                try { applyCollectionMeasureRowVisibility(); } catch (eColMeasure) { }
            }, 60);
        }
        container.addEventListener('change', scheduleEmptySectionRefresh, true);
        container.addEventListener('click', scheduleEmptySectionRefresh, true);
        // Card-style radios: click often lands on img/label; ensure price refreshes after selection applies.
        container.addEventListener('click', function (e) {
            if (!shouldRecalculateFromClick(e.target)) return;
            try {
                var clickedCard = e.target.closest ? e.target.closest('.common-check-option, .door-setup-option') : null;
                var clickedInp = clickedCard ? clickedCard.querySelector('input[data-option-id]') : null;
                if (clickedInp) {
                    var cid = clickedInp.getAttribute('data-option-id');
                    if (cid) markOptionTouched(cid);
                }
                markParentWraps(e.target);
            } catch (eMark) { }
            if (isStileAndRailProfileInteraction(e.target)) return;
            updateEstimatedPrice();
            try { updateDoorPreview(); } catch (eClkPrev) { }
        }, true);
    }

    function openInsertsInfoDrawer(sourceBtn) {
        if (typeof window.__openInsertsInfoDrawer === 'function') {
            return window.__openInsertsInfoDrawer(sourceBtn);
        }
        if (window.DoorConf2Update && typeof window.DoorConf2Update.openInsertsInfoDrawer === 'function') {
            return window.DoorConf2Update.openInsertsInfoDrawer(sourceBtn);
        }
        var modal = document.querySelector('.inserts-info-snippet .inserts-info-modal[id]')
            || document.querySelector('.inserts-info-modal[id*="inserts_info_drawer"]');
        if (!modal) return false;
        var panel = modal.querySelector('.inserts-info-modal__panel');
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        if (panel && panel.focus) {
            try { panel.focus(); } catch (eFocus) { }
        }
        return true;
    }

    function openMeasureGuideDrawer() {
        if (typeof window.__openMeasureGuideDrawer === 'function') {
            return window.__openMeasureGuideDrawer();
        }
        if (window.DoorConf2Update && typeof window.DoorConf2Update.openMeasureGuideDrawer === 'function') {
            return window.DoorConf2Update.openMeasureGuideDrawer();
        }
        var selectors = [
            'button.measure-guide-open-btn[data-measure-drawer-open]',
            '[data-measure-drawer-open]',
            'button.measure-guide-open-btn'
        ];
        for (var i = 0; i < selectors.length; i++) {
            var matches = all(selectors[i]).filter(function (el) {
                return !!(el && el.offsetParent !== null);
            });
            if (matches.length) {
                matches[0].click();
                return true;
            }
        }
        for (var j = 0; j < selectors.length; j++) {
            var hiddenMatches = all(selectors[j]);
            if (hiddenMatches.length) {
                hiddenMatches[0].click();
                return true;
            }
        }
        return false;
    }

    function openWoodSpeciesDrawer() {
        if (typeof window.__openWoodSpeciesDrawer === 'function') {
            return window.__openWoodSpeciesDrawer();
        }
        if (window.DoorConf2Update && typeof window.DoorConf2Update.openWoodSpeciesDrawer === 'function') {
            return window.DoorConf2Update.openWoodSpeciesDrawer();
        }
        return false;
    }

    function openScreenTypesDrawer() {
        if (typeof window.__openScreenTypesDrawer === 'function') {
            return window.__openScreenTypesDrawer();
        }
        if (window.DoorConf2Update && typeof window.DoorConf2Update.openScreenTypesDrawer === 'function') {
            return window.DoorConf2Update.openScreenTypesDrawer();
        }
        return false;
    }

    function openStormGlassDrawer() {
        if (typeof window.__openStormGlassDrawer === 'function') {
            return window.__openStormGlassDrawer();
        }
        if (window.DoorConf2Update && typeof window.DoorConf2Update.openStormGlassDrawer === 'function') {
            return window.DoorConf2Update.openStormGlassDrawer();
        }
        return false;
    }

    /** Opens the Edge Profile info drawer by clicking its theme trigger button. */
    function openEdgeProfileInfoDrawer(drawerId) {
        var id = String(drawerId || '').trim();
        if (!id) {
            var infoModal = document.querySelector('[id*="edge_profile_info_drawer"][role="dialog"], .edge-profile-drawer-modal[id]');
            if (infoModal && infoModal.id) id = infoModal.id;
        }
        if (id) {
            var sel = 'button.edge-profile-drawer__trigger[data-edge-profile-trigger="' + id.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]';
            var btn = document.querySelector(sel) || document.querySelector('button.edge-profile-drawer__trigger[data-edge-profile-trigger="' + id + '"]');
            if (btn) {
                btn.click();
                return true;
            }
        }
        var any = all('button.edge-profile-drawer__trigger').filter(function (el) { return !!(el && el.offsetParent !== null); });
        if (any.length) {
            any[0].click();
            return true;
        }
        return false;
    }

    /** Same modal/drawer as the theme "Door Setup Options" button (edge_profile / door setup drawer). */
    function getDoorSetupDrawerAriaControls() {
        if (window.DoorConf2Update && typeof window.DoorConf2Update.getDoorSetupDrawerAriaControls === 'function') {
            var fromUpdate = window.DoorConf2Update.getDoorSetupDrawerAriaControls();
            if (fromUpdate) return fromUpdate;
        }
        var woodBtns = all('button.wood-species-open-btn');
        for (var i = 0; i < woodBtns.length; i++) {
            var b0 = woodBtns[i];
            var txt0 = String(b0 && b0.textContent || '').trim().toLowerCase();
            if (txt0 === 'door setup options' && b0.getAttribute('aria-controls')) {
                return b0.getAttribute('aria-controls');
            }
        }
        for (var j = 0; j < woodBtns.length; j++) {
            var b = woodBtns[j];
            var txt = String(b && b.textContent || '').trim().toLowerCase();
            if (txt.indexOf('door setup') !== -1 && b.getAttribute('aria-controls')) {
                return b.getAttribute('aria-controls');
            }
        }
        var q = document.querySelector('button.wood-species-open-btn[aria-controls*="door_setup"]')
            || document.querySelector('button.wood-species-open-btn[aria-controls*="edge_profile"]');
        if (q && q.getAttribute('aria-controls')) return q.getAttribute('aria-controls');
        return '';
    }

    /** The Edge Profile Options drawer (not Door Setup Options). */
    function getEdgeProfileDrawerAriaControls() {
        if (window.DoorConf2Update && typeof window.DoorConf2Update.getEdgeProfileDrawerAriaControls === 'function') {
            var fromUpdate = window.DoorConf2Update.getEdgeProfileDrawerAriaControls();
            if (fromUpdate) return fromUpdate;
        }
        var woodBtns = all('button.wood-species-open-btn');
        for (var i = 0; i < woodBtns.length; i++) {
            var b0 = woodBtns[i];
            var txt0 = String(b0 && b0.textContent || '').trim().toLowerCase();
            if (!b0 || !b0.getAttribute) continue;
            if (!b0.getAttribute('aria-controls')) continue;
            if (txt0.indexOf('edge profile') === -1) continue;
            if (txt0.indexOf('door setup') !== -1) continue;
            return b0.getAttribute('aria-controls');
        }
        var q = document.querySelector('button.wood-species-open-btn[aria-controls*="edge_profile"]');
        if (q && q.getAttribute('aria-controls')) return q.getAttribute('aria-controls');
        return '';
    }

    function openEdgeProfileDrawer() {
        if (typeof window.__openEdgeProfileDrawer === 'function') {
            return window.__openEdgeProfileDrawer();
        }
        if (window.DoorConf2Update && typeof window.DoorConf2Update.openEdgeProfileDrawer === 'function') {
            return window.DoorConf2Update.openEdgeProfileDrawer();
        }
        return false;
    }

    function getScreenTypesDrawerAriaControls() {
        if (window.DoorConf2Update && typeof window.DoorConf2Update.getScreenTypesDrawerAriaControls === 'function') {
            var fromUpdate = window.DoorConf2Update.getScreenTypesDrawerAriaControls();
            if (fromUpdate) return fromUpdate;
        }
        return '';
    }

    function getStormGlassDrawerAriaControls() {
        if (window.DoorConf2Update && typeof window.DoorConf2Update.getStormGlassDrawerAriaControls === 'function') {
            var fromUpdate = window.DoorConf2Update.getStormGlassDrawerAriaControls();
            if (fromUpdate) return fromUpdate;
        }
        return '';
    }

    function getPanelProfileDrawerAriaControls() {
        if (window.DoorConf2Update && typeof window.DoorConf2Update.getPanelProfileDrawerAriaControls === 'function') {
            var fromUpdate = window.DoorConf2Update.getPanelProfileDrawerAriaControls();
            if (fromUpdate) return fromUpdate;
        }
        var btns = all('button[aria-controls]');
        for (var i = 0; i < btns.length; i++) {
            var b = btns[i];
            if (!b || !b.getAttribute) continue;
            var txt = String(b.textContent || '').trim().toLowerCase();
            if (txt.indexOf('panel profile') !== -1 || txt.indexOf('panel profiles') !== -1) {
                return b.getAttribute('aria-controls') || '';
            }
        }
        for (var j = 0; j < btns.length; j++) {
            var b2 = btns[j];
            if (!b2 || !b2.getAttribute) continue;
            var ac = String(b2.getAttribute('aria-controls') || '');
            var acLower = ac.toLowerCase();
            if (acLower.indexOf('panel_profile') !== -1 || acLower.indexOf('panel-profile') !== -1) {
                return ac;
            }
        }
        return '';
    }

    function openPanelProfileDrawer() {
        if (typeof window.__openPanelProfileDrawer === 'function') {
            return window.__openPanelProfileDrawer();
        }
        if (window.DoorConf2Update && typeof window.DoorConf2Update.openPanelProfileDrawer === 'function') {
            return window.DoorConf2Update.openPanelProfileDrawer();
        }
        return false;
    }

    function getLocksetPrepDrawerAriaControls() {
        if (window.DoorConf2Update && typeof window.DoorConf2Update.getLocksetPrepDrawerAriaControls === 'function') {
            var fromUpdate = window.DoorConf2Update.getLocksetPrepDrawerAriaControls();
            if (fromUpdate) return fromUpdate;
        }
        var btns = all('button[aria-controls]:not([data-lockset-prep-open])');
        for (var i = 0; i < btns.length; i++) {
            var b = btns[i];
            if (!b || !b.getAttribute) continue;
            var txt = String(b.textContent || '').trim().toLowerCase();
            if (txt.indexOf('lockset') !== -1 && txt.indexOf('prep') !== -1) {
                return b.getAttribute('aria-controls') || '';
            }
        }
        for (var j = 0; j < btns.length; j++) {
            var b2 = btns[j];
            if (!b2 || !b2.getAttribute) continue;
            var ac = String(b2.getAttribute('aria-controls') || '');
            var acLower = ac.toLowerCase();
            if (acLower.indexOf('lockset_prep') !== -1 || acLower.indexOf('lockset-prep') !== -1 || acLower.indexOf('lockset') !== -1) {
                return ac;
            }
        }
        return '';
    }

    function openLocksetPrepDrawer() {
        if (typeof window.__openLocksetPrepDrawer === 'function') {
            return window.__openLocksetPrepDrawer();
        }
        if (window.DoorConf2Update && typeof window.DoorConf2Update.openLocksetPrepDrawer === 'function') {
            return window.DoorConf2Update.openLocksetPrepDrawer();
        }
        return false;
    }

    function openDoorSetupDrawer() {
        if (typeof window.__openDoorSetupDrawer === 'function') {
            return window.__openDoorSetupDrawer();
        }
        if (window.DoorConf2Update && typeof window.DoorConf2Update.openDoorSetupDrawer === 'function') {
            return window.DoorConf2Update.openDoorSetupDrawer();
        }
        return false;
    }

    function resolveChoiceImageSrc(choice) {
        if (!choice) return '';
        var img = choice.image != null ? choice.image : choice.image_url;
        if (!img) return '';
        if (typeof img === 'string') return img;
        if (img.url) return img.url;
        if (img.src) return img.src;
        if (img.value && img.value.url) return img.value.url;
        if (img.preview_image && typeof img.preview_image === 'string') return img.preview_image;
        if (img.preview_image && img.preview_image.url) return img.preview_image.url;
        return '';
    }

    function normalizeChoiceDescriptionText(d) {
        try {
            var out = '';
            if (!d) return '';
            if (typeof d === 'string' || typeof d === 'number' || typeof d === 'boolean') out = String(d).trim();
            else if (typeof d === 'object') {
                if (typeof d.value === 'string') out = d.value.trim();
                else if (typeof d.text === 'string') out = d.text.trim();
                else if (typeof d.label === 'string') out = d.label.trim();
                else if (typeof d.html === 'string') {
                    var tmp = document.createElement('div');
                    tmp.innerHTML = d.html;
                    out = (tmp.textContent || tmp.innerText || '').trim();
                } else {
                    for (var i = 0; i < 4; i++) {
                        var key = ['content', 'description', 'subtext', 'note'][i];
                        if (d && typeof d[key] === 'string') {
                            out = d[key].trim();
                            break;
                        }
                    }
                }
            }
            return mapCollectionDoorWording(out);
        } catch (e) { }
        return '';
    }

    /**
     * 2026-04-30 — Pooja — Reference: used for panel_profile pricing gate (panel_int_ext / panel_storm_panel).
     * True when config stores boolean true, common truthy strings, or a non-empty checkbox value array.
     */
    function getCfgValueByKeyVariants(cfg, key) {
        if (!cfg || !key) return undefined;
        // Exact first.
        if (Object.prototype.hasOwnProperty.call(cfg, key)) return cfg[key];
        // Common variants: hyphen/underscore swaps.
        var k1 = String(key || '');
        var kUnderscore = k1.replace(/-/g, '_');
        var kHyphen = k1.replace(/_/g, '-');
        if (Object.prototype.hasOwnProperty.call(cfg, kUnderscore)) return cfg[kUnderscore];
        if (Object.prototype.hasOwnProperty.call(cfg, kHyphen)) return cfg[kHyphen];
        return undefined;
    }

    function isConfigFlagMarkedTrue(cfg, key) {
        if (!cfg || !key) return false;
        var raw = getCfgValueByKeyVariants(cfg, key);
        if (raw === true) return true;
        if (typeof raw === 'string') {
            var s = raw.trim().toLowerCase();
            return s === 'true' || s === '1' || s === 'yes' || s === 'on';
        }
        if (Array.isArray(raw)) {
            if (!raw.length) return false;
            for (var ai = 0; ai < raw.length; ai++) {
                var sv = String(raw[ai] != null ? raw[ai] : '').trim().toLowerCase();
                if (sv === 'true' || sv === '1' || sv === 'yes' || sv === 'on') return true;
            }
            return true;
        }
        return false;
    }

    // 2026-04-30 — Pooja — Reference: some options represent "enabled" by any non-empty selection
    // (e.g. select/radio choices like "interior"/"exterior"), not literal boolean true.
    function isConfigKeyMarkedEnabled(cfg, key) {
        if (!cfg || !key) return false;
        var raw = getCfgValueByKeyVariants(cfg, key);
        if (raw == null) return false;
        if (raw === true) return true;
        if (raw === false) return false;
        if (Array.isArray(raw)) return raw.length > 0;
        if (typeof raw === 'number') return raw !== 0;
        var s = String(raw).trim().toLowerCase();
        if (!s) return false;
        if (s === 'false' || s === '0' || s === 'no' || s === 'off' || s === 'none' || s === 'n/a') return false;
        return true;
    }

    /**
     * 2026-04-30 — Pooja — Reference: panel_profile pricing must apply only when
     * panel_int_ext OR panel_storm_panel is "marked true".
     *
     * We first check `config`, but also fall back to checking the live DOM because some UI-only
     * controls are not part of the metaobject schema (and thus won't be in `config`).
     */
    function isPanelProfilePricingGateOpen(cfg) {
        try {
            // Accept both literal boolean "true" and any non-empty selection for these fields.
            var byCfg =
                isConfigKeyMarkedEnabled(cfg, 'panel_int_ext')
                || isConfigKeyMarkedEnabled(cfg, 'panel_storm_panel');
            if (byCfg) return true;
        } catch (eCfgGate) { }
        try {
            var root = document.getElementById('door-configurator-options') || document;
            if (!root) return false;

            function anyTruthyControl(sel) {
                try {
                    var el = root.querySelector(sel);
                    if (!el) return false;
                    var tag = (el.tagName || '').toLowerCase();
                    var type = (el.type || '').toLowerCase();
                    if (tag === 'input' && (type === 'checkbox' || type === 'radio')) return !!el.checked;
                    if (tag === 'select') return el.value != null && String(el.value) !== '';
                    return true;
                } catch (eSel) { }
                return false;
            }

            // Prefer exact ids, but support common attribute naming patterns as fallbacks.
            var intExt =
                anyTruthyControl('input[data-option-id="panel_int_ext"]:checked') ||
                anyTruthyControl('select[data-option-id="panel_int_ext"]') ||
                anyTruthyControl('input[name="panel_int_ext"]:checked') ||
                anyTruthyControl('input[name="attributes[panel_int_ext]"]:checked') ||
                anyTruthyControl('select[name="panel_int_ext"]') ||
                anyTruthyControl('select[name="attributes[panel_int_ext]"]');

            var storm =
                anyTruthyControl('input[data-option-id="panel_storm_panel"]:checked') ||
                anyTruthyControl('select[data-option-id="panel_storm_panel"]') ||
                anyTruthyControl('input[name="panel_storm_panel"]:checked') ||
                anyTruthyControl('input[name="attributes[panel_storm_panel]"]:checked') ||
                anyTruthyControl('select[name="panel_storm_panel"]') ||
                anyTruthyControl('select[name="attributes[panel_storm_panel]"]');

            return !!(intExt || storm);
        } catch (eDomGate) { }
        return false;
    }

    // 2026-04-30 — Pooja — Reference: when card UI stores the selection in data-choice-value
    // (not necessarily the underlying <input>.value), use this to recover the selected choice value.
    function getSelectedChoiceValueFromDom(optionId) {
        try {
            var root = document.getElementById('door-configurator-options') || document;
            if (!root || !optionId) return '';

            // Select-based UI.
            var sel = root.querySelector('select[data-option-id="' + optionId + '"]');
            if (sel && sel.value != null && sel.value !== '') return String(sel.value || '');

            // Native radio/checkbox value.
            var checked = root.querySelector('input[data-option-id="' + optionId + '"][type="radio"]:checked, input[data-option-id="' + optionId + '"][type="checkbox"]:checked');
            if (checked && checked.value != null && String(checked.value) !== '') return String(checked.value || '');

            // Card UI: find checked input inside `.common-check-option` and read wrapper's data-choice-value.
            var checkedInCard = root.querySelector('.common-check-option input[data-option-id="' + optionId + '"][type="radio"]:checked, .common-check-option input[data-option-id="' + optionId + '"][type="checkbox"]:checked');
            if (checkedInCard) {
                var wrap = checkedInCard.closest ? checkedInCard.closest('.common-check-option') : null;
                var cv = wrap && wrap.getAttribute ? wrap.getAttribute('data-choice-value') : '';
                if (cv) return String(cv || '');
            }

            // Final fallback: any element marked selected that has data-choice-value.
            var selectedCard = root.querySelector('.common-check-option--selected[data-choice-value]');
            if (selectedCard) {
                var cv2 = selectedCard.getAttribute('data-choice-value');
                if (cv2) return String(cv2 || '');
            }
        } catch (e) { }
        return '';
    }

    // Pricing from metaobject schema only (priceType + priceValue per choice; optional conditional override)
    function calculatePriceFromSchema(basePrice, config, schema) {
        var total = basePrice;
        if (!Array.isArray(schema)) return total;

        // Cache for config_choice flags keyed by choice.value
        // { [value]: { panel_int_ext: boolean, panel_storm_panel: boolean } }
        if (!window.__configChoiceFlagsByValue) window.__configChoiceFlagsByValue = {};
        if (!window.__configChoiceFlagsLoading) window.__configChoiceFlagsLoading = {};

        function fetchConfigChoiceFlagsByValue(value) {
            try {
                if (window.__doorSelectionLogOnly) {
                    return Promise.resolve({ panel_int_ext: false, panel_storm_panel: false });
                }
                var v = String(value == null ? '' : value).trim();
                if (!v) return Promise.reject(new Error('missing value'));
                if (window.__configChoiceFlagsByValue[v]) return Promise.resolve(window.__configChoiceFlagsByValue[v]);
                if (window.__configChoiceFlagsLoading[v]) return window.__configChoiceFlagsLoading[v];

                var base = (window.DOOR_PRICING_RULE_PROXY_BASE || 'https://api.vintagedoors.com');
                base = String(base || '').replace(/\/+$/, '');
                var url = base + '/config-choice.php?value=' + encodeURIComponent(v);

                var p = fetch(url, { mode: 'cors', credentials: 'omit' })
                    .then(function (r) { if (!r || !r.ok) throw new Error('bad response'); return r.json(); })
                    .then(function (json) {
                        var flags = {
                            panel_int_ext: !!(json && json.flags && json.flags.panel_int_ext),
                            panel_storm_panel: !!(json && json.flags && json.flags.panel_storm_panel)
                        };
                        window.__configChoiceFlagsByValue[v] = flags;
                        return flags;
                    })
                    .catch(function (e) {
                        // Cache negative so we don't spam network.
                        window.__configChoiceFlagsByValue[v] = { panel_int_ext: false, panel_storm_panel: false, _error: true };
                        throw e;
                    })
                    .finally(function () {
                        try { delete window.__configChoiceFlagsLoading[v]; } catch (e2) { }
                    });

                window.__configChoiceFlagsLoading[v] = p;
                return p;
            } catch (eOuter) {
                return Promise.reject(eOuter);
            }
        }

        schema.forEach(function (opt) {
            if (!opt || !opt.id || !opt.type) return;
            // Stile/rail is priced once at the end (full list price on top of other options).
            if (optionIsStileAndRailProfile(opt)) return;
            // Applied molding uses millwork_product_pricing tier map (door-conf2-update.js).
            if (optionIsAppliedMolding(opt)) return;
            var optType = (opt.type || '').toLowerCase();
            var selected = config ? config[opt.id] : null;
            var choices = Array.isArray(opt.options) ? opt.options : [];

            function choiceFieldTruthy(choice, key) {
                try {
                    if (!choice || !key) return false;
                    var v = choice[key];
                    if (v == null && typeof key === 'string') {
                        // allow hyphen/underscore variants
                        var k2 = key.indexOf('_') !== -1 ? key.replace(/_/g, '-') : key.replace(/-/g, '_');
                        v = choice[k2];
                    }
                    if (v === true) return true;
                    if (v === false) return false;
                    if (typeof v === 'number') return v !== 0;
                    var s = String(v == null ? '' : v).trim().toLowerCase();
                    if (!s) return false;
                    if (s === 'true' || s === '1' || s === 'yes' || s === 'on') return true;
                    if (s === 'false' || s === '0' || s === 'no' || s === 'off') return false;
                    return true; // non-empty string means enabled
                } catch (e) { }
                return false;
            }

            function applyChoice(choice) {
                if (!choice) return;
                var t = choice.priceType || choice.price_type;
                var v = parseFloat(choice.priceValue || choice.price_value || 0);
                function norm(s) { return String(s || '').trim().toLowerCase(); }
                function oneMatch(key, val) {
                    var otherVal = config[key];
                    return Array.isArray(otherVal)
                        ? otherVal.some(function (ov) { return norm(ov) === norm(val); })
                        : norm(otherVal || '') === norm(val);
                }
                function checkOverride(o) {
                    // Compound: price_when = [{key, value}, ...] — all must match
                    var whenArr = o && (o.price_when || o.priceWhen);
                    if (Array.isArray(whenArr) && whenArr.length > 0) {
                        for (var j = 0; j < whenArr.length; j++) {
                            var cond = whenArr[j];
                            var k = cond.key || cond.price_when_key;
                            var v = cond.value != null ? cond.value : cond.price_when_value;
                            if (!k || v == null || !oneMatch(k, v)) return false;
                        }
                        return true;
                    }
                    // Single: price_when_key + price_when_value
                    var whenKey = o && (o.priceWhenKey || o.price_when_key);
                    if (!whenKey || (o.priceWhenValue == null && o.price_when_value == null)) return false;
                    var whenVal = o.priceWhenValue != null ? o.priceWhenValue : o.price_when_value;
                    if (whenVal === '') return false;
                    return oneMatch(whenKey, whenVal);
                }
                // Overrides: from array (set 1/2/3) or from JSON field priceOverridesRaw (unlimited). First match wins.
                var overrides = choice.priceOverrides;
                if (!Array.isArray(overrides) && choice.priceOverridesRaw != null) {
                    try {
                        overrides = typeof choice.priceOverridesRaw === 'string' ? JSON.parse(choice.priceOverridesRaw) : choice.priceOverridesRaw;
                    } catch (e) { overrides = []; }
                }
                if (!Array.isArray(overrides)) overrides = [];
                // Stile & rail: always use the choice list price (priceValue) on top of the running total.
                // Conditional overrides on metaobject rows often replace $125 with a small delta (e.g. $15);
                // business rule is full list add-on for this option id only.
                if (!optionIsStileAndRailProfile(opt)) {
                    if (overrides.length && config) {
                        for (var i = 0; i < overrides.length; i++) {
                            var o = overrides[i];
                            if (checkOverride(o)) {
                                t = o.priceWhenType || o.price_when_type || 'fixed';
                                v = parseFloat((o.priceWhenValueNumber != null ? o.priceWhenValueNumber : o.price_when_value_number) || 0);
                                break;
                            }
                        }
                    } else if (config) {
                        // Single override (backward compatible)
                        var whenKey = choice.priceWhenKey || choice.price_when_key;
                        var whenVal = choice.priceWhenValue != null ? choice.priceWhenValue : choice.price_when_value;
                        if (whenKey && whenVal != null && whenVal !== '') {
                            var otherVal = config[whenKey];
                            var match = Array.isArray(otherVal)
                                ? otherVal.some(function (ov) { return norm(ov) === norm(whenVal); })
                                : norm(otherVal || '') === norm(whenVal);
                            if (match) {
                                t = choice.priceWhenType || choice.price_when_type || 'fixed';
                                v = parseFloat((choice.priceWhenValueNumber != null ? choice.priceWhenValueNumber : choice.price_when_value_number) || 0);
                            }
                        }
                    }
                }
                if (!t) t = 'fixed';
                // 2026-04-30 — Pooja — Reference: panel_profile price_value adds only when
                // customer picked a profile AND (panel_int_ext OR panel_storm_panel) is marked true.
                if (optionIsPanelProfile(opt)) {
                    // Primary: the metaobject choice itself carries these flags (as seen in Shopify admin).
                    var byChoice =
                        choiceFieldTruthy(choice, 'panel_int_ext')
                        || choiceFieldTruthy(choice, 'panel_storm_panel');

                    // If schema doesn't carry the flags, fetch from config_choice by value (async, cached).
                    var byConfigChoiceCache = false;
                    try {
                        var cached = window.__configChoiceFlagsByValue[String(choice.value || '')];
                        if (cached) byConfigChoiceCache = !!(cached.panel_int_ext || cached.panel_storm_panel);
                    } catch (eCache) { }

                    // Fallback: some themes may provide these as config/DOM controls.
                    var ppAllow = byChoice || byConfigChoiceCache || isPanelProfilePricingGateOpen(config);

                    // If not allowed yet and we don't have cache, kick off fetch and reprice once loaded.
                    if (!ppAllow) {
                        try {
                            var vv = String(choice.value || '');
                            if (vv && !window.__configChoiceFlagsByValue[vv] && !window.__configChoiceFlagsLoading[vv]) {
                                fetchConfigChoiceFlagsByValue(vv).then(function () {
                                    try { updateEstimatedPrice(); } catch (eUpd) { }
                                });
                            }
                        } catch (eKick) { }
                    }
                    if (!ppAllow) return;
                }
                if (t === 'fixed') total += v;
                else if (t === 'percent') total += (basePrice * v);
            }

            if (optType === 'select' || optType === 'radio') {
                var selectedStr = selected != null ? String(selected) : '';
                var ch = choices.find(function (c) { return String(c.value || '') === selectedStr; });
                // 2026-04-30 — Pooja — Reference: panel_profile sometimes uses card UI with data-choice-value.
                if (!ch && optionIsPanelProfile(opt)) {
                    var domVal = getSelectedChoiceValueFromDom(String(opt.id || ''));
                    if (domVal) {
                        ch = choices.find(function (c) { return String(c.value || '') === String(domVal || ''); });
                    }
                }
                applyChoice(ch);
            } else if (optType === 'checkbox') {
                var arr = Array.isArray(selected) ? selected : [];
                arr.forEach(function (val) {
                    var valStr = val != null ? String(val) : '';
                    var ch2 = choices.find(function (c) { return String(c.value || '') === valStr; });
                    applyChoice(ch2);
                });
            }
        });
        return total;
    }

    function calculateRunningPricesPerOption(basePrice, config, schema) {
        var result = [];
        if (!Array.isArray(schema)) return result;
        var running = basePrice;
        schema.forEach(function (opt) {
            if (!opt || !opt.id || !opt.type) return;
            if (optionIsStileAndRailProfile(opt)) return;
            if (optionIsAppliedMolding(opt)) return;
            var optType = (opt.type || '').toLowerCase();
            var selected = config ? config[opt.id] : null;
            var choices = Array.isArray(opt.options) ? opt.options : [];
            if (optType !== 'select' && optType !== 'radio' && optType !== 'checkbox') return;

            function norm(s) { return String(s || '').trim().toLowerCase(); }
            function oneMatch(key, val) {
                var otherVal = config[key];
                return Array.isArray(otherVal)
                    ? otherVal.some(function (ov) { return norm(ov) === norm(val); })
                    : norm(otherVal || '') === norm(val);
            }
            function resolveChoicePrice(choice) {
                if (!choice) return 0;
                var t = choice.priceType || choice.price_type;
                var v = parseFloat(choice.priceValue || choice.price_value || 0);
                var overrides = choice.priceOverrides;
                if (!Array.isArray(overrides) && choice.priceOverridesRaw != null) {
                    try {
                        overrides = typeof choice.priceOverridesRaw === 'string' ? JSON.parse(choice.priceOverridesRaw) : choice.priceOverridesRaw;
                    } catch (e) { overrides = []; }
                }
                if (!Array.isArray(overrides)) overrides = [];
                if (!optionIsStileAndRailProfile(opt) && config) {
                    if (overrides.length) {
                        for (var i = 0; i < overrides.length; i++) {
                            var o = overrides[i];
                            var whenArr = o && (o.price_when || o.priceWhen);
                            var matched = false;
                            if (Array.isArray(whenArr) && whenArr.length > 0) {
                                matched = true;
                                for (var j = 0; j < whenArr.length; j++) {
                                    var cond = whenArr[j];
                                    var k = cond.key || cond.price_when_key;
                                    var cv = cond.value != null ? cond.value : cond.price_when_value;
                                    if (!k || cv == null || !oneMatch(k, cv)) { matched = false; break; }
                                }
                            } else {
                                var whenKey = o && (o.priceWhenKey || o.price_when_key);
                                var whenVal = o && (o.priceWhenValue != null ? o.priceWhenValue : o.price_when_value);
                                if (whenKey && whenVal != null && whenVal !== '') matched = oneMatch(whenKey, whenVal);
                            }
                            if (matched) {
                                t = o.priceWhenType || o.price_when_type || 'fixed';
                                v = parseFloat((o.priceWhenValueNumber != null ? o.priceWhenValueNumber : o.price_when_value_number) || 0);
                                break;
                            }
                        }
                    } else {
                        var whenKey2 = choice.priceWhenKey || choice.price_when_key;
                        var whenVal2 = choice.priceWhenValue != null ? choice.priceWhenValue : choice.price_when_value;
                        if (whenKey2 && whenVal2 != null && whenVal2 !== '' && oneMatch(whenKey2, whenVal2)) {
                            t = choice.priceWhenType || choice.price_when_type || 'fixed';
                            v = parseFloat((choice.priceWhenValueNumber != null ? choice.priceWhenValueNumber : choice.price_when_value_number) || 0);
                        }
                    }
                }
                if (!t) t = 'fixed';
                if (t === 'fixed') return isNaN(v) ? 0 : v;
                if (t === 'percent') return isNaN(v) ? 0 : (basePrice * v);
                return 0;
            }

            var delta = 0;
            if (optType === 'select' || optType === 'radio') {
                var selectedStr = selected != null ? String(selected) : '';
                var ch = choices.find(function (c) { return String(c.value || '') === selectedStr; });
                if (!ch && optionIsPanelProfile(opt)) {
                    var domVal = getSelectedChoiceValueFromDom(String(opt.id || ''));
                    if (domVal) ch = choices.find(function (c) { return String(c.value || '') === String(domVal || ''); });
                }
                delta = resolveChoicePrice(ch);
            } else if (optType === 'checkbox') {
                var arr = Array.isArray(selected) ? selected : [];
                arr.forEach(function (val) {
                    var valStr = val != null ? String(val) : '';
                    var ch2 = choices.find(function (c) { return String(c.value || '') === valStr; });
                    delta += resolveChoicePrice(ch2);
                });
            }
            var prev = running;
            running += delta;
            result.push({
                optionId: opt.id,
                label: opt.label || opt.id,
                choicePrice: delta,
                prevTotal: prev,
                runningTotal: running
            });
        });
        return result;
    }

    function isStileAndRailProfileInput(el) {
        if (!el) return false;
        try {
            var oid = el.getAttribute ? String(el.getAttribute('data-option-id') || '') : '';
            if (oid === 'stile_and_rail_profile') return true;
            var name = el.name != null ? String(el.name) : '';
            return name.indexOf('Stile and Rail Profile') !== -1;
        } catch (e) { }
        return false;
    }

    function readDoorEstimatedPriceFromDom() {
        try {
            if (
                window.DoorIntExtPricingRule
                && typeof window.DoorIntExtPricingRule.readEstimatedPriceFromDom === 'function'
            ) {
                return window.DoorIntExtPricingRule.readEstimatedPriceFromDom();
            }
            var nodes = document.querySelectorAll('#door-estimated-price');
            if (!nodes.length) return 0;
            // Prefer the PER-UNIT numeric stored by the pricing writer, since the visible text
            // is now qty-multiplied for display.
            function readNode(node) {
                if (!node) return 0;
                var attr = node.getAttribute && node.getAttribute('data-door-price-numeric');
                if (attr !== null && attr !== undefined && attr !== '') {
                    var pa = parseFloat(attr);
                    if (!isNaN(pa)) return pa;
                }
                var n = parseFloat(String(node.textContent || '').replace(/[^0-9.-]+/g, ''));
                return isNaN(n) ? 0 : n;
            }
            for (var i = 0; i < nodes.length; i++) {
                if (nodes[i].offsetParent !== null) {
                    return readNode(nodes[i]);
                }
            }
            return readNode(nodes[0]);
        } catch (e) { }
        return 0;
    }

    function writeDoorEstimatedPriceFromConf2(amount, meta) {
        if (
            window.DoorIntExtPricingRule
            && typeof window.DoorIntExtPricingRule.writeEstimatedPriceDisplay === 'function'
        ) {
            var result = window.DoorIntExtPricingRule.writeEstimatedPriceDisplay(amount, meta);
            try { updateOptionRunningPriceLabels(); } catch (eLabel) { }
            return result;
        }
        var nodes = document.querySelectorAll('#door-estimated-price');
        var formatted = formatMoney(amount);
        for (var i = 0; i < nodes.length; i++) nodes[i].textContent = formatted;
        try { updateOptionRunningPriceLabels(); } catch (eLabel) { }
    }

    /** Round currency for stored pricing snapshot fields. */
    function roundDoorMoney(n) {
        var x = parseFloat(n);
        if (isNaN(x)) return 0;
        return Math.round(x * 100) / 100;
    }

    function getGlassFormulaAddonForStoredOption(config, optionId) {
        if (!window.GlassFormulaCalculation || !config) return 0;
        var val = config[optionId];
        if (val == null || val === '') return 0;
        var key = window.GlassFormulaCalculation.normChoiceValue(val);
        if (!key) return 0;
        return window.GlassFormulaCalculation.calculateAddonFromCache([key]) || 0;
    }

    /**
     * Capture applied unit price + addon breakdown for admin app and my-saved-doors edit restore.
     */
    function buildDoorPriceSnapshotForStorage(config, basePrice) {
        var breakdown = {};
        var sidelightGf = getGlassFormulaAddonForStoredOption(config, 'sidelight_style');
        var transomGf = getGlassFormulaAddonForStoredOption(config, 'transom_style');
        if (sidelightGf > 0.005) breakdown.glass_formula_sidelight = roundDoorMoney(sidelightGf);
        if (transomGf > 0.005) breakdown.glass_formula_transom = roundDoorMoney(transomGf);

        var addonWindowMap = {
            sidelight_transom_oversized: '__doorAddon_sidelightTransomOversized',
            sidelight_transom_oversized_pair1: '__doorAddon_sidelightTransomOversizedPair1',
            sidelight_transom_oversized_pair2: '__doorAddon_sidelightTransomOversizedPair2',
            storm_glass: '__doorAddon_storm_glass',
            stile_and_rail_profile: '__doorAddon_stile_and_rail_profile',
            int_ext_oversized: '__doorAddon_intExtOversizedApi',
            interior_door_thickness: '__doorAddon_interiorDoorThickness',
            sidelight_panel_thickness: '__doorAddon_sidelightPanelThickness',
            door_seal_kit_matching: '__doorAddon_door_seal_kit_matching',
            door_sweeps_matching: '__doorAddon_door_sweeps_matching',
            priming_services: '__doorAddon_priming_services',
            applied_molding_tier: '__doorAddon_applied_molding_tier',
            pet_gates_measurements: '__doorAddon_pet_gates_measurements',
            screen_storm_oversized: '__doorScreenStormAddon_oversized',
            screen_storm_thickness: '__doorScreenStormAddon_thickness',
            screen_storm_thickness_frac: '__doorScreenStormAddon_thickness_frac',
            screen_storm_sidelight_transom: '__doorScreenStormAddon_sidelight_transom',
            screen_storm_transom_combo: '__doorScreenStormAddon_transom_combo',
            screen_storm_panel_door_thickness_extra: '__doorScreenStormAddon_panel_door_thickness_extra'
        };
        Object.keys(addonWindowMap).forEach(function (bk) {
            var amt = parseFloat(window[addonWindowMap[bk]] || 0) || 0;
            if (amt > 0.005) breakdown[bk] = roundDoorMoney(amt);
        });
        try {
            if (window.DoorIntExtPricingRule && typeof window.DoorIntExtPricingRule.getIntExtGeneralOversizedAddonTotal === 'function') {
                var intExtCombined = window.DoorIntExtPricingRule.getIntExtGeneralOversizedAddonTotal();
                if (intExtCombined > 0.005) breakdown.int_ext_oversized = roundDoorMoney(intExtCombined);
            }
        } catch (eIntExtBd) { }

        var themeTotal = parseFloat(window.__doorThemeOptionTotal) || 0;
        if (themeTotal < basePrice - 0.02) {
            try {
                var priceRes = calculateDoorPrice(basePrice, config);
                themeTotal = (priceRes && typeof priceRes.price === 'number') ? priceRes.price : basePrice;
            } catch (eTheme) {
                themeTotal = basePrice;
            }
        }

        var applied = readDoorEstimatedPriceFromDom();
        if (applied < basePrice - 0.02) {
            var extraAddons = 0;
            if (window.DoorIntExtPricingRule && typeof window.DoorIntExtPricingRule.getDoorAddonTotalSum === 'function') {
                extraAddons = window.DoorIntExtPricingRule.getDoorAddonTotalSum();
            }
            extraAddons += (parseFloat(window['__doorAddon_storm_glass'] || 0) || 0);
            extraAddons += (parseFloat(window['__doorAddon_stile_and_rail_profile'] || 0) || 0);
            extraAddons += (parseFloat(window['__doorAddon_door_seal_kit_matching'] || 0) || 0);
            extraAddons += (parseFloat(window['__doorAddon_door_sweeps_matching'] || 0) || 0);
            extraAddons += (parseFloat(window['__doorAddon_priming_services'] || 0) || 0);
            extraAddons += (parseFloat(window['__doorAddon_applied_molding_tier'] || 0) || 0);
            extraAddons += (parseFloat(window['__doorAddon_pet_gates_measurements'] || 0) || 0);
            applied = themeTotal + extraAddons;
        }

        var addonsTotal = applied - themeTotal;
        if (addonsTotal < 0) addonsTotal = 0;

        var singleThemeTotal = themeTotal;
        try {
            var priceResSingle = calculateDoorPrice(basePrice, config, true, false);
            singleThemeTotal = (priceResSingle && typeof priceResSingle.price === 'number') ? priceResSingle.price : basePrice;
        } catch (eThemeSingle) { }

        var doubleThemeTotal = themeTotal * 2;
        try {
            var priceResDouble = calculateDoorPrice(basePrice, config, false, true);
            doubleThemeTotal = (priceResDouble && typeof priceResDouble.price === 'number') ? priceResDouble.price : basePrice * 2;
        } catch (eThemeDouble) { }

        var singleApplied = singleThemeTotal + addonsTotal;
        var doubleApplied = doubleThemeTotal + addonsTotal;

        return {
            _applied_unit_price: roundDoorMoney(applied),
            _theme_option_total: roundDoorMoney(themeTotal),
            _addons_total: roundDoorMoney(addonsTotal),
            _addon_breakdown: breakdown,
            _single_door_price: roundDoorMoney(singleApplied),
            _double_door_price: roundDoorMoney(doubleApplied),
            _pricing_snapshot_at: new Date().toISOString()
        };
    }

    function applyStoredDoorPricingFromOptions(opts) {
        if (!opts || typeof opts !== 'object') return;
        var bd = opts._addon_breakdown;
        var hasBreakdown = bd && typeof bd === 'object';
        var applied = parseFloat(opts._applied_unit_price);
        var hasApplied = !isNaN(applied) && applied > 0;
        if (!hasBreakdown && !hasApplied) return;

        if (parseFloat(opts._theme_option_total) > 0) {
            window.__doorThemeOptionTotal = parseFloat(opts._theme_option_total);
        }

        if (hasBreakdown) {
            var restoreMap = {
                sidelight_transom_oversized: '__doorAddon_sidelightTransomOversized',
                sidelight_transom_oversized_pair1: '__doorAddon_sidelightTransomOversizedPair1',
                sidelight_transom_oversized_pair2: '__doorAddon_sidelightTransomOversizedPair2',
                storm_glass: '__doorAddon_storm_glass',
                stile_and_rail_profile: '__doorAddon_stile_and_rail_profile',
                int_ext_oversized: '__doorAddon_intExtOversizedApi',
                interior_door_thickness: '__doorAddon_interiorDoorThickness',
                sidelight_panel_thickness: '__doorAddon_sidelightPanelThickness',
                door_seal_kit_matching: '__doorAddon_door_seal_kit_matching',
                door_sweeps_matching: '__doorAddon_door_sweeps_matching',
                priming_services: '__doorAddon_priming_services',
                pet_gates_measurements: '__doorAddon_pet_gates_measurements',
                screen_storm_oversized: '__doorScreenStormAddon_oversized',
                screen_storm_thickness: '__doorScreenStormAddon_thickness',
                screen_storm_thickness_frac: '__doorScreenStormAddon_thickness_frac',
                screen_storm_sidelight_transom: '__doorScreenStormAddon_sidelight_transom',
                screen_storm_transom_combo: '__doorScreenStormAddon_transom_combo',
                screen_storm_panel_door_thickness_extra: '__doorScreenStormAddon_panel_door_thickness_extra'
            };
            var skipScreenStormStoredAddons = !!(
                window.PriceScreenStorm
                && typeof window.PriceScreenStorm.isScreenAndStormDoorsProductType === 'function'
                && window.PriceScreenStorm.isScreenAndStormDoorsProductType()
            );
            Object.keys(restoreMap).forEach(function (bk) {
                if (skipScreenStormStoredAddons && bk.indexOf('screen_storm_') === 0) return;
                if (bd[bk] != null && bd[bk] !== '') {
                    window[restoreMap[bk]] = parseFloat(bd[bk]) || 0;
                }
            });
            if (bd.stile_and_rail_profile != null) {
                try { window.__doorLastStileRailListPrice = parseFloat(bd.stile_and_rail_profile) || 0; } catch (eSt) { }
            }
        }

        if (
            window.DoorIntExtPricingRule
            && typeof window.DoorIntExtPricingRule.syncEstimatedPriceDisplay === 'function'
        ) {
            window.DoorIntExtPricingRule.syncEstimatedPriceDisplay({
                source: 'loadSavedConfig',
                silent: true,
                doorSealKitMatching: parseFloat(window['__doorAddon_door_seal_kit_matching'] || 0) || 0,
                doorSweepsMatching: parseFloat(window['__doorAddon_door_sweeps_matching'] || 0) || 0,
                primingServices: parseFloat(window['__doorAddon_priming_services'] || 0) || 0
            });
        } else if (hasApplied) {
            writeDoorEstimatedPriceFromConf2(applied, { source: 'loadSavedConfig' });
        }

        if (hasApplied) {
            var currentShown = readDoorEstimatedPriceFromDom();
            if (currentShown + 0.02 < applied) {
                writeDoorEstimatedPriceFromConf2(applied, { source: 'loadSavedConfig_fallback' });
            }
        }
        try { syncMeasurementSelectedPriceLabels(opts); } catch (eMeasPrice) { }
    }

    function refreshScreenStormPricingAfterSavedRestore() {
        try {
            if (
                !window.PriceScreenStorm
                || typeof window.PriceScreenStorm.applyScreenStormOversizedPricing !== 'function'
                || typeof window.PriceScreenStorm.isScreenAndStormDoorsProductType !== 'function'
                || !window.PriceScreenStorm.isScreenAndStormDoorsProductType()
            ) {
                return;
            }
            var triggerSelectors = [
                'select#door_height[data-door-user-changed="1"]',
                'select#door_height_fraction[data-door-user-changed="1"]',
                'select[id^="panel-door-width-int"][data-door-user-changed="1"]',
                'select[id^="panel-door-width-frac"][data-door-user-changed="1"]',
                'select#exact-door-width-int[data-door-user-changed="1"]',
                'select[id^="exact-door-width-int"][data-door-user-changed="1"]'
            ];
            var triggerEl = null;
            for (var ti = 0; ti < triggerSelectors.length; ti++) {
                triggerEl = document.querySelector(triggerSelectors[ti]);
                if (triggerEl) break;
            }
            if (triggerEl) {
                window.PriceScreenStorm.applyScreenStormOversizedPricing(triggerEl);
            }
        } catch (eSsRestore) { }
    }


    function prefetchSavedSidelightTransomApi(opts, done) {
        var finish = typeof done === 'function' ? done : function () { };
        if (!window.GlassFormulaCalculation || !opts) {
            finish();
            return;
        }
        var keys = [];
        ['sidelight_style', 'transom_style'].forEach(function (id) {
            var v = opts[id];
            if (v == null || v === '') return;
            var k = window.GlassFormulaCalculation.normChoiceValue(v);
            if (k) keys.push(k);
        });
        if (!keys.length) {
            finish();
            return;
        }
        var miss = window.GlassFormulaCalculation.getMissingFromCache(keys);
        if (miss && miss.length && typeof window.GlassFormulaCalculation.load === 'function') {
            window.GlassFormulaCalculation.load(miss).then(finish).catch(finish);
            return;
        }
        finish();
    }

    /**
     * Stile/rail: replace previous profile list price with the new one on the current display total.
     * (change event already has the new radio checked — do not read “previous” from getCurrentConfig().)
     */
    function applyStileAndRailProfilePriceUpdate() {
        if (window.__doorStileApplyBusy) return;
        window.__doorStileApplyBusy = true;
        try {
            var container = document.getElementById('door-configurator');
            if (!container || !doorConfigSchema || !Array.isArray(doorConfigSchema)) return;
            var basePrice = parseFloat(container.getAttribute('data-base-price')) || 0;
            if (isNaN(basePrice)) basePrice = 0;
            var config = getCurrentConfig();
            var newStile = getStileAndRailProfileListPrice(basePrice, config, doorConfigSchema);
            var theme = calculateDoorPrice(basePrice, config).price;
            window.__doorThemeOptionTotal = theme;
            window['__doorAddon_stile_and_rail_profile'] = newStile;
            window.__doorLastStileRailListPrice = newStile;
            var total = theme;
            if (
                window.DoorIntExtPricingRule
                && typeof window.DoorIntExtPricingRule.syncEstimatedPriceDisplay === 'function'
            ) {
                window.__doorStileSyncInProgress = true;
                var stileVal = '';
                try {
                    var stileInp = document.querySelector(
                        'input[type="radio"][data-option-id="stile_and_rail_profile"]:checked,' +
                        'input[type="radio"][name="attributes[Stile and Rail Profile]"]:checked'
                    );
                    if (stileInp && stileInp.value != null) stileVal = String(stileInp.value);
                } catch (eSel) { }
                window.DoorIntExtPricingRule.syncEstimatedPriceDisplay({
                    source: 'stile_and_rail_profile',
                    userAction: true,
                    selected: stileVal,
                    stileAddon: newStile,
                    themeOptionTotal: theme
                });
                window.__doorStileSyncInProgress = false;
                total = readDoorEstimatedPriceFromDom();
                try {
                    document.dispatchEvent(new CustomEvent('door-configurator-price-updated', {
                        detail: { themeOptionTotal: theme, source: 'stile_and_rail_profile' }
                    }));
                } catch (eStileEvt) { }
            } else {
                var addons = parseFloat(window.__doorIntExtAddonPrice || 0) || 0;
                total = theme + addons + newStile;
                writeDoorEstimatedPriceFromConf2(total, {
                    source: 'stile_and_rail_profile',
                    userAction: true,
                    stileAddon: newStile
                });
            }
        } catch (eApply) { }
        finally {
            try {
                function resyncStileDisplay() {
                    try {
                        if (
                            window.DoorIntExtPricingRule
                            && typeof window.DoorIntExtPricingRule.syncEstimatedPriceDisplay === 'function'
                        ) {
                            window.__doorStileSyncInProgress = true;
                            window.DoorIntExtPricingRule.syncEstimatedPriceDisplay({ silent: true });
                            window.__doorStileSyncInProgress = false;
                        }
                    } catch (eRe) { }
                }
                setTimeout(function () {
                    resyncStileDisplay();
                    window.__doorStileApplyBusy = false;
                }, 0);
            } catch (eFin) { }
        }
    }

    function bindStileAndRailProfileAdditivePricing() {
        /* Stile priced via bindDelegatedPriceUpdate + card change only (avoids triple fire). */
    }

    // Always recomputed from `basePrice` + current `config` (no persisted running total).
    function calculateDoorPrice(basePrice, config, forceSingleDoor, forceDoubleDoor) {
        // Price from metaobject schema only (no static rules)
        if (doorConfigSchema && Array.isArray(doorConfigSchema) && doorConfigSchema.length) {
            var total = calculatePriceFromSchema(basePrice, config, doorConfigSchema);

            // Slab-only pricing adjustment:
            // - When any selected choice value is "slab_only"
            // - Add the selected `wood_type` choice's slab interior/exterior extra to the running total.
            // This way, normal `wood_type.priceValue` stays, and the extra becomes:
            //   wood_type.priceValue + wood_type.(slab interior/exterior)
            try {
                function normSelectionValue(v) {
                    return String(v == null ? '' : v).trim().toLowerCase().replace(/[\s-]+/g, '_');
                }
                // Debug flag: set `window.DOOR_PRICE_DEBUG = true` in console to enable logs.
                function toNum(n) {
                    var x = parseFloat(n);
                    return isNaN(x) ? 0 : x;
                }
                function parseFractionValue(v) {
                    if (v == null) return 0;
                    var s = String(v).trim();
                    if (!s) return 0;
                    if (s === '½') return 0.5;
                    if (s === '¼') return 0.25;
                    if (s === '¾') return 0.75;
                    if (s.indexOf('/') !== -1) {
                        var parts = s.split('/');
                        if (parts.length >= 2) {
                            var a = toNum(parts[0]);
                            var b = toNum(parts[1]);
                            if (b) return a / b;
                        }
                    }
                    return toNum(s);
                }
                function getPricingRuleIntExtRecords() {
                    try {
                        if (Array.isArray(window.pricing_rule_int_ext)) return window.pricing_rule_int_ext;
                        if (typeof window.pricing_rule_int_ext === 'string' && window.pricing_rule_int_ext.trim()) {
                            try {
                                var raw1 = JSON.parse(window.pricing_rule_int_ext);
                                var data1 = typeof raw1 === 'string' ? JSON.parse(raw1) : raw1;
                                if (Array.isArray(data1)) return data1;
                            } catch (e1) { }
                        }
                        if (Array.isArray(window.pricingRuleIntExt)) return window.pricingRuleIntExt;
                        if (typeof window.pricingRuleIntExt === 'string' && window.pricingRuleIntExt.trim()) {
                            try {
                                var raw2 = JSON.parse(window.pricingRuleIntExt);
                                var data2 = typeof raw2 === 'string' ? JSON.parse(raw2) : raw2;
                                if (Array.isArray(data2)) return data2;
                            } catch (e2) { }
                        }
                        var el = document.getElementById('door-configurator-pricing-rule-int-ext');
                        if (el) {
                            var txt = String(el.textContent || '').trim();
                            if (txt) {
                                var raw = JSON.parse(txt);
                                var data = typeof raw === 'string' ? JSON.parse(raw) : raw;
                                if (Array.isArray(data)) return data;
                            }
                        }
                    } catch (e) { }
                    return [];
                }
                function findPricingRulePrice(records, key, width, height) {
                    var want = normSelectionValue(key);
                    for (var i = 0; i < records.length; i++) {
                        var r = records[i] || {};
                        var rk =
                            r.key != null ? r.key
                                : (r.type != null ? r.type
                                    : (r.value != null ? r.value : ''));
                        if (normSelectionValue(rk) !== want) continue;

                        var wMin = r.width_min != null ? r.width_min : (r.widthMin != null ? r.widthMin : r.min_width);
                        var wMax = r.width_max != null ? r.width_max : (r.widthMax != null ? r.widthMax : r.max_width);
                        var hMin = r.height_min != null ? r.height_min : (r.heightMin != null ? r.heightMin : r.min_height);
                        var hMax = r.height_max != null ? r.height_max : (r.heightMax != null ? r.heightMax : r.max_height);
                        if (wMin != null && width < toNum(wMin)) continue;
                        if (wMax != null && width > toNum(wMax)) continue;
                        if (hMin != null && height < toNum(hMin)) continue;
                        if (hMax != null && height > toNum(hMax)) continue;

                        var p = r.price != null ? r.price : (r.price_value != null ? r.price_value : r.amount);
                        var parsed = parseFloat(p);
                        var price = isNaN(parsed) ? 0 : parsed;
                        try {
                            if (window && window.DOOR_PRICE_DEBUG) {
                                console.log('[pricing_rule_int_ext] MATCH', { key: key, width: width, height: height, price: price, row: r });
                            }
                        } catch (eDbg1) { }
                        return price;
                    }
                    try {
                        if (window && window.DOOR_PRICE_DEBUG) {
                            console.log('[pricing_rule_int_ext] NO MATCH', { key: key, width: width, height: height, records: records && records.length });
                        }
                    } catch (eDbg2) { }
                    return 0;
                }

                function getDoorSurface() {
                    // Prefer tags (requested), fall back to product type.
                    // Returns: 'interior' | 'exterior' | null
                    try {
                        var container = document.getElementById('door-configurator');
                        if (!container) return null;

                        var tagsAttr = container.getAttribute('data-product-tags') || '';
                        var tags = [];
                        try {
                            var parsed = typeof tagsAttr === 'string' && tagsAttr.trim() ? JSON.parse(tagsAttr) : [];
                            tags = Array.isArray(parsed)
                                ? parsed.map(function (t) { return String(t).trim().toLowerCase(); }).filter(Boolean)
                                : [];
                        } catch (eTags) {
                            tags = String(tagsAttr || '').split('|').map(function (t) { return String(t).trim().toLowerCase(); }).filter(Boolean);
                        }
                        // Shopify tags like "Interior Doors" / interior_doors → slab & pre-hung extras use interior fields.
                        for (var tdi = 0; tdi < tags.length; tdi++) {
                            var doorCatTag = normSelectionValue(tags[tdi]);
                            if (doorCatTag === 'interior_doors') return 'interior';
                            if (doorCatTag === 'exterior_doors') return 'exterior';
                        }
                        if (tags.indexOf('interior') !== -1) return 'interior';
                        if (tags.indexOf('exterior') !== -1) return 'exterior';

                        var productType = container.getAttribute('data-product-type') || '';
                        productType = String(productType || '').toLowerCase();
                        if (productType.indexOf('interior') !== -1) return 'interior';
                        if (productType.indexOf('exterior') !== -1) return 'exterior';
                    } catch (e) { }
                    return null;
                }
                function anySelectedValueEquals(targetValue) {
                    if (!config || typeof config !== 'object') return false;
                    var targetNorm = normSelectionValue(targetValue);
                    for (var i = 0; i < doorConfigSchema.length; i++) {
                        var opt = doorConfigSchema[i];
                        if (!opt || !opt.id) continue;
                        var selected = config[opt.id];
                        if (Array.isArray(selected)) {
                            for (var j = 0; j < selected.length; j++) {
                                if (normSelectionValue(selected[j]) === targetNorm) return true;
                            }
                        } else {
                            if (normSelectionValue(selected) === targetNorm) return true;
                        }
                    }
                    // Fallback: some UI controls may not be schema-backed (no data-option-id),
                    // so they won't appear in `config`. In that case, scan DOM for checked/selected values.
                    try {
                        var optionsContainer = document.getElementById('door-configurator-options');
                        if (!optionsContainer) return false;
                        var els = optionsContainer.querySelectorAll('input, select, textarea');
                        for (var k = 0; k < els.length; k++) {
                            var el = els[k];
                            if (!el) continue;
                            var tag = (el.tagName || '').toLowerCase();
                            var type = (el.type || '').toLowerCase();
                            if (tag === 'input' && (type === 'checkbox' || type === 'radio')) {
                                if (!el.checked) continue;
                                if (normSelectionValue(el.value) === targetNorm) return true;
                            } else if (tag === 'select') {
                                if (normSelectionValue(el.value) === targetNorm) return true;
                            } else {
                                // text/number inputs etc.
                                if (normSelectionValue(el.value) === targetNorm) return true;
                            }
                        }
                    } catch (eFallbackSel) { }
                    return false;
                }
                function findSelectedChoiceByValue(valueNorm) {
                    // Finds the *choice object* for a selected value across all options.
                    // Useful when price extras live on the selected choice (e.g. round_top/arch_top).
                    if (!config || typeof config !== 'object') return null;
                    for (var i = 0; i < doorConfigSchema.length; i++) {
                        var opt = doorConfigSchema[i];
                        if (!opt || !opt.id || !Array.isArray(opt.options)) continue;
                        var selected = config[opt.id];
                        var choices = opt.options;
                        if (Array.isArray(selected)) {
                            for (var j = 0; j < selected.length; j++) {
                                if (normSelectionValue(selected[j]) !== valueNorm) continue;
                                var valStr = String(selected[j] == null ? '' : selected[j]);
                                return choices.find(function (c) { return String(c && c.value != null ? c.value : '') === valStr; }) || null;
                            }
                        } else {
                            if (normSelectionValue(selected) !== valueNorm) continue;
                            var selStr = String(selected == null ? '' : selected);
                            return choices.find(function (c) { return String(c && c.value != null ? c.value : '') === selStr; }) || null;
                        }
                    }
                    return null;
                }

                // Determines whether to use interior or exterior pricing extras.
                var doorSurface = null;
                doorSurface = getDoorSurface();

                var isSlabOnlySelected = false;
                var woodSlabExtra = 0;

                // Detect "slab_only" selection regardless of which option it belongs to.
                isSlabOnlySelected = anySelectedValueEquals('slab_only');
                var isPreHungOnJambSelected = false;
                isPreHungOnJambSelected = anySelectedValueEquals('pre_hung_on_jamb');

                // -----------------------------
                // Sidelight metaobject pricing_rule_int_ext adjustment
                // -----------------------------
                try {
                    if (isSidelightDesignSelected(config)) {
                        // Width = sidelight_width + sidelight_width_fraction
                        var sideW = toNum(config && config.sidelight_width);
                        var sideWFrac = parseFractionValue(config && config.sidelight_width_fraction);
                        var sidelightWidth = sideW + sideWFrac;

                        // Height = door_height + door_height_fraction
                        var doorH = toNum(config && config.door_height);
                        var doorHFrac = parseFractionValue(config && config.door_height_fraction);
                        var doorHeight = doorH + doorHFrac;

                        // Build key from product surface and selection type.
                        var surfaceKey = (doorSurface === 'exterior') ? 'exterior' : (doorSurface === 'interior' ? 'interior' : '');
                        var selKey = '';
                        if (isPreHungOnJambSelected) selKey = 'prehung';
                        else if (isSlabOnlySelected) selKey = 'slab';

                        if (surfaceKey && selKey) {
                            var textKey = surfaceKey + '_' + selKey;
                            var rules = getPricingRuleIntExtRecords();
                            var addonPrice = findPricingRulePrice(rules, textKey, sidelightWidth, doorHeight);
                            if (addonPrice) total += addonPrice;
                        }
                    }
                } catch (eSideRule) { }

                // -----------------------------
                // Glass formula metaobject addon (pieces * basic_eqn_calc)
                // Implemented in `sidelight_calculations.js` as `window.GlassFormulaCalculation`.
                // -----------------------------
                try {
                    if (window.GlassFormulaCalculation) {
                        // IMPORTANT: Only call the glass-formula API when sidelight style OR transom style is selected/changed.
                        // Other option changes should NOT trigger network calls.
                        var gfRoot = document.getElementById('door-configurator-options') || document;
                        var gfKeys = [];
                        if (typeof window.GlassFormulaCalculation.getSelectedSidelightTransomStyleKeysFromDom === 'function') {
                            gfKeys = window.GlassFormulaCalculation.getSelectedSidelightTransomStyleKeysFromDom();
                        }
                        if (!gfKeys.length) {
                            var gfStyleVal = '';
                            try {
                                var gfChecked = gfRoot.querySelector('input[type="radio"][data-option-id="sidelight_style"]:checked');
                                if (gfChecked && gfChecked.value != null) gfStyleVal = String(gfChecked.value || '');
                            } catch (eGfStyle) { }
                            if (!gfStyleVal) {
                                try {
                                    var gfSel = gfRoot.querySelector('select[data-option-id="sidelight_style"]');
                                    if (gfSel) gfStyleVal = String(gfSel.value || '');
                                } catch (eGfStyle2) { }
                            }
                            if (!gfStyleVal) {
                                try {
                                    var transomChecked = gfRoot.querySelector(
                                        'input[type="radio"][data-option-id="transom_style"]:checked,' +
                                        'input[type="radio"][name="attributes[Transom Style]"]:checked'
                                    );
                                    if (transomChecked && transomChecked.value != null) gfStyleVal = String(transomChecked.value || '');
                                } catch (eGfStyle3) { }
                            }
                            if (!gfStyleVal) {
                                try {
                                    var transomSel = gfRoot.querySelector(
                                        'select[data-option-id="transom_style"],' +
                                        'select[name="attributes[Transom Style]"]'
                                    );
                                    if (transomSel) gfStyleVal = String(transomSel.value || '');
                                } catch (eGfStyle4) { }
                            }
                            if (gfStyleVal) {
                                gfKeys = [window.GlassFormulaCalculation.normChoiceValue(gfStyleVal)];
                            }
                        }
                        var gfAddonCached = window.GlassFormulaCalculation.calculateAddonFromCache(gfKeys);
                        if (gfAddonCached) total += gfAddonCached;

                        // Network fetch is handled once per sidelight/transom style click in sidelight-calculations.js.
                    }
                } catch (eGlassFormula) { }

                // -----------------------------
                // Storm glass pricing addon (glass_type_exterior, glass_type_interior, or glass_type_screen_and_storm)
                // Uses:
                // - glass_formula (from sidelight_transom_calculations.php): basic_eqn_calc + shape
                // - glass_type_exterior (exterior products) or glass_type_interior (tag: interior-doors): sq_ft + straight/shaped pricing
                // Formula (only when shape is present):
                //   round(sq_ft * basic_eqn_calc) * shape + shaped_pricing
                // -----------------------------
                try {
                    if (window.GlassFormulaCalculation && typeof window.GlassFormulaCalculation.calculateStormGlassAddonFromCache === 'function') {
                        var stormVal = '';
                        stormVal = (config && (config.glass_type || config.storm_glass_type || config.storm_glass || config.select_storm_glass)) || '';
                        if (!stormVal) {
                            // Fallback to DOM read (in case option id differs in schema).
                            var gfRoot2 = document.getElementById('door-configurator-options') || document;
                            try {
                                var stormChecked = gfRoot2.querySelector(
                                    'input[type="radio"][data-option-id="glass_type"]:checked,' +
                                    'input[type="radio"][data-option-id="storm_glass_type"]:checked,' +
                                    'input[type="radio"][data-option-id="storm_glass"]:checked,' +
                                    'input[type="radio"][data-option-id="select_storm_glass"]:checked,' +
                                    'input[type="radio"][name="attributes[Select Storm Glasses]"]:checked'
                                );
                                if (stormChecked && stormChecked.value != null) stormVal = String(stormChecked.value || '');
                            } catch (eStormDom) { }
                            if (!stormVal) {
                                try {
                                    var stormSel = gfRoot2.querySelector(
                                        'select[data-option-id="glass_type"],' +
                                        'select[data-option-id="storm_glass_type"],' +
                                        'select[data-option-id="storm_glass"],' +
                                        'select[data-option-id="select_storm_glass"],' +
                                        'select[name="attributes[Select Storm Glasses]"]'
                                    );
                                    if (stormSel) stormVal = String(stormSel.value || '');
                                } catch (eStormDom2) { }
                            }
                        }

                        var stormKey = stormVal ? window.GlassFormulaCalculation.normChoiceValue(stormVal) : '';
                        if (stormKey) {
                            var shouldApplyStorm = true;
                            if (typeof window.GlassFormulaCalculation.shouldApplyGlassTypeExteriorAddon === 'function') {
                                shouldApplyStorm = window.GlassFormulaCalculation.shouldApplyGlassTypeExteriorAddon(stormKey);
                            }
                            if (!shouldApplyStorm) {
                                window['__doorAddon_storm_glass'] = 0;
                            } else {
                                var totalBeforeStormGlass = total;
                                var shapedPayload = null;
                                var stormAdd2 = 0;
                                if (typeof window.GlassFormulaCalculation.calculateStormGlassAddonTotalFromCache === 'function') {
                                    shapedPayload = window.GlassFormulaCalculation.calculateStormGlassAddonTotalFromCache(stormKey);
                                    stormAdd2 = shapedPayload && shapedPayload.ok ? (parseFloat(shapedPayload.total) || 0) : 0;
                                } else {
                                    var stormGlassFormulaKey = '';
                                    if (typeof window.GlassFormulaCalculation.getSelectedSidelightTransomStyleKeyFromDom === 'function') {
                                        stormGlassFormulaKey = window.GlassFormulaCalculation.getSelectedSidelightTransomStyleKeyFromDom() || '';
                                    }
                                    if (!stormGlassFormulaKey && config) {
                                        var rawGfStyle = config.sidelight_style || config.transom_style || '';
                                        if (rawGfStyle) {
                                            stormGlassFormulaKey = window.GlassFormulaCalculation.normChoiceValue(rawGfStyle);
                                        }
                                    }
                                    shapedPayload = window.GlassFormulaCalculation.calculateStormGlassAddonFromCache(stormGlassFormulaKey, stormKey);
                                    stormAdd2 = shapedPayload && shapedPayload.ok ? (parseFloat(shapedPayload.total) || 0) : 0;
                                }
                                var formulaKeysForLog = (shapedPayload && shapedPayload.formulaKeys)
                                    ? shapedPayload.formulaKeys.join('+')
                                    : (typeof window.GlassFormulaCalculation.getSelectedSidelightTransomStyleKeyFromDom === 'function'
                                        ? (window.GlassFormulaCalculation.getSelectedSidelightTransomStyleKeyFromDom() || '')
                                        : '');
                                var stormLogKey = stormKey + '|' + formulaKeysForLog + '|' + stormAdd2;
                                // Replace prior storm glass amount (do not stack); layered onto display via pricing-rule sync.
                                var prevStormGlassAddon = parseFloat(window['__doorAddon_storm_glass'] || 0) || 0;
                                window['__doorAddon_storm_glass'] = stormAdd2;
                                if (stormAdd2) {
                                    try {
                                        if (window.__doorStormGlassAlertKey !== stormLogKey) {
                                            window.__doorStormGlassAlertKey = stormLogKey;
                                            console.log('Storm glass add-on added:', String(stormAdd2));
                                        }
                                    } catch (eA) { }
                                }
                                if (stormAdd2 > 0.01 || prevStormGlassAddon > 0.01) {
                                    try {
                                        if (
                                            window.DoorIntExtPricingRule
                                            && typeof window.DoorIntExtPricingRule.syncEstimatedPriceDisplay === 'function'
                                        ) {
                                            window.DoorIntExtPricingRule.syncEstimatedPriceDisplay({
                                                source: 'storm_glass_calc',
                                                userAction: true,
                                                stormGlassAddon: stormAdd2
                                            });
                                        }
                                    } catch (eStormSync) { }
                                }
                                try {
                                    if (window.DOOR_PRICE_DEBUG !== false && window.__doorStormGlassCalcLogKey !== stormLogKey) {
                                        window.__doorStormGlassCalcLogKey = stormLogKey;
                                        var themeForLog = totalBeforeStormGlass;
                                        var displayAfter = themeForLog + stormAdd2;
                                        if (
                                            window.DoorIntExtPricingRule
                                            && typeof window.DoorIntExtPricingRule.getDoorAddonTotalSum === 'function'
                                        ) {
                                            displayAfter = themeForLog + window.DoorIntExtPricingRule.getDoorAddonTotalSum();
                                        }
                                        var stormLogPayload = {
                                            option: 'attributes[Select Storm Glasses]',
                                            selectedValue: stormVal,
                                            normalizedKey: stormKey,
                                            sidelightFormulaKey: formulaKeysForLog,
                                            formulaBreakdown: shapedPayload,
                                            stormGlassAddon: stormAdd2,
                                            themeOptionTotal: themeForLog,
                                            displayTotal: displayAfter,
                                            formula: themeForLog + ' + ' + stormAdd2 + ' = ' + (themeForLog + stormAdd2)
                                        };
                                        if (
                                            window.GlassFormulaCalculation
                                            && typeof window.GlassFormulaCalculation.logStormGlass === 'function'
                                        ) {
                                            window.GlassFormulaCalculation.logStormGlass('addon_replaced', stormLogPayload);
                                        } else {
                                            void 0;
                                        }
                                    }
                                } catch (eStormLog) { }

                                if (typeof window.GlassFormulaCalculation.getMissingStormGlassTypeFromCache === 'function'
                                    && typeof window.GlassFormulaCalculation.loadStormGlassTypeFromApi === 'function') {
                                    var missStorm = window.GlassFormulaCalculation.getMissingStormGlassTypeFromCache([stormKey]);
                                    if (missStorm && missStorm.length) {
                                        window.GlassFormulaCalculation.loadStormGlassTypeFromApi(missStorm).then(function () {
                                            try { updateEstimatedPrice(); } catch (e) { }
                                        });
                                    }
                                } else if (typeof window.GlassFormulaCalculation.getMissingGlassTypeExteriorFromCache === 'function'
                                    && typeof window.GlassFormulaCalculation.loadGlassTypeExterior === 'function') {
                                    var missStorm2 = window.GlassFormulaCalculation.getMissingGlassTypeExteriorFromCache([stormKey]);
                                    if (missStorm2 && missStorm2.length) {
                                        window.GlassFormulaCalculation.loadGlassTypeExterior(missStorm2).then(function () {
                                            try { updateEstimatedPrice(); } catch (e) { }
                                        });
                                    }
                                }
                                if (stormGlassFormulaKey
                                    && typeof window.GlassFormulaCalculation.getMissingFromCache === 'function'
                                    && typeof window.GlassFormulaCalculation.load === 'function') {
                                    var missGfFormula = window.GlassFormulaCalculation.getMissingFromCache([stormGlassFormulaKey]);
                                    if (missGfFormula && missGfFormula.length) {
                                        window.GlassFormulaCalculation.load(missGfFormula).then(function () {
                                            try { updateEstimatedPrice(); } catch (eGfLoad) { }
                                        });
                                    }
                                }
                            } // shouldApplyStorm
                        } else {
                            window['__doorAddon_storm_glass'] = 0;
                        }
                    }
                } catch (eStormGlassStraightPricing) { }

                var selectedTopStyleChoice =
                    findSelectedChoiceByValue('round_top') || findSelectedChoiceByValue('arch_top');
                var hasRoundOrArchTop = !!selectedTopStyleChoice;
                // Slab-only + round/arch top: do not add metaobject pre_hung_exterior / pre_hung_interior from the
                // top choice (use that choice's schema priceValue + wood slab extra only).
                var waiveSlabArchedTopPreHungMeta = hasRoundOrArchTop && isSlabOnlySelected;

                // Apply slab extra when:
                // - slab_only is selected, OR
                // - pre_hung_on_jamb is selected (requested: pre-hung on jamb includes slab extra too)
                var shouldApplyWoodSlabExtra = isSlabOnlySelected || anySelectedValueEquals('pre_hung_on_jamb');
                if (shouldApplyWoodSlabExtra) {
                    var woodOpt = doorConfigSchema.find(function (o) { return o && o.id === 'wood_type'; });
                    var woodSelected = config ? config['wood_type'] : null;
                    if (woodOpt && woodSelected != null && Array.isArray(woodOpt.options)) {
                        var selectedChoice = woodOpt.options.find(function (c) {
                            return String(c && c.value != null ? c.value : '') === String(woodSelected);
                        });
                        if (selectedChoice) {
                            var raw = 0;
                            if (doorSurface === 'interior') {
                                raw = selectedChoice.slabInterior != null ? selectedChoice.slabInterior : selectedChoice.slab_interior;
                            } else if (doorSurface === 'exterior') {
                                raw = selectedChoice.slabExterior != null ? selectedChoice.slabExterior : selectedChoice.slab_exterior;
                            } else {
                                raw = 0; // Unsupported product surface => no extra price.
                            }
                            var parsed = parseFloat(raw);
                            if (!isNaN(parsed)) woodSlabExtra = parsed;
                        }
                    }
                }

                total += woodSlabExtra;

                // Pre-hung on jamb pricing adjustment (mirrors slab-only logic):
                // When any selected choice value is "pre_hung_on_jamb",
                // add selected `wood_type` choice's pre-hung interior/exterior extra.
                var woodPreHungExtra = 0;

                if (isPreHungOnJambSelected) {
                    var woodOpt2 = doorConfigSchema.find(function (o) { return o && o.id === 'wood_type'; });
                    var woodSelected2 = config ? config['wood_type'] : null;
                    if (woodOpt2 && woodSelected2 != null && Array.isArray(woodOpt2.options)) {
                        var selectedChoice2 = woodOpt2.options.find(function (c) {
                            return String(c && c.value != null ? c.value : '') === String(woodSelected2);
                        });
                        if (selectedChoice2) {
                            var raw2 = 0;
                            if (doorSurface === 'interior') {
                                raw2 = selectedChoice2.preHungInterior != null ? selectedChoice2.preHungInterior : selectedChoice2.pre_hung_interior;
                            } else if (doorSurface === 'exterior') {
                                raw2 = selectedChoice2.preHungExterior != null ? selectedChoice2.preHungExterior : selectedChoice2.pre_hung_exterior;
                            } else {
                                raw2 = 0; // Unsupported product surface => no extra price.
                            }
                            var parsed2 = parseFloat(raw2);
                            if (!isNaN(parsed2)) woodPreHungExtra = parsed2;
                        }
                    }
                    // Exterior + poplar + round/arch top: waive wood_type pre_hung_exterior (only in this combination; other woods unchanged).
                    if (doorSurface === 'exterior' && normSelectionValue(woodSelected2) === 'poplar' && hasRoundOrArchTop) {
                        woodPreHungExtra = 0;
                    }
                }

                total += woodPreHungExtra;

                // Round/Arch top + Pre-hung pricing adjustment:
                // - If customer selects "round_top" or "arch_top", schema pricing already adds that choice's priceValue.
                // - Additionally, when a pre-hung selection is made (slab_only OR pre_hung_on_jamb),
                //   add the selected top option's pre-hung interior/exterior extra (if present).
                //
                // This mirrors the wood_type special-case behavior, but pulls extras from the selected
                // "round_top"/"arch_top" choice object itself.
                var preHungSelected = isSlabOnlySelected
                    || isPreHungOnJambSelected
                    || anySelectedValueEquals('pre_hung_interior')
                    || anySelectedValueEquals('pre_hung_exterior');
                if (preHungSelected) {
                    var topChoice = selectedTopStyleChoice;
                    if (topChoice) {
                        var topPreHungRaw = 0;
                        if (doorSurface === 'interior') {
                            topPreHungRaw = topChoice.preHungInterior != null ? topChoice.preHungInterior : topChoice.pre_hung_interior;
                        } else if (doorSurface === 'exterior') {
                            topPreHungRaw = topChoice.preHungExterior != null ? topChoice.preHungExterior : topChoice.pre_hung_exterior;
                        } else {
                            topPreHungRaw = 0;
                        }
                        var topPreHungParsed = parseFloat(topPreHungRaw);
                        var waiveTopPreHungExt =
                            doorSurface === 'exterior'
                            && normSelectionValue(config && config['wood_type']) === 'poplar';
                        if (!isNaN(topPreHungParsed) && !waiveTopPreHungExt && !waiveSlabArchedTopPreHungMeta) {
                            total += topPreHungParsed;
                        }
                    }
                }
            } catch (e) {
                // Fail open: keep original schema total if the adjustment can't be computed.
            }

            // Double door: only when choice value normalizes to `double_door` (e.g. metaobject value double_door).
            // Selecting `single_door` or anything else recalculates with no multiplier.
            try {
                function normForDoubleCheck(v) {
                    return String(v == null ? '' : v).trim().toLowerCase().replace(/\s+/g, '_');
                }
                function selectionIsDoubleDoor(cfg) {
                    if (forceSingleDoor) return false;
                    if (forceDoubleDoor) return true;
                    if (!cfg || typeof cfg !== 'object' || !doorConfigSchema || !Array.isArray(doorConfigSchema)) return false;
                    for (var di = 0; di < doorConfigSchema.length; di++) {
                        var dopt = doorConfigSchema[di];
                        if (!dopt || !dopt.id) continue;
                        var sel = cfg[dopt.id];
                        var list = Array.isArray(sel) ? sel : (sel !== null && sel !== undefined && sel !== '' ? [sel] : []);
                        for (var dj = 0; dj < list.length; dj++) {
                            if (normForDoubleCheck(list[dj]) === 'double_door') return true;
                        }
                    }
                    return false;
                }
                if (selectionIsDoubleDoor(config)) {
                    total = total * 2;
                }
            } catch (eDouble) { }

            var catalogAddons = applyCatalogMetaobjectAddonsFromUpdate(config);
            total += catalogAddons.total || 0;

            return {
                price: total,
                currency: Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : null
            };
        }
        var catalogAddonsBase = applyCatalogMetaobjectAddonsFromUpdate(config);
        return {
            price: basePrice + (catalogAddonsBase.total || 0),
            currency: Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : null
        };
    }

    function formatMoney(amount) {
        try {
            var locale = (navigator.language || 'en-US');
            var currency = Shopify && Shopify.currency && Shopify.currency.active
                ? Shopify.currency.active
                : 'USD';
            return new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currency
            }).format(amount);
        } catch (e) {
            return '$' + amount.toFixed(2);
        }
    }

    function buildSelectedOptionImageMap(config, schema) {
        var out = {};
        if (!config || !Array.isArray(schema)) return out;
        function put(optId, val, choice) {
            if (!optId || val == null || !choice) return;
            var src = resolveChoiceImageSrc(choice) || '';
            if (!src && choice.image) {
                src = typeof choice.image === 'string'
                    ? choice.image
                    : (choice.image && (choice.image.url || choice.image.src)) || '';
            }
            if (!src) return;
            if (!out[optId]) out[optId] = {};
            out[optId][String(val)] = String(src);
        }
        schema.forEach(function (opt) {
            if (!opt || !opt.id) return;
            var oid = String(opt.id);
            var selected = config[oid];
            if (selected == null || selected === '') return;
            var choices = Array.isArray(opt.options) ? opt.options : [];
            if (!choices.length) return;
            if (Array.isArray(selected)) {
                selected.forEach(function (sv) {
                    var ch = choices.find(function (c) { return String(c && c.value != null ? c.value : '') === String(sv); });
                    put(oid, sv, ch);
                });
            } else {
                var chOne = choices.find(function (c) { return String(c && c.value != null ? c.value : '') === String(selected); });
                put(oid, selected, chOne);
            }
        });
        return out;
    }

    // Build a readable, ordered list of everything the customer selected, for the
    // custom admin app. Captures schema options (exposure, hinge, measurements,
    // etc.), the bevel-glass toggle, measurement dropdowns, and selected hardware.
    // Order matches configurator desiredOptionOrder (same as config page UI).
    function buildSelectedSummaryForStorage(config, schema) {
        var items = [];
        function pushItem(label, value, image) {
            label = String(label == null ? '' : label).trim();
            value = String(value == null ? '' : value).trim();
            if (!label || !value) return;
            items.push({ label: label, value: value, image: image || '' });
        }

        function pushSchemaOption(opt) {
            if (!opt || !opt.id) return;
            var label = opt.label || opt.id;
            var optType = (opt.type || '').toLowerCase();
            // Dp merge code 10-09 start — skip schema exact-pre-hung int/frac (measurement DOM uses Pre-hung Jamb Width)
            var oidSkipPh = normalizeOptionIdKey(opt.id);
            if (
                /^(exact_pre_hung|jamb_pre_hung|panel_pre_hung|rough_pre_hung)/.test(oidSkipPh) ||
                oidSkipPh === 'pre_hung_unit_depth' ||
                // Dp start VDN-390 23-10
                oidSkipPh === 'prehung_unit_depth' ||
                oidSkipPh === 'pre_hung_jamb_width' ||
                oidSkipPh === 'prehung_jamb_width' ||
                oidSkipPh === 'pre_hung_jamb_depth' ||
                oidSkipPh === 'prehung_jamb_depth'
                // Dp end VDN-390 23-10
            ) {
                return;
            }
            // Dp merge code 10-09 end
            if (optType === 'dimension') {
                var vCm = config[opt.id + '_cm'];
                var vIn = config[opt.id + '_in'];
                if (vCm != null && vCm !== '') pushItem(label + ' (cm)', String(vCm));
                if (vIn != null && vIn !== '') pushItem(label + ' (inches)', String(vIn));
                return;
            }
            var val = config[opt.id];
            if (val === null || val === undefined || val === '') return;
            if (normalizeOptionIdKey(opt.id) === 'screen_and_storm_inserts_additional_options') return;
            if (isInactiveScreenStormTypeOption(opt.id)) return;
            if (isInactivePanelProfileOption(opt.id)) return;
            // Dp start 27-08 — do not persist placeholder Select as Hardware Swing Direction
            var oidNormLip = normalizeOptionIdKey(opt.id);
            if ((oidNormLip === 'swing_direction' || oidNormLip === 'hardware_swing_direction')
                && /^(select|please select|not selected|none|n\/a)$/i.test(String(val).trim())) {
                return;
            }
            // Dp end 27-08
            if (optType === 'checkbox') {
                var arr = Array.isArray(val) ? val : [];
                if (arr.length === 0) return;
                var choices = opt.options || [];
                var labels = arr.map(function (v) {
                    var c = choices.find(function (o) { return String(o.value || '') === String(v); });
                    return c && (c.label || c.value) ? (c.label || c.value) : v;
                });
                pushItem(label, labels.join(', '));
            } else if ((optType === 'select' || optType === 'radio') && Array.isArray(opt.options)) {
                var ch = opt.options.find(function (o) { return String(o.value || '') === String(val); });
                pushItem(label, ch && (ch.label || ch.value) ? (ch.label || ch.value) : String(val));
            } else {
                pushItem(label, String(val));
            }
        }

        // 1) Schema options in config-page render order.
        try {
            var orderedSchema = schemaForDoorRenderOrder(
                Array.isArray(schema) && schema.length ? schema : (doorConfigSchema || [])
            );
            orderedSchema.forEach(pushSchemaOption);
        } catch (eProps) {
            try {
                var props = getLineItemPropertiesFromSchema() || {};
                Object.keys(props).forEach(function (label) {
                    var v = props[label];
                    if (v == null || String(v) === '') return;
                    if (/bevel/i.test(label)) return;
                    pushItem(label, v);
                });
            } catch (eProps2) { }
        }

        // Extras that may not be plain schema rows (keep after related schema options).
        try {
            if (config.transom_count) {
                var tLabel = 'Single or Double Transom?';
                var tv = String(config.transom_count || '');
                if (tv === 'single_transom_across_both_doors') pushItem(tLabel, 'Single transom across both doors');
                else if (tv === 'two_transoms_one_over_each_door') pushItem(tLabel, 'Two transoms, one over each door');
                else pushItem(tLabel, tv);
            }
        } catch (eExtraProps) { }
        try {
            if (config.door_location_exposure) {
                pushItem('Where will the door be located?', String(config.door_location_exposure || ''));
            }
        } catch (eExposureProps) { }
        try {
            var addlSummaryLabels = getSelectedInsertsAdditionalOptionLabels(config);
            if (addlSummaryLabels.length) {
                pushItem('Additional Options', addlSummaryLabels.join(', '));
            }
        } catch (eAddlSum) { }

        // 2) Bevel glass: always show Add/No, even when unchecked — unless storm glass is not in the current inserts mode.
        try {
            if (insertsModeShowsStormGlassType(getSelectedScreenStormInsertsMode())) {
                var bevel = document.querySelector('input[type="checkbox"][data-option-id="glass_bevel"]');
                if (bevel) pushItem('Beveled Glass', bevel.checked ? 'Add Beveled Glass' : 'No Beveled Glass');
            }
        } catch (eBevel) { }

        // 3) Measurement dropdown rows (door-measurement-embedded-dimensions / static rows).
        try {
            var rowSeen = {};
            // Dp start 26-08 — include static panels / jamb rough stack so Exact Door Width/Height,
            // Sidelight, Transom, Pre-Hung depth are always captured for quote description.
            all('.door-measurement-embedded-dimensions .door-measure-dimension-row, .door-measurement-static-rows .door-measure-dimension-row, .door-measurement-static-panel .door-measure-dimension-row, .door-rough-panel-jamb-sidelight .door-measure-dimension-row, .door-jamb-sidelight-addon .door-measure-dimension-row, .door-jamb-transom-addon .door-measure-dimension-row').forEach(function (row) {
                if (!row || row.offsetParent === null) return; // skip hidden rows
                if (row.closest && row.closest('.door-hidden')) return;
                var titleEl = row.querySelector('.door-measure-dimension-title');
                var title = titleEl ? String(titleEl.textContent || '').trim() : '';
                if (!title) return;
                var parts = [];
                var intPart = '';
                var fracPart = '';
                all('select, input[type="number"], input[type="text"]', row).forEach(function (ctrl) {
                    if (ctrl.disabled) return;
                    var v = '';
                    if (ctrl.tagName === 'SELECT') {
                        var op = ctrl.options && ctrl.selectedIndex >= 0 ? ctrl.options[ctrl.selectedIndex] : null;
                        if (op && String(op.value) !== '') v = String(op.textContent || op.value || '').trim();
                    } else {
                        v = String(ctrl.value || '').trim();
                    }
                    if (!v) return;
                    parts.push(v);
                    var cid = String(ctrl.id || '').toLowerCase();
                    if (/frac|fraction/.test(cid) || (ctrl.classList && ctrl.classList.contains('door-dimension-frac-select'))) {
                        fracPart = v;
                    } else if (!intPart) {
                        intPart = v;
                    }
                });
                if (!parts.length) return;
                var key = title.toLowerCase();
                if (rowSeen[key]) return;
                // Dp merge code 10-09 start — store front label only (schema used Unit Depth; UI is Jamb Width)
                var titleNk = key.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
                // Dp start VDN-390 23-10
                if (
                    titleNk === 'pre hung unit depth' ||
                    titleNk === 'prehung unit depth' ||
                    titleNk === 'pre hung jamb width' ||
                    titleNk === 'prehung jamb width' ||
                    titleNk === 'pre hung jamb depth' ||
                    titleNk === 'prehung jamb depth'
                ) {
                    title = 'Pre-hung Jamb Depth';
                    key = 'pre-hung jamb depth';
                    if (
                        rowSeen[key] || rowSeen['pre hung jamb depth'] ||
                        rowSeen['pre-hung jamb width'] || rowSeen['pre hung jamb width'] ||
                        rowSeen['pre-hung unit depth'] || rowSeen['pre hung unit depth']
                    ) return;
                    rowSeen['pre-hung jamb depth'] = true;
                    rowSeen['pre hung jamb depth'] = true;
                    rowSeen['pre-hung jamb width'] = true;
                    rowSeen['pre hung jamb width'] = true;
                    rowSeen['pre-hung unit depth'] = true;
                    rowSeen['pre hung unit depth'] = true;
                }
                // Dp end VDN-390 23-10
                // Dp merge code 10-09 end
                // Dp start 02-09 — Opening W/H collapse into one Rough/Finished Opening Size line
                var mtRawDom = String(config.measurement_type || config['measurement-type'] || '').toLowerCase();
                var titleNorm = key.replace(/[_-]+/g, ' ').trim();
                if (mtRawDom.indexOf('finished') !== -1) {
                    if (titleNorm === 'rough opening width' || titleNorm === 'rough opening height'
                        || titleNorm === 'finished opening width' || titleNorm === 'finished opening height') {
                        return;
                    }
                } else if (mtRawDom.indexOf('rough') !== -1) {
                    if (titleNorm === 'finished opening width' || titleNorm === 'finished opening height'
                        || titleNorm === 'rough opening width' || titleNorm === 'rough opening height') {
                        return;
                    }
                }
                // Dp end 02-09
                rowSeen[key] = true;
                // Prefer int + fraction display (skip bare trailing "0" fraction).
                var displayVal = parts.join(' ');
                if (intPart) {
                    if (fracPart && fracPart !== '0' && fracPart !== '00' && fracPart !== '0/0') {
                        displayVal = intPart + ' ' + fracPart;
                    } else {
                        displayVal = intPart;
                    }
                }
                pushItem(title, displayVal);
            });
            // Dp end 26-08
        } catch (eMeasure) { }

        // Dp start 26-08 — backfill measurement W/H/T from config keys when DOM rows were skipped
        // (hidden panels / offsetParent). Slab Only + Rough Opening Size stores finished_* values.
        try {
            function readCfgKey() {
                for (var i = 0; i < arguments.length; i++) {
                    var k = arguments[i];
                    if (config[k] != null && String(config[k]).trim() !== '') return String(config[k]).trim();
                }
                return '';
            }
            function combineInches(intV, fracV) {
                intV = String(intV || '').trim();
                fracV = String(fracV || '').trim();
                if (fracV === '0' || fracV === '00' || fracV === '0/0') fracV = '';
                if (!intV && !fracV) return '';
                if (intV && fracV) return intV + ' ' + fracV;
                return intV || fracV;
            }
            function pushIfMissing(label, value) {
                if (!label || !value) return;
                var lk = String(label).toLowerCase();
                for (var i = 0; i < items.length; i++) {
                    var it = items[i];
                    if (it && String(it.label || '').toLowerCase() === lk) return;
                }
                pushItem(label, value);
            }
            var mtRaw = String(config.measurement_type || config['measurement-type'] || '').toLowerCase();
            var fw = combineInches(readCfgKey('finished_width_int', 'finished-width-int'), readCfgKey('finished_width_frac', 'finished-width-frac', 'finished_width_fraction'));
            var fh = combineInches(readCfgKey('finished_height_int', 'finished-height-int'), readCfgKey('finished_height_frac', 'finished-height-frac', 'finished_height_fraction'));
            var rw = combineInches(readCfgKey('rough-width-int', 'rough_width_int'), readCfgKey('rough-width-frac', 'rough-width-frac_label', 'rough_width_frac', 'rough_width_fraction'));
            var rh = combineInches(readCfgKey('rough-height-int', 'rough_height_int'), readCfgKey('rough-height-frac', 'rough-height-frac_label', 'rough_height_frac', 'rough_height_fraction'));
            var ew = combineInches(readCfgKey('exact_door_width_int', 'exact-door-width-int', 'exact_door_width', 'door_width'), readCfgKey('exact_door_width_frac', 'exact-door-width-frac', 'exact_door_width_fraction', 'door_width_fraction'));
            var eh = combineInches(readCfgKey('door_height', 'exact_door_height', 'exact-door-height-int'), readCfgKey('door_height_fraction', 'door_height_frac', 'exact_door_height_frac'));
            if (mtRaw.indexOf('rough') !== -1) {
                pushIfMissing('Rough Opening Width', rw || fw || ew);
                // Dp start 02-09 — never substitute Exact Door Height when rough-height-int is set
                pushIfMissing('Rough Opening Height', rh || fh);
                // Dp end 02-09
            } else if (mtRaw.indexOf('finished') !== -1) {
                // Dp start 02-09 — Finished Opening Size collapse builds W x H; do not store standalone W/H rows
                // (avoids duplicate Rough Opening Width/Height leaking from jamb calc fields)
                // Dp end 02-09
            }
            if (mtRaw.indexOf('exact') !== -1 || (!mtRaw && (ew || eh))) {
                pushIfMissing('Exact Door Width', ew);
                pushIfMissing('Exact Door Height', eh);
            }
            var thick = readCfgKey(
                'finished-door-thickness_label', 'finished_door_thickness_label',
                'finished-door-thickness', 'finished_door_thickness',
                'exact-door-thickness-frac_label', 'exact_door_thickness_frac_label',
                'exact_door_thickness_frac', 'exact-door-thickness-frac',
                'door_thickness', 'exact_door_thickness', 'panel-door-thickness-frac'
            );
            if (thick) pushIfMissing('Door Thickness', thick);
        } catch (eMeasBackfill) { }
        // Dp end 26-08

        // 4) Selected hardware products (multi-add, finish + qty per line).
        try {
            getHardwareSelectionsForConfig().forEach(function (row, idx) {
                if (!row) return;
                var line = formatHardwareSelectionSummaryLine(row);
                if (line) pushItem(idx === 0 ? 'Hardware' : 'Hardware ' + (idx + 1), line, row.image || '');
            });
        } catch (eHw) { }

        // 5) Selected casing product (single, length + qty).
        try {
            getCasingSelectionsForConfig().forEach(function (row, idx) {
                if (!row) return;
                var line = String(row.title || row.product_id || 'Casing');
                if (row.length_label) line += ' — ' + row.length_label;
                if (row.qty && row.qty > 1) line += ' (×' + row.qty + ')';
                pushItem(idx === 0 ? 'Casing' : 'Casing ' + (idx + 1), line, row.image || '');
            });
        } catch (eCasing) { }

        // 6) Millwork wood / length / thickness (baluster & custom-length products).
        try {
            if (window.DoorConf2Update && typeof window.DoorConf2Update.getMillworkSummaryItemsForConfig === 'function') {
                window.DoorConf2Update.getMillworkSummaryItemsForConfig().forEach(function (row) {
                    if (!row) return;
                    pushItem(row.label, row.value, row.image || '');
                });
            }
        } catch (eMillwork) { }

        // 7) Landing-hardware dropdowns (Finish, Closer Color, Swing, Backset, …).
        try {
            if (window.DoorConf2Update && typeof window.DoorConf2Update.captureLandingHardwareSummaryEntries === 'function') {
                window.DoorConf2Update.captureLandingHardwareSummaryEntries(pushItem);
            }
        } catch (eLhSum) { }

        // 8) Custom panel unit design choices
        try {
            if (config.panel_unit_design) {
                var label = 'Panel Unit Design';
                var val = config.panel_unit_design;
                if (val === 'design_porch_enclosure_system') {
                    pushItem(label, 'Design a Porch Enclosure System');
                } else if (val === 'order_individual_panels') {
                    pushItem(label, 'Order Individual Panels');
                    var panels = config.panel_unit_individual_measurements || [];
                    var thickMapInd = {
                        '1.125': '1 1/8', '1.25': '1 1/4', '1.375': '1 3/8',
                        '1.5': '1 1/2', '1.75': '1 3/4', '2.25': '2 1/4'
                    };
                    panels.forEach(function (panel, idx) {
                        if (!panel) return;
                        var panelLabel = 'Panel Set #' + (idx + 1);
                        var wTok = '';
                        var hTok = '';
                        if (panel.width_int != null && String(panel.width_int) !== '') {
                            var wN = (parseFloat(panel.width_int) || 0) + (parseFloat(panel.width_frac) || 0);
                            wTok = typeof dpPorchInchLabel === 'function' ? dpPorchInchLabel(wN) : String(wN);
                        }
                        if (panel.height_int != null && String(panel.height_int) !== '') {
                            var hN = (parseFloat(panel.height_int) || 0) + (parseFloat(panel.height_frac) || 0);
                            hTok = typeof dpPorchInchLabel === 'function' ? dpPorchInchLabel(hN) : String(hN);
                        }
                        if (wTok && hTok) pushItem(panelLabel, wTok + 'w x ' + hTok + 'h');
                        else if (wTok) pushItem(panelLabel, wTok + 'w');
                        else if (hTok) pushItem(panelLabel, hTok + 'h');
                        if (panel.thickness != null && String(panel.thickness).trim() !== '') {
                            var tRaw = String(panel.thickness).trim();
                            var tVal = thickMapInd[tRaw] || tRaw;
                            pushItem(panelLabel + ' Thickness', String(tVal).replace(/"+$/g, ''));
                        }
                        if (panel.quantity != null && String(panel.quantity).trim() !== '') {
                            pushItem(panelLabel + ' Quantity', String(panel.quantity));
                        }
                    });
                }
            }
        } catch (ePanelSummary) { }

        // Dp start 17-08
        try {
            var encOpeningsSum = (config && (config.panel_unit_enclosure_openings || config._panel_unit_enclosure_openings)) || [];
            var panelUnitValSum = String((config && config.panel_unit_design) || '');
            if (Array.isArray(encOpeningsSum) && encOpeningsSum.length && (panelUnitValSum === 'design_porch_enclosure_system' || /enclosure/i.test(panelUnitValSum))) {
                var thickMapSum = {
                    '1.125': '1 1/8', '1.25': '1 1/4', '1.375': '1 3/8',
                    '1.5': '1 1/2', '1.75': '1 3/4', '2.25': '2 1/4'
                };
                function panelUnitInchSum(intVal, fracVal) {
                    var n = (parseFloat(intVal) || 0) + (parseFloat(fracVal) || 0);
                    if (!n && String(intVal || '') === '') return '';
                    return String(n);
                }
                function panelUnitSillInchSum(intVal, fracVal) {
                    var intN = parseFloat(intVal);
                    var fracN = parseFloat(fracVal) || 0;
                    if ((intVal == null || String(intVal) === '') && !fracN) return '';
                    var intLabel = isNaN(intN) ? '5' : String(Math.round(intN));
                    if (!fracN) return intLabel;
                    var fracMap = { 0.125: '1/8', 0.25: '1/4', 0.375: '3/8', 0.5: '1/2', 0.625: '5/8', 0.75: '3/4', 0.875: '7/8' };
                    var fLabel = '';
                    Object.keys(fracMap).forEach(function (k) {
                        if (!fLabel && Math.abs(parseFloat(k) - fracN) < 0.0001) fLabel = fracMap[k];
                    });
                    return fLabel ? (intLabel + ' ' + fLabel) : String((isNaN(intN) ? 0 : intN) + fracN);
                }
                function panelUnitHumanizeSum(v) {
                    return String(v || '').replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
                }
                encOpeningsSum.forEach(function (op, idx) {
                    if (!op) return;
                    var prefix = encOpeningsSum.length > 1 ? ((idx === 0 ? 'Porch Opening #' : 'Panel Opening #') + (idx + 1) + ' ') : '';
                    var wTxt = panelUnitInchSum(op.width_int, op.width_frac);
                    var hTxt = panelUnitInchSum(op.height_int, op.height_frac);
                    if (wTxt) pushItem(prefix + 'Finished Opening Width', wTxt + '"');
                    if (hTxt) pushItem(prefix + 'Finished Opening Height', hTxt + '"');
                    var panelThickRawSum = op.thickness != null && String(op.thickness).trim() !== '' ? String(op.thickness).trim() : '1.125';
                    pushItem(prefix + 'Panel Thickness', (thickMapSum[panelThickRawSum] || panelThickRawSum) + '"');
                    if (op.panels) pushItem(prefix + 'Panels per opening', String(op.panels));
                    var trimOnSum = op.trim_system === 'true' || op.trim_system === true || op.trim_system === '1' || op.trim_system === 1;
                    pushItem(prefix + 'Add Trim System', trimOnSum ? 'On' : 'Off');
                    if (trimOnSum) {
                        var sTxt = panelUnitSillInchSum(op.sill_depth || '5', op.sill_frac || '0');
                        if (sTxt) pushItem(prefix + 'Sill Width', sTxt + '"');
                        // Dp start 17-08
                        var saSum = dpPorchStopsAstragalsFromOpening(op);
                        if (saSum.stops) pushItem(prefix + 'Stops', saSum.stops);
                        if (saSum.astragals) pushItem(prefix + 'Astragals', saSum.astragals);
                        // Dp end 17-08
                    }
                    (op.doors || []).forEach(function (door, doorIdx) {
                        if (!door) return;
                        var dnRaw = door.door_number || door.doorNumber || door.number || door.index;
                        var dn = parseInt(dnRaw, 10);
                        if (!dn || dn < 1) dn = doorIdx + 1;
                        if (door.swing_direction || door.swingDirection) {
                            pushItem(prefix + 'Door #' + dn + ' Swing Direction', panelUnitHumanizeSum(door.swing_direction || door.swingDirection));
                        }
                        if (door.hinge_finish || door.hingeFinish) {
                            pushItem(prefix + 'Door #' + dn + ' Hinge Finish', panelUnitHumanizeSum(door.hinge_finish || door.hingeFinish));
                        }
                        if (door.lockset_preparation || door.locksetPreparation) {
                            pushItem(prefix + 'Door #' + dn + ' Lockset Preparation', panelUnitHumanizeSum(door.lockset_preparation || door.locksetPreparation));
                        }
                    });
                });
            }
        } catch (eEncSum) { }
        // Dp end 17-08

        // Final pass: keep display order aligned with config page (desiredOptionOrder).
        try {
            var summaryOrderKeys = [
                'door unit design', 'panel unit design', 'panel set', 'sidelight', 'transom',
                'door setup', 'pre-hung', 'prehung', 'top style',
                'wood', 'select wood',
                'screen and storm', 'screen type', 'select screen', 'storm glass',
                'select glass', 'glass type', 'frame color', 'additional options',
                'swing', 'where will the door', 'door location', 'exposure',
                'measurement',
                'stile and rail', 'applied molding', 'sdl',
                'panel profile',
                'hinge', 'lockset',
                'shelf', 'priming', 'door sweep', 'door seal', 'pet door',
                'bevel',
                'exact door', 'finished opening', 'rough opening', 'jamb',
                'hardware', 'casing'
            ];
            function summaryItemRank(row) {
                var key = String((row && row.label) || '').toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
                if (!key) return 9000;
                for (var i = 0; i < summaryOrderKeys.length; i++) {
                    if (key.indexOf(summaryOrderKeys[i]) !== -1) return i;
                }
                return 8000;
            }
            items.sort(function (a, b) {
                var ra = summaryItemRank(a);
                var rb = summaryItemRank(b);
                if (ra !== rb) return ra - rb;
                return String((a && a.label) || '').localeCompare(String((b && b.label) || ''));
            });
        } catch (eSumSort) { }

        // Dp start 17-08 — porch enclosure fields stay together as the last sequence
        try {
            var porchSeqOrder = [
                'finished opening width',
                'finished opening height',
                'panel thickness',
                'panels per opening',
                'add trim system',
                'sill width',
                'stops',
                'astragals',
                'door #'
            ];
            function isPorchSeqSummaryLabel(label) {
                var key = String(label || '').toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
                if (!key || key === 'panel unit design') return false;
                if (/^(porch|panel) opening #\d+/.test(key)) return true;
                if (/finished opening (width|height)/.test(key)) return true;
                if (key === 'panel thickness' || / panel thickness$/.test(key)) return true;
                if (key.indexOf('panels per opening') !== -1) return true;
                if (key.indexOf('add trim system') !== -1) return true;
                if (key === 'sill' || key.indexOf('sill width') !== -1) return true;
                if (/^door #\d+/.test(key)) return true;
                if (key === 'stops' || key === 'astragals') return true;
                return false;
            }
            function porchSeqRank(label) {
                var key = String(label || '').toLowerCase();
                for (var pi = 0; pi < porchSeqOrder.length; pi++) {
                    if (key.indexOf(porchSeqOrder[pi]) !== -1) return pi;
                }
                return 90;
            }
            var porchTail = [];
            var restSummary = [];
            items.forEach(function (row) {
                if (isPorchSeqSummaryLabel(row && row.label)) porchTail.push(row);
                else restSummary.push(row);
            });
            porchTail.sort(function (a, b) {
                var ra = porchSeqRank(a && a.label);
                var rb = porchSeqRank(b && b.label);
                if (ra !== rb) return ra - rb;
                return String((a && a.label) || '').localeCompare(String((b && b.label) || ''));
            });
            items = restSummary.concat(porchTail);
        } catch (ePorchSeq) { }
        // Dp end 17-08

        try {
            items = items.filter(function (row) {
                return !isInactiveScreenStormSummaryLabel(row && row.label)
                    && !isInactivePanelProfileSummaryLabel(row && row.label);
            });
        } catch (eSumPrune) { }

        // Dp merge code 10-09 start — never persist both Unit Depth and Jamb Width in selected_summary
        try {
            var phDepthIdx = -1;
            var phJambIdx = -1;
            for (var phi = 0; phi < items.length; phi++) {
                var phNk = String((items[phi] && items[phi].label) || '')
                    .toLowerCase()
                    .replace(/[_-]+/g, ' ')
                    .replace(/\s+/g, ' ')
                    .trim();
                if (phNk.indexOf('pre hung unit depth') === 0 || phNk.indexOf('prehung unit depth') === 0) phDepthIdx = phi;
                if (phNk.indexOf('pre hung jamb width') === 0 || phNk.indexOf('prehung jamb width') === 0) phJambIdx = phi;
            }
            if (phDepthIdx >= 0 && phJambIdx >= 0) {
                var dVal = String((items[phDepthIdx] && items[phDepthIdx].value) || '').trim();
                var jVal = String((items[phJambIdx] && items[phJambIdx].value) || '').trim();
                if (jVal && dVal && jVal !== dVal && /\d+\s*\/\s*\d+/.test(dVal) && !/\d+\s*\/\s*\d+/.test(jVal)) {
                    items[phJambIdx].value = dVal;
                } else if (!jVal && dVal) {
                    items[phJambIdx].value = dVal;
                }
                // Dp start VDN-390 23-10
                items[phJambIdx].label = 'Pre-hung Jamb Depth';
                // Dp end VDN-390 23-10
                items.splice(phDepthIdx, 1);
            } else if (phDepthIdx >= 0) {
                // Dp start VDN-390 23-10
                items[phDepthIdx].label = 'Pre-hung Jamb Depth';
                // Dp end VDN-390 23-10
            }
        } catch (ePhSumDedup) { }
        // Dp merge code 10-09 end
        // Dp start VDN-390 23-10
        // Jamb Width / Jamb Depth / Unit Depth are one field: keep a single "Pre-hung Jamb Depth" row
        // at the first position, preferring a value with a fraction.
        try {
            var phAllIdx = [];
            for (var phk = 0; phk < items.length; phk++) {
                var phKey = String((items[phk] && items[phk].label) || '')
                    .toLowerCase()
                    .replace(/[_-]+/g, ' ')
                    .replace(/\s+/g, ' ')
                    .trim();
                if (
                    phKey.indexOf('pre hung jamb width') === 0 || phKey.indexOf('prehung jamb width') === 0 ||
                    phKey.indexOf('pre hung jamb depth') === 0 || phKey.indexOf('prehung jamb depth') === 0 ||
                    phKey.indexOf('pre hung unit depth') === 0 || phKey.indexOf('prehung unit depth') === 0
                ) {
                    phAllIdx.push(phk);
                }
            }
            if (phAllIdx.length) {
                var phKeepIdx = phAllIdx[0];
                var phBestVal = '';
                phAllIdx.forEach(function (ix) {
                    var v = String((items[ix] && items[ix].value) || '').trim();
                    if (!v) return;
                    if (!phBestVal || (/\d+\s*\/\s*\d+/.test(v) && !/\d+\s*\/\s*\d+/.test(phBestVal))) phBestVal = v;
                });
                items[phKeepIdx].label = 'Pre-hung Jamb Depth';
                if (phBestVal) items[phKeepIdx].value = phBestVal;
                for (var phr = phAllIdx.length - 1; phr >= 1; phr--) items.splice(phAllIdx[phr], 1);
            }
        } catch (ePhDepthDedup) { }
        // Dp end VDN-390 23-10


        return items;
    }

    // Capture options that aren't reliably part of the metaobject schema (exposure,
    // bevel, hinge, hardware grid, measurement dropdowns) directly from the rendered
    // DOM, so the admin app can render them as EDITABLE controls (cards/dropdowns).
    function adminLabelFromAttrName(inp, fallback) {
        var n = inp && inp.getAttribute ? (inp.getAttribute('name') || '') : '';
        var m = n.match(/attributes\[([^\]]+)\]/);
        return m ? m[1] : (fallback || (inp && inp.getAttribute ? inp.getAttribute('data-option-id') : '') || '');
    }
    function adminCaptureChoiceOption(oid, type) {
        var inputs = all('input[data-option-id="' + oid + '"]').filter(function (i) {
            return i.type === 'radio' || i.type === 'checkbox';
        });
        if (!inputs.length) return null;
        var label = adminLabelFromAttrName(inputs[0], oid);
        var choices = [];
        var seen = {};
        var current = type === 'checkbox' ? [] : null;
        var imgMap = {};
        inputs.forEach(function (inp) {
            var val = String(inp.value);
            var card = inp.closest('.common-check-option') || inp.parentElement;
            if (!seen[val]) {
                seen[val] = true;
                var lblEl = card ? card.querySelector('.common-check-option-label, .common-check-option-text') : null;
                var clbl = lblEl ? String(lblEl.textContent || '').trim() : '';
                if (!clbl) clbl = val;
                var imgEl = card ? card.querySelector('img') : null;
                var src = imgEl ? String(imgEl.getAttribute('src') || '') : '';
                choices.push({ value: val, label: clbl, image: src });
                if (src) imgMap[val] = src;
            }
            if (inp.checked) { if (type === 'checkbox') current.push(val); else current = val; }
        });
        return { entry: { id: oid, label: label, type: type, options: choices }, current: current, images: imgMap };
    }
    function adminCaptureBevel() {
        var inp = document.querySelector('input[type="checkbox"][data-option-id="glass_bevel"]');
        if (!inp) return null;
        var bevelVal = inp.checked ? [String(inp.value || 'true')] : [];
        return {
            entry: { id: 'glass_bevel', label: 'Beveled Glass', type: 'checkbox', options: [{ value: 'true', label: 'Add Beveled Glass' }] },
            current: bevelVal,
            images: {}
        };
    }
    function adminCaptureHardware() {
        var grid = document.querySelector('.door-hardware-options-cards, [data-hardware-detail="1"]');
        if (!grid) return null;
        var choices = [];
        var imgMap = {};
        all('.door-suggested-hardware-card, .door-hardware-product-block', grid).forEach(function (card) {
            var val = String(card.getAttribute('data-product-id') || card.getAttribute('data-choice-value') || '');
            if (!val) return;
            var titleEl = card.querySelector('.door-suggested-hardware-card__title, .door-hw-product__title, .common-check-option-label');
            var clbl = titleEl ? String(titleEl.textContent || '').trim() : val;
            var finishLbl = String(card.getAttribute('data-hw-finish-label') || '').trim();
            if (finishLbl) clbl = clbl + ' — ' + finishLbl;
            getHwFieldDefsForLineItems().forEach(function (fieldDef) {
                var part = String(card.getAttribute(fieldDef.dataLabel) || '').trim();
                if (part) clbl = clbl + ' — ' + part;
            });
            var imgEl = card.querySelector('.door-suggested-hardware-card__image, .door-hw-product__media img, img');
            var src = imgEl ? String(imgEl.getAttribute('src') || '') : '';
            choices.push({ value: val, label: clbl, image: src });
            if (src) imgMap[val] = src;
        });
        if (!choices.length) return null;
        var current = getHardwareSelectionsForConfig();
        return {
            entry: {
                id: 'hardware_options',
                label: 'Hardware',
                type: 'hardware_multi',
                options: choices,
                _hardwareSelections: true
            },
            current: current,
            images: imgMap
        };
    }
    function adminCaptureCasing() {
        var current = getCasingSelectionsForConfig();
        if (!current.length) return null;
        var choices = [];
        var imgMap = {};
        current.forEach(function (row) {
            if (!row || !row.product_id) return;
            var val = String(row.product_id);
            var lbl = String(row.title || val);
            var sku = String(row.sku || '').trim();
            // Dp start 31-07
            // if (sku && lbl.indexOf(sku) === -1) lbl = lbl + ' / ' + sku;
            // Dp end 31-07
            var src = String(row.image || '');
            choices.push({ value: val, label: lbl, image: src });
            if (src) imgMap[val] = src;
        });
        if (!choices.length) return null;
        return {
            entry: {
                id: 'casing_options',
                label: 'Casing',
                type: 'casing_multi',
                options: choices,
                _casingSelections: true
            },
            current: current,
            images: imgMap
        };
    }
    function adminCaptureMeasurementSelects() {
        var results = [];
        var seenIds = {};
        // The live measurement dimension <select>s render inside the embedded / static-rows
        // wrappers (see renderDynamicOptions), NOT only ".door-measurement-static-panels".
        // Scanning just the panels missed every dimension on save, so the admin never got
        // the measurement dropdowns as editable controls and the storefront edit had nothing
        // to restore. Match the same containers the restore path reads from so the saved
        // measurements stay in sync both ways (admin <-> storefront).
        all('.door-measurement-static-panels select, .door-measurement-static-panel select, .door-measurement-embedded-dimensions select, .door-measurement-static-rows select, .door-measure-dimension-row select, .door-measure-dimension-inputs-row select').forEach(function (sel) {
            var id = sel.id || (sel.getAttribute && sel.getAttribute('data-option-id')) || '';
            if (!id || seenIds[id]) return;
            // Skip hidden measurement panels (slab/combo/transom defaults) so the admin only
            // gets the active/visible dimension controls and the chosen value (not a default).
            if (sel.closest && sel.closest('.door-hidden')) return;
            seenIds[id] = true;
            var opts = [];
            var hasReal = false;
            all('option', sel).forEach(function (o) {
                opts.push({ value: String(o.value), label: String(o.textContent || o.value || '').trim() });
                if (String(o.value) !== '') hasReal = true;
            });
            if (!hasReal) return;
            var row = sel.closest('.door-measure-dimension-row');
            var titleEl = row ? row.querySelector('.door-measure-dimension-title') : null;
            var title = titleEl ? String(titleEl.textContent || '').trim() : '';
            var isFrac = /frac/i.test(id);
            var label = title ? (title + (isFrac ? ' (fraction)' : '')) : id;
            results.push({ entry: { id: id, label: label, type: 'select', options: opts, _adminGroup: 'measurement' }, current: sel.value || null, images: {} });
        });
        return results;
    }
    // Capture each "Order Individual Panels" panel set (Exact Panel Width / Height /
    // Thickness / Quantity, for every Panel Set #N) as EDITABLE admin controls so staff
    // can adjust the porch-panel measurements in the door-config admin app. Mirrors
    // adminCaptureMeasurementSelects but keyed per set + dimension with deterministic ids
    // (panel_unit_set_{n}_{dim}); admin_sync_panel_unit_measurements() reconstructs the
    // panel_unit_individual_measurements array from these on save so storefront restore
    // and the read-only summary stay in sync.
    function adminCapturePanelUnitSets() {
        var results = [];
        var listEl = document.querySelector('.door-panel-unit-size-list');
        if (!listEl) return results;
        // Only capture when the individual-panels flow is the active (visible) choice.
        var wrap = listEl.closest ? listEl.closest('[data-panel-unit-individual-measurements]') : null;
        if (wrap && wrap.classList && wrap.classList.contains('door-hidden')) return results;
        var dimDefs = [
            { attr: 'width-int', key: 'width_int', label: 'Exact Panel Width', type: 'select' },
            { attr: 'width-frac', key: 'width_frac', label: 'Exact Panel Width (fraction)', type: 'select' },
            { attr: 'height-int', key: 'height_int', label: 'Exact Panel Height', type: 'select' },
            { attr: 'height-frac', key: 'height_frac', label: 'Exact Panel Height (fraction)', type: 'select' },
            { attr: 'thickness', key: 'thickness', label: 'Panel Thickness', type: 'select' },
            { attr: 'quantity', key: 'quantity', label: 'Panel Quantity', type: 'number' }
        ];
        all('.door-panel-unit-size-entry', listEl).forEach(function (entry, idx) {
            var setNo = idx + 1;
            dimDefs.forEach(function (def) {
                var el = entry.querySelector('[data-panel-dimension="' + def.attr + '"]');
                if (!el) return;
                var id = 'panel_unit_set_' + setNo + '_' + def.key;
                var label = 'Panel Set #' + setNo + ' — ' + def.label;
                if (def.type === 'select') {
                    var opts = [];
                    var hasReal = false;
                    all('option', el).forEach(function (o) {
                        opts.push({ value: String(o.value), label: String(o.textContent || o.value || '').trim() });
                        if (String(o.value) !== '') hasReal = true;
                    });
                    if (!hasReal) return;
                    results.push({
                        entry: { id: id, label: label, type: 'select', options: opts, _adminGroup: 'panel_unit', _panelUnitSet: setNo, _panelUnitDim: def.key },
                        current: el.value != null && el.value !== '' ? String(el.value) : null,
                        images: {}
                    });
                } else {
                    results.push({
                        entry: { id: id, label: label, type: 'number', _adminGroup: 'panel_unit', _panelUnitSet: setNo, _panelUnitDim: def.key },
                        current: el.value !== '' ? el.value : null,
                        images: {}
                    });
                }
            });
        });
        return results;
    }
    // Dp start 17-08
    function adminCaptureSelectOptionsFromEl(el) {
        var opts = [];
        if (!el || !el.options) return opts;
        Array.prototype.forEach.call(el.options, function (o) {
            if (!o) return;
            opts.push({
                value: String(o.value),
                label: String(o.textContent || o.value || '').trim()
            });
        });
        return opts;
    }
    function adminCapturePanelUnitEnclosureOpenings() {
        var results = [];
        var listEl = document.querySelector('.door-porch-opening-list');
        if (!listEl) return results;
        var openings = [];
        try {
            if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.collectPanelUnitEnclosureOpeningsFromDom === 'function') {
                openings = window.DoorConf2Measurements.collectPanelUnitEnclosureOpeningsFromDom() || [];
            }
        } catch (eCollect) { openings = []; }
        if (!Array.isArray(openings) || !openings.length) return results;
        var firstEntry = listEl.querySelector('.door-porch-opening-entry');
        var swingChoices = [
            { value: 'out_right', label: 'Out Right' },
            { value: 'out_left', label: 'Out Left' },
            { value: 'in_right', label: 'In Right' },
            { value: 'in_left', label: 'In Left' },
            { value: 'barn_door', label: 'Barn Door' },
            { value: 'pocket_door', label: 'Pocket Door' }
        ];
        var hingeChoices = [
            { value: 'oil_rubbed_bronze', label: 'Oil-Rubbed Bronze' },
            { value: 'polished_brass', label: 'Polished Brass' },
            { value: 'unlacquered_brass', label: 'Unlacquered Brass' },
            { value: 'black', label: 'Black' },
            { value: 'satin_nickel', label: 'Satin Nickel' },
            { value: 'french_antique', label: 'French Antique' },
            { value: 'pewter', label: 'Pewter' }
        ];
        var locksetChoices = [
            { value: 'none', label: 'None (Your installer will drill)' },
            { value: 'mortise_lock_prep', label: 'Mortise lock prep (For premium locksets)' }
        ];
        openings.forEach(function (op, idx) {
            if (!op) return;
            var setNo = idx + 1;
            var prefix = (idx === 0 ? 'Porch Opening #' : 'Panel Opening #') + setNo + ' — ';
            function pushSelect(key, label, value, optionEl, fallbackChoices) {
                var opts = adminCaptureSelectOptionsFromEl(optionEl);
                if (!opts.length && fallbackChoices) opts = fallbackChoices.slice();
                if (!opts.length) return;
                results.push({
                    entry: {
                        id: 'panel_unit_enclosure_' + setNo + '_' + key,
                        label: prefix + label,
                        type: 'select',
                        options: opts,
                        _adminGroup: 'panel_unit',
                        _panelUnitEnclosure: setNo
                    },
                    current: value != null && value !== '' ? String(value) : null,
                    images: {}
                });
            }
            pushSelect('width_int', 'Finished Opening Width', op.width_int, firstEntry && firstEntry.querySelector('[data-porch-dimension="width-int"]'));
            pushSelect('width_frac', 'Finished Opening Width (fraction)', op.width_frac, firstEntry && firstEntry.querySelector('[data-porch-dimension="width-frac"]'));
            pushSelect('height_int', 'Finished Opening Height', op.height_int, firstEntry && firstEntry.querySelector('[data-porch-dimension="height-int"]'));
            pushSelect('height_frac', 'Finished Opening Height (fraction)', op.height_frac, firstEntry && firstEntry.querySelector('[data-porch-dimension="height-frac"]'));
            pushSelect('thickness', 'Panel Thickness', op.thickness, firstEntry && firstEntry.querySelector('[data-porch-dimension="thickness"]'));
            results.push({
                entry: {
                    id: 'panel_unit_enclosure_' + setNo + '_panels',
                    label: prefix + 'Panels per opening',
                    type: 'number',
                    _adminGroup: 'panel_unit',
                    _panelUnitEnclosure: setNo
                },
                current: op.panels != null && op.panels !== '' ? String(op.panels) : '1',
                images: {}
            });
            results.push({
                entry: {
                    id: 'panel_unit_enclosure_' + setNo + '_trim_system',
                    label: prefix + 'Add Trim System',
                    type: 'checkbox',
                    options: [{ value: 'true', label: 'Enable Trim System' }],
                    _adminGroup: 'panel_unit',
                    _panelUnitEnclosure: setNo
                },
                current: (op.trim_system === 'true' || op.trim_system === true) ? 'true' : 'false',
                images: {}
            });
            pushSelect('sill_depth', 'Sill Width', op.sill_depth, firstEntry && firstEntry.querySelector('[data-porch-sill="depth"]'));
            pushSelect('sill_frac', 'Sill Width (fraction)', op.sill_frac, firstEntry && firstEntry.querySelector('[data-porch-sill="depth-frac"]'));
            (op.doors || []).forEach(function (door) {
                if (!door) return;
                var d = parseInt(door.door_number, 10);
                if (!d) return;
                results.push({
                    entry: {
                        id: 'panel_unit_enclosure_' + setNo + '_door_' + d + '_active',
                        label: prefix + 'Door #' + d,
                        type: 'checkbox',
                        options: [{ value: 'true', label: 'Door #' + d }],
                        _adminGroup: 'panel_unit',
                        _panelUnitEnclosure: setNo
                    },
                    current: 'true',
                    images: {}
                });
                pushSelect('door_' + d + '_swing_direction', 'Door #' + d + ' Swing Direction', door.swing_direction, null, swingChoices);
                pushSelect('door_' + d + '_hinge_finish', 'Door #' + d + ' Hinge Finish', door.hinge_finish, null, hingeChoices);
                pushSelect('door_' + d + '_lockset_preparation', 'Door #' + d + ' Lockset Preparation', door.lockset_preparation, null, locksetChoices);
            });
        });
        return results;
    }
    // Dp end 17-08
    // Remove heavy showWhenProductTags data (option-level and choice-level) before
    // saving the schema to the DB. The admin never uses it and it bloats options_json.
    function stripShowWhenProductTags(schema) {
        if (!Array.isArray(schema)) return schema;
        return schema.map(function (opt) {
            if (!opt || typeof opt !== 'object') return opt;
            var clone = {};
            Object.keys(opt).forEach(function (k) {
                if (k === 'showWhenProductTags') return;
                var v = opt[k];
                if (k === 'options' && Array.isArray(v)) {
                    clone[k] = v.map(function (c) {
                        if (!c || typeof c !== 'object') return c;
                        var cc = {};
                        Object.keys(c).forEach(function (ck) {
                            if (ck === 'showWhenProductTags') return;
                            cc[ck] = c[ck];
                        });
                        return cc;
                    });
                } else {
                    clone[k] = v;
                }
            });
            return clone;
        });
    }

    function buildAdminEditableExtras() {
        var entries = [];
        var values = {};
        var images = {};
        function add(res) {
            if (!res || !res.entry) return;
            entries.push(res.entry);
            values[res.entry.id] = res.current;
            var canon = String(res.entry.id || '').toLowerCase().replace(/-/g, '_');
            if (canon && canon !== res.entry.id) {
                values[canon] = res.current;
            }
            if (res.images && Object.keys(res.images).length) images[res.entry.id] = res.images;
        }
        try { add(adminCaptureChoiceOption('door_location_exposure', 'radio')); } catch (e1) { }
        try { add(adminCaptureChoiceOption('panel_unit_design', 'radio')); } catch (e1b) { }
        try { add(adminCaptureBevel()); } catch (e2) { }
        try { add(adminCaptureChoiceOption('hinge_finish', 'radio')); } catch (e3) { }
        try { add(adminCaptureHardware()); } catch (e4) { }
        try { add(adminCaptureCasing()); } catch (e4c) { }
        try { adminCaptureMeasurementSelects().forEach(add); } catch (e5) { }
        try { adminCapturePanelUnitSets().forEach(add); } catch (e6) { }
        // Dp start 17-08
        try { adminCapturePanelUnitEnclosureOpenings().forEach(add); } catch (e7) { }
        // Dp end 17-08
        return { entries: entries, values: values, images: images };
    }

    var _touchedOptionIds = {};
    var _priceBeforeChange = null;
    var _optionPriceData = {};
    var _doorRestoreApplying = false;

    function markOptionTouched(optionId) {
        if (_doorRestoreApplying) return;
        if (optionId) {
            _priceBeforeChange = readDoorEstimatedPriceFromDom() || 0;
            _touchedOptionIds[optionId] = true;
            _touchedOptionIds.__lastTouched = optionId;
        }
    }

    function updateOptionRunningPriceLabels() {
        if (DOOR_SELECTION_LOG_ONLY) {
            try {
                all('.door-option-running-price').forEach(function (el) {
                    if (el && el.parentNode) el.parentNode.removeChild(el);
                });
            } catch (eHideRunningPrice) { }
            return;
        }
        var optionsContainer = document.getElementById('door-configurator-options');
        if (!optionsContainer) return;
        var currentTotal = readDoorEstimatedPriceFromDom() || 0;
        var lastTouched = _touchedOptionIds.__lastTouched || '';
        var prevTotal = _priceBeforeChange != null ? _priceBeforeChange : currentTotal;
        var delta = currentTotal - prevTotal;
        delta = Math.round(delta * 100) / 100;

        if (lastTouched) {
            _optionPriceData[lastTouched] = {
                prevTotal: prevTotal,
                delta: Math.abs(delta),
                totalAfter: currentTotal
            };
        }

        var allWraps = optionsContainer.querySelectorAll('.door-option-wrap[data-option-id]');
        for (var i = 0; i < allWraps.length; i++) {
            var wrap = allWraps[i];
            var optId = wrap.getAttribute('data-option-id') || '';
            if (!optId) continue;
            var priceId = 'door-running-price--' + optId;
            var priceEl = document.getElementById(priceId);

            if (!_touchedOptionIds[optId]) {
                if (priceEl) priceEl.style.display = 'none';
                continue;
            }

            var headerRow = wrap.querySelector(
                ':scope > .door-option-header-row,' +
                ':scope > .door-section-title,' +
                ':scope > .door-measurement-type-heading,' +
                ':scope > .door-accordion-header > .door-option-header-row,' +
                ':scope > .door-accordion-header,' +
                ':scope > button > .door-option-header-row'
            );
            if (!headerRow) continue;

            if (!priceEl) {
                priceEl = document.createElement('div');
                priceEl.id = priceId;
                priceEl.className = 'door-option-running-price';
                priceEl.style.cssText = 'font-weight:600;white-space:nowrap;padding-top:4px;';
                headerRow.insertAdjacentElement('afterend', priceEl);
            }
            priceEl.style.display = '';

            var data = _optionPriceData[optId];
            if (data) {
                priceEl.innerHTML =
                    '<span>' + formatMoney(data.prevTotal) + '</span>' +
                    ' + ' +
                    '<span>' + formatMoney(data.delta) + '</span>' +
                    ' = ' +
                    '<span style="font-weight:700;">' + formatMoney(data.totalAfter) + '</span>';
            } else {
                priceEl.innerHTML =
                    '<span style="font-weight:700;">' + formatMoney(currentTotal) + '</span>';
            }
        }
    }

    (function observeEstimatedPriceChanges() {
        try {
            var priceNode = document.getElementById('door-estimated-price');
            if (!priceNode || typeof MutationObserver === 'undefined') return;
            var debounceTimer = null;
            var observer = new MutationObserver(function () {
                if (debounceTimer) clearTimeout(debounceTimer);
                debounceTimer = setTimeout(function () {
                    try { updateOptionRunningPriceLabels(); } catch (e) { }
                    try { syncMeasurementSelectedPriceLabels(null); } catch (eMeas) { }
                }, 80);
            });
            observer.observe(priceNode, { childList: true, characterData: true, subtree: true });
        } catch (e) { }
    })();

    // -----------------------------
    // Door preview (single image / layered preview)
    // -----------------------------
    var DOOR_PREVIEW_TEMP_IMAGES = {
        door_unit_design: {
            single_door: 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/Single_Door.png?v=1775814017',
            double_door: 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/Single_Door.png?v=1775814017'
        },
        transom_style: {
            __any__: 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/image_85.png?v=1775814017'
        },
        sidelight_location: {
            __any__: 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/image_84.png?v=1775814017'
        }
    };

    var DOOR_PREVIEW_STATIC_OVERLAYS = {
        sidelight: 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/image_84.png?v=1775814017',
        transom: 'https://cdn.shopify.com/s/files/1/0784/9059/9679/files/image_85.png?v=1775814017'
    };

    function getChoiceByValue(optId, selectedValue) {
        if (!doorConfigSchema || !Array.isArray(doorConfigSchema)) return null;
        var opt = doorConfigSchema.find(function (o) { return o && String(o.id || '') === String(optId || ''); });
        if (!opt || !Array.isArray(opt.options)) return null;
        var v = selectedValue != null ? String(selectedValue) : '';
        if (!v) return null;
        return opt.options.find(function (c) { return String(c && c.value != null ? c.value : '') === v; }) || null;
    }

    function getProductBasePrice() {
        try {
            var container = document.getElementById('door-configurator');
            if (!container) return 0;
            var n = parseFloat(container.getAttribute('data-base-price'));
            return isNaN(n) ? 0 : n;
        } catch (e) { }
        return 0;
    }

    function getSelectedWoodTypePriceValue() {
        try {
            var config = getCurrentConfig();
            var selected = config ? config.wood_type : null;
            var choice = getChoiceByValue('wood_type', selected);
            if (!choice) {
                var root = document.getElementById('door-configurator-options') || document;
                var checked = root.querySelector('input[type="radio"][data-option-id="wood_type"]:checked');
                if (!checked) checked = root.querySelector('input[type="radio"][name="attributes[Select Wood]"]:checked');
                if (checked) choice = getChoiceByValue('wood_type', checked.value);
            }
            if (!choice) return 0;
            var n = parseFloat(choice.priceValue != null ? choice.priceValue : choice.price_value);
            return isNaN(n) ? 0 : n;
        } catch (e) { }
        return 0;
    }

    try {
        window.DoorConfiguratorPricing = window.DoorConfiguratorPricing || {};
        window.DoorConfiguratorPricing.getProductBasePrice = getProductBasePrice;
        window.DoorConfiguratorPricing.getSelectedWoodTypePriceValue = getSelectedWoodTypePriceValue;
    } catch (eExposePricing) { }

    function resolveDoorPreviewLayerSrc(choice, optId) {
        var fromChoice = resolveChoiceImageSrc(choice);
        if (fromChoice) return fromChoice;
        try {
            var map = DOOR_PREVIEW_TEMP_IMAGES && optId ? DOOR_PREVIEW_TEMP_IMAGES[String(optId)] : null;
            if (!map || !choice) return '';
            var v = String(choice.value || '');
            if (map[v]) return String(map[v]);
            if (map.__any__) return String(map.__any__);
            return '';
        } catch (e) { }
        return '';
    }

    function setLayerImage(imgEl, src) {
        if (!imgEl) return;
        var s = String(src || '').trim();
        if (!s) {
            imgEl.hidden = true;
            imgEl.removeAttribute('src');
            return;
        }
        imgEl.hidden = false;
        if (imgEl.getAttribute('src') !== s) imgEl.setAttribute('src', s);
    }

    function updateDoorPreview() {

        try {
            if (window && window.__doorPreviewConfigModeAttached) return;
        } catch (eCfgMode) { }

        var container = document.getElementById('door-configurator');
        if (!container) return;
        var media = document.getElementById('door-config-media');
        if (!media) return;

        var config = getCurrentConfig();

        var door1 = document.getElementById('door-preview-door-1');
        var door2 = document.getElementById('door-preview-door-2');
        var transom1 = document.getElementById('door-preview-transom-1');
        var transom2 = document.getElementById('door-preview-transom-2');
        var sidelightLeft = document.getElementById('door-preview-sidelight-left');
        var sidelightRight = document.getElementById('door-preview-sidelight-right');
        var wood1 = document.getElementById('door-preview-wood-1');
        var wood2 = document.getElementById('door-preview-wood-2');

        function getSelectedCardImageSrc(optionId) {
            try {
                var root = document.getElementById('door-configurator-options') || container;
                if (!root) return '';
                var checked = root.querySelector('input[type="radio"][data-option-id="' + String(optionId) + '"]:checked');
                if (!checked || !checked.closest) return '';
                var card = checked.closest('label.common-check-option');
                if (!card) return '';
                var img = card.querySelector('img.common-check-option-image');
                return img && img.getAttribute('src') ? String(img.getAttribute('src')) : '';
            } catch (e) { }
            return '';
        }

        function getDoorCount() {
            var v = String(config.door_unit_design || '').trim();
            if (v === 'double_door') return 2;
            return 1;
        }
        var doorCount = getDoorCount();
        console.log("doorCount", doorCount);
        try { media.setAttribute('data-door-count', String(doorCount)); } catch (eDoorCount) { }

        var doorChoice = getChoiceByValue('door_unit_design', config.door_unit_design) || { value: String(config.door_unit_design || 'single_door') };
        var doorSrc =
            getSelectedCardImageSrc('door_unit_design')
            || resolveDoorPreviewLayerSrc(doorChoice, 'door_unit_design');
        console.log("doorSrc", doorSrc);
        if (doorSrc) {
            if (door1 && door1.getAttribute('src') !== doorSrc) door1.setAttribute('src', doorSrc);
            if (door2 && door2.getAttribute('src') !== doorSrc) door2.setAttribute('src', doorSrc);
        }
        if (door2) door2.hidden = doorCount !== 2;

        var hasSidelight = false;
        try {
            hasSidelight = !!(config.sidelight_location || config.sidelight_style);
        } catch (e2) { }

        var sidelightSrc = '';
        if (hasSidelight) {
            // Prefer the selected sidelight style's image URL (from schema choice image/image_url),
            // but fall back to the legacy static overlay if none is provided.
            var sidelightStyleChoice = getChoiceByValue('sidelight_style', config.sidelight_style)
                || (config.sidelight_style != null && String(config.sidelight_style).trim()
                    ? { value: String(config.sidelight_style) }
                    : null);
            sidelightSrc =
                resolveDoorPreviewLayerSrc(sidelightStyleChoice, 'sidelight_style')
                || DOOR_PREVIEW_STATIC_OVERLAYS.sidelight
                || '';
        }

        var locVal = String(config.sidelight_location || '');
        var showLeft = hasSidelight && (locVal === 'left_only' || locVal === 'both_sides');
        var showRight = hasSidelight && (locVal === 'right_only' || locVal === 'both_sides');
        setLayerImage(sidelightLeft, showLeft ? sidelightSrc : '');
        setLayerImage(sidelightRight, showRight ? sidelightSrc : '');

        var hasTransom = false;
        try {
            hasTransom = !!config.transom_style;
        } catch (e3) { }
        if (hasTransom) {
            var transomStyleChoice = getChoiceByValue('transom_style', config.transom_style)
                || (config.transom_style != null && String(config.transom_style).trim()
                    ? { value: String(config.transom_style) }
                    : null);
            var transomSrc =
                resolveDoorPreviewLayerSrc(transomStyleChoice, 'transom_style')
                || DOOR_PREVIEW_STATIC_OVERLAYS.transom
                || '';
            setLayerImage(transom1, transomSrc);
            setLayerImage(transom2, doorCount === 2 ? transomSrc : '');
        } else {
            setLayerImage(transom1, '');
            setLayerImage(transom2, '');
        }

        var woodChoice = getChoiceByValue('wood_type', config.wood_type);
        var woodSrc = resolveDoorPreviewLayerSrc(woodChoice || { value: String(config.wood_type || '') }, 'wood_type');
        setLayerImage(wood1, woodSrc);
        setLayerImage(wood2, doorCount === 2 ? woodSrc : '');
    }

    var estimatedPriceRafId = null;

    var doorHubspot = null;

    /** Door unit qty (not hardware card qty). */
    function getDoorQuantityInput() {
        if (doorHubspot && doorHubspot.getDoorQuantityInput) return doorHubspot.getDoorQuantityInput();
        var byId = document.getElementById('door-config-quantity');
        if (byId) return byId;
        var container = document.getElementById('door-configurator');
        if (!container) return null;
        return container.querySelector('.door-add-to-cart-wrap input[name="quantity"]');
    }

    function getDoorQuantity() {
        if (doorHubspot && doorHubspot.getDoorQuantity) return doorHubspot.getDoorQuantity();
        var qtyInput = getDoorQuantityInput();
        if (qtyInput) {
            var qtyVal = parseInt(qtyInput.value, 10);
            if (!isNaN(qtyVal) && qtyVal >= 1) return qtyVal;
        }
        try {
            var config = getCurrentConfig();
            if (config && config._quantity != null) {
                var stored = parseInt(config._quantity, 10);
                if (!isNaN(stored) && stored >= 1) return stored;
            }
        } catch (eQty) { }
        return 1;
    }

    function logSelectedOptionsWithQty() {
        try {
            var config = getCurrentConfig();
            var qty = getDoorQuantity();
            window.__doorSelectionSnapshot = { quantity: qty, selections: config };
        } catch (eLogSel) { }
    }

    function updateEstimatedPrice() {
        if (window.__doorStileSyncInProgress || window.__doorStileApplyBusy) return;
        if (estimatedPriceRafId != null) return;
        var schedule =
            typeof requestAnimationFrame === 'function'
                ? requestAnimationFrame
                : function (fn) { return setTimeout(fn, 0); };
        estimatedPriceRafId = schedule(function () {
            estimatedPriceRafId = null;
            if (window.__doorStileSyncInProgress || window.__doorStileApplyBusy) return;
            var container = document.getElementById('door-configurator');
            if (!container) return;
            if (DOOR_SELECTION_LOG_ONLY) {
                logSelectedOptionsWithQty();
                runMeasurementUiSync();
                return;
            }
            var basePriceAttr = container.getAttribute('data-base-price');
            if (!basePriceAttr) return;
            var basePrice = parseFloat(basePriceAttr);
            if (isNaN(basePrice)) return;

            var config = getCurrentConfig();
            var result = calculateDoorPrice(basePrice, config);
            var schemaTotal = result.price;
            window.__doorThemeOptionTotal = schemaTotal;
            if (
                window.DoorIntExtPricingRule
                && typeof window.DoorIntExtPricingRule.syncEstimatedPriceDisplay === 'function'
            ) {
                var screenStormLayer = 0;
                try {
                    if (
                        window.PriceScreenStorm
                        && typeof window.PriceScreenStorm.syncScreenStormAddonGateState === 'function'
                    ) {
                        window.PriceScreenStorm.syncScreenStormAddonGateState();
                    }
                    if (typeof window.DoorIntExtPricingRule.getScreenStormAddonLayerTotal === 'function') {
                        screenStormLayer = window.DoorIntExtPricingRule.getScreenStormAddonLayerTotal();
                    } else if (window.PriceScreenStorm && typeof window.PriceScreenStorm.getScreenStormAddonTotalSum === 'function') {
                        screenStormLayer = window.PriceScreenStorm.getScreenStormAddonTotalSum();
                    }
                } catch (eSsLayer) { }
                var hasScreenStormLayer = screenStormLayer > 0.01;
                window.DoorIntExtPricingRule.syncEstimatedPriceDisplay({
                    source: 'updateEstimatedPrice',
                    silent: !hasScreenStormLayer,
                    userAction: hasScreenStormLayer,
                    forceLog: hasScreenStormLayer,
                    doorSealKitMatching: parseFloat(window['__doorAddon_door_seal_kit_matching'] || 0) || 0,
                    doorSweepsMatching: parseFloat(window['__doorAddon_door_sweeps_matching'] || 0) || 0,
                    primingServices: parseFloat(window['__doorAddon_priming_services'] || 0) || 0
                });
                if (hasScreenStormLayer && window.PriceScreenStorm && typeof window.PriceScreenStorm.ensureScreenStormPriceAppliedToDom === 'function') {
                    setTimeout(function () {
                        try { window.PriceScreenStorm.ensureScreenStormPriceAppliedToDom({ source: 'updateEstimatedPrice_followup' }); } catch (eSsEnsure) { }
                    }, 120);
                }
            } else {
                var layered =
                    schemaTotal
                    + (parseFloat(window['__doorAddon_storm_glass'] || 0) || 0)
                    + (parseFloat(window['__doorAddon_stile_and_rail_profile'] || 0) || 0);
                writeDoorEstimatedPriceFromConf2(layered, { source: 'updateEstimatedPrice', silent: true });
            }
            try {
                document.dispatchEvent(new CustomEvent('door-configurator-price-updated', {
                    detail: {
                        themeOptionTotal: schemaTotal,
                        doorSealKitMatching: parseFloat(window['__doorAddon_door_seal_kit_matching'] || 0) || 0,
                        doorSweepsMatching: parseFloat(window['__doorAddon_door_sweeps_matching'] || 0) || 0,
                        primingServices: parseFloat(window['__doorAddon_priming_services'] || 0) || 0
                    }
                }));
            } catch (ePriceEvt) { }
            ensureDoorPriceBoxVisible();
            runMeasurementUiSync();
            updateOptionRunningPriceLabels();
        });
    }

    // Add-to-cart: delegated on document so the button works even if #door-configurator is not in DOM at DOMContentLoaded.
    function bindAddToCart() {
        document.addEventListener('click', function (e) {
            var btn = e.target && (e.target.id === 'door-add-to-cart-btn' ? e.target : (e.target.closest && e.target.closest('#door-add-to-cart-btn')));
            if (!btn) return;
            e.preventDefault();
            e.stopPropagation();
            var container = document.getElementById('door-configurator');
            var addToCartMessageEl = document.getElementById('door-add-to-cart-message');
            if (!container) return;

            var basePrice = parseFloat(container.getAttribute('data-base-price')) || 0;
            var variantId = container.getAttribute('data-variant-id') || '';
            var config = getCurrentConfig();

            if (!variantId) {
                if (addToCartMessageEl) {
                    addToCartMessageEl.style.display = 'block';
                    addToCartMessageEl.textContent = 'This product is not available to add to cart.';
                    addToCartMessageEl.style.color = '#b91c1c';
                }
                return;
            }

            var priceResult = calculateDoorPrice(basePrice, config);
            var configuredPrice = (priceResult && typeof priceResult.price === 'number') ? priceResult.price : basePrice;
            if (
                window.DoorIntExtPricingRule
                && typeof window.DoorIntExtPricingRule.getDoorAddonTotalSum === 'function'
            ) {
                configuredPrice =
                    (parseFloat(window.__doorThemeOptionTotal) || configuredPrice)
                    + window.DoorIntExtPricingRule.getDoorAddonTotalSum();
            } else {
                configuredPrice +=
                    (parseFloat(window['__doorAddon_storm_glass'] || 0) || 0)
                    + (parseFloat(window['__doorAddon_stile_and_rail_profile'] || 0) || 0);
            }
            var configuredPriceStr = configuredPrice.toFixed(2);

            var props = getLineItemPropertiesFromSchema();
            var properties = { _configured_price: configuredPriceStr };
            Object.keys(props).forEach(function (k) {
                if (k && props[k] != null) properties[k] = String(props[k]);
            });

            btn.disabled = true;
            if (addToCartMessageEl) {
                addToCartMessageEl.style.display = 'block';
                addToCartMessageEl.textContent = 'Adding to cart…';
                addToCartMessageEl.style.color = '';
            }

            var storefrontUrl = container.getAttribute('data-storefront-api-url');
            var storefrontToken = container.getAttribute('data-storefront-access-token');
            var useStorefront = storefrontUrl && storefrontToken;

            function onError(msg) {
                btn.disabled = false;
                if (addToCartMessageEl) {
                    addToCartMessageEl.textContent = msg || 'Could not add to cart. Try again.';
                    addToCartMessageEl.style.color = '#b91c1c';
                }
            }

            if (useStorefront) {
                var attributes = [];
                Object.keys(properties).forEach(function (k) {
                    attributes.push({ key: k, value: properties[k] });
                });
                var merchandiseId = variantId.indexOf('gid://') === 0 ? variantId : ('gid://shopify/ProductVariant/' + variantId);
                var cartCreateMutation = 'mutation CartCreate($input: CartInput!) { cartCreate(input: $input) { cart { id checkoutUrl } userErrors { field message } } }';
                var variables = {
                    input: {
                        lines: [
                            { merchandiseId: merchandiseId, quantity: 1, attributes: attributes }
                        ]
                    }
                };
                fetch(storefrontUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': storefrontToken
                    },
                    body: JSON.stringify({ query: cartCreateMutation, variables: variables })
                })
                    .then(function (res) { return res.json(); })
                    .then(function (data) {
                        var payload = data.data && data.data.cartCreate;
                        var errs = (payload && payload.userErrors) || [];
                        if (payload && payload.cart && payload.cart.checkoutUrl && errs.length === 0) {
                            if (addToCartMessageEl) {
                                addToCartMessageEl.textContent = 'Redirecting to cart…';
                                addToCartMessageEl.style.color = '';
                            }
                            window.location.href = payload.cart.checkoutUrl;
                            return;
                        }
                        var errMsg = errs.length ? errs.map(function (e) { return e.message; }).join('; ') : (data.errors && data.errors[0] && data.errors[0].message) || 'Could not add to cart.';
                        onError(errMsg);
                    })
                    .catch(function () { onError(); });
            } else {
                var numericVariantId = variantId.replace(/\D/g, '') || variantId;
                var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
                fetch(root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [{
                            id: parseInt(numericVariantId, 10) || numericVariantId,
                            quantity: 1,
                            properties: properties
                        }]
                    })
                })
                    .then(function (res) { return res.json(); })
                    .then(function (data) {
                        if (data.items && data.items.length > 0) {
                            if (addToCartMessageEl) {
                                addToCartMessageEl.textContent = 'Added to cart.';
                                addToCartMessageEl.style.color = '';
                            }
                            window.location.href = root + (root === '/' ? 'cart' : 'cart');
                        } else {
                            onError(data.description || data.message || 'Could not add to cart.');
                        }
                    })
                    .catch(function () { onError(); });
            }
        });
    }

    function attachEvents() {
        var container = document.getElementById('door-configurator');
        if (!container) return;

        try {
            var cfgMatch = String((window.location && window.location.search) || '').match(/[?&]config_id=(\d+)/);
            if (cfgMatch && cfgMatch[1]) {
                container.setAttribute('data-edit-config-id', cfgMatch[1]);
            }
        } catch (eEarlyCfg) { }

        doorConf2MeasurementsInit();

        if (!DOOR_SELECTION_LOG_ONLY) {
            bindStileAndRailProfileAdditivePricing();
        }

        // Open the theme's "How To Measure" drawer from our inline measurement help button.
        container.addEventListener('door-measurement-help', function () {
            openMeasureGuideDrawer();
        }, true);

        // If the customer is logged in and returned from login (?autosave=1), just make sure the note is visible.
        // Do NOT remove/query the selected value, or clean the query string.
        var returnedNote = document.getElementById('door-returned-from-login-note');
        if (returnedNote && typeof window.location !== 'undefined' && window.location.search && window.location.search.indexOf('autosave=1') !== -1) {
            returnedNote.style.display = '';
            // Leave the query string and state alone so user can see their context.
            // Just surface the note so customer knows to select a collection (no need to fill all details again).
        }

        // Guard: some environments polyfill/override `location.search` unexpectedly.
        var locSearch = '';
        try { locSearch = String((window.location && window.location.search) || ''); } catch (eLoc) { locSearch = ''; }
        if (returnedNote && locSearch.indexOf('autosave=1') !== -1) {
            // Scroll the note into view after making it visible
            setTimeout(function () {
                returnedNote.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 200);
        }

        var schemaEl = document.getElementById('door-configurator-schema');
        var optionsContainer = document.getElementById('door-configurator-options');
        if (schemaEl && optionsContainer) {
            try {
                var schemaText = (schemaEl.textContent || '').trim();
                if (!schemaText) {
                    if (productIsPorchPanelProduct()) {
                        optionsContainer.innerHTML = '';
                        appendStaticPanelUnitDesignSection(optionsContainer);
                        initializePanelUnitDesignSections(optionsContainer, []);
                        bindDynamicOptionsEvents(optionsContainer);
                        updateDoorPreview();
                    } else {
                        optionsContainer.innerHTML = '<p class="door-options-error" style="padding:1rem;color:#6b7280;">No options schema found.</p>';
                    }
                    return;
                }
                var raw = JSON.parse(schemaText);
                var schema = typeof raw === 'string' ? JSON.parse(raw) : raw;
                if (Array.isArray(schema)) {
                    schema = schema.filter(function (opt) {
                        if (!opt || opt.id == null) return true;
                        var id = String(opt.id).toLowerCase().replace(/-/g, '_').replace(/\s+/g, '_');
                        return id !== 'entrance_unit_sidelight'
                            && id !== 'entrance_unit_transoms'
                            && id !== 'entrance_unit_transom'
                            && id !== 'no_slab';
                    });
                }
                if (!Array.isArray(schema) || !schema.length) {
                    if (productIsPorchPanelProduct()) {
                        optionsContainer.innerHTML = '';
                        appendStaticPanelUnitDesignSection(optionsContainer);
                        initializePanelUnitDesignSections(optionsContainer, []);
                        bindDynamicOptionsEvents(optionsContainer);
                        updateDoorPreview();
                    } else {
                        optionsContainer.innerHTML = '<p class="door-options-error" style="padding:1rem;color:#6b7280;">No options to display.</p>';
                    }
                    return;
                }
                renderDynamicOptions(schema, optionsContainer);
                applyHideWhen(schema, optionsContainer);
                applyChoiceVisibility(schema, optionsContainer);
                applyProductTagChoiceVisibility(schema, optionsContainer);
                try {
                    if (
                        window.DoorConf2Measurements
                        && typeof window.DoorConf2Measurements.syncNoSlabDoorSetupVisibility === 'function'
                    ) {
                        window.DoorConf2Measurements.syncNoSlabDoorSetupVisibility(schema, optionsContainer);
                    }
                } catch (eNoSlabRender) { }
                syncPanelProfileHero(optionsContainer);
                syncMeasurementTypeSectionPreHungGate(schema, optionsContainer);
                syncHingeFinishVisibility(schema, optionsContainer);
                syncLocksetPrepVisibility(schema, optionsContainer);
                try { applyLocksetPrepNoneDefault(optionsContainer); } catch (eLocksetSchemaLoad) { }
                syncMeasurementTabCardVisibility(optionsContainer, schema);
                syncMeasurementTypeDetailsVisibility(optionsContainer, schema);
                syncSlabSidelightMeasurementUI(optionsContainer, schema);
                if (!doorRestorePending()) {
                    applyStaticMeasurementDimensionDefaults(optionsContainer);
                }
                bindDynamicOptionsEvents(optionsContainer);
                updateDoorPreview();
                function clearAllDefaultSelections() {
                    optionsContainer.querySelectorAll('input[type="radio"]').forEach(function (r) {
                        if (isPanelUnitDesignSectionEl(r)) return;
                        var oid = r.getAttribute ? String(r.getAttribute('data-option-id') || '') : '';
                        if (normalizeOptionIdKey(oid) === 'lockset_prep') return;
                        r.checked = false;
                    });
                    optionsContainer.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
                        if (isPanelUnitDesignSectionEl(cb)) return;
                        cb.checked = false;
                    });
                    optionsContainer.querySelectorAll('.common-check-option--selected').forEach(function (c) {
                        if (isPanelUnitDesignSectionEl(c)) return;
                        if (c.querySelector && c.querySelector('input[type="radio"][data-option-id="lockset_prep"]')) return;
                        c.classList.remove('common-check-option--selected');
                    });
                    optionsContainer.querySelectorAll('select[data-option-id]').forEach(function (sel) {
                        var unit = sel.getAttribute ? String(sel.getAttribute('data-unit') || '') : '';
                        if (unit === 'in-int' || unit === 'in-frac') return;
                        if (sel.getAttribute && sel.getAttribute('data-door-user-changed') === '1') return;
                        var sid = String(sel.id || '').toLowerCase();
                        if (
                            sid === 'exact-door-thickness-frac'
                            || sid.indexOf('exact-door-thickness-frac') === 0
                            || sid === 'door-thickness'
                        ) return;
                        // Keep Door Sweep / Door Stops on their "No …" defaults (no empty placeholder).
                        var oid = sel.getAttribute ? String(sel.getAttribute('data-option-id') || '') : '';
                        if (optionWantsNoneAsDefaultSelect(oid)) return;
                        sel.value = '';
                    });
                    try { applyAdditionalOptionsNoneDefaults(optionsContainer); } catch (eAddlNoneClear) { }
                    try { syncLocksetPrepVisibility(doorConfigSchema, optionsContainer); } catch (eLocksetVisAfterClear) { }
                    try { applyLocksetPrepNoneDefault(optionsContainer); } catch (eLocksetAfterClear) { }
                    syncSidelightTransomAccordionHeaderUi(optionsContainer);
                }
                // After login (?autosave=1), restored selections must not be cleared by theme
                // default-reset timers (options like shelf often have no collection default).
                if (!doorRestorePending()) {
                    clearAllDefaultSelections();
                    applyStaticMeasurementDimensionDefaults(optionsContainer);
                    setTimeout(clearAllDefaultSelections, 0);
                    setTimeout(function () { applyStaticMeasurementDimensionDefaults(optionsContainer); }, 0);
                    setTimeout(clearAllDefaultSelections, 100);
                    setTimeout(function () { applyStaticMeasurementDimensionDefaults(optionsContainer); }, 100);
                    setTimeout(clearAllDefaultSelections, 300);
                    setTimeout(function () {
                        applyStaticMeasurementDimensionDefaults(optionsContainer);
                        applySidelightTransomMeasurementTypeDefaultSelection(optionsContainer, true);
                        try { applyAdditionalOptionsNoneDefaults(optionsContainer); } catch (eAddlNone300) { }
                        try { syncLocksetPrepVisibility(doorConfigSchema, optionsContainer); } catch (eLocksetVis300) { }
                        try { applyLocksetPrepNoneDefault(optionsContainer); } catch (eLockset300) { }
                    }, 300);
                    // ===== DEFAULT OPTIONS (custom.configurator_defaults metafield) - START =====
                    setTimeout(function () {
                        applyCollectionDefaultSelections(optionsContainer);
                        try { applyAdditionalOptionsNoneDefaults(optionsContainer); } catch (eAddlNone350) { }
                        // --- Dp start 16-07  ---
                        applyScreenAndStormInsertsDefaultSelection(optionsContainer);
                        // --- Dp end 16-07  ---
                        // Dp merge code 10-09 start
                        try { applyDoorLocationExposureDefaultSelection(optionsContainer); } catch (eExpDef350) { }
                        // Dp merge code 10-09 end
                        applySidelightTransomMeasurementTypeDefaultSelection(optionsContainer);
                        applyShelfDefaultFromConfiguratorDefaults(optionsContainer);
                        try { syncLocksetPrepVisibility(doorConfigSchema, optionsContainer); } catch (eLocksetVis350) { }
                        try { applyLocksetPrepNoneDefault(optionsContainer); } catch (eLockset350) { }
                        try { promoteSelectedProfileToHero(optionsContainer, { collapseAccordion: false }); } catch (eHeroDef350) { }
                        applyStaticMeasurementDimensionDefaults(optionsContainer);
                        if (
                            window.DoorIntExtPricingRule
                            && typeof window.DoorIntExtPricingRule.refreshGeneralIntExtOversizedFromDomIfReady === 'function'
                        ) {
                            window.DoorIntExtPricingRule.refreshGeneralIntExtOversizedFromDomIfReady(null);
                        }
                    }, 350);
                    setTimeout(function () {
                        applyCollectionDefaultSelections(optionsContainer);
                        try { applyAdditionalOptionsNoneDefaults(optionsContainer); } catch (eAddlNone600) { }
                        // --- Dp start 16-07  ---
                        applyScreenAndStormInsertsDefaultSelection(optionsContainer);
                        // --- Dp end 16-07  ---
                        // Dp merge code 10-09 start
                        try { applyDoorLocationExposureDefaultSelection(optionsContainer); } catch (eExpDef350) { }
                        // Dp merge code 10-09 end
                        applySidelightTransomMeasurementTypeDefaultSelection(optionsContainer);
                        applyShelfDefaultFromConfiguratorDefaults(optionsContainer);
                        try { syncLocksetPrepVisibility(doorConfigSchema, optionsContainer); } catch (eLocksetVis600) { }
                        try { applyLocksetPrepNoneDefault(optionsContainer); } catch (eLockset600) { }
                        try { promoteSelectedProfileToHero(optionsContainer, { collapseAccordion: false }); } catch (eHeroDef600) { }
                        applyStaticMeasurementDimensionDefaults(optionsContainer);
                        if (
                            window.DoorIntExtPricingRule
                            && typeof window.DoorIntExtPricingRule.refreshGeneralIntExtOversizedFromDomIfReady === 'function'
                        ) {
                            window.DoorIntExtPricingRule.refreshGeneralIntExtOversizedFromDomIfReady(null);
                        }
                    }, 600);
                    setTimeout(function () {
                        pulseDependentVisibilityFromDefaults(optionsContainer);
                        // --- Dp start 16-07  ---
                        applyScreenAndStormInsertsDefaultSelection(optionsContainer);
                        // --- Dp end 16-07  ---
                        // Dp merge code 10-09 start
                        try { applyDoorLocationExposureDefaultSelection(optionsContainer); } catch (eExpDef350) { }
                        // Dp merge code 10-09 end
                        applySidelightTransomMeasurementTypeDefaultSelection(optionsContainer);
                        applyShelfDefaultFromConfiguratorDefaults(optionsContainer);
                        try { syncLocksetPrepVisibility(doorConfigSchema, optionsContainer); } catch (eLocksetVis800) { }
                        try { applyLocksetPrepNoneDefault(optionsContainer); } catch (eLockset800) { }
                        try { promoteSelectedProfileToHero(optionsContainer, { collapseAccordion: false }); } catch (eHeroDef800) { }
                    }, 800);
                    setTimeout(function () { applyStaticMeasurementDimensionDefaults(optionsContainer); }, 850);
                    setTimeout(function () {
                        applyStaticMeasurementDimensionDefaults(optionsContainer);
                        // --- Dp start 16-07  ---
                        applyScreenAndStormInsertsDefaultSelection(optionsContainer);
                        // --- Dp end 16-07  ---
                        // Dp merge code 10-09 start
                        try { applyDoorLocationExposureDefaultSelection(optionsContainer); } catch (eExpDef350) { }
                        // Dp merge code 10-09 end
                        applySidelightTransomMeasurementTypeDefaultSelection(optionsContainer);
                        applyShelfDefaultFromConfiguratorDefaults(optionsContainer);
                        try { syncLocksetPrepVisibility(doorConfigSchema, optionsContainer); } catch (eLocksetVis1500) { }
                        try { applyLocksetPrepNoneDefault(optionsContainer); } catch (eLockset1500) { }
                    }, 1500);
                    // ===== DEFAULT OPTIONS (custom.configurator_defaults metafield) - END =====
                } else {
                    _collectionDefaultsApplied = true;
                }
                if (productIsPorchPanelProduct()) {
                    setTimeout(function () {
                        try {
                            if (!schemaIncludesPanelUnitDesignOption(schema) && !panelUnitDesignSectionExists(document.getElementById('door-configurator'))) {
                                appendStaticPanelUnitDesignSection(optionsContainer);
                            }
                            initializePanelUnitDesignSections(optionsContainer, schema);
                        } catch (ePorchPanelReinit) { }
                    }, 50);
                }
            } catch (e) {
                optionsContainer.innerHTML = '<p class="door-options-error" style="padding:1rem;color:#b91c1c;font-size:0.9rem;">Could not load options. Please refresh the page. If this continues, check the browser console (F12) for details.</p>';
                if (typeof console !== 'undefined' && console.error) console.error('Door configurator schema error:', e);
            }
        } else {
            try {
                initializePanelUnitDesignSections(optionsContainer, doorConfigSchema || []);
            } catch (ePanelUnitBoot) { }
        }
        bindDelegatedPriceUpdate();
        try { window.__doorUpdateEstimatedPrice = updateEstimatedPrice; } catch (eExposePrice) { }
        try {
            initializePanelUnitDesignSections(
                document.getElementById('door-configurator-options'),
                doorConfigSchema || []
            );
        } catch (ePanelUnitFinalInit) { }

        if (DOOR_SELECTION_LOG_ONLY) {
            if (container) container.classList.add('door-configurator--log-only');
            var qtyInputLog = getDoorQuantityInput();
            if (qtyInputLog) {
                qtyInputLog.addEventListener('change', function () {
                    logSelectedOptionsWithQty();
                });
            }
            var addToCartBtnLog = document.getElementById('door-add-to-cart-btn');
            if (addToCartBtnLog) addToCartBtnLog.style.display = 'none';
            var priceBoxLog = document.querySelector('.door-price-box');
            if (priceBoxLog) priceBoxLog.style.display = 'none';
            logSelectedOptionsWithQty();
        } else {
            if (container) container.classList.remove('door-configurator--log-only');
            ensureDoorPriceBoxVisible();
            try { updateEstimatedPrice(); } catch (eInitPrice) { }
        }

        var apiBase = 'https://api.vintagedoors.com';
        var folderSelect = document.getElementById('door-save-folder');
        var newFolderInput = document.getElementById('door-new-folder-name');
        var quotePageUrl = '/pages/request-a-quote';

        function buildDoorConfigForStorage(container) {
            try {
                if (!container) container = document.getElementById('door-configurator');
                if (!container) return null;
                var basePriceAttr = container.getAttribute('data-base-price');
                var productId = container.getAttribute('data-product-id');
                var productName = container.getAttribute('data-product-name') || '';
                var productImage = container.getAttribute('data-product-image') || '';
                var productHandle = container.getAttribute('data-product-handle') || '';
                var variantId = container.getAttribute('data-variant-id') || '';
                var productSku = (container.getAttribute('data-product-sku') || '').trim();
                var basePrice = parseFloat(basePriceAttr) || 0;
                var config = typeof getCurrentConfig === 'function' ? (getCurrentConfig() || {}) : {};
                var selectedOptionImages = {};
                var selectedSummary = [];
                var qtySave = 1;
                try { qtySave = getDoorQuantity(); } catch (eQty) { qtySave = 1; }
                try { selectedOptionImages = buildSelectedOptionImageMap(config, doorConfigSchema) || {}; } catch (eImg) { }
                try { selectedSummary = buildSelectedSummaryForStorage(config, doorConfigSchema) || []; } catch (eSum) { }
                var adminExtras = { entries: [], values: {}, images: {} };
                try { adminExtras = buildAdminEditableExtras() || adminExtras; } catch (eEx) { }
                var extraIds = {};
                (adminExtras.entries || []).forEach(function (e) { extraIds[String(e.id)] = true; });
                var baseSchema = Array.isArray(doorConfigSchema) ? doorConfigSchema.slice() : [];
                var mergedSchema = (adminExtras.entries || []).concat(
                    baseSchema.filter(function (o) { return !(o && extraIds[String(o.id)]); })
                );
                try { mergedSchema = stripShowWhenProductTags(mergedSchema); } catch (eStrip) { }
                if ((!mergedSchema || !mergedSchema.length) && document.querySelector('[data-landing-hardware-config="1"]')) {
                    mergedSchema = [{ id: 'hardware_options', label: 'Hardware', type: 'hardware_multi' }];
                }
                var configWithExtras = Object.assign({}, config, adminExtras.values || {});
                Object.keys(adminExtras.images || {}).forEach(function (oid) {
                    selectedOptionImages[oid] = Object.assign({}, selectedOptionImages[oid] || {}, adminExtras.images[oid]);
                });
                var priceSnapshot = {};
                try { priceSnapshot = buildDoorPriceSnapshotForStorage(configWithExtras, basePrice) || {}; } catch (ePrice) { }
                var productTagsForStorage = [];
                try {
                    var tagsAttrSave = container.getAttribute('data-product-tags') || '';
                    if (tagsAttrSave.trim()) {
                        var parsedTagsSave = JSON.parse(tagsAttrSave);
                        if (Array.isArray(parsedTagsSave)) {
                            productTagsForStorage = parsedTagsSave.map(normProductTagSlug).filter(Boolean);
                        }
                    }
                } catch (eTagsSave) {
                    productTagsForStorage = String(container.getAttribute('data-product-tags') || '')
                        .split(/[|,]/)
                        .map(normProductTagSlug)
                        .filter(Boolean);
                }
                if (!productTagsForStorage.length && Array.isArray(config._product_tags)) {
                    productTagsForStorage = config._product_tags.map(normProductTagSlug).filter(Boolean);
                }
                var routeCollection = (container.getAttribute('data-route-collection') || '').trim();
                if (!routeCollection) {
                    try {
                        var pathCol = String((window.location && window.location.pathname) || '').match(/\/collections\/([^\/\?#]+)/);
                        if (pathCol && pathCol[1]) routeCollection = decodeURIComponent(pathCol[1]);
                    } catch (eRouteCol) { }
                }
                var productCollectionHandles = [];
                try {
                    var handlesAttr = container.getAttribute('data-product-collection-handles') || '[]';
                    var parsedHandles = JSON.parse(handlesAttr);
                    if (Array.isArray(parsedHandles)) {
                        productCollectionHandles = parsedHandles.map(function (h) {
                            return String(h || '').trim();
                        }).filter(Boolean);
                    }
                } catch (eHandles) { }
                if (!routeCollection && productCollectionHandles.length) {
                    routeCollection = productCollectionHandles[0];
                }
                var configForStorage = Object.assign({}, configWithExtras, {
                    _selected_option_images: selectedOptionImages,
                    _pricing_schema: mergedSchema,
                    _selected_summary: selectedSummary,
                    _quantity: qtySave,
                    _product_sku: productSku,
                    _product_type: (container.getAttribute('data-product-type') || '').trim(),
                    _product_tags: productTagsForStorage,
                    _route_collection: routeCollection,
                    _product_collection_handles: productCollectionHandles,
                    _hardware_selections: (Array.isArray(config._hardware_selections) && config._hardware_selections.length)
                        ? config._hardware_selections
                        : (config.hardware_options || []),
                    _casing_selections: config.casing_options || config._casing_selections || [],
                    _friendly_name: getItemFriendlyName()
                }, priceSnapshot);
                return {
                    container: container,
                    productId: productId,
                    productName: productName,
                    productImage: productImage,
                    productHandle: productHandle,
                    variantId: variantId,
                    productSku: productSku,
                    basePrice: basePrice,
                    qtySave: qtySave,
                    configForStorage: configForStorage,
                    computedPrice: priceSnapshot && priceSnapshot._applied_unit_price != null
                        ? priceSnapshot._applied_unit_price
                        : basePrice
                };
            } catch (eBuild) {
                if (typeof console !== 'undefined' && console.error) {
                    console.error('[door] buildDoorConfigForStorage failed', eBuild);
                }
                return null;
            }
        }

        if (window.DoorConf2Update && typeof window.DoorConf2Update.bootHubspotIntegration === 'function') {
            doorHubspot = window.DoorConf2Update.bootHubspotIntegration({
                apiBase: apiBase,
                folderSelect: folderSelect,
                newFolderInput: newFolderInput,
                getCurrentConfig: getCurrentConfig,
                calculateDoorPrice: calculateDoorPrice,
                readDoorEstimatedPriceFromDom: readDoorEstimatedPriceFromDom,
                getLineItemPropertiesFromSchema: getLineItemPropertiesFromSchema,
                getHardwareSelectionsForConfig: getHardwareSelectionsForConfig,
                buildDoorConfigForStorage: buildDoorConfigForStorage,
                quotePageUrl: quotePageUrl
            });
        }
        if (folderSelect) {
            folderSelect.addEventListener('change', function () {
                if (newFolderInput) {
                    var isNew = folderSelect.value === '__new__';
                    newFolderInput.style.display = isNew ? 'block' : 'none';
                    newFolderInput.classList.toggle('door-visible', isNew);
                    newFolderInput.classList.toggle('form-field', isNew);
                    newFolderInput.classList.toggle('form-field--input', isNew);
                    if (!isNew) newFolderInput.value = '';
                    syncExistingProjectNameNote();
                }
            });
        }
        function findExistingFolderByName(name) {
            var want = String(name || '').trim().toLowerCase();
            if (!want || !folderSelect) return null;
            var opts = folderSelect.options || [];
            for (var i = 0; i < opts.length; i++) {
                var op = opts[i];
                if (!op || !op.value || op.value === '__new__' || op.disabled) continue;
                if (String(op.textContent || '').trim().toLowerCase() !== want) continue;
                var id = parseInt(op.value, 10);
                if (isNaN(id)) continue;
                return { id: id, name: String(op.textContent || '').trim() };
            }
            return null;
        }
        function syncExistingProjectNameNote() {
            var note = document.getElementById('door-existing-project-note');
            if (!note) return null;
            var isNew = folderSelect && folderSelect.value === '__new__';
            var typed = newFolderInput && newFolderInput.value ? newFolderInput.value.trim() : '';
            var match = (isNew && typed) ? findExistingFolderByName(typed) : null;
            note.style.display = match ? 'block' : 'none';
            return match;
        }
        if (newFolderInput && !newFolderInput.getAttribute('data-existing-project-bound')) {
            newFolderInput.setAttribute('data-existing-project-bound', '1');
            newFolderInput.addEventListener('input', syncExistingProjectNameNote);
            newFolderInput.addEventListener('blur', syncExistingProjectNameNote);
        }
        function getItemFriendlyName() {
            var el = document.getElementById('door-item-friendly-name');
            return el && el.value ? String(el.value).trim() : '';
        }
        function setItemFriendlyName(value) {
            var el = document.getElementById('door-item-friendly-name');
            if (el) el.value = value != null ? String(value) : '';
        }
        function syncFolderSelectDivDropdown() {
            if (!folderSelect) return;
            var divApi = window.DoorConf2Update || window.DoorConf2Hardware;
            if (!divApi) return;
            if (typeof divApi.enhanceDoorSelectWithDivDropdown === 'function') {
                divApi.enhanceDoorSelectWithDivDropdown(folderSelect);
            }
            var divWrap = folderSelect.nextElementSibling;
            if (!(divWrap && divWrap.classList && divWrap.classList.contains('door-div-select'))) {
                var parent = folderSelect.parentNode;
                divWrap = parent ? parent.querySelector('.door-div-select') : null;
            }
            if (!divWrap || !divWrap.classList || !divWrap.classList.contains('door-div-select')) return;
            if (typeof divApi.rebuildDoorDivSelectOptions === 'function') {
                divApi.rebuildDoorDivSelectOptions(folderSelect, divWrap);
            } else if (typeof divApi.syncDoorDivSelectFromNative === 'function') {
                divApi.syncDoorDivSelectFromNative(folderSelect, divWrap);
            }
        }
        function isQuotedFlag(v) {
            return v === 1 || v === true || v === '1';
        }
        function folderSaveStatsFromConfigs(configs) {
            var stats = {};
            (Array.isArray(configs) ? configs : []).forEach(function (c) {
                if (!c || c.folder_id == null || c.folder_id === '') return;
                var id = String(c.folder_id);
                if (!stats[id]) stats[id] = { total: 0, quoted: 0 };
                stats[id].total += 1;
                if (isQuotedFlag(c.is_quoted)) stats[id].quoted += 1;
            });
            return stats;
        }
        function isFolderBlockedForSave(folder, stats, statsReady) {
            if (!folder) return true;
            if (isQuotedFlag(folder.fully_quoted)) return true;
            var qs = String(folder.quote_status || '').toLowerCase();
            if (qs === 'quoted' || qs === 'quote_requested') return true;
            var os = String(folder.order_status || '').toLowerCase();
            if (os === 'draft' || os === 'paid' || os === 'ordered') return true;
            if (String(folder.shopify_draft_order_id || '').trim()) return true;
            if (statsReady) {
                var st = stats[String(folder.id)];
                if (!st || st.total <= 0) return true;
                if (st.quoted >= st.total) return true;
            }
            return false;
        }
        function loadFoldersIntoSelect(email, done) {
            if (!folderSelect || !email) { if (done) done(); return; }
            var prev = folderSelect.value;
            Promise.all([
                fetch(apiBase + '/api/folders.php?email=' + encodeURIComponent(email) + '&exclude_fully_quoted=1').then(function (r) { return r.json(); }),
                fetch(apiBase + '/api/configurations.php?email=' + encodeURIComponent(email) + '&include_quote_cart=1').then(function (r) { return r.json(); }).catch(function () { return null; })
            ]).then(function (results) {
                var list = Array.isArray(results[0]) ? results[0] : [];
                var configs = results[1];
                var statsReady = Array.isArray(configs);
                var stats = statsReady ? folderSaveStatsFromConfigs(configs) : {};
                while (folderSelect.firstChild) folderSelect.removeChild(folderSelect.firstChild);
                folderSelect.appendChild(document.createElement('option')).value = '';
                folderSelect.lastChild.textContent = 'Select a project...';
                list.forEach(function (f) {
                    if (isFolderBlockedForSave(f, stats, statsReady)) return;
                    var opt = document.createElement('option');
                    opt.value = String(f.id);
                    opt.textContent = f.name || ('Folder #' + f.id);
                    folderSelect.appendChild(opt);
                });
                var o = document.createElement('option');
                o.value = '__new__';
                o.textContent = '+ New project...';
                folderSelect.appendChild(o);
                if (prev && folderSelect.querySelector('option[value="' + String(prev).replace(/"/g, '') + '"]')) {
                    folderSelect.value = prev;
                } else {
                    folderSelect.selectedIndex = 0;
                    folderSelect.value = '';
                }
                syncFolderSelectDivDropdown();
                if (done) done();
            })
                .catch(function () { if (done) done(); });
        }

        function normSavedOptionKey(s) {
            return String(s == null ? '' : s).trim().toLowerCase().replace(/-/g, '_');
        }

        var SAVED_MEASUREMENT_ALIAS_GROUPS = [
            ['exact_door_width_int', 'exact_door_width', 'door_width'],
            ['exact_door_width_frac', 'exact_door_width_fraction', 'door_width_fraction'],
            ['door_height', 'exact_door_height'],
            ['door_height_fraction', 'door_height_frac'],
            ['exact_door_thickness_frac', 'exact_door_thickness', 'door_thickness'],
            ['exact_pre_hung_frac', 'exact_pre_hung'],
            ['finished_width_int', 'finished_width'],
            ['finished_width_frac', 'finished_width_fraction'],
            ['finished_height_int', 'finished_height'],
            ['finished_height_frac', 'finished_height_fraction'],
            ['rough_width_int', 'rough_width'],
            ['rough_width_frac', 'rough_width_fraction'],
            ['rough_height_int', 'rough_height'],
            ['rough_height_frac', 'rough_height_fraction'],
            ['panel_width_int', 'panel_width'],
            ['panel_height_int', 'panel_height'],
            ['panel_height_frac', 'panel_height_fraction'],
            ['sidelight_width', 'sidelight_width_int'],
            ['sidelight_width_fraction', 'sidelight_width_frac'],
            ['panel_transom_height_int', 'panel_transom_height'],
            ['panel_transom_height_frac', 'panel_transom_height_fraction'],
            // Panel Unit Design can be stored under multiple legacy ids depending on
            // schema/source (storefront/admin), so treat them as one saved-value group.
            ['panel_unit_design', 'porch_panel_project', 'porch_panel_order', 'porch_panel_order_type']
        ];

        function savedOptionKeysForId(id) {
            var norm = normSavedOptionKey(id);
            var keys = [String(id || ''), norm, norm.replace(/_/g, '-')];
            SAVED_MEASUREMENT_ALIAS_GROUPS.forEach(function (group) {
                var groupNorm = group.map(normSavedOptionKey);
                if (groupNorm.indexOf(norm) === -1) return;
                group.forEach(function (g) {
                    keys.push(g);
                    keys.push(String(g).replace(/_/g, '-'));
                });
            });
            var out = [];
            keys.forEach(function (k) {
                if (k && out.indexOf(k) === -1) out.push(k);
            });
            return out;
        }

        function getSavedOptionValue(opts, id) {
            if (!opts || id == null || id === '') return null;
            var i, k, val;
            for (i = 0; i < savedOptionKeysForId(id).length; i++) {
                k = savedOptionKeysForId(id)[i];
                if (!Object.prototype.hasOwnProperty.call(opts, k)) continue;
                val = opts[k];
                if (val !== null && val !== '') return val;
            }
            return null;
        }

        function isPanelUnitDesignOptionId(optionId) {
            var norm = normSavedOptionKey(optionId);
            return norm === 'panel_unit_design'
                || norm === 'porch_panel_project'
                || norm === 'porch_panel_order'
                || norm === 'porch_panel_order_type';
        }

        function normalizePanelUnitDesignValue(v) {
            var s = String(v == null ? '' : v).trim();
            if (!s) return '';
            var norm = normSavedOptionKey(s);
            if (norm === 'design_porch_enclosure_system'
                || norm === 'design_a_porch_enclosure_system'
                || norm === 'design_porch_enclosure') {
                return 'design_porch_enclosure_system';
            }
            if (norm === 'order_individual_panels'
                || norm === 'order_individual_panel'
                || norm === 'order_individual'
                || norm === 'order_fixed'
                || norm === 'order_fixed_panels') {
                return 'order_individual_panels';
            }
            return s;
        }

        function setSelectValueFromSaved(sel, val) {
            if (!sel || val == null || val === '') return false;
            var target = String(val);
            var i, op, applied = false;
            for (i = 0; i < sel.options.length; i++) {
                op = sel.options[i];
                if (!op) continue;
                if (String(op.value) === target) {
                    sel.selectedIndex = i;
                    sel.value = String(op.value);
                    applied = true;
                    break;
                }
                if (op.value !== '' && !isNaN(parseFloat(op.value)) && !isNaN(parseFloat(target))) {
                    if (Math.abs(parseFloat(op.value) - parseFloat(target)) < 0.000001) {
                        sel.selectedIndex = i;
                        sel.value = String(op.value);
                        applied = true;
                        break;
                    }
                }
            }
            // Final fallback: normalized-key match (case / dash insensitive) so saved
            // values that differ only in formatting still restore the right option.
            if (!applied) {
                var targetNorm = normSavedOptionKey(target);
                for (i = 0; i < sel.options.length; i++) {
                    op = sel.options[i];
                    if (!op || op.value === '') continue;
                    if (normSavedOptionKey(op.value) === targetNorm) {
                        sel.selectedIndex = i;
                        sel.value = String(op.value);
                        applied = true;
                        break;
                    }
                }
            }
            if (!applied) return false;
            try {
                sel.dispatchEvent(new Event('change', { bubbles: true }));
            } catch (eCh) { }
            if (window.DoorConf2Hardware && typeof window.DoorConf2Hardware.syncDoorDivSelectFromNative === 'function') {
                var divWrap = sel.nextElementSibling;
                if (sel.getAttribute('data-door-div-select') === '1' && divWrap && divWrap.classList && divWrap.classList.contains('door-div-select')) {
                    window.DoorConf2Hardware.syncDoorDivSelectFromNative(sel, divWrap);
                }
            }
            return true;
        }

        // The Additional Options selects (Door Sweep / Door Stops with Seals / Pet Door)
        // are moved into a dedicated accordion and converted to custom div-dropdowns by a
        // late, retrying render loop. That can finish AFTER the saved-config re-apply runs,
        // so a one-shot applyConfigToInputs() misses them. This self-retries until each
        // select exists, then applies the saved value and syncs the custom dropdown UI.
        function restoreAdditionalOptionsSelectsFromSaved(opts, attempt) {
            if (!opts || !optionsContainer) return;
            attempt = attempt || 0;
            var pending = false;
            ADDITIONAL_OPTIONS_SELECT_IDS.forEach(function (oid) {
                var saved = getSavedOptionValue(opts, oid);
                if (saved == null || saved === '') return; // nothing saved → keep default
                var sel = optionsContainer.querySelector('select[data-option-id="' + oid + '"]');
                if (!sel) { pending = true; return; }
                // Ensure the custom div-dropdown exists before applying the saved value.
                try { enhanceDoorSelectWithDivDropdown(sel); } catch (eEnh) { }
                var ok = setSelectValueFromSaved(sel, saved);
                if (!ok) {
                    // Matching <option> may not be populated yet → retry later.
                    pending = true;
                    return;
                }
                try {
                    var dw = sel.nextElementSibling;
                    if (window.DoorConf2Hardware && typeof window.DoorConf2Hardware.syncDoorDivSelectFromNative === 'function'
                        && dw && dw.classList && dw.classList.contains('door-div-select')) {
                        window.DoorConf2Hardware.syncDoorDivSelectFromNative(sel, dw);
                    }
                } catch (eSync) { }
            });
            if (pending && attempt < 25) {
                setTimeout(function () { restoreAdditionalOptionsSelectsFromSaved(opts, attempt + 1); }, 250);
            }
        }

        function savedGlassBevelEnabled(opts) {
            var val = getSavedOptionValue(opts, 'glass_bevel');
            if (Array.isArray(val)) {
                for (var i = 0; i < val.length; i++) {
                    var s = String(val[i] == null ? '' : val[i]).toLowerCase();
                    if (s && s !== 'false' && s !== '0' && s !== 'no' && s !== 'off') return true;
                }
            } else if (val != null && val !== '') {
                var s2 = String(val).toLowerCase();
                if (s2 !== 'false' && s2 !== '0' && s2 !== 'no' && s2 !== 'off') return true;
            }
            if (Array.isArray(opts._selected_summary)) {
                for (var j = 0; j < opts._selected_summary.length; j++) {
                    var item = opts._selected_summary[j];
                    if (!item) continue;
                    var bevelLbl = String(item.label || '').toLowerCase();
                    if (bevelLbl !== 'bevel glass' && bevelLbl !== 'beveled glass') continue;
                    var v = String(item.value || '').toLowerCase();
                    if (v.indexOf('add') !== -1 && v.indexOf('no bevel') === -1) return true;
                }
            }
            return false;
        }

        function applyGlassBevelFromSavedOptions(opts) {
            var inp = document.querySelector('input[type="checkbox"][data-option-id="glass_bevel"]');
            if (!inp) return;
            var on = savedGlassBevelEnabled(opts);
            inp.checked = on;
            if (on) {
                var val = getSavedOptionValue(opts, 'glass_bevel');
                if (Array.isArray(val) && val.length) inp.value = String(val[0]);
            }
        }

        function applyMeasurementSelectsFromSavedOptions(opts) {
            doorConf2MeasurementsCall('applyMeasurementSelectsFromSavedOptions', opts, {
                optionsContainer: optionsContainer,
                getSavedOptionValue: getSavedOptionValue,
                setSelectValueFromSaved: setSelectValueFromSaved
            });
        }

        function syncMeasurementUiAfterSavedRestore(opts) {
            doorConf2MeasurementsCall('syncMeasurementUiAfterSavedRestore', opts, {
                getSavedOptionValue: getSavedOptionValue,
                savedOptionKeysForId: savedOptionKeysForId,
                normSavedOptionKey: normSavedOptionKey,
                setSelectValueFromSaved: setSelectValueFromSaved,
                optionsContainer: document.getElementById('door-configurator-options')
            });
        }

        function applyScreenAndStormInsertsAdditionalOptionsFromSavedOptions(opts) {
            if (!opts) return;
            var val = opts['screen_and_storm_inserts_additional_options'];
            var arr = Array.isArray(val) ? val : (val != null && val !== '' ? [val] : []);
            var container = document.getElementById('door-configurator-options');
            if (!container) return;
            var inputs = all('input[type="checkbox"][data-option-id="screen_and_storm_inserts_additional_options"]', container);
            inputs.forEach(function (el) {
                var matched = false;
                for (var ci = 0; ci < arr.length; ci++) {
                    if (String(el.value) === String(arr[ci]) || normSavedOptionKey(el.value) === normSavedOptionKey(arr[ci])) {
                        matched = true;
                        break;
                    }
                }
                el.checked = matched;
                if (el.closest) {
                    var card = el.closest('.common-check-option');
                    if (card) {
                        card.classList.toggle('common-check-option--selected', matched);
                    }
                }
            });
        }

        function applySavedExtrasFromOptions(opts) {
            if (!opts) return;
            syncMeasurementUiAfterSavedRestore(opts);
            applyMeasurementSelectsFromSavedOptions(opts);
            applyGlassBevelFromSavedOptions(opts);
            try { syncMeasurementSelectedPriceLabels(opts); } catch (eMeasLbl) { }
            try { reapplySavedPanelUnitDesign(opts); } catch (ePanelDesign) { }
            try {
                if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.applyPanelUnitIndividualMeasurementsFromSavedOptions === 'function') {
                    window.DoorConf2Measurements.applyPanelUnitIndividualMeasurementsFromSavedOptions(opts);
                }
            } catch (ePanelsRestore) { }
            try {
                if (window.DoorConf2Measurements && typeof window.DoorConf2Measurements.applyPanelUnitEnclosureOpeningsFromSavedOptions === 'function') {
                    window.DoorConf2Measurements.applyPanelUnitEnclosureOpeningsFromSavedOptions(opts);
                }
            } catch (eEnclosureRestore) { }
            try {
                applyScreenAndStormInsertsAdditionalOptionsFromSavedOptions(opts);
            } catch (eAddlRestore) { }
        }

        function applyConfigToInputs(opts, applyOpts) {
            if (!doorConfigSchema || !optionsContainer || !opts) return;
            applyOpts = applyOpts || {};
            var skipTouched = !!applyOpts.skipTouched;
            var formControlSelector = function (id) {
                return 'select[data-option-id="' + id + '"], input[data-option-id="' + id + '"]';
            };
            _doorRestoreApplying = true;
            try {
                doorConfigSchema.forEach(function (opt) {
                    if (skipTouched && opt && opt.id && _touchedOptionIds[opt.id]) return;
                    var optType = (opt.type || '').toLowerCase();
                    var inputs = all(formControlSelector(opt.id), optionsContainer);
                    var val = getSavedOptionValue(opts, opt.id);
                    if (val == null && opts[opt.id] != null) val = opts[opt.id];
                    if (optType === 'dimension') {
                        var cmSel = optionsContainer.querySelector('select[data-option-id="' + opt.id + '"][data-unit="cm"], input[data-option-id="' + opt.id + '"][data-unit="cm"]');
                        var inHiddenSel = optionsContainer.querySelector('input[data-option-id="' + opt.id + '"][data-unit="in"], select[data-option-id="' + opt.id + '"][data-unit="in"]');
                        var vCm = opts[opt.id + '_cm'];
                        var vIn = opts[opt.id + '_in'];
                        if (cmSel && vCm != null && vCm !== '') cmSel.value = String(vCm);

                        // Set split inch controls: integer + fraction + hidden combined value.
                        if (vIn != null && vIn !== '') {
                            if (inHiddenSel) inHiddenSel.value = String(vIn);
                            var intSel = optionsContainer.querySelector('select[data-option-id="' + opt.id + '"][data-unit="in-int"]');
                            var fracSel = optionsContainer.querySelector('select[data-option-id="' + opt.id + '"][data-unit="in-frac"]');
                            if (intSel && fracSel && inHiddenSel) {
                                var unitIn = opt.unit_in || opt.range_in || {};
                                var step = unitIn && unitIn.step != null ? parseFloat(unitIn.step) : 0.25;
                                if (isNaN(step) || step <= 0) step = 0.25;

                                var fracOptions;
                                if (step <= 0.26) {
                                    fracOptions = [
                                        { value: '0', label: '0' },
                                        { value: '0.25', label: '1/4' },
                                        { value: '0.5', label: '1/2' },
                                        { value: '0.75', label: '3/4' }
                                    ];
                                } else if (step <= 0.51) {
                                    fracOptions = [
                                        { value: '0', label: '0' },
                                        { value: '0.5', label: '1/2' }
                                    ];
                                } else {
                                    fracOptions = [{ value: '0', label: '0' }];
                                }

                                var num = parseFloat(vIn);
                                if (!isNaN(num)) {
                                    var intPart = Math.floor(num + 1e-9);
                                    var fracPart = Math.round((num - intPart) * 100) / 100;

                                    if (intPart >= 1 && intPart <= 50) {
                                        var found = fracOptions.find(function (f) {
                                            return Math.abs(parseFloat(f.value) - fracPart) < 1e-6;
                                        });
                                        if (found) {
                                            intSel.value = String(intPart);
                                            fracSel.value = found.value;
                                        } else {
                                            intSel.value = '';
                                            fracSel.value = '';
                                            inHiddenSel.value = '';
                                        }
                                    } else {
                                        intSel.value = '';
                                        fracSel.value = '';
                                        inHiddenSel.value = '';
                                    }
                                }
                            }
                        } else if (inHiddenSel) {
                            inHiddenSel.value = '';
                        }
                    } else if (optType === 'checkbox') {
                        var arr = Array.isArray(val) ? val : (val != null && val !== '' ? [val] : []);
                        inputs.forEach(function (el) {
                            var matched = false;
                            for (var ci = 0; ci < arr.length; ci++) {
                                if (String(el.value) === String(arr[ci]) || normSavedOptionKey(el.value) === normSavedOptionKey(arr[ci])) {
                                    matched = true;
                                    break;
                                }
                            }
                            el.checked = matched;
                            if (el.closest) {
                                var card = el.closest('.common-check-option');
                                if (card) {
                                    card.classList.toggle('common-check-option--selected', matched);
                                }
                            }
                        });
                    } else if (optType === 'radio') {
                        var targetRadio = String(val == null ? '' : val);
                        var matchedRadio = null;
                        // Prefer an exact value match, then fall back to a normalized-key match
                        // so saved values that differ only in case/dashes still pre-select.
                        inputs.forEach(function (el) {
                            if (matchedRadio) return;
                            if (String(el.value || '') === targetRadio) matchedRadio = el;
                        });
                        if (!matchedRadio && targetRadio !== '') {
                            inputs.forEach(function (el) {
                                if (matchedRadio) return;
                                if (normSavedOptionKey(el.value) === normSavedOptionKey(targetRadio)) matchedRadio = el;
                            });
                        }
                        inputs.forEach(function (el) { el.checked = (el === matchedRadio); });
                        var selectedRadioVal = matchedRadio ? String(matchedRadio.value || '') : '';
                        var radioWrap = optionsContainer.querySelector('.door-option-wrap[data-option-id="' + opt.id + '"] .common-check-options')
                            || optionsContainer.querySelector('[data-option-id="' + opt.id + '"] .common-check-options');
                        if (radioWrap) {
                            radioWrap.querySelectorAll('.common-check-option').forEach(function (card) {
                                card.classList.toggle('common-check-option--selected', selectedRadioVal !== '' && String(card.getAttribute('data-choice-value') || '') === selectedRadioVal);
                            });
                        }
                        if (matchedRadio) {
                            try { matchedRadio.dispatchEvent(new Event('change', { bubbles: true })); } catch (eRadioCh) { }
                        }
                    } else if (inputs.length && val !== undefined && val !== null) {
                        var firstInput = inputs[0];
                        if (firstInput.tagName === 'SELECT' && val !== '') {
                            // Robust helper: exact + numeric + normalized match, dispatches change
                            // (so dependent options reveal) and syncs the custom div-dropdown UI
                            // used by the additional-options selects (door_sweep / seal / pet_door).
                            setSelectValueFromSaved(firstInput, val);
                        } else {
                            firstInput.value = val === '' ? '' : String(val);
                        }
                    }
                });
                applySavedExtrasFromOptions(opts);
                applyHideWhen(doorConfigSchema, optionsContainer);
                applyChoiceVisibility(doorConfigSchema, optionsContainer);
                applyProductTagChoiceVisibility(doorConfigSchema, optionsContainer);
                syncPanelProfileHero(optionsContainer);
                syncMeasurementTypeSectionPreHungGate(doorConfigSchema, optionsContainer);
                syncHingeFinishVisibility(doorConfigSchema, optionsContainer);
                syncLocksetPrepVisibility(doorConfigSchema, optionsContainer);
                try { pulseDependentVisibilityFromDefaults(optionsContainer); } catch (ePulseRestore) { }
                updateEstimatedPrice();
                updateDoorPreview();
            } finally {
                _doorRestoreApplying = false;
            }
        }

        function getQueryParam(name) {
            var m = window.location.search.match(new RegExp('[?&]' + name + '=([^&]*)'));
            return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
        }

        function buildConfigReturnUrl() {
            var path = window.location.pathname || '/';
            var pairs = [];
            var seen = {};
            var raw = (window.location.search || '').replace(/^\?/, '');
            if (raw) {
                raw.split('&').forEach(function (part) {
                    if (!part) return;
                    var kv = part.split('=');
                    var key = decodeURIComponent(kv[0] || '');
                    if (!key || key === 'door_post_login' || key === 'door_from_profile') return;
                    if (seen[key]) return;
                    seen[key] = true;
                    pairs.push(part);
                });
            }
            seen.autosave = true;
            pairs = pairs.filter(function (part) {
                var k = part.split('=')[0];
                return k !== 'autosave' && k !== 'door_post_login' && k !== 'door_from_profile';
            });
            pairs.push('autosave=1');
            return path + (pairs.length ? '?' + pairs.join('&') : '?autosave=1');
        }

        function toAbsoluteStoreUrl(relativeOrAbsolute) {
            var u = (relativeOrAbsolute || '').trim();
            if (!u) return '';
            if (u.indexOf('http') === 0) return u;
            return window.location.origin + (u.charAt(0) === '/' ? u : '/' + u);
        }

        function getCompleteProfilePageUrl(cfgContainer) {
            var path = (cfgContainer && cfgContainer.getAttribute('data-complete-profile-page-url')) || '/pages/complete-profile';
            return toAbsoluteStoreUrl(path);
        }

        function storeConfigReturnUrls(cfgContainer) {
            var relative = buildConfigReturnUrl();
            var absolute = toAbsoluteStoreUrl(relative);
            try {
                localStorage.setItem('door_config_return_url', absolute);
                localStorage.setItem('door_config_return_path', relative);
            } catch (e) { }
            return { relative: relative, absolute: absolute };
        }

        function isDoorProfileComplete(cfgContainer) {
            if (!cfgContainer) return false;
            try {
                if (sessionStorage.getItem('door_profile_form_done') === '1') return true;
            } catch (eSess) { }
            if (cfgContainer.getAttribute('data-profile-complete') === '1') return true;
            var first = (cfgContainer.getAttribute('data-customer-first-name') || '').trim();
            var phone = (cfgContainer.getAttribute('data-customer-phone') || '').trim();
            var zip = (cfgContainer.getAttribute('data-customer-zip') || '').trim();
            return first !== '' && phone !== '' && zip !== '';
        }

        function showDoorReturnedNote() {
            var note = document.getElementById('door-returned-from-login-note');
            if (!note) return;
            note.style.display = '';
            setTimeout(function () {
                try { note.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (eScroll) { }
            }, 200);
        }

        function restoreConfigFromLocalStorage(cfgContainer, done) {
            var raw = null;
            try { raw = localStorage.getItem('door_autosave_payload'); } catch (eRaw) { }
            if (!raw) { if (done) done(false); return; }
            var saved = null;
            try { saved = JSON.parse(raw); } catch (eParse) { }
            if (!saved || !saved.options) { if (done) done(false); return; }

            applyConfigToInputs(saved.options);
            try {
                setTimeout(function () { reapplySavedSwingDirection(saved.options); }, 300);
                setTimeout(function () { reapplySavedSwingDirection(saved.options); }, 1700);
            } catch (eSwingReapplyLocal) { }

            var custEmail = (cfgContainer.getAttribute('data-customer-email') || '').trim();
            if (folderSelect && custEmail) {
                loadFoldersIntoSelect(custEmail, function () {
                    if (folderSelect && saved.folderValue) {
                        folderSelect.value = saved.folderValue;
                        if (newFolderInput) {
                            var isNewRestore = folderSelect.value === '__new__';
                            newFolderInput.style.display = isNewRestore ? 'block' : 'none';
                            newFolderInput.classList.toggle('door-visible', isNewRestore);
                        }
                        syncFolderSelectDivDropdown();
                    }
                    if (newFolderInput && saved.newFolderName) newFolderInput.value = saved.newFolderName;
                    if (saved.friendlyName) setItemFriendlyName(saved.friendlyName);
                    if (done) done(true);
                });
            } else {
                if (done) done(true);
            }
        }

        function runDoorAuthReturnFlow() {
            var cfgContainer = document.getElementById('door-configurator');
            if (!cfgContainer) return;

            var custEmail = (cfgContainer.getAttribute('data-customer-email') || '').trim();
            if (!custEmail) return;

            var postLogin = getQueryParam('door_post_login') === '1';
            var autosave = getQueryParam('autosave') === '1';
            var profileComplete = isDoorProfileComplete(cfgContainer);
            var urls = storeConfigReturnUrls(cfgContainer);
            var returnUrl = urls.relative;
            var returnAbsolute = urls.absolute;
            var completeProfileUrl = getCompleteProfilePageUrl(cfgContainer);

            if (postLogin && !autosave) {
                if (!profileComplete) {
                    try { sessionStorage.setItem('door_pending_profile', '1'); } catch (ePending) { }
                    window.location.replace(completeProfileUrl);
                    return;
                }
                window.location.replace(returnUrl);
                return;
            }

            var pendingProfile = false;
            try { pendingProfile = sessionStorage.getItem('door_pending_profile') === '1'; } catch (ePend) { }
            if (pendingProfile && profileComplete && !autosave) {
                var storedReturn = '';
                try { storedReturn = localStorage.getItem('door_config_return_url') || returnAbsolute; } catch (eRet) { storedReturn = returnAbsolute; }
                var storedPath = '';
                try { storedPath = localStorage.getItem('door_config_return_path') || returnUrl; } catch (ePath) { storedPath = returnUrl; }
                var current = window.location.pathname + window.location.search;
                var targetPath = storedPath || returnUrl;
                if (targetPath && current !== targetPath && current.indexOf('autosave=1') === -1) {
                    window.location.replace(targetPath);
                    return;
                }
            }

            if (autosave) {
                restoreConfigFromLocalStorage(cfgContainer, function (restored) {
                    if (restored) {
                        showDoorReturnedNote();
                        try {
                            sessionStorage.removeItem('door_pending_profile');
                        } catch (eClr) { }
                    }
                });
            }
        }

        (function bindDoorProfileReturnWatcher() {
            var reloaded = false;
            function maybeReloadForProfileComplete() {
                if (reloaded) return;
                try {
                    if (sessionStorage.getItem('door_pending_profile') !== '1') return;
                } catch (e) { return; }
                reloaded = true;
                window.location.reload();
            }
            document.addEventListener('visibilitychange', function () {
                if (document.visibilityState === 'visible') maybeReloadForProfileComplete();
            });
            window.addEventListener('pageshow', function (ev) {
                if (ev && ev.persisted) maybeReloadForProfileComplete();
            });
        })();

        // If customer clicked "Log in to save", store current selections before redirecting.
        var loginToSaveLink = document.getElementById('door-login-to-save');
        if (loginToSaveLink) {
            loginToSaveLink.addEventListener('click', function (e) {
                var guestMsg = document.getElementById('door-guest-quote-message');
                if (!validateSdlProfileBeforeSubmit(guestMsg)) {
                    if (e && e.preventDefault) e.preventDefault();
                    return false;
                }
                try {
                    var payload = {
                        options: getCurrentConfig(),
                        folderValue: folderSelect ? folderSelect.value : '',
                        newFolderName: newFolderInput ? newFolderInput.value : '',
                        friendlyName: getItemFriendlyName(),
                        ts: Date.now()
                    };
                    localStorage.setItem('door_autosave_payload', JSON.stringify(payload));
                    var cfgEl = document.getElementById('door-configurator');
                    storeConfigReturnUrls(cfgEl);
                } catch (eStore) { }
            });
        }
        function resolveCustomerEmailForFolders() {
            var cfgEl = document.getElementById('door-configurator');
            var attrEmail = cfgEl && cfgEl.getAttribute('data-customer-email')
                ? cfgEl.getAttribute('data-customer-email').trim() : '';
            if (attrEmail) return attrEmail;
            var emailInput = document.getElementById('door-customer-email');
            return emailInput && emailInput.value ? emailInput.value.trim() : '';
        }
        var emailInputForFolders = document.getElementById('door-customer-email');
        if (folderSelect) {
            folderSelect.addEventListener('focus', function () {
                var email = (emailInputForFolders && emailInputForFolders.value.trim())
                    || resolveCustomerEmailForFolders();
                if (email) loadFoldersIntoSelect(email);
            });
        }
        // Preload the logged-in customer's collections on page load so they appear
        // without needing to focus the dropdown. Skipped when a specific saved config is
        // being restored (that flow loads + selects the folder itself, avoiding a race).
        if (folderSelect && !/[?&]config_id=\d+/.test(String((window.location && window.location.search) || ''))) {
            var preloadFolderEmail = resolveCustomerEmailForFolders();
            if (preloadFolderEmail) loadFoldersIntoSelect(preloadFolderEmail);
        }

        var saveButton = document.getElementById('door-save-config-button');
        if (saveButton) {
            saveButton.addEventListener('click', function () {
                try {
                    var returnedNoteOnSave = document.getElementById('door-returned-from-login-note');
                    if (returnedNoteOnSave) returnedNoteOnSave.style.display = 'none';
                } catch (eHideReturnedNote) { }
                var container = document.getElementById('door-configurator');
                var emailInput = document.getElementById('door-customer-email');
                var messageEl = document.getElementById('door-save-config-message');
                var originalSaveText = saveButton.textContent;
                if (!validateSdlProfileBeforeSubmit(messageEl)) {
                    return;
                }
                saveButton.disabled = true;
                saveButton.textContent = 'Saving...';
                if (messageEl) {
                    messageEl.classList.remove('is-success', 'is-error');
                    messageEl.style.display = 'none';
                    messageEl.textContent = '';
                }
                var email = (container && container.getAttribute('data-customer-email') ? container.getAttribute('data-customer-email').trim() : '') ||
                    (emailInput && emailInput.value ? emailInput.value.trim() : '');
                if (!email) {
                    if (messageEl) {
                        messageEl.classList.remove('is-success');
                        messageEl.classList.add('is-error');
                        messageEl.style.display = 'block';
                        messageEl.style.color = '#b91c1c';
                        messageEl.textContent = 'Please log in to save the project.';
                    }
                    saveButton.disabled = false;
                    saveButton.textContent = originalSaveText;
                    return;
                }

                var folderValue = folderSelect ? folderSelect.value : '';
                var folderId = null;
                var folderName = null;
                if (folderValue === '__new__' && newFolderInput && newFolderInput.value.trim()) {
                    folderName = newFolderInput.value.trim();
                    var existingFolder = findExistingFolderByName(folderName);
                    syncExistingProjectNameNote();
                    if (existingFolder) {
                        folderId = existingFolder.id;
                        folderName = null;
                    }
                } else if (folderValue && folderValue !== '__new__') {
                    folderId = parseInt(folderValue, 10);
                    if (isNaN(folderId)) folderId = null;
                }
                if (folderId == null && !folderName) {
                    if (messageEl) {
                        messageEl.classList.remove('is-success');
                        messageEl.classList.add('is-error');
                        messageEl.style.display = 'block';
                        messageEl.style.color = '#b91c1c';
                        messageEl.textContent = 'Please select a project or enter a name for a new one.';
                    }
                    saveButton.disabled = false;
                    saveButton.textContent = originalSaveText;
                    return;
                }

                // Human-readable collection name to store in HubSpot (e.g. "fk", "Office", or entered new name).
                var savedProjectName = '';
                if (folderValue === '__new__') {
                    savedProjectName = folderName || (newFolderInput && newFolderInput.value ? newFolderInput.value.trim() : '');
                } else if (folderSelect && folderSelect.options && folderSelect.selectedIndex >= 0) {
                    savedProjectName = (folderSelect.options[folderSelect.selectedIndex].text || '').trim();
                }

                if (!container) container = document.getElementById('door-configurator');
                var basePriceAttr = container.getAttribute('data-base-price');
                var productId = container.getAttribute('data-product-id');
                var productName = container.getAttribute('data-product-name') || '';
                var productImage = container.getAttribute('data-product-image') || '';
                var productHandle = container.getAttribute('data-product-handle') || '';
                var variantId = container.getAttribute('data-variant-id') || '';
                var productSku = (container.getAttribute('data-product-sku') || '').trim();
                var basePrice = parseFloat(basePriceAttr) || 0;
                var config = getCurrentConfig();
                var selectedOptionImages = buildSelectedOptionImageMap(config, doorConfigSchema);
                var selectedSummary = buildSelectedSummaryForStorage(config, doorConfigSchema);
                var qtySave = getDoorQuantity();
                var appliedLineTotal = doorHubspot && doorHubspot.getAppliedLineTotal
                    ? doorHubspot.getAppliedLineTotal(container, qtySave)
                    : 0;

                // Merge DOM-captured extra options (exposure, bevel, hinge, hardware,
                // measurement dropdowns) into the schema + values + images so the admin
                // renders them as editable controls.
                var adminExtras = buildAdminEditableExtras();
                var extraIds = {};
                adminExtras.entries.forEach(function (e) { extraIds[String(e.id)] = true; });
                var baseSchema = Array.isArray(doorConfigSchema) ? doorConfigSchema.slice() : [];
                // Put the DOM-captured extras FIRST so they can never be lost to JSON size
                // truncation, then the remaining base options (minus any duplicates).
                var mergedSchema = adminExtras.entries.concat(
                    baseSchema.filter(function (o) { return !(o && extraIds[String(o.id)]); })
                );
                // Drop bulky showWhenProductTags data from the schema before saving.
                mergedSchema = stripShowWhenProductTags(mergedSchema);
                // Hardware-only landing pages may have no metaobject schema — still persist a stub
                // so the admin Saved carts edit page can render editable hardware controls.
                if ((!mergedSchema || !mergedSchema.length) && document.querySelector('[data-landing-hardware-config="1"]')) {
                    mergedSchema = [{
                        id: 'hardware_options',
                        label: 'Hardware',
                        type: 'hardware_multi'
                    }];
                }
                var configWithExtras = Object.assign({}, config, adminExtras.values);
                Object.keys(adminExtras.images).forEach(function (oid) {
                    selectedOptionImages[oid] = Object.assign({}, selectedOptionImages[oid] || {}, adminExtras.images[oid]);
                });

                var priceSnapshot = buildDoorPriceSnapshotForStorage(configWithExtras, basePrice);
                // Product tags for HubSpot sub_product_category (and admin). Prefer current
                // product DOM tags; keep any already on config (e.g. edit restore).
                var productTagsForStorage = [];
                try {
                    var tagsAttrSave = container.getAttribute('data-product-tags') || '';
                    if (tagsAttrSave.trim()) {
                        var parsedTagsSave = JSON.parse(tagsAttrSave);
                        if (Array.isArray(parsedTagsSave)) {
                            productTagsForStorage = parsedTagsSave.map(normProductTagSlug).filter(Boolean);
                        }
                    }
                } catch (eTagsSave) {
                    productTagsForStorage = String(container.getAttribute('data-product-tags') || '')
                        .split(/[|,]/)
                        .map(normProductTagSlug)
                        .filter(Boolean);
                }
                if (!productTagsForStorage.length && Array.isArray(config._product_tags)) {
                    productTagsForStorage = config._product_tags.map(normProductTagSlug).filter(Boolean);
                }
                var routeCollectionSave = (container.getAttribute('data-route-collection') || '').trim();
                if (!routeCollectionSave) {
                    try {
                        var pathColSave = String((window.location && window.location.pathname) || '').match(/\/collections\/([^\/\?#]+)/);
                        if (pathColSave && pathColSave[1]) routeCollectionSave = decodeURIComponent(pathColSave[1]);
                    } catch (eRouteColSave) { }
                }
                var productCollectionHandlesSave = [];
                try {
                    var handlesAttrSave = container.getAttribute('data-product-collection-handles') || '[]';
                    var parsedHandlesSave = JSON.parse(handlesAttrSave);
                    if (Array.isArray(parsedHandlesSave)) {
                        productCollectionHandlesSave = parsedHandlesSave.map(function (h) {
                            return String(h || '').trim();
                        }).filter(Boolean);
                    }
                } catch (eHandlesSave) { }
                if (!routeCollectionSave && productCollectionHandlesSave.length) {
                    routeCollectionSave = productCollectionHandlesSave[0];
                }
                var configForStorage = Object.assign({}, configWithExtras, {
                    _selected_option_images: selectedOptionImages,
                    // Persist the schema (incl. DOM-captured extras) so admin staff can edit
                    // the controls. Price is never recalculated from this.
                    _pricing_schema: mergedSchema,
                    // Readable list of customer selections + quantity for the admin app.
                    _selected_summary: selectedSummary,
                    _quantity: qtySave,
                    _product_sku: productSku,
                    _product_type: (container.getAttribute('data-product-type') || '').trim(),
                    // Shopify product tags → HubSpot line item sub_product_category matching.
                    _product_tags: productTagsForStorage,
                    _route_collection: routeCollectionSave,
                    _product_collection_handles: productCollectionHandlesSave,
                    _hardware_selections: (Array.isArray(config._hardware_selections) && config._hardware_selections.length)
                        ? config._hardware_selections
                        : (config.hardware_options || []),
                    // Persist casing so the admin Saved carts view can render the selected casing
                    // (product + length + qty) instead of "No casing added on the storefront".
                    _casing_selections: config.casing_options || config._casing_selections || [],
                    _friendly_name: getItemFriendlyName()
                }, priceSnapshot);
                var currency = (Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD');

                var props = getLineItemPropertiesFromSchema();
                var summaryParts = [];
                Object.keys(props || {}).forEach(function (k) {
                    var v = props[k];
                    if (v != null && v !== '') {
                        summaryParts.push(k + ': ' + v);
                    }
                });
                var optionsSummary = summaryParts.join('; ');

                var editId = container.getAttribute('data-edit-config-id');
                var isUpdate = !!editId;

                var url = apiBase + '/api/configurations.php';
                var method = isUpdate ? 'PUT' : 'POST';
                var payload = isUpdate
                    ? {
                        id: parseInt(editId, 10),
                        email: email,
                        options: configForStorage,
                        basePrice: basePrice,
                        computedPrice: priceSnapshot._applied_unit_price
                    }
                    : {
                        customerEmail: email,
                        baseProductId: productId,
                        productTitle: productName,
                        productImageUrl: productImage,
                        productHandle: productHandle,
                        variantId: variantId,
                        options: configForStorage,
                        notesFromCustomer: '',
                        basePrice: basePrice,
                        computedPrice: priceSnapshot._applied_unit_price
                    };
                if (folderId != null) payload.folder_id = folderId;
                if (folderName) payload.folder_name = folderName;
                payload.in_quote_cart = 0;
                payload.is_quoted = 0;

                fetch(url, {
                    method: method,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                })
                    .then(function (res) {
                        if (!res.ok) throw new Error('Request failed');
                        return res.json();
                    })
                    .then(function (data) {
                        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
                        var path = '/pages/my-saved-doors';
                        var myDoorsUrl = (root && root !== '/') ? root.replace(/\/$/, '') + path : path;
                        var msg = isUpdate
                            ? 'Project updated. Our team will follow up if needed.'
                            : 'Project saved. Our sales team will contact you.';
                        // TEMP: hide "View my saved doors" link from success message
                        var successHtml = msg;
                        // var successHtml = msg + ' <a href="' + myDoorsUrl + '" style="font-weight:600;">View my saved doors</a>';

                        // Save to Project: custom app + HubSpot deal (same as before).
                        var hubspotConfigId = editId || (data && data.id != null ? String(data.id) : '');
                        if (hubspotConfigId && container && !container.getAttribute('data-edit-config-id')) {
                            container.setAttribute('data-edit-config-id', hubspotConfigId);
                        }
                        // After first save, next label should be Update project.
                        if (hubspotConfigId && !isUpdate) {
                            originalSaveText = 'Update project';
                        }

                        function finishSaveSuccess(extraHtml) {
                            if (messageEl) {
                                messageEl.classList.remove('is-error');
                                messageEl.classList.add('is-success');
                                messageEl.style.display = 'block';
                                messageEl.style.color = '#166534';
                                messageEl.innerHTML = successHtml + (extraHtml || '');
                            }
                            try {
                                var returnedNote = document.getElementById('door-returned-from-login-note');
                                if (returnedNote) returnedNote.style.display = 'none';
                            } catch (eHideNote) { }
                            saveButton.disabled = false;
                            saveButton.textContent = originalSaveText;
                            try {
                                if (getQueryParam('autosave') === '1') {
                                    localStorage.removeItem('door_autosave_payload');
                                }
                            } catch (e) { }
                            window.location.href = myDoorsUrl;
                        }

                        if (doorHubspot && doorHubspot.syncAfterSave && savedProjectName) {
                            var hubspotStarted = doorHubspot.syncAfterSave({
                                container: container,
                                email: email,
                                folderId: folderId != null ? folderId : (data && data.folder_id != null ? data.folder_id : null),
                                savedProjectName: savedProjectName,
                                config: configForStorage,
                                configForStorage: configForStorage,
                                props: props,
                                summaryParts: summaryParts,
                                qtySave: qtySave,
                                productSku: productSku,
                                basePrice: basePrice,
                                productId: productId,
                                productHandle: productHandle,
                                productName: productName,
                                appliedLineTotal: appliedLineTotal,
                                currency: currency,
                                isUpdate: isUpdate,
                                editId: hubspotConfigId || editId,
                                data: data,
                                messageEl: messageEl,
                                saveButton: saveButton,
                                originalSaveText: originalSaveText,
                                successMessageHtml: successHtml,
                                onComplete: finishSaveSuccess,
                                getQueryParam: getQueryParam
                            });
                            // HubSpot sync will call onComplete when finished — keep "Saving..." until then.
                            if (hubspotStarted) return;
                        }

                        finishSaveSuccess();
                    })
                    .catch(function () {
                        if (messageEl) {
                            messageEl.classList.remove('is-success');
                            messageEl.classList.add('is-error');
                            messageEl.style.display = 'block';
                            messageEl.style.color = '#b91c1c';
                            messageEl.textContent = 'Something went wrong. Please try again.';
                        }
                        saveButton.disabled = false;
                        saveButton.textContent = originalSaveText;
                    });
            });
        }

        // Re-assert a saved radio/select option after post-restore syncs run. Needed for:
        //  - swing_direction: gate collections auto-select the first allowed swing option
        //    whenever none is checked, which races with / clobbers the restored value.
        //  - door_location_exposure: the "Where will the door be located?" cards are
        //    injected manually (not part of doorConfigSchema), so applyConfigToInputs
        //    never restores them.
        // Re-applying after each measurement sync makes the saved selection stick.
        function reapplySavedRadioOption(opts, optionId) {
            var oc = document.getElementById('door-configurator-options');
            if (!oc || !opts || !optionId) return;
            var val = getSavedOptionValue(opts, optionId);
            if ((val == null || val === '') && opts[optionId] != null) val = opts[optionId];
            if (val == null || val === '') return;
            var want = String(val);
            var panelUnitOption = isPanelUnitDesignOptionId(optionId);
            var wantNormPanelUnit = panelUnitOption ? normalizePanelUnitDesignValue(want) : '';
            // Dp merge code 10-09 start
            var exposureOption = String(optionId || '').toLowerCase().replace(/-/g, '_') === 'door_location_exposure';
            // Dp merge code 10-09 end
            var matched = null;
            oc.querySelectorAll('input[type="radio"][data-option-id="' + optionId + '"]').forEach(function (el) {
                var isMatch = false;
                if (panelUnitOption) {
                    isMatch = normalizePanelUnitDesignValue(el.value || '') === wantNormPanelUnit;
                } else if (exposureOption) {
                    // Dp merge code 10-09 start — Full Exposure ↔ full_exposure
                    try {
                        isMatch = defaultSelectionValuesMatch(optionId, want, el.value);
                    } catch (eExpMatch) {
                        isMatch = String(el.value || '') === want;
                    }
                    // Dp merge code 10-09 end
                } else {
                    isMatch = String(el.value || '') === want;
                }
                el.checked = isMatch;
                if (isMatch) matched = el;
                var card = el.closest ? el.closest('.common-check-option, .door-sweep-extra-option, .door-wood-exposure-card') : null;
                if (card) card.classList.toggle('common-check-option--selected', isMatch);
            });
            oc.querySelectorAll('select[data-option-id="' + optionId + '"]').forEach(function (sel) {
                var chosen = null;
                Array.prototype.some.call(sel.options || [], function (o) {
                    if (!o) return false;
                    var isMatch = panelUnitOption
                        ? normalizePanelUnitDesignValue(o.value || '') === wantNormPanelUnit
                        : String(o.value) === want;
                    if (isMatch) {
                        chosen = String(o.value);
                        return true;
                    }
                    return false;
                });
                if (chosen != null) sel.value = chosen;
            });
            if (matched) { try { matched.dispatchEvent(new Event('change', { bubbles: true })); } catch (eRadioReapply) { } }
        }

        function reapplySavedPanelUnitDesign(opts) {
            ['panel_unit_design', 'porch_panel_project', 'porch_panel_order', 'porch_panel_order_type'].forEach(function (id) {
                reapplySavedRadioOption(opts, id);
            });
        }

        // Restore exposure first (its change handler may re-trigger gate rules that
        // auto-select swing), then re-assert swing so it wins.
        function reapplySavedSwingDirection(opts) {
            reapplySavedRadioOption(opts, 'door_location_exposure');
            // panel_unit_design is injected statically (like exposure), so it isn't part of
            // doorConfigSchema and applyConfigToInputs never restores it. Re-assert the saved
            // pick (e.g. order_individual_panels) so the porch-panel choice sticks on edit.
            reapplySavedPanelUnitDesign(opts);
            reapplySavedRadioOption(opts, 'swing_direction');
        }

        function hideRequestQuoteUiForEditMode(containerEl) {
            var root = containerEl || document.getElementById('door-configurator');
            if (!root) return;
            root.classList.add('door-edit-mode');
            root.setAttribute('data-edit-config-id', root.getAttribute('data-edit-config-id') || getQueryParam('config_id') || '1');

            var block = root.querySelector('.door-request-quote-block');
            if (block) block.style.display = 'none';

            var rqTitle = document.getElementById('door-request-quote-title');
            if (rqTitle) rqTitle.style.display = 'none';
            var rqIntro = document.getElementById('door-request-quote-intro');
            if (rqIntro) rqIntro.style.display = 'none';
            var addToQuoteBtn = document.getElementById('door-send-to-hubspot-button');
            if (addToQuoteBtn) addToQuoteBtn.style.display = 'none';
            var addToQuoteMsg = document.getElementById('door-hubspot-message');
            if (addToQuoteMsg) addToQuoteMsg.style.display = 'none';

            // Fallback when theme liquid still lacks IDs / wrapper (live snippet not redeployed).
            if (!block && !rqTitle) {
                var saveBox = root.querySelector('.door-save-config');
                if (saveBox) {
                    var titles = saveBox.querySelectorAll(':scope > .door-section-title, .door-section-title');
                    for (var ti = 0; ti < titles.length; ti++) {
                        if (!titles[ti].classList.contains('door-save-project-title') &&
                            /request\s+a\s+quote/i.test((titles[ti].textContent || '').trim())) {
                            titles[ti].style.display = 'none';
                            break;
                        }
                    }
                    var intros = saveBox.querySelectorAll('.door-save-config-intro');
                    for (var ii = 0; ii < intros.length; ii++) {
                        if (/request a quote for this design now/i.test(intros[ii].textContent || '')) {
                            intros[ii].style.display = 'none';
                            break;
                        }
                    }
                }
            }
        }

        function loadSavedConfig() {
            var configId = getQueryParam('config_id');
            var email = getQueryParam('email');
            var container = document.getElementById('door-configurator');
            var emailFromCustomer = container ? (container.getAttribute('data-customer-email') || '') : '';
            var emailToUse = (email || emailFromCustomer || '').trim();
            doorSavedRestoreDebugLog('loadSavedConfig called', {
                configId: configId,
                emailParam: email || '',
                emailFromCustomer: emailFromCustomer || '',
                emailToUse: emailToUse || '',
                build: DOOR_SAVED_RESTORE_BUILD
            });
            if (!container) {
                doorSavedRestoreDebugLog('loadSavedConfig abort', { reason: 'missing #door-configurator' });
                return;
            }
            if (!configId) {
                doorSavedRestoreDebugLog('loadSavedConfig abort', { reason: 'missing config_id in URL' });
                return;
            }

            // Hide Request a Quote UI as soon as config_id is present (even if email is missing).
            try { hideRequestQuoteUiForEditMode(container); } catch (eHideRqEarly) { }

            if (!emailToUse) {
                doorSavedRestoreDebugLog('loadSavedConfig abort', {
                    reason: 'missing email — add &email=YOUR_EMAIL to the URL or log in on the storefront'
                });
                return;
            }

            // Mark edit mode before schema boot timers run (blocks default-reset timers).
            container.setAttribute('data-edit-config-id', configId);
            try { hideRequestQuoteUiForEditMode(container); } catch (eHideRq) { }

            // Keep QTY visible when editing a saved design; hide only Add to cart.
            var addToCartWrap = document.querySelector('.door-add-to-cart-wrap');
            if (addToCartWrap) {
                addToCartWrap.style.display = '';
                var addToCartBtn = addToCartWrap.querySelector('#door-add-to-cart-btn');
                if (addToCartBtn) addToCartBtn.style.display = 'none';
            }

            fetch(apiBase + '/api/configurations.php?id=' + encodeURIComponent(configId) + '&email=' + encodeURIComponent(emailToUse))
                .then(function (r) { return r.json(); })
                .then(function (c) {
                    if (c.error) {
                        doorSavedRestoreDebugLog('fetch-config error', c.error);
                        return;
                    }
                    doorSavedRestoreDebugLog('fetch-config ok', { id: c.id, hasSummary: !!(c.options && c.options._selected_summary) });
                    var opts = c.options || {};
                    try {
                        var hwListForSchema = opts._hardware_selections || opts.hardware_options || [];
                        if (window.DoorConf2Update && typeof window.DoorConf2Update.mergeLandingHardwareSchemaKeys === 'function' && hwListForSchema.length) {
                            opts = window.DoorConf2Update.mergeLandingHardwareSchemaKeys(opts, hwListForSchema);
                        }
                    } catch (eHwSchemaMerge) { }
                    doorConf2MeasurementsCall('hydrateMeasurementOptionsFromSummary', opts, {
                        getSavedOptionValue: getSavedOptionValue,
                        savedOptionKeysForId: savedOptionKeysForId
                    });
                    applyConfigToInputs(opts);
                    // Restore the Additional Options selects (Door Sweep / Door Stops with Seals /
                    // Pet Door). These render into a late accordion + custom dropdowns, so this
                    // self-retries until the selects exist and then syncs the custom UI.
                    try { restoreAdditionalOptionsSelectsFromSaved(opts); } catch (eAddlSel) { }
                    // Restore the saved casing pick (product + length + qty). The casing UI
                    // lives in DoorConf2Update and renders late, so it self-retries until ready.
                    try {
                        if (window.DoorConf2Update && typeof window.DoorConf2Update.restoreCasingSelection === 'function') {
                            var savedCasingList = opts._casing_selections || opts.casing_options
                                || (opts._casing_selection ? [opts._casing_selection] : []);
                            if (savedCasingList && savedCasingList.length) {
                                window.DoorConf2Update.restoreCasingSelection(savedCasingList);
                            }
                        }
                    } catch (eCasingRestore) { }
                    // Restore millwork wood / length / thickness (baluster & similar no-schema products).
                    try {
                        if (window.DoorConf2Update && typeof window.DoorConf2Update.restoreMillworkSelectionsFromSaved === 'function') {
                            window.DoorConf2Update.restoreMillworkSelectionsFromSaved(opts);
                        }
                    } catch (eMillworkRestore) { }
                    // Restore landing-hardware finish / function / closer color / swing / backset / etc.
                    try {
                        if (window.DoorConf2Update && typeof window.DoorConf2Update.restoreLandingHardwareSelectionsFromSaved === 'function') {
                            window.DoorConf2Update.restoreLandingHardwareSelectionsFromSaved(opts);
                        }
                    } catch (eLhRestore) { }
                    // Restore the saved hardware pick (finish + function + thickness + qty).
                    // Hardware cards render late too, so the module self-retries until ready.
                    try {
                        if (window.DoorConf2Hardware && typeof window.DoorConf2Hardware.restoreHardwareSelection === 'function') {
                            var savedHardwareList = opts._hardware_selections || opts.hardware_options || [];
                            if (savedHardwareList && savedHardwareList.length) {
                                window.DoorConf2Hardware.restoreHardwareSelection(savedHardwareList);
                            }
                        }
                    } catch (eHardwareRestore) { }
                    var optionsContainer = document.getElementById('door-configurator-options');
                    if (optionsContainer) {
                        setTimeout(function () {
                            applySavedExtrasFromOptions(opts);
                            applyHideWhen(doorConfigSchema, optionsContainer);
                            applyChoiceVisibility(doorConfigSchema, optionsContainer);
                            applyProductTagChoiceVisibility(doorConfigSchema, optionsContainer);
                            syncPanelProfileHero(optionsContainer);
                            syncMeasurementTypeSectionPreHungGate(doorConfigSchema, optionsContainer);
                            syncHingeFinishVisibility(doorConfigSchema, optionsContainer);
                            syncLocksetPrepVisibility(doorConfigSchema, optionsContainer);
                            try { pulseDependentVisibilityFromDefaults(optionsContainer); } catch (ePulse) { }
                            prefetchSavedSidelightTransomApi(opts, function () {
                                // Re-assert selections now that transom/sidelight glass styles have
                                // loaded and their cards/selects have finished rendering.
                                try { applyConfigToInputs(opts, { skipTouched: true }); } catch (eReapplyPrefetch) { }
                                try { restoreAdditionalOptionsSelectsFromSaved(opts); } catch (eAddlSel2) { }
                                try {
                                    if (window.DoorConf2Update && typeof window.DoorConf2Update.restoreMillworkSelectionsFromSaved === 'function') {
                                        window.DoorConf2Update.restoreMillworkSelectionsFromSaved(opts);
                                    }
                                } catch (eMillworkRestore2) { }
                                try {
                                    if (window.DoorConf2Update && typeof window.DoorConf2Update.restoreLandingHardwareSelectionsFromSaved === 'function') {
                                        window.DoorConf2Update.restoreLandingHardwareSelectionsFromSaved(opts);
                                    }
                                } catch (eLhRestore2) { }
                                applyMeasurementSelectsFromSavedOptions(opts);
                                try { runMeasurementUiSync(); } catch (eMeasResync) { }
                                try { reapplySavedSwingDirection(opts); } catch (eSwingReapply1) { }
                                refreshScreenStormPricingAfterSavedRestore();
                                updateEstimatedPrice();
                                applyStoredDoorPricingFromOptions(opts);
                                updateDoorPreview();
                                try { openRestoredDesignAccordions(optionsContainer); } catch (eOpenDesign1) { }
                                try { syncMeasurementSelectedPriceLabels(opts); } catch (eMeasLbl2) { }
                            });
                            setTimeout(function () {
                                // Re-assert saved selections after dependent options have revealed,
                                // so child radio/select options that appeared late still pre-select.
                                try { applyConfigToInputs(opts, { skipTouched: true }); } catch (eReapply) { }
                                applySavedExtrasFromOptions(opts);
                                applyMeasurementSelectsFromSavedOptions(opts);
                                try { runMeasurementUiSync(); } catch (eMeasLate) { }
                                try { reapplySavedSwingDirection(opts); } catch (eSwingReapply2) { }
                                try {
                                    if (window.DoorConf2Update && typeof window.DoorConf2Update.restoreMillworkSelectionsFromSaved === 'function') {
                                        window.DoorConf2Update.restoreMillworkSelectionsFromSaved(opts);
                                    }
                                } catch (eMillworkRestore3) { }
                                try {
                                    if (window.DoorConf2Update && typeof window.DoorConf2Update.restoreLandingHardwareSelectionsFromSaved === 'function') {
                                        window.DoorConf2Update.restoreLandingHardwareSelectionsFromSaved(opts);
                                    }
                                } catch (eLhRestore3) { }
                                refreshScreenStormPricingAfterSavedRestore();
                                updateEstimatedPrice();
                                applyStoredDoorPricingFromOptions(opts);
                                try { openRestoredDesignAccordions(optionsContainer); } catch (eOpenDesign2) { }
                                try { syncMeasurementSelectedPriceLabels(opts); } catch (eMeasLbl3) { }
                            }, 1600);
                        }, 120);
                    } else {
                        prefetchSavedSidelightTransomApi(opts, function () {
                            updateEstimatedPrice();
                            applyStoredDoorPricingFromOptions(opts);
                            updateDoorPreview();
                        });
                    }
                    var savedQty = parseInt(opts._quantity, 10);
                    if (!isNaN(savedQty) && savedQty >= 1) {
                        var doorQtyInput = getDoorQuantityInput();
                        if (doorQtyInput) doorQtyInput.value = String(savedQty);
                        // Refresh the estimated-price box so it shows unit × restored qty.
                        try {
                            if (window.DoorIntExtPricingRule && typeof window.DoorIntExtPricingRule.syncEstimatedPriceDisplay === 'function') {
                                setTimeout(function () {
                                    window.DoorIntExtPricingRule.syncEstimatedPriceDisplay({ source: 'qty_restore', userAction: true, forceLog: true });
                                }, 60);
                            }
                        } catch (eQtyRestore) { }
                    }
                    var emailInput = document.getElementById('door-customer-email');
                    var custEmail = c.customer_email || emailToUse;
                    if (emailInput) emailInput.value = custEmail;
                    var saveBtn = document.getElementById('door-save-config-button');
                    if (saveBtn) saveBtn.textContent = 'Update project';
                    if (folderSelect && custEmail) {
                        loadFoldersIntoSelect(custEmail, function () {
                            if (c.folder_id != null) {
                                var existing = folderSelect.querySelector('option[value="' + String(c.folder_id) + '"]');
                                if (existing) folderSelect.value = String(c.folder_id);
                            }
                            if (newFolderInput) {
                                var isNewEdit = folderSelect.value === '__new__';
                                newFolderInput.style.display = isNewEdit ? 'block' : 'none';
                                newFolderInput.classList.toggle('door-visible', isNewEdit);
                            }
                            try {
                                setItemFriendlyName((opts && opts._friendly_name) || '');
                            } catch (eFn) { }
                            syncFolderSelectDivDropdown();
                        });
                    } else {
                        try {
                            setItemFriendlyName((opts && opts._friendly_name) || '');
                        } catch (eFn2) { }
                    }
                })
                .catch(function (err) {
                    doorSavedRestoreDebugLog('fetch-config failed', { message: err && err.message ? err.message : String(err) });
                });
        }

        updateEstimatedPrice();
        updateDoorPreview();
        loadSavedConfig();

        runDoorAuthReturnFlow();
    }

    function onReady() {
        if (window.DoorConf2Hardware && typeof window.DoorConf2Hardware.init === 'function') {
            window.DoorConf2Hardware.init({
                resolveChoiceImageSrc: resolveChoiceImageSrc,
                formatMoney: formatMoney,
                updateEstimatedPrice: updateEstimatedPrice
            });
        }
        doorConf2MeasurementsInit();
        try {
            window.__doorFormatEstimatedPrice = formatMoney;
            window.__doorApplyMeasurementTabSelection = applyMeasurementTypeTabSelection;
            window.__doorRunMeasurementUiSync = runMeasurementUiSync;
        } catch (eFmt) { }
        try {
            document.addEventListener('door-sidelight-transom-price-ready', function () {
                try { updateEstimatedPrice(); } catch (eSlReady) { }
                try { syncMeasurementSelectedPriceLabels(null); } catch (eSlMeasLbl) { }
            });
            document.addEventListener('door-screen-storm-measurement-price-ready', function (e) {
                try {
                    if (
                        window.DoorIntExtPricingRule
                        && typeof window.DoorIntExtPricingRule.syncEstimatedPriceDisplay === 'function'
                    ) {
                        window.DoorIntExtPricingRule.syncEstimatedPriceDisplay({
                            source: 'door-screen-storm-measurement-price-ready',
                            userAction: true,
                            forceLog: true
                        });
                    }
                    if (
                        window.PriceScreenStorm
                        && typeof window.PriceScreenStorm.ensureScreenStormPriceAppliedToDom === 'function'
                    ) {
                        window.PriceScreenStorm.ensureScreenStormPriceAppliedToDom({
                            source: 'door-screen-storm-measurement-price-ready',
                            detail: e && e.detail ? e.detail : null
                        });
                    }
                    updateOptionRunningPriceLabels();
                    try { syncMeasurementSelectedPriceLabels(null); } catch (eSsMeasLbl) { }
                } catch (eSsMeas) { }
            });
            document.addEventListener('door-storm-glass-price-ready', function (e) {
                try {
                    updateEstimatedPrice();
                    if (
                        window.DoorIntExtPricingRule
                        && typeof window.DoorIntExtPricingRule.syncEstimatedPriceDisplay === 'function'
                    ) {
                        window.DoorIntExtPricingRule.syncEstimatedPriceDisplay({
                            source: 'door-storm-glass-price-ready',
                            userAction: true
                        });
                    }
                    var detail = e && e.detail ? e.detail : {};
                    var theme = parseFloat(window.__doorThemeOptionTotal) || 0;
                    var storm = parseFloat(window['__doorAddon_storm_glass'] || 0) || 0;
                    if (storm > 0) {
                        var alertKey = String(detail.key || '') + '|' + String(storm);
                        if (window.__doorStormGlassAlertKey !== alertKey) {
                            window.__doorStormGlassAlertKey = alertKey;
                            try {
                                console.log('Storm glass add-on added:', String(storm));
                            } catch (eAlert) { }
                        }
                    }
                    if (window.DOOR_PRICE_DEBUG === false) return;
                    var payload = {
                        normalizedKey: detail.key,
                        selectedValue: detail.value,
                        themeOptionTotal: theme,
                        stormGlassAddon: storm,
                        displayTotal: readDoorEstimatedPriceFromDom(),
                        formula: theme + ' + ' + storm + ' = ' + (theme + storm)
                    };
                    if (
                        window.GlassFormulaCalculation
                        && typeof window.GlassFormulaCalculation.logStormGlass === 'function'
                    ) {
                        window.GlassFormulaCalculation.logStormGlass('display_after_api', payload);
                    } else {
                        void 0;
                    }
                } catch (eStormReady) { }
            });
        } catch (eStormBind) { }
        attachEvents();
        try {
            if (
                window.GlassFormulaCalculation
                && typeof window.GlassFormulaCalculation.ensureSidelightTransomLoaded === 'function'
            ) {
                window.GlassFormulaCalculation.ensureSidelightTransomLoaded();
            }
        } catch (eSlBoot) { }
        bindAddToCart(); // Delegated listener so Add to cart works even if configurator loads late
        // --- Dp start 31-07 — door-pdp-back link redirect logic ---
        // MERGE: seo_pdp_url — on configurator (?config=), Back → landing /products/{handle};
        // collection/home only when not in configurator mode.
        try {
            var backLinks = document.querySelectorAll('.door-pdp-back, .door-pdp-back-link, [data-pdp-back-link]');
            // Deduplicate Back links inside each topbar (can appear after config fetch swap)
            document.querySelectorAll('.door-pdp-topbar').forEach(function (tb) {
                var backs = tb.querySelectorAll('.door-pdp-back, [data-pdp-back-link]');
                for (var di = 1; di < backs.length; di++) {
                    if (backs[di] && backs[di].parentNode) backs[di].parentNode.removeChild(backs[di]);
                }
            });
            backLinks = document.querySelectorAll('.door-pdp-back, .door-pdp-back-link, [data-pdp-back-link]');
            if (backLinks && backLinks.length > 0) {
                var pathName = String(window.location.pathname || '');
                var prodMatch = pathName.match(/\/products\/([^\/\?#]+)/);
                var prodHandle = prodMatch ? decodeURIComponent(prodMatch[1]) : '';
                var hasConfigParam = false;
                try {
                    hasConfigParam = !!(new URL(window.location.href).searchParams.get('config'));
                } catch (eCfg) { }
                var isConfigurator =
                    hasConfigParam ||
                    document.documentElement.classList.contains('pdp-configurator-loaded') ||
                    !!document.getElementById('door-configurator');

                var dest;
                if (isConfigurator && prodHandle) {
                    dest = '/products/' + encodeURIComponent(prodHandle);
                } else {
                    var backCol = null;
                    var nestedMatch = pathName.match(/\/collections\/([^\/\?#]+)\/products\//);
                    if (nestedMatch && nestedMatch[1]) {
                        backCol = nestedMatch[1];
                    } else {
                        try {
                            var rawCtx = sessionStorage.getItem('pdp_col_context');
                            if (rawCtx) {
                                var ctxData = JSON.parse(rawCtx);
                                if (
                                    ctxData &&
                                    ctxData.col &&
                                    !/^\d+$/.test(String(ctxData.col)) &&
                                    (!prodHandle || ctxData.handle === prodHandle)
                                ) {
                                    backCol = ctxData.col;
                                }
                            }
                        } catch (eCtx) { }
                        if (!backCol && document.referrer) {
                            try {
                                var refUrl = new URL(document.referrer);
                                if (refUrl.origin === window.location.origin) {
                                    var refCol = refUrl.pathname.match(/\/collections\/([^\/\?#]+)/);
                                    if (refCol && refCol[1] && refUrl.pathname.indexOf('/products/') === -1) {
                                        backCol = refCol[1];
                                    }
                                }
                            } catch (eRef) { }
                        }
                    }
                    dest = backCol ? '/collections/' + encodeURIComponent(backCol) : '/';
                }
                backLinks.forEach(function (link) {
                    link.setAttribute('href', dest);
                    link.setAttribute('data-pdp-back-dest', dest);
                    link.addEventListener('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        window.location.href = dest;
                    }, { capture: true });
                });
            }
        } catch (eBackLink) { }
        // --- Dp end 31-07 — door-pdp-back link redirect logic ---
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', onReady);
    } else {
        onReady();
    }
})();
